(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb406"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb406"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
'use strict';

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});
parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $dd934af551f44020$export$3ba232387fd5d6dd, (v) => $dd934af551f44020$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $dd934af551f44020$export$7568632d0d33d16d, (v) => $dd934af551f44020$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $dd934af551f44020$export$88948ce120ea2619, (v) => $dd934af551f44020$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $dd934af551f44020$export$6a7bc4e911dc01cf, (v) => $dd934af551f44020$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $dd934af551f44020$export$f680877a34711e37, (v) => $dd934af551f44020$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $dd934af551f44020$export$aaabe4eda9ed9969, (v) => $dd934af551f44020$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $dd934af551f44020$export$306c0aa65ff9ec16, (v) => $dd934af551f44020$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $dd934af551f44020$export$7b286972b8d8ccbf, (v) => $dd934af551f44020$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$3ba232387fd5d6dd;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$7568632d0d33d16d;
var $dd934af551f44020$export$88948ce120ea2619;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6a7bc4e911dc01cf;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$f680877a34711e37;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$aaabe4eda9ed9969;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$306c0aa65ff9ec16;
var $dd934af551f44020$export$7b286972b8d8ccbf;
var $dd934af551f44020$export$83d89fbfd8236492;
'use strict';
var $dd934af551f44020$var$l = Symbol.for("react.element"), $dd934af551f44020$var$n = Symbol.for("react.portal"), $dd934af551f44020$var$p = Symbol.for("react.fragment"), $dd934af551f44020$var$q = Symbol.for("react.strict_mode"), $dd934af551f44020$var$r = Symbol.for("react.profiler"), $dd934af551f44020$var$t = Symbol.for("react.provider"), $dd934af551f44020$var$u = Symbol.for("react.context"), $dd934af551f44020$var$v = Symbol.for("react.forward_ref"), $dd934af551f44020$var$w = Symbol.for("react.suspense"), $dd934af551f44020$var$x = Symbol.for("react.memo"), $dd934af551f44020$var$y = Symbol.for("react.lazy"), $dd934af551f44020$var$z = Symbol.iterator;
function $dd934af551f44020$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$z && a[$dd934af551f44020$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd934af551f44020$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$C = Object.assign, $dd934af551f44020$var$D = {};
function $dd934af551f44020$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
$dd934af551f44020$var$E.prototype.isReactComponent = {};
$dd934af551f44020$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$F() {}
$dd934af551f44020$var$F.prototype = $dd934af551f44020$var$E.prototype;
function $dd934af551f44020$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
var $dd934af551f44020$var$H = $dd934af551f44020$var$G.prototype = new $dd934af551f44020$var$F;
$dd934af551f44020$var$H.constructor = $dd934af551f44020$var$G;
$dd934af551f44020$var$C($dd934af551f44020$var$H, $dd934af551f44020$var$E.prototype);
$dd934af551f44020$var$H.isPureReactComponent = !0;
var $dd934af551f44020$var$I = Array.isArray, $dd934af551f44020$var$J = Object.prototype.hasOwnProperty, $dd934af551f44020$var$K = {
    current: null
}, $dd934af551f44020$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$J.call(b, d) && !$dd934af551f44020$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd934af551f44020$var$K.current
    };
}
function $dd934af551f44020$var$N(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$l;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$P = /\/+/g;
function $dd934af551f44020$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$l:
                case $dd934af551f44020$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd934af551f44020$var$Q(h, 0) : d, $dd934af551f44020$var$I(c) ? (e = "", null != a && (e = a.replace($dd934af551f44020$var$P, "$&/") + "/"), $dd934af551f44020$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd934af551f44020$var$O(c) && (c = $dd934af551f44020$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd934af551f44020$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd934af551f44020$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd934af551f44020$var$Q(k, g);
        h += $dd934af551f44020$var$R(k, b, e, f, c);
    }
    else if (f = $dd934af551f44020$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd934af551f44020$var$Q(k, g++), h += $dd934af551f44020$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd934af551f44020$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd934af551f44020$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd934af551f44020$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd934af551f44020$var$U = {
    current: null
}, $dd934af551f44020$var$V = {
    transition: null
}, $dd934af551f44020$var$W = {
    ReactCurrentDispatcher: $dd934af551f44020$var$U,
    ReactCurrentBatchConfig: $dd934af551f44020$var$V,
    ReactCurrentOwner: $dd934af551f44020$var$K
};
function $dd934af551f44020$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$S,
    forEach: function(a, b, e) {
        $dd934af551f44020$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$E;
$dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$p;
$dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$r;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$G;
$dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$q;
$dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$W;
$dd934af551f44020$export$3ba232387fd5d6dd = $dd934af551f44020$var$X;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd934af551f44020$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$J.call(b, f) && !$dd934af551f44020$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd934af551f44020$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$M;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$O;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$T
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$7568632d0d33d16d = function(a) {
    var b = $dd934af551f44020$var$V.transition;
    $dd934af551f44020$var$V.transition = {};
    try {
        a();
    } finally{
        $dd934af551f44020$var$V.transition = b;
    }
};
$dd934af551f44020$export$88948ce120ea2619 = $dd934af551f44020$var$X;
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$U.current.useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a) {
    return $dd934af551f44020$var$U.current.useContext(a);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6a7bc4e911dc01cf = function(a) {
    return $dd934af551f44020$var$U.current.useDeferredValue(a);
};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$U.current.useEffect(a, b);
};
$dd934af551f44020$export$f680877a34711e37 = function() {
    return $dd934af551f44020$var$U.current.useId();
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useImperativeHandle(a, b, e);
};
$dd934af551f44020$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd934af551f44020$var$U.current.useInsertionEffect(a, b);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$U.current.useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$U.current.useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useReducer(a, b, e);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$U.current.useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$U.current.useState(a);
};
$dd934af551f44020$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useSyncExternalStore(a, b, e);
};
$dd934af551f44020$export$7b286972b8d8ccbf = function() {
    return $dd934af551f44020$var$U.current.useTransition();
};
$dd934af551f44020$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("23wBm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17f526922e4a857c$export$ae55be85d98224ed, (v) => $17f526922e4a857c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $17f526922e4a857c$export$d39a5bbd09211389, (v) => $17f526922e4a857c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $17f526922e4a857c$export$882461b6382ed46c, (v) => $17f526922e4a857c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $17f526922e4a857c$export$466bfc07425424d5, (v) => $17f526922e4a857c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $17f526922e4a857c$export$cd75ccfd720a3cd4, (v) => $17f526922e4a857c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $17f526922e4a857c$export$fa8d919ba61d84db, (v) => $17f526922e4a857c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $17f526922e4a857c$export$757ceba2d55c277e, (v) => $17f526922e4a857c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $17f526922e4a857c$export$b3890eb0ae9dca99, (v) => $17f526922e4a857c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $17f526922e4a857c$export$502457920280e6be, (v) => $17f526922e4a857c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $17f526922e4a857c$export$c78a37762a8d58e1, (v) => $17f526922e4a857c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $17f526922e4a857c$export$dc54d992c10e8a18, (v) => $17f526922e4a857c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $17f526922e4a857c$export$83d89fbfd8236492, (v) => $17f526922e4a857c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $17f526922e4a857c$export$ae55be85d98224ed;
var $17f526922e4a857c$export$d39a5bbd09211389;
var $17f526922e4a857c$export$882461b6382ed46c;
var $17f526922e4a857c$export$466bfc07425424d5;
var $17f526922e4a857c$export$cd75ccfd720a3cd4;
var $17f526922e4a857c$export$fa8d919ba61d84db;
var $17f526922e4a857c$export$757ceba2d55c277e;
var $17f526922e4a857c$export$b3890eb0ae9dca99;
var $17f526922e4a857c$export$502457920280e6be;
var $17f526922e4a857c$export$c78a37762a8d58e1;
var $17f526922e4a857c$export$dc54d992c10e8a18;
var $17f526922e4a857c$export$83d89fbfd8236492;
'use strict';

var $8NFma = parcelRequire("8NFma");

var $clk2u = parcelRequire("clk2u");
function $17f526922e4a857c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17f526922e4a857c$var$da = new Set, $17f526922e4a857c$var$ea = {};
function $17f526922e4a857c$var$fa(a, b) {
    $17f526922e4a857c$var$ha(a, b);
    $17f526922e4a857c$var$ha(a + "Capture", b);
}
function $17f526922e4a857c$var$ha(a, b) {
    $17f526922e4a857c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$17f526922e4a857c$var$da.add(b[a]);
}
var $17f526922e4a857c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $17f526922e4a857c$var$ja = Object.prototype.hasOwnProperty, $17f526922e4a857c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $17f526922e4a857c$var$la = {}, $17f526922e4a857c$var$ma = {};
function $17f526922e4a857c$var$oa(a) {
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$ma, a)) return !0;
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$la, a)) return !1;
    if ($17f526922e4a857c$var$ka.test(a)) return $17f526922e4a857c$var$ma[a] = !0;
    $17f526922e4a857c$var$la[a] = !0;
    return !1;
}
function $17f526922e4a857c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $17f526922e4a857c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $17f526922e4a857c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $17f526922e4a857c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $17f526922e4a857c$var$ra = /[\-:]([a-z])/g;
function $17f526922e4a857c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$17f526922e4a857c$var$z.xlinkHref = new $17f526922e4a857c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $17f526922e4a857c$var$ta(a, b, c, d) {
    var e = $17f526922e4a857c$var$z.hasOwnProperty(b) ? $17f526922e4a857c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $17f526922e4a857c$var$qa(b, c, e, d) && (c = null), d || null === e ? $17f526922e4a857c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $17f526922e4a857c$var$ua = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $17f526922e4a857c$var$va = Symbol.for("react.element"), $17f526922e4a857c$var$wa = Symbol.for("react.portal"), $17f526922e4a857c$var$ya = Symbol.for("react.fragment"), $17f526922e4a857c$var$za = Symbol.for("react.strict_mode"), $17f526922e4a857c$var$Aa = Symbol.for("react.profiler"), $17f526922e4a857c$var$Ba = Symbol.for("react.provider"), $17f526922e4a857c$var$Ca = Symbol.for("react.context"), $17f526922e4a857c$var$Da = Symbol.for("react.forward_ref"), $17f526922e4a857c$var$Ea = Symbol.for("react.suspense"), $17f526922e4a857c$var$Fa = Symbol.for("react.suspense_list"), $17f526922e4a857c$var$Ga = Symbol.for("react.memo"), $17f526922e4a857c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $17f526922e4a857c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $17f526922e4a857c$var$Ja = Symbol.iterator;
function $17f526922e4a857c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $17f526922e4a857c$var$Ja && a[$17f526922e4a857c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $17f526922e4a857c$var$A = Object.assign, $17f526922e4a857c$var$La;
function $17f526922e4a857c$var$Ma(a) {
    if (void 0 === $17f526922e4a857c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $17f526922e4a857c$var$La = b && b[1] || "";
    }
    return "\n" + $17f526922e4a857c$var$La + a;
}
var $17f526922e4a857c$var$Na = !1;
function $17f526922e4a857c$var$Oa(a, b) {
    if (!a || $17f526922e4a857c$var$Na) return "";
    $17f526922e4a857c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $17f526922e4a857c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $17f526922e4a857c$var$Ma(a) : "";
}
function $17f526922e4a857c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $17f526922e4a857c$var$Ma(a.type);
        case 16:
            return $17f526922e4a857c$var$Ma("Lazy");
        case 13:
            return $17f526922e4a857c$var$Ma("Suspense");
        case 19:
            return $17f526922e4a857c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $17f526922e4a857c$var$Oa(a.type, !1), a;
        case 11:
            return a = $17f526922e4a857c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $17f526922e4a857c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $17f526922e4a857c$var$ya:
            return "Fragment";
        case $17f526922e4a857c$var$wa:
            return "Portal";
        case $17f526922e4a857c$var$Aa:
            return "Profiler";
        case $17f526922e4a857c$var$za:
            return "StrictMode";
        case $17f526922e4a857c$var$Ea:
            return "Suspense";
        case $17f526922e4a857c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $17f526922e4a857c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $17f526922e4a857c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $17f526922e4a857c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $17f526922e4a857c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $17f526922e4a857c$var$Qa(a.type) || "Memo";
        case $17f526922e4a857c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $17f526922e4a857c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $17f526922e4a857c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $17f526922e4a857c$var$Qa(b);
        case 8:
            return b === $17f526922e4a857c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $17f526922e4a857c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $17f526922e4a857c$var$Ua(a) {
    var b = $17f526922e4a857c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $17f526922e4a857c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $17f526922e4a857c$var$Ua(a));
}
function $17f526922e4a857c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $17f526922e4a857c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $17f526922e4a857c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $17f526922e4a857c$var$Ya(a, b) {
    var c = b.checked;
    return $17f526922e4a857c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $17f526922e4a857c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $17f526922e4a857c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $17f526922e4a857c$var$ab(a, b) {
    b = b.checked;
    null != b && $17f526922e4a857c$var$ta(a, "checked", b, !1);
}
function $17f526922e4a857c$var$bb(a, b) {
    $17f526922e4a857c$var$ab(a, b);
    var c = $17f526922e4a857c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $17f526922e4a857c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $17f526922e4a857c$var$cb(a, b.type, $17f526922e4a857c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $17f526922e4a857c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $17f526922e4a857c$var$cb(a, b, c) {
    if ("number" !== b || $17f526922e4a857c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $17f526922e4a857c$var$eb = Array.isArray;
function $17f526922e4a857c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $17f526922e4a857c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $17f526922e4a857c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($17f526922e4a857c$var$p(91));
    return $17f526922e4a857c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $17f526922e4a857c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($17f526922e4a857c$var$p(92));
            if ($17f526922e4a857c$var$eb(c)) {
                if (1 < c.length) throw Error($17f526922e4a857c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $17f526922e4a857c$var$Sa(c)
    };
}
function $17f526922e4a857c$var$ib(a, b) {
    var c = $17f526922e4a857c$var$Sa(b.value), d = $17f526922e4a857c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $17f526922e4a857c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $17f526922e4a857c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $17f526922e4a857c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $17f526922e4a857c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $17f526922e4a857c$var$mb, $17f526922e4a857c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $17f526922e4a857c$var$mb = $17f526922e4a857c$var$mb || document.createElement("div");
        $17f526922e4a857c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $17f526922e4a857c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $17f526922e4a857c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $17f526922e4a857c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $17f526922e4a857c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($17f526922e4a857c$var$pb).forEach(function(a) {
    $17f526922e4a857c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $17f526922e4a857c$var$pb[b] = $17f526922e4a857c$var$pb[a];
    });
});
function $17f526922e4a857c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $17f526922e4a857c$var$pb.hasOwnProperty(a) && $17f526922e4a857c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $17f526922e4a857c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $17f526922e4a857c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $17f526922e4a857c$var$tb = $17f526922e4a857c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $17f526922e4a857c$var$ub(a, b) {
    if (b) {
        if ($17f526922e4a857c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($17f526922e4a857c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($17f526922e4a857c$var$p(62));
    }
}
function $17f526922e4a857c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $17f526922e4a857c$var$wb = null;
function $17f526922e4a857c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $17f526922e4a857c$var$yb = null, $17f526922e4a857c$var$zb = null, $17f526922e4a857c$var$Ab = null;
function $17f526922e4a857c$var$Bb(a) {
    if (a = $17f526922e4a857c$var$Cb(a)) {
        if ("function" !== typeof $17f526922e4a857c$var$yb) throw Error($17f526922e4a857c$var$p(280));
        var b = a.stateNode;
        b && (b = $17f526922e4a857c$var$Db(b), $17f526922e4a857c$var$yb(a.stateNode, a.type, b));
    }
}
function $17f526922e4a857c$var$Eb(a) {
    $17f526922e4a857c$var$zb ? $17f526922e4a857c$var$Ab ? $17f526922e4a857c$var$Ab.push(a) : $17f526922e4a857c$var$Ab = [
        a
    ] : $17f526922e4a857c$var$zb = a;
}
function $17f526922e4a857c$var$Fb() {
    if ($17f526922e4a857c$var$zb) {
        var a = $17f526922e4a857c$var$zb, b = $17f526922e4a857c$var$Ab;
        $17f526922e4a857c$var$Ab = $17f526922e4a857c$var$zb = null;
        $17f526922e4a857c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$17f526922e4a857c$var$Bb(b[a]);
    }
}
function $17f526922e4a857c$var$Gb(a, b) {
    return a(b);
}
function $17f526922e4a857c$var$Hb() {}
var $17f526922e4a857c$var$Ib = !1;
function $17f526922e4a857c$var$Jb(a, b, c) {
    if ($17f526922e4a857c$var$Ib) return a(b, c);
    $17f526922e4a857c$var$Ib = !0;
    try {
        return $17f526922e4a857c$var$Gb(a, b, c);
    } finally{
        if ($17f526922e4a857c$var$Ib = !1, null !== $17f526922e4a857c$var$zb || null !== $17f526922e4a857c$var$Ab) $17f526922e4a857c$var$Hb(), $17f526922e4a857c$var$Fb();
    }
}
function $17f526922e4a857c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $17f526922e4a857c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($17f526922e4a857c$var$p(231, b, typeof c));
    return c;
}
var $17f526922e4a857c$var$Lb = !1;
if ($17f526922e4a857c$var$ia) try {
    var $17f526922e4a857c$var$Mb = {};
    Object.defineProperty($17f526922e4a857c$var$Mb, "passive", {
        get: function() {
            $17f526922e4a857c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
    window.removeEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
} catch (a) {
    $17f526922e4a857c$var$Lb = !1;
}
function $17f526922e4a857c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $17f526922e4a857c$var$Ob = !1, $17f526922e4a857c$var$Pb = null, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, $17f526922e4a857c$var$Sb = {
    onError: function(a) {
        $17f526922e4a857c$var$Ob = !0;
        $17f526922e4a857c$var$Pb = a;
    }
};
function $17f526922e4a857c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Ob = !1;
    $17f526922e4a857c$var$Pb = null;
    $17f526922e4a857c$var$Nb.apply($17f526922e4a857c$var$Sb, arguments);
}
function $17f526922e4a857c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Tb.apply(this, arguments);
    if ($17f526922e4a857c$var$Ob) {
        if ($17f526922e4a857c$var$Ob) {
            var l = $17f526922e4a857c$var$Pb;
            $17f526922e4a857c$var$Ob = !1;
            $17f526922e4a857c$var$Pb = null;
        } else throw Error($17f526922e4a857c$var$p(198));
        $17f526922e4a857c$var$Qb || ($17f526922e4a857c$var$Qb = !0, $17f526922e4a857c$var$Rb = l);
    }
}
function $17f526922e4a857c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $17f526922e4a857c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $17f526922e4a857c$var$Xb(a) {
    if ($17f526922e4a857c$var$Vb(a) !== a) throw Error($17f526922e4a857c$var$p(188));
}
function $17f526922e4a857c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $17f526922e4a857c$var$Vb(a);
        if (null === b) throw Error($17f526922e4a857c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $17f526922e4a857c$var$Xb(e), a;
                if (f === d) return $17f526922e4a857c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($17f526922e4a857c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($17f526922e4a857c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($17f526922e4a857c$var$p(190));
    }
    if (3 !== c.tag) throw Error($17f526922e4a857c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $17f526922e4a857c$var$Zb(a) {
    a = $17f526922e4a857c$var$Yb(a);
    return null !== a ? $17f526922e4a857c$var$$b(a) : null;
}
function $17f526922e4a857c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $17f526922e4a857c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$ac = $clk2u.unstable_scheduleCallback, $17f526922e4a857c$var$bc = $clk2u.unstable_cancelCallback, $17f526922e4a857c$var$cc = $clk2u.unstable_shouldYield, $17f526922e4a857c$var$dc = $clk2u.unstable_requestPaint, $17f526922e4a857c$var$B = $clk2u.unstable_now, $17f526922e4a857c$var$ec = $clk2u.unstable_getCurrentPriorityLevel, $17f526922e4a857c$var$fc = $clk2u.unstable_ImmediatePriority, $17f526922e4a857c$var$gc = $clk2u.unstable_UserBlockingPriority, $17f526922e4a857c$var$hc = $clk2u.unstable_NormalPriority, $17f526922e4a857c$var$ic = $clk2u.unstable_LowPriority, $17f526922e4a857c$var$jc = $clk2u.unstable_IdlePriority, $17f526922e4a857c$var$kc = null, $17f526922e4a857c$var$lc = null;
function $17f526922e4a857c$var$mc(a) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberRoot) try {
        $17f526922e4a857c$var$lc.onCommitFiberRoot($17f526922e4a857c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $17f526922e4a857c$var$oc = Math.clz32 ? Math.clz32 : $17f526922e4a857c$var$nc, $17f526922e4a857c$var$pc = Math.log, $17f526922e4a857c$var$qc = Math.LN2;
function $17f526922e4a857c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($17f526922e4a857c$var$pc(a) / $17f526922e4a857c$var$qc | 0) | 0;
}
var $17f526922e4a857c$var$rc = 64, $17f526922e4a857c$var$sc = 4194304;
function $17f526922e4a857c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $17f526922e4a857c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $17f526922e4a857c$var$tc(h) : (f &= g, 0 !== f && (d = $17f526922e4a857c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $17f526922e4a857c$var$tc(g) : 0 !== f && (d = $17f526922e4a857c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $17f526922e4a857c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $17f526922e4a857c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $17f526922e4a857c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $17f526922e4a857c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $17f526922e4a857c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $17f526922e4a857c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $17f526922e4a857c$var$yc() {
    var a = $17f526922e4a857c$var$rc;
    $17f526922e4a857c$var$rc <<= 1;
    0 === ($17f526922e4a857c$var$rc & 4194240) && ($17f526922e4a857c$var$rc = 64);
    return a;
}
function $17f526922e4a857c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $17f526922e4a857c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $17f526922e4a857c$var$oc(b);
    a[b] = c;
}
function $17f526922e4a857c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $17f526922e4a857c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $17f526922e4a857c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $17f526922e4a857c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $17f526922e4a857c$var$C = 0;
function $17f526922e4a857c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $17f526922e4a857c$var$Ec, $17f526922e4a857c$var$Fc, $17f526922e4a857c$var$Gc, $17f526922e4a857c$var$Hc, $17f526922e4a857c$var$Ic, $17f526922e4a857c$var$Jc = !1, $17f526922e4a857c$var$Kc = [], $17f526922e4a857c$var$Lc = null, $17f526922e4a857c$var$Mc = null, $17f526922e4a857c$var$Nc = null, $17f526922e4a857c$var$Oc = new Map, $17f526922e4a857c$var$Pc = new Map, $17f526922e4a857c$var$Qc = [], $17f526922e4a857c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $17f526922e4a857c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $17f526922e4a857c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $17f526922e4a857c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $17f526922e4a857c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $17f526922e4a857c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $17f526922e4a857c$var$Pc.delete(b.pointerId);
    }
}
function $17f526922e4a857c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $17f526922e4a857c$var$Cb(b), null !== b && $17f526922e4a857c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $17f526922e4a857c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $17f526922e4a857c$var$Lc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $17f526922e4a857c$var$Mc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $17f526922e4a857c$var$Nc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $17f526922e4a857c$var$Oc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $17f526922e4a857c$var$Pc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $17f526922e4a857c$var$Vc(a) {
    var b = $17f526922e4a857c$var$Wc(a.target);
    if (null !== b) {
        var c = $17f526922e4a857c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $17f526922e4a857c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $17f526922e4a857c$var$Ic(a.priority, function() {
                        $17f526922e4a857c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $17f526922e4a857c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $17f526922e4a857c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $17f526922e4a857c$var$wb = d;
            c.target.dispatchEvent(d);
            $17f526922e4a857c$var$wb = null;
        } else return b = $17f526922e4a857c$var$Cb(c), null !== b && $17f526922e4a857c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $17f526922e4a857c$var$Zc(a, b, c) {
    $17f526922e4a857c$var$Xc(a) && c.delete(b);
}
function $17f526922e4a857c$var$$c() {
    $17f526922e4a857c$var$Jc = !1;
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Lc) && ($17f526922e4a857c$var$Lc = null);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Mc) && ($17f526922e4a857c$var$Mc = null);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Nc) && ($17f526922e4a857c$var$Nc = null);
    $17f526922e4a857c$var$Oc.forEach($17f526922e4a857c$var$Zc);
    $17f526922e4a857c$var$Pc.forEach($17f526922e4a857c$var$Zc);
}
function $17f526922e4a857c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $17f526922e4a857c$var$Jc || ($17f526922e4a857c$var$Jc = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $17f526922e4a857c$var$$c)));
}
function $17f526922e4a857c$var$bd(a) {
    function b(b) {
        return $17f526922e4a857c$var$ad(b, a);
    }
    if (0 < $17f526922e4a857c$var$Kc.length) {
        $17f526922e4a857c$var$ad($17f526922e4a857c$var$Kc[0], a);
        for(var c = 1; c < $17f526922e4a857c$var$Kc.length; c++){
            var d = $17f526922e4a857c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Lc, a);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Mc, a);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Nc, a);
    $17f526922e4a857c$var$Oc.forEach(b);
    $17f526922e4a857c$var$Pc.forEach(b);
    for(c = 0; c < $17f526922e4a857c$var$Qc.length; c++)d = $17f526922e4a857c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $17f526922e4a857c$var$Qc.length && (c = $17f526922e4a857c$var$Qc[0], null === c.blockedOn);)$17f526922e4a857c$var$Vc(c), null === c.blockedOn && $17f526922e4a857c$var$Qc.shift();
}
var $17f526922e4a857c$var$cd = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$dd = !0;
function $17f526922e4a857c$var$ed(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$gd(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 4, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$fd(a, b, c, d) {
    if ($17f526922e4a857c$var$dd) {
        var e = $17f526922e4a857c$var$Yc(a, b, c, d);
        if (null === e) $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c), $17f526922e4a857c$var$Sc(a, d);
        else if ($17f526922e4a857c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($17f526922e4a857c$var$Sc(a, d), b & 4 && -1 < $17f526922e4a857c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $17f526922e4a857c$var$Cb(e);
                null !== f && $17f526922e4a857c$var$Ec(f);
                f = $17f526922e4a857c$var$Yc(a, b, c, d);
                null === f && $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $17f526922e4a857c$var$hd(a, b, d, null, c);
    }
}
var $17f526922e4a857c$var$id = null;
function $17f526922e4a857c$var$Yc(a, b, c, d) {
    $17f526922e4a857c$var$id = null;
    a = $17f526922e4a857c$var$xb(d);
    a = $17f526922e4a857c$var$Wc(a);
    if (null !== a) {
        if (b = $17f526922e4a857c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $17f526922e4a857c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $17f526922e4a857c$var$id = a;
    return null;
}
function $17f526922e4a857c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($17f526922e4a857c$var$ec()){
                case $17f526922e4a857c$var$fc:
                    return 1;
                case $17f526922e4a857c$var$gc:
                    return 4;
                case $17f526922e4a857c$var$hc:
                case $17f526922e4a857c$var$ic:
                    return 16;
                case $17f526922e4a857c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ld = null, $17f526922e4a857c$var$md = null;
function $17f526922e4a857c$var$nd() {
    if ($17f526922e4a857c$var$md) return $17f526922e4a857c$var$md;
    var a, b = $17f526922e4a857c$var$ld, c = b.length, d, e = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $17f526922e4a857c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $17f526922e4a857c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $17f526922e4a857c$var$pd() {
    return !0;
}
function $17f526922e4a857c$var$qd() {
    return !1;
}
function $17f526922e4a857c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $17f526922e4a857c$var$pd : $17f526922e4a857c$var$qd;
        this.isPropagationStopped = $17f526922e4a857c$var$qd;
        return this;
    }
    $17f526922e4a857c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $17f526922e4a857c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $17f526922e4a857c$var$pd);
        },
        persist: function() {},
        isPersistent: $17f526922e4a857c$var$pd
    });
    return b;
}
var $17f526922e4a857c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $17f526922e4a857c$var$td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$sd), $17f526922e4a857c$var$ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    view: 0,
    detail: 0
}), $17f526922e4a857c$var$vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$ud), $17f526922e4a857c$var$wd, $17f526922e4a857c$var$xd, $17f526922e4a857c$var$yd, $17f526922e4a857c$var$Ad = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $17f526922e4a857c$var$yd && ($17f526922e4a857c$var$yd && "mousemove" === a.type ? ($17f526922e4a857c$var$wd = a.screenX - $17f526922e4a857c$var$yd.screenX, $17f526922e4a857c$var$xd = a.screenY - $17f526922e4a857c$var$yd.screenY) : $17f526922e4a857c$var$xd = $17f526922e4a857c$var$wd = 0, $17f526922e4a857c$var$yd = a);
        return $17f526922e4a857c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $17f526922e4a857c$var$xd;
    }
}), $17f526922e4a857c$var$Bd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ad), $17f526922e4a857c$var$Cd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    dataTransfer: 0
}), $17f526922e4a857c$var$Dd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Cd), $17f526922e4a857c$var$Ed = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    relatedTarget: 0
}), $17f526922e4a857c$var$Fd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ed), $17f526922e4a857c$var$Gd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Hd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Gd), $17f526922e4a857c$var$Id = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $17f526922e4a857c$var$Jd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Id), $17f526922e4a857c$var$Kd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    data: 0
}), $17f526922e4a857c$var$Ld = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Kd), $17f526922e4a857c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $17f526922e4a857c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $17f526922e4a857c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $17f526922e4a857c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $17f526922e4a857c$var$Od[a]) ? !!b[a] : !1;
}
function $17f526922e4a857c$var$zd() {
    return $17f526922e4a857c$var$Pd;
}
var $17f526922e4a857c$var$Qd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $17f526922e4a857c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $17f526922e4a857c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $17f526922e4a857c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $17f526922e4a857c$var$Rd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Qd), $17f526922e4a857c$var$Sd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $17f526922e4a857c$var$Td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Sd), $17f526922e4a857c$var$Ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $17f526922e4a857c$var$zd
}), $17f526922e4a857c$var$Vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ud), $17f526922e4a857c$var$Wd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Xd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Wd), $17f526922e4a857c$var$Yd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $17f526922e4a857c$var$Zd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Yd), $17f526922e4a857c$var$$d = [
    9,
    13,
    27,
    32
], $17f526922e4a857c$var$ae = $17f526922e4a857c$var$ia && "CompositionEvent" in window, $17f526922e4a857c$var$be = null;
$17f526922e4a857c$var$ia && "documentMode" in document && ($17f526922e4a857c$var$be = document.documentMode);
var $17f526922e4a857c$var$ce = $17f526922e4a857c$var$ia && "TextEvent" in window && !$17f526922e4a857c$var$be, $17f526922e4a857c$var$de = $17f526922e4a857c$var$ia && (!$17f526922e4a857c$var$ae || $17f526922e4a857c$var$be && 8 < $17f526922e4a857c$var$be && 11 >= $17f526922e4a857c$var$be), $17f526922e4a857c$var$ee = String.fromCharCode(32), $17f526922e4a857c$var$fe = !1;
function $17f526922e4a857c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $17f526922e4a857c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $17f526922e4a857c$var$ie = !1;
function $17f526922e4a857c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $17f526922e4a857c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $17f526922e4a857c$var$fe = !0;
            return $17f526922e4a857c$var$ee;
        case "textInput":
            return a = b.data, a === $17f526922e4a857c$var$ee && $17f526922e4a857c$var$fe ? null : a;
        default:
            return null;
    }
}
function $17f526922e4a857c$var$ke(a, b) {
    if ($17f526922e4a857c$var$ie) return "compositionend" === a || !$17f526922e4a857c$var$ae && $17f526922e4a857c$var$ge(a, b) ? (a = $17f526922e4a857c$var$nd(), $17f526922e4a857c$var$md = $17f526922e4a857c$var$ld = $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $17f526922e4a857c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $17f526922e4a857c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$17f526922e4a857c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $17f526922e4a857c$var$ne(a, b, c, d) {
    $17f526922e4a857c$var$Eb(d);
    b = $17f526922e4a857c$var$oe(b, "onChange");
    0 < b.length && (c = new $17f526922e4a857c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $17f526922e4a857c$var$pe = null, $17f526922e4a857c$var$qe = null;
function $17f526922e4a857c$var$re(a) {
    $17f526922e4a857c$var$se(a, 0);
}
function $17f526922e4a857c$var$te(a) {
    var b = $17f526922e4a857c$var$ue(a);
    if ($17f526922e4a857c$var$Wa(b)) return a;
}
function $17f526922e4a857c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $17f526922e4a857c$var$we = !1;
if ($17f526922e4a857c$var$ia) {
    var $17f526922e4a857c$var$xe;
    if ($17f526922e4a857c$var$ia) {
        var $17f526922e4a857c$var$ye = "oninput" in document;
        if (!$17f526922e4a857c$var$ye) {
            var $17f526922e4a857c$var$ze = document.createElement("div");
            $17f526922e4a857c$var$ze.setAttribute("oninput", "return;");
            $17f526922e4a857c$var$ye = "function" === typeof $17f526922e4a857c$var$ze.oninput;
        }
        $17f526922e4a857c$var$xe = $17f526922e4a857c$var$ye;
    } else $17f526922e4a857c$var$xe = !1;
    $17f526922e4a857c$var$we = $17f526922e4a857c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $17f526922e4a857c$var$Ae() {
    $17f526922e4a857c$var$pe && ($17f526922e4a857c$var$pe.detachEvent("onpropertychange", $17f526922e4a857c$var$Be), $17f526922e4a857c$var$qe = $17f526922e4a857c$var$pe = null);
}
function $17f526922e4a857c$var$Be(a) {
    if ("value" === a.propertyName && $17f526922e4a857c$var$te($17f526922e4a857c$var$qe)) {
        var b = [];
        $17f526922e4a857c$var$ne(b, $17f526922e4a857c$var$qe, a, $17f526922e4a857c$var$xb(a));
        $17f526922e4a857c$var$Jb($17f526922e4a857c$var$re, b);
    }
}
function $17f526922e4a857c$var$Ce(a, b, c) {
    "focusin" === a ? ($17f526922e4a857c$var$Ae(), $17f526922e4a857c$var$pe = b, $17f526922e4a857c$var$qe = c, $17f526922e4a857c$var$pe.attachEvent("onpropertychange", $17f526922e4a857c$var$Be)) : "focusout" === a && $17f526922e4a857c$var$Ae();
}
function $17f526922e4a857c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $17f526922e4a857c$var$te($17f526922e4a857c$var$qe);
}
function $17f526922e4a857c$var$Ee(a, b) {
    if ("click" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $17f526922e4a857c$var$He = "function" === typeof Object.is ? Object.is : $17f526922e4a857c$var$Ge;
function $17f526922e4a857c$var$Ie(a, b) {
    if ($17f526922e4a857c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$17f526922e4a857c$var$ja.call(b, e) || !$17f526922e4a857c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $17f526922e4a857c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $17f526922e4a857c$var$Ke(a, b) {
    var c = $17f526922e4a857c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $17f526922e4a857c$var$Je(c);
    }
}
function $17f526922e4a857c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $17f526922e4a857c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $17f526922e4a857c$var$Me() {
    for(var a = window, b = $17f526922e4a857c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $17f526922e4a857c$var$Xa(a.document);
    }
    return b;
}
function $17f526922e4a857c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $17f526922e4a857c$var$Oe(a) {
    var b = $17f526922e4a857c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $17f526922e4a857c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $17f526922e4a857c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $17f526922e4a857c$var$Ke(c, f);
                var g = $17f526922e4a857c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $17f526922e4a857c$var$Pe = $17f526922e4a857c$var$ia && "documentMode" in document && 11 >= document.documentMode, $17f526922e4a857c$var$Qe = null, $17f526922e4a857c$var$Re = null, $17f526922e4a857c$var$Se = null, $17f526922e4a857c$var$Te = !1;
function $17f526922e4a857c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $17f526922e4a857c$var$Te || null == $17f526922e4a857c$var$Qe || $17f526922e4a857c$var$Qe !== $17f526922e4a857c$var$Xa(d) || (d = $17f526922e4a857c$var$Qe, "selectionStart" in d && $17f526922e4a857c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $17f526922e4a857c$var$Se && $17f526922e4a857c$var$Ie($17f526922e4a857c$var$Se, d) || ($17f526922e4a857c$var$Se = d, d = $17f526922e4a857c$var$oe($17f526922e4a857c$var$Re, "onSelect"), 0 < d.length && (b = new $17f526922e4a857c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $17f526922e4a857c$var$Qe)));
}
function $17f526922e4a857c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $17f526922e4a857c$var$We = {
    animationend: $17f526922e4a857c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $17f526922e4a857c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $17f526922e4a857c$var$Ve("Animation", "AnimationStart"),
    transitionend: $17f526922e4a857c$var$Ve("Transition", "TransitionEnd")
}, $17f526922e4a857c$var$Xe = {}, $17f526922e4a857c$var$Ye = {};
$17f526922e4a857c$var$ia && ($17f526922e4a857c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $17f526922e4a857c$var$We.animationend.animation, delete $17f526922e4a857c$var$We.animationiteration.animation, delete $17f526922e4a857c$var$We.animationstart.animation), "TransitionEvent" in window || delete $17f526922e4a857c$var$We.transitionend.transition);
function $17f526922e4a857c$var$Ze(a) {
    if ($17f526922e4a857c$var$Xe[a]) return $17f526922e4a857c$var$Xe[a];
    if (!$17f526922e4a857c$var$We[a]) return a;
    var b = $17f526922e4a857c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $17f526922e4a857c$var$Ye) return $17f526922e4a857c$var$Xe[a] = b[c];
    return a;
}
var $17f526922e4a857c$var$$e = $17f526922e4a857c$var$Ze("animationend"), $17f526922e4a857c$var$af = $17f526922e4a857c$var$Ze("animationiteration"), $17f526922e4a857c$var$bf = $17f526922e4a857c$var$Ze("animationstart"), $17f526922e4a857c$var$cf = $17f526922e4a857c$var$Ze("transitionend"), $17f526922e4a857c$var$df = new Map, $17f526922e4a857c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $17f526922e4a857c$var$ff(a, b) {
    $17f526922e4a857c$var$df.set(a, b);
    $17f526922e4a857c$var$fa(b, [
        a
    ]);
}
for(var $17f526922e4a857c$var$gf = 0; $17f526922e4a857c$var$gf < $17f526922e4a857c$var$ef.length; $17f526922e4a857c$var$gf++){
    var $17f526922e4a857c$var$hf = $17f526922e4a857c$var$ef[$17f526922e4a857c$var$gf], $17f526922e4a857c$var$jf = $17f526922e4a857c$var$hf.toLowerCase(), $17f526922e4a857c$var$kf = $17f526922e4a857c$var$hf[0].toUpperCase() + $17f526922e4a857c$var$hf.slice(1);
    $17f526922e4a857c$var$ff($17f526922e4a857c$var$jf, "on" + $17f526922e4a857c$var$kf);
}
$17f526922e4a857c$var$ff($17f526922e4a857c$var$$e, "onAnimationEnd");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$af, "onAnimationIteration");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$bf, "onAnimationStart");
$17f526922e4a857c$var$ff("dblclick", "onDoubleClick");
$17f526922e4a857c$var$ff("focusin", "onFocus");
$17f526922e4a857c$var$ff("focusout", "onBlur");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$cf, "onTransitionEnd");
$17f526922e4a857c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$17f526922e4a857c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $17f526922e4a857c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $17f526922e4a857c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($17f526922e4a857c$var$lf));
function $17f526922e4a857c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $17f526922e4a857c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $17f526922e4a857c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($17f526922e4a857c$var$Qb) throw a = $17f526922e4a857c$var$Rb, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, a;
}
function $17f526922e4a857c$var$D(a, b) {
    var c = b[$17f526922e4a857c$var$of];
    void 0 === c && (c = b[$17f526922e4a857c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($17f526922e4a857c$var$pf(b, a, 2, !1), c.add(d));
}
function $17f526922e4a857c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $17f526922e4a857c$var$pf(c, a, d, b);
}
var $17f526922e4a857c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $17f526922e4a857c$var$sf(a) {
    if (!a[$17f526922e4a857c$var$rf]) {
        a[$17f526922e4a857c$var$rf] = !0;
        $17f526922e4a857c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($17f526922e4a857c$var$mf.has(b) || $17f526922e4a857c$var$qf(b, !1, a), $17f526922e4a857c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$17f526922e4a857c$var$rf] || (b[$17f526922e4a857c$var$rf] = !0, $17f526922e4a857c$var$qf("selectionchange", !1, b));
    }
}
function $17f526922e4a857c$var$pf(a, b, c, d) {
    switch($17f526922e4a857c$var$jd(b)){
        case 1:
            var e = $17f526922e4a857c$var$ed;
            break;
        case 4:
            e = $17f526922e4a857c$var$gd;
            break;
        default:
            e = $17f526922e4a857c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$17f526922e4a857c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $17f526922e4a857c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $17f526922e4a857c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $17f526922e4a857c$var$Jb(function() {
        var d = f, e = $17f526922e4a857c$var$xb(c), g = [];
        a: {
            var h = $17f526922e4a857c$var$df.get(a);
            if (void 0 !== h) {
                var k = $17f526922e4a857c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $17f526922e4a857c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $17f526922e4a857c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $17f526922e4a857c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $17f526922e4a857c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $17f526922e4a857c$var$Vd;
                        break;
                    case $17f526922e4a857c$var$$e:
                    case $17f526922e4a857c$var$af:
                    case $17f526922e4a857c$var$bf:
                        k = $17f526922e4a857c$var$Hd;
                        break;
                    case $17f526922e4a857c$var$cf:
                        k = $17f526922e4a857c$var$Xd;
                        break;
                    case "scroll":
                        k = $17f526922e4a857c$var$vd;
                        break;
                    case "wheel":
                        k = $17f526922e4a857c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $17f526922e4a857c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $17f526922e4a857c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $17f526922e4a857c$var$Kb(w, x), null != F && t.push($17f526922e4a857c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $17f526922e4a857c$var$wb && (n = c.relatedTarget || c.fromElement) && ($17f526922e4a857c$var$Wc(n) || n[$17f526922e4a857c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $17f526922e4a857c$var$Wc(n) : null, null !== n && (J = $17f526922e4a857c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $17f526922e4a857c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $17f526922e4a857c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $17f526922e4a857c$var$ue(k);
                        u = null == n ? h : $17f526922e4a857c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $17f526922e4a857c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $17f526922e4a857c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $17f526922e4a857c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $17f526922e4a857c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $17f526922e4a857c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $17f526922e4a857c$var$vf(t);
                                x = $17f526922e4a857c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $17f526922e4a857c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $17f526922e4a857c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $17f526922e4a857c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $17f526922e4a857c$var$ve;
                else if ($17f526922e4a857c$var$me(h)) {
                    if ($17f526922e4a857c$var$we) na = $17f526922e4a857c$var$Fe;
                    else {
                        na = $17f526922e4a857c$var$De;
                        var xa = $17f526922e4a857c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $17f526922e4a857c$var$Ee);
                if (na && (na = na(a, d))) {
                    $17f526922e4a857c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $17f526922e4a857c$var$cb(h, "number", h.value);
            }
            xa = d ? $17f526922e4a857c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($17f526922e4a857c$var$me(xa) || "true" === xa.contentEditable) $17f526922e4a857c$var$Qe = xa, $17f526922e4a857c$var$Re = d, $17f526922e4a857c$var$Se = null;
                    break;
                case "focusout":
                    $17f526922e4a857c$var$Se = $17f526922e4a857c$var$Re = $17f526922e4a857c$var$Qe = null;
                    break;
                case "mousedown":
                    $17f526922e4a857c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $17f526922e4a857c$var$Te = !1;
                    $17f526922e4a857c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($17f526922e4a857c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $17f526922e4a857c$var$Ue(g, c, e);
            }
            var $a;
            if ($17f526922e4a857c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $17f526922e4a857c$var$ie ? $17f526922e4a857c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($17f526922e4a857c$var$de && "ko" !== c.locale && ($17f526922e4a857c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $17f526922e4a857c$var$ie && ($a = $17f526922e4a857c$var$nd()) : ($17f526922e4a857c$var$kd = e, $17f526922e4a857c$var$ld = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, $17f526922e4a857c$var$ie = !0)), xa = $17f526922e4a857c$var$oe(d, ba), 0 < xa.length && (ba = new $17f526922e4a857c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $17f526922e4a857c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $17f526922e4a857c$var$ce ? $17f526922e4a857c$var$je(a, c) : $17f526922e4a857c$var$ke(a, c)) d = $17f526922e4a857c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $17f526922e4a857c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $17f526922e4a857c$var$se(g, b);
    });
}
function $17f526922e4a857c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $17f526922e4a857c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $17f526922e4a857c$var$Kb(a, c), null != f && d.unshift($17f526922e4a857c$var$tf(a, f, e)), f = $17f526922e4a857c$var$Kb(a, b), null != f && d.push($17f526922e4a857c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $17f526922e4a857c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $17f526922e4a857c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.unshift($17f526922e4a857c$var$tf(c, k, h))) : e || (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.push($17f526922e4a857c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $17f526922e4a857c$var$xf = /\r\n?/g, $17f526922e4a857c$var$yf = /\u0000|\uFFFD/g;
function $17f526922e4a857c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($17f526922e4a857c$var$xf, "\n").replace($17f526922e4a857c$var$yf, "");
}
function $17f526922e4a857c$var$Af(a, b, c) {
    b = $17f526922e4a857c$var$zf(b);
    if ($17f526922e4a857c$var$zf(a) !== b && c) throw Error($17f526922e4a857c$var$p(425));
}
function $17f526922e4a857c$var$Bf() {}
var $17f526922e4a857c$var$Cf = null, $17f526922e4a857c$var$Df = null;
function $17f526922e4a857c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $17f526922e4a857c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $17f526922e4a857c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $17f526922e4a857c$var$Hf = "function" === typeof Promise ? Promise : void 0, $17f526922e4a857c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $17f526922e4a857c$var$Hf ? function(a) {
    return $17f526922e4a857c$var$Hf.resolve(null).then(a).catch($17f526922e4a857c$var$If);
} : $17f526922e4a857c$var$Ff;
function $17f526922e4a857c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $17f526922e4a857c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $17f526922e4a857c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $17f526922e4a857c$var$bd(b);
}
function $17f526922e4a857c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $17f526922e4a857c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nf = Math.random().toString(36).slice(2), $17f526922e4a857c$var$Of = "__reactFiber$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Pf = "__reactProps$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$uf = "__reactContainer$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$of = "__reactEvents$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Qf = "__reactListeners$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Rf = "__reactHandles$" + $17f526922e4a857c$var$Nf;
function $17f526922e4a857c$var$Wc(a) {
    var b = a[$17f526922e4a857c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$17f526922e4a857c$var$uf] || c[$17f526922e4a857c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $17f526922e4a857c$var$Mf(a); null !== a;){
                if (c = a[$17f526922e4a857c$var$Of]) return c;
                a = $17f526922e4a857c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $17f526922e4a857c$var$Cb(a) {
    a = a[$17f526922e4a857c$var$Of] || a[$17f526922e4a857c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $17f526922e4a857c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($17f526922e4a857c$var$p(33));
}
function $17f526922e4a857c$var$Db(a) {
    return a[$17f526922e4a857c$var$Pf] || null;
}
var $17f526922e4a857c$var$Sf = [], $17f526922e4a857c$var$Tf = -1;
function $17f526922e4a857c$var$Uf(a) {
    return {
        current: a
    };
}
function $17f526922e4a857c$var$E(a) {
    0 > $17f526922e4a857c$var$Tf || (a.current = $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf], $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = null, $17f526922e4a857c$var$Tf--);
}
function $17f526922e4a857c$var$G(a, b) {
    $17f526922e4a857c$var$Tf++;
    $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = a.current;
    a.current = b;
}
var $17f526922e4a857c$var$Vf = {}, $17f526922e4a857c$var$H = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Vf), $17f526922e4a857c$var$Wf = $17f526922e4a857c$var$Uf(!1), $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$Vf;
function $17f526922e4a857c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $17f526922e4a857c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $17f526922e4a857c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $17f526922e4a857c$var$$f() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
}
function $17f526922e4a857c$var$ag(a, b, c) {
    if ($17f526922e4a857c$var$H.current !== $17f526922e4a857c$var$Vf) throw Error($17f526922e4a857c$var$p(168));
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
function $17f526922e4a857c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($17f526922e4a857c$var$p(108, $17f526922e4a857c$var$Ra(a) || "Unknown", e));
    return $17f526922e4a857c$var$A({}, c, d);
}
function $17f526922e4a857c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $17f526922e4a857c$var$Vf;
    $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$H.current;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, $17f526922e4a857c$var$Wf.current);
    return !0;
}
function $17f526922e4a857c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($17f526922e4a857c$var$p(169));
    c ? (a = $17f526922e4a857c$var$bg(a, b, $17f526922e4a857c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a)) : $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
var $17f526922e4a857c$var$eg = null, $17f526922e4a857c$var$fg = !1, $17f526922e4a857c$var$gg = !1;
function $17f526922e4a857c$var$hg(a) {
    null === $17f526922e4a857c$var$eg ? $17f526922e4a857c$var$eg = [
        a
    ] : $17f526922e4a857c$var$eg.push(a);
}
function $17f526922e4a857c$var$ig(a) {
    $17f526922e4a857c$var$fg = !0;
    $17f526922e4a857c$var$hg(a);
}
function $17f526922e4a857c$var$jg() {
    if (!$17f526922e4a857c$var$gg && null !== $17f526922e4a857c$var$eg) {
        $17f526922e4a857c$var$gg = !0;
        var a = 0, b = $17f526922e4a857c$var$C;
        try {
            var c = $17f526922e4a857c$var$eg;
            for($17f526922e4a857c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $17f526922e4a857c$var$eg = null;
            $17f526922e4a857c$var$fg = !1;
        } catch (e) {
            throw null !== $17f526922e4a857c$var$eg && ($17f526922e4a857c$var$eg = $17f526922e4a857c$var$eg.slice(a + 1)), $17f526922e4a857c$var$ac($17f526922e4a857c$var$fc, $17f526922e4a857c$var$jg), e;
        } finally{
            $17f526922e4a857c$var$C = b, $17f526922e4a857c$var$gg = !1;
        }
    }
    return null;
}
var $17f526922e4a857c$var$kg = [], $17f526922e4a857c$var$lg = 0, $17f526922e4a857c$var$mg = null, $17f526922e4a857c$var$ng = 0, $17f526922e4a857c$var$og = [], $17f526922e4a857c$var$pg = 0, $17f526922e4a857c$var$qg = null, $17f526922e4a857c$var$rg = 1, $17f526922e4a857c$var$sg = "";
function $17f526922e4a857c$var$tg(a, b) {
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$ng;
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$mg;
    $17f526922e4a857c$var$mg = a;
    $17f526922e4a857c$var$ng = b;
}
function $17f526922e4a857c$var$ug(a, b, c) {
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg;
    $17f526922e4a857c$var$qg = a;
    var d = $17f526922e4a857c$var$rg;
    a = $17f526922e4a857c$var$sg;
    var e = 32 - $17f526922e4a857c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $17f526922e4a857c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $17f526922e4a857c$var$rg = 1 << 32 - $17f526922e4a857c$var$oc(b) + e | c << e | d;
        $17f526922e4a857c$var$sg = f + a;
    } else $17f526922e4a857c$var$rg = 1 << f | c << e | d, $17f526922e4a857c$var$sg = a;
}
function $17f526922e4a857c$var$vg(a) {
    null !== a.return && ($17f526922e4a857c$var$tg(a, 1), $17f526922e4a857c$var$ug(a, 1, 0));
}
function $17f526922e4a857c$var$wg(a) {
    for(; a === $17f526922e4a857c$var$mg;)$17f526922e4a857c$var$mg = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null, $17f526922e4a857c$var$ng = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null;
    for(; a === $17f526922e4a857c$var$qg;)$17f526922e4a857c$var$qg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$sg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$rg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null;
}
var $17f526922e4a857c$var$xg = null, $17f526922e4a857c$var$yg = null, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$zg = null;
function $17f526922e4a857c$var$Ag(a, b) {
    var c = $17f526922e4a857c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $17f526922e4a857c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $17f526922e4a857c$var$qg ? {
                id: $17f526922e4a857c$var$rg,
                overflow: $17f526922e4a857c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $17f526922e4a857c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $17f526922e4a857c$var$Eg(a) {
    if ($17f526922e4a857c$var$I) {
        var b = $17f526922e4a857c$var$yg;
        if (b) {
            var c = b;
            if (!$17f526922e4a857c$var$Cg(a, b)) {
                if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
                b = $17f526922e4a857c$var$Lf(c.nextSibling);
                var d = $17f526922e4a857c$var$xg;
                b && $17f526922e4a857c$var$Cg(a, b) ? $17f526922e4a857c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$xg = a);
            }
        } else {
            if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $17f526922e4a857c$var$I = !1;
            $17f526922e4a857c$var$xg = a;
        }
    }
}
function $17f526922e4a857c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $17f526922e4a857c$var$xg = a;
}
function $17f526922e4a857c$var$Gg(a) {
    if (a !== $17f526922e4a857c$var$xg) return !1;
    if (!$17f526922e4a857c$var$I) return $17f526922e4a857c$var$Fg(a), $17f526922e4a857c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$17f526922e4a857c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $17f526922e4a857c$var$yg)) {
        if ($17f526922e4a857c$var$Dg(a)) throw $17f526922e4a857c$var$Hg(), Error($17f526922e4a857c$var$p(418));
        for(; b;)$17f526922e4a857c$var$Ag(a, b), b = $17f526922e4a857c$var$Lf(b.nextSibling);
    }
    $17f526922e4a857c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($17f526922e4a857c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $17f526922e4a857c$var$yg = null;
        }
    } else $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg ? $17f526922e4a857c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $17f526922e4a857c$var$Hg() {
    for(var a = $17f526922e4a857c$var$yg; a;)a = $17f526922e4a857c$var$Lf(a.nextSibling);
}
function $17f526922e4a857c$var$Ig() {
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg = null;
    $17f526922e4a857c$var$I = !1;
}
function $17f526922e4a857c$var$Jg(a) {
    null === $17f526922e4a857c$var$zg ? $17f526922e4a857c$var$zg = [
        a
    ] : $17f526922e4a857c$var$zg.push(a);
}
var $17f526922e4a857c$var$Kg = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig;
function $17f526922e4a857c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($17f526922e4a857c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($17f526922e4a857c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($17f526922e4a857c$var$p(284));
        if (!c._owner) throw Error($17f526922e4a857c$var$p(290, a));
    }
    return a;
}
function $17f526922e4a857c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($17f526922e4a857c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $17f526922e4a857c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $17f526922e4a857c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $17f526922e4a857c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $17f526922e4a857c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $17f526922e4a857c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $17f526922e4a857c$var$Lg(a, b, c), d.return = a, d;
        d = $17f526922e4a857c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $17f526922e4a857c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $17f526922e4a857c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $17f526922e4a857c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $17f526922e4a857c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c = $17f526922e4a857c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $17f526922e4a857c$var$Lg(a, null, b), c.return = a, c;
                case $17f526922e4a857c$var$wa:
                    return b = $17f526922e4a857c$var$Sg(b, a.mode, c), b.return = a, b;
                case $17f526922e4a857c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($17f526922e4a857c$var$eb(b) || $17f526922e4a857c$var$Ka(b)) return b = $17f526922e4a857c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $17f526922e4a857c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $17f526922e4a857c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $17f526922e4a857c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($17f526922e4a857c$var$eb(c) || $17f526922e4a857c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $17f526922e4a857c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $17f526922e4a857c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $17f526922e4a857c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $17f526922e4a857c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($17f526922e4a857c$var$eb(d) || $17f526922e4a857c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $17f526922e4a857c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $17f526922e4a857c$var$Ka(h);
        if ("function" !== typeof l) throw Error($17f526922e4a857c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($17f526922e4a857c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $17f526922e4a857c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $17f526922e4a857c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $17f526922e4a857c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $17f526922e4a857c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $17f526922e4a857c$var$ya ? (d = $17f526922e4a857c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $17f526922e4a857c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $17f526922e4a857c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $17f526922e4a857c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $17f526922e4a857c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $17f526922e4a857c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($17f526922e4a857c$var$eb(f)) return n(a, d, f, h);
            if ($17f526922e4a857c$var$Ka(f)) return t(a, d, f, h);
            $17f526922e4a857c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $17f526922e4a857c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $17f526922e4a857c$var$Ug = $17f526922e4a857c$var$Og(!0), $17f526922e4a857c$var$Vg = $17f526922e4a857c$var$Og(!1), $17f526922e4a857c$var$Wg = $17f526922e4a857c$var$Uf(null), $17f526922e4a857c$var$Xg = null, $17f526922e4a857c$var$Yg = null, $17f526922e4a857c$var$Zg = null;
function $17f526922e4a857c$var$$g() {
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Xg = null;
}
function $17f526922e4a857c$var$ah(a) {
    var b = $17f526922e4a857c$var$Wg.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wg);
    a._currentValue = b;
}
function $17f526922e4a857c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $17f526922e4a857c$var$ch(a, b) {
    $17f526922e4a857c$var$Xg = a;
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($17f526922e4a857c$var$dh = !0), a.firstContext = null);
}
function $17f526922e4a857c$var$eh(a) {
    var b = a._currentValue;
    if ($17f526922e4a857c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $17f526922e4a857c$var$Yg) {
            if (null === $17f526922e4a857c$var$Xg) throw Error($17f526922e4a857c$var$p(308));
            $17f526922e4a857c$var$Yg = a;
            $17f526922e4a857c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Yg.next = a;
    }
    return b;
}
var $17f526922e4a857c$var$fh = null;
function $17f526922e4a857c$var$gh(a) {
    null === $17f526922e4a857c$var$fh ? $17f526922e4a857c$var$fh = [
        a
    ] : $17f526922e4a857c$var$fh.push(a);
}
function $17f526922e4a857c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $17f526922e4a857c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $17f526922e4a857c$var$ih(a, d);
}
function $17f526922e4a857c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $17f526922e4a857c$var$jh = !1;
function $17f526922e4a857c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $17f526922e4a857c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $17f526922e4a857c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $17f526922e4a857c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($17f526922e4a857c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $17f526922e4a857c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $17f526922e4a857c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $17f526922e4a857c$var$ih(a, c);
}
function $17f526922e4a857c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
function $17f526922e4a857c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $17f526922e4a857c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $17f526922e4a857c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $17f526922e4a857c$var$A({}, q, r);
                            break a;
                        case 2:
                            $17f526922e4a857c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $17f526922e4a857c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $17f526922e4a857c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($17f526922e4a857c$var$p(191, e));
            e.call(d);
        }
    }
}
var $17f526922e4a857c$var$th = {}, $17f526922e4a857c$var$uh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$vh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$wh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th);
function $17f526922e4a857c$var$xh(a) {
    if (a === $17f526922e4a857c$var$th) throw Error($17f526922e4a857c$var$p(174));
    return a;
}
function $17f526922e4a857c$var$yh(a, b) {
    $17f526922e4a857c$var$G($17f526922e4a857c$var$wh, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, $17f526922e4a857c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $17f526922e4a857c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $17f526922e4a857c$var$lb(b, a);
    }
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, b);
}
function $17f526922e4a857c$var$zh() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$vh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$wh);
}
function $17f526922e4a857c$var$Ah(a) {
    $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
    var b = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
    var c = $17f526922e4a857c$var$lb(b, a.type);
    b !== c && ($17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a), $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, c));
}
function $17f526922e4a857c$var$Bh(a) {
    $17f526922e4a857c$var$vh.current === a && ($17f526922e4a857c$var$E($17f526922e4a857c$var$uh), $17f526922e4a857c$var$E($17f526922e4a857c$var$vh));
}
var $17f526922e4a857c$var$L = $17f526922e4a857c$var$Uf(0);
function $17f526922e4a857c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$Dh = [];
function $17f526922e4a857c$var$Eh() {
    for(var a = 0; a < $17f526922e4a857c$var$Dh.length; a++)$17f526922e4a857c$var$Dh[a]._workInProgressVersionPrimary = null;
    $17f526922e4a857c$var$Dh.length = 0;
}
var $17f526922e4a857c$var$Fh = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$Gh = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$Hh = 0, $17f526922e4a857c$var$M = null, $17f526922e4a857c$var$N = null, $17f526922e4a857c$var$O = null, $17f526922e4a857c$var$Ih = !1, $17f526922e4a857c$var$Jh = !1, $17f526922e4a857c$var$Kh = 0, $17f526922e4a857c$var$Lh = 0;
function $17f526922e4a857c$var$P() {
    throw Error($17f526922e4a857c$var$p(321));
}
function $17f526922e4a857c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$17f526922e4a857c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $17f526922e4a857c$var$Nh(a, b, c, d, e, f) {
    $17f526922e4a857c$var$Hh = f;
    $17f526922e4a857c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $17f526922e4a857c$var$Fh.current = null === a || null === a.memoizedState ? $17f526922e4a857c$var$Oh : $17f526922e4a857c$var$Ph;
    a = c(d, e);
    if ($17f526922e4a857c$var$Jh) {
        f = 0;
        do {
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            if (25 <= f) throw Error($17f526922e4a857c$var$p(301));
            f += 1;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
            b.updateQueue = null;
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Qh;
            a = c(d, e);
        }while ($17f526922e4a857c$var$Jh);
    }
    $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
    b = null !== $17f526922e4a857c$var$N && null !== $17f526922e4a857c$var$N.next;
    $17f526922e4a857c$var$Hh = 0;
    $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
    $17f526922e4a857c$var$Ih = !1;
    if (b) throw Error($17f526922e4a857c$var$p(300));
    return a;
}
function $17f526922e4a857c$var$Sh() {
    var a = 0 !== $17f526922e4a857c$var$Kh;
    $17f526922e4a857c$var$Kh = 0;
    return a;
}
function $17f526922e4a857c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Uh() {
    if (null === $17f526922e4a857c$var$N) {
        var a = $17f526922e4a857c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $17f526922e4a857c$var$N.next;
    var b = null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState : $17f526922e4a857c$var$O.next;
    if (null !== b) $17f526922e4a857c$var$O = b, $17f526922e4a857c$var$N = a;
    else {
        if (null === a) throw Error($17f526922e4a857c$var$p(310));
        $17f526922e4a857c$var$N = a;
        a = {
            memoizedState: $17f526922e4a857c$var$N.memoizedState,
            baseState: $17f526922e4a857c$var$N.baseState,
            baseQueue: $17f526922e4a857c$var$N.baseQueue,
            queue: $17f526922e4a857c$var$N.queue,
            next: null
        };
        null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    }
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $17f526922e4a857c$var$Wh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $17f526922e4a857c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($17f526922e4a857c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $17f526922e4a857c$var$M.lanes |= m;
                $17f526922e4a857c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $17f526922e4a857c$var$He(d, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $17f526922e4a857c$var$M.lanes |= f, $17f526922e4a857c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $17f526922e4a857c$var$Xh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $17f526922e4a857c$var$He(f, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $17f526922e4a857c$var$Yh() {}
function $17f526922e4a857c$var$Zh(a, b) {
    var c = $17f526922e4a857c$var$M, d = $17f526922e4a857c$var$Uh(), e = b(), f = !$17f526922e4a857c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $17f526922e4a857c$var$dh = !0);
    d = d.queue;
    $17f526922e4a857c$var$$h($17f526922e4a857c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $17f526922e4a857c$var$O && $17f526922e4a857c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
        0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(c, b, e);
    }
    return e;
}
function $17f526922e4a857c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $17f526922e4a857c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
}
function $17f526922e4a857c$var$ai(a, b, c) {
    return c(function() {
        $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
    });
}
function $17f526922e4a857c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$17f526922e4a857c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $17f526922e4a857c$var$fi(a) {
    var b = $17f526922e4a857c$var$ih(a, 1);
    null !== b && $17f526922e4a857c$var$gi(b, a, 1, -1);
}
function $17f526922e4a857c$var$hi(a) {
    var b = $17f526922e4a857c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $17f526922e4a857c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $17f526922e4a857c$var$ii.bind(null, $17f526922e4a857c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $17f526922e4a857c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $17f526922e4a857c$var$ji() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$ki(a, b, c, d) {
    var e = $17f526922e4a857c$var$Th();
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $17f526922e4a857c$var$li(a, b, c, d) {
    var e = $17f526922e4a857c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $17f526922e4a857c$var$N) {
        var g = $17f526922e4a857c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $17f526922e4a857c$var$Mh(d, g.deps)) {
            e.memoizedState = $17f526922e4a857c$var$bi(b, c, f, d);
            return;
        }
    }
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, f, d);
}
function $17f526922e4a857c$var$mi(a, b) {
    return $17f526922e4a857c$var$ki(8390656, 8, a, b);
}
function $17f526922e4a857c$var$$h(a, b) {
    return $17f526922e4a857c$var$li(2048, 8, a, b);
}
function $17f526922e4a857c$var$ni(a, b) {
    return $17f526922e4a857c$var$li(4, 2, a, b);
}
function $17f526922e4a857c$var$oi(a, b) {
    return $17f526922e4a857c$var$li(4, 4, a, b);
}
function $17f526922e4a857c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $17f526922e4a857c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $17f526922e4a857c$var$li(4, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
}
function $17f526922e4a857c$var$ri() {}
function $17f526922e4a857c$var$si(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ti(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ui(a, b, c) {
    if (0 === ($17f526922e4a857c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $17f526922e4a857c$var$dh = !0), a.memoizedState = c;
    $17f526922e4a857c$var$He(c, b) || (c = $17f526922e4a857c$var$yc(), $17f526922e4a857c$var$M.lanes |= c, $17f526922e4a857c$var$rh |= c, a.baseState = !0);
    return b;
}
function $17f526922e4a857c$var$vi(a, b) {
    var c = $17f526922e4a857c$var$C;
    $17f526922e4a857c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $17f526922e4a857c$var$Gh.transition;
    $17f526922e4a857c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$Gh.transition = d;
    }
}
function $17f526922e4a857c$var$wi() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$xi(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, c);
    else if (c = $17f526922e4a857c$var$hh(a, b, c, d), null !== c) {
        var e = $17f526922e4a857c$var$R();
        $17f526922e4a857c$var$gi(c, a, d, e);
        $17f526922e4a857c$var$Bi(c, b, d);
    }
}
function $17f526922e4a857c$var$ii(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($17f526922e4a857c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $17f526922e4a857c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $17f526922e4a857c$var$hh(a, b, e, d);
        null !== c && (e = $17f526922e4a857c$var$R(), $17f526922e4a857c$var$gi(c, a, d, e), $17f526922e4a857c$var$Bi(c, b, d));
    }
}
function $17f526922e4a857c$var$zi(a) {
    var b = a.alternate;
    return a === $17f526922e4a857c$var$M || null !== b && b === $17f526922e4a857c$var$M;
}
function $17f526922e4a857c$var$Ai(a, b) {
    $17f526922e4a857c$var$Jh = $17f526922e4a857c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $17f526922e4a857c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
var $17f526922e4a857c$var$Rh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$P,
    useContext: $17f526922e4a857c$var$P,
    useEffect: $17f526922e4a857c$var$P,
    useImperativeHandle: $17f526922e4a857c$var$P,
    useInsertionEffect: $17f526922e4a857c$var$P,
    useLayoutEffect: $17f526922e4a857c$var$P,
    useMemo: $17f526922e4a857c$var$P,
    useReducer: $17f526922e4a857c$var$P,
    useRef: $17f526922e4a857c$var$P,
    useState: $17f526922e4a857c$var$P,
    useDebugValue: $17f526922e4a857c$var$P,
    useDeferredValue: $17f526922e4a857c$var$P,
    useTransition: $17f526922e4a857c$var$P,
    useMutableSource: $17f526922e4a857c$var$P,
    useSyncExternalStore: $17f526922e4a857c$var$P,
    useId: $17f526922e4a857c$var$P,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Oh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: function(a, b) {
        $17f526922e4a857c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $17f526922e4a857c$var$ki(4194308, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $17f526922e4a857c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $17f526922e4a857c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $17f526922e4a857c$var$xi.bind(null, $17f526922e4a857c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $17f526922e4a857c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $17f526922e4a857c$var$hi,
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        return $17f526922e4a857c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$hi(!1), b = a[0];
        a = $17f526922e4a857c$var$vi.bind(null, a[1]);
        $17f526922e4a857c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $17f526922e4a857c$var$M, e = $17f526922e4a857c$var$Th();
        if ($17f526922e4a857c$var$I) {
            if (void 0 === c) throw Error($17f526922e4a857c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
            0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $17f526922e4a857c$var$mi($17f526922e4a857c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $17f526922e4a857c$var$Th(), b = $17f526922e4a857c$var$Q.identifierPrefix;
        if ($17f526922e4a857c$var$I) {
            var c = $17f526922e4a857c$var$sg;
            var d = $17f526922e4a857c$var$rg;
            c = (d & ~(1 << 32 - $17f526922e4a857c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $17f526922e4a857c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $17f526922e4a857c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Ph = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Wh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Qh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Xh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return null === $17f526922e4a857c$var$N ? b.memoizedState = a : $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
};
function $17f526922e4a857c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $17f526922e4a857c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $17f526922e4a857c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17f526922e4a857c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $17f526922e4a857c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $17f526922e4a857c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $17f526922e4a857c$var$R(), d = $17f526922e4a857c$var$yi(a), e = $17f526922e4a857c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $17f526922e4a857c$var$nh(a, e, d);
        null !== b && ($17f526922e4a857c$var$gi(b, a, d, c), $17f526922e4a857c$var$oh(b, a, d));
    }
};
function $17f526922e4a857c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$17f526922e4a857c$var$Ie(c, d) || !$17f526922e4a857c$var$Ie(e, f) : !0;
}
function $17f526922e4a857c$var$Gi(a, b, c) {
    var d = !1, e = $17f526922e4a857c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $17f526922e4a857c$var$eh(f) : (e = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $17f526922e4a857c$var$Yf(a, e) : $17f526922e4a857c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $17f526922e4a857c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $17f526922e4a857c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $17f526922e4a857c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $17f526922e4a857c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $17f526922e4a857c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $17f526922e4a857c$var$eh(f) : (f = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, e.context = $17f526922e4a857c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($17f526922e4a857c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $17f526922e4a857c$var$Ei.enqueueReplaceState(e, e.state, null), $17f526922e4a857c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $17f526922e4a857c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $17f526922e4a857c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $17f526922e4a857c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $17f526922e4a857c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $17f526922e4a857c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $17f526922e4a857c$var$Ni(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $17f526922e4a857c$var$Oi || ($17f526922e4a857c$var$Oi = !0, $17f526922e4a857c$var$Pi = d);
        $17f526922e4a857c$var$Li(a, b);
    };
    return c;
}
function $17f526922e4a857c$var$Qi(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $17f526922e4a857c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $17f526922e4a857c$var$Li(a, b);
        "function" !== typeof d && (null === $17f526922e4a857c$var$Ri ? $17f526922e4a857c$var$Ri = new Set([
            this
        ]) : $17f526922e4a857c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $17f526922e4a857c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $17f526922e4a857c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $17f526922e4a857c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $17f526922e4a857c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $17f526922e4a857c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $17f526922e4a857c$var$mh(-1, 1), b.tag = 2, $17f526922e4a857c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $17f526922e4a857c$var$Wi = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$dh = !1;
function $17f526922e4a857c$var$Xi(a, b, c, d) {
    b.child = null === a ? $17f526922e4a857c$var$Vg(b, null, c, d) : $17f526922e4a857c$var$Ug(b, a.child, c, d);
}
function $17f526922e4a857c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $17f526922e4a857c$var$ch(b, e);
    d = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    c = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && c && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, d, e);
    return b.child;
}
function $17f526922e4a857c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$17f526922e4a857c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $17f526922e4a857c$var$bj(a, b, f, d, e);
        a = $17f526922e4a857c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $17f526922e4a857c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $17f526922e4a857c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $17f526922e4a857c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $17f526922e4a857c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($17f526922e4a857c$var$Ie(f, d) && a.ref === b.ref) {
            if ($17f526922e4a857c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($17f526922e4a857c$var$dh = !0);
            else return b.lanes = a.lanes, $17f526922e4a857c$var$Zi(a, b, e);
        }
    }
    return $17f526922e4a857c$var$cj(a, b, c, d, e);
}
function $17f526922e4a857c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj);
            $17f526922e4a857c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= d;
    $17f526922e4a857c$var$Xi(a, b, e, c);
    return b.child;
}
function $17f526922e4a857c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $17f526922e4a857c$var$cj(a, b, c, d, e) {
    var f = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current;
    f = $17f526922e4a857c$var$Yf(b, f);
    $17f526922e4a857c$var$ch(b, e);
    c = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    d = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && d && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, c, e);
    return b.child;
}
function $17f526922e4a857c$var$hj(a, b, c, d, e) {
    if ($17f526922e4a857c$var$Zf(c)) {
        var f = !0;
        $17f526922e4a857c$var$cg(b);
    } else f = !1;
    $17f526922e4a857c$var$ch(b, e);
    if (null === b.stateNode) $17f526922e4a857c$var$ij(a, b), $17f526922e4a857c$var$Gi(b, c, d), $17f526922e4a857c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $17f526922e4a857c$var$eh(l) : (l = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, l = $17f526922e4a857c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $17f526922e4a857c$var$Hi(b, g, d, l);
        $17f526922e4a857c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof m && ($17f526922e4a857c$var$Di(b, c, m, d), k = b.memoizedState), (h = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $17f526922e4a857c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $17f526922e4a857c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $17f526922e4a857c$var$eh(k) : (k = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, k = $17f526922e4a857c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $17f526922e4a857c$var$Hi(b, g, d, k);
        $17f526922e4a857c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof y && ($17f526922e4a857c$var$Di(b, c, y, d), n = b.memoizedState), (l = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $17f526922e4a857c$var$jj(a, b, c, d, f, e);
}
function $17f526922e4a857c$var$jj(a, b, c, d, e, f) {
    $17f526922e4a857c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $17f526922e4a857c$var$dg(b, c, !1), $17f526922e4a857c$var$Zi(a, b, f);
    d = b.stateNode;
    $17f526922e4a857c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $17f526922e4a857c$var$Ug(b, a.child, null, f), b.child = $17f526922e4a857c$var$Ug(b, null, h, f)) : $17f526922e4a857c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $17f526922e4a857c$var$dg(b, c, !0);
    return b.child;
}
function $17f526922e4a857c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $17f526922e4a857c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $17f526922e4a857c$var$ag(a, b.context, !1);
    $17f526922e4a857c$var$yh(a, b.containerInfo);
}
function $17f526922e4a857c$var$lj(a, b, c, d, e) {
    $17f526922e4a857c$var$Ig();
    $17f526922e4a857c$var$Jg(e);
    b.flags |= 256;
    $17f526922e4a857c$var$Xi(a, b, c, d);
    return b.child;
}
var $17f526922e4a857c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $17f526922e4a857c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $17f526922e4a857c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $17f526922e4a857c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, e & 1);
    if (null === a) {
        $17f526922e4a857c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $17f526922e4a857c$var$pj(g, d, 0, null), a = $17f526922e4a857c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $17f526922e4a857c$var$nj(c), b.memoizedState = $17f526922e4a857c$var$mj, a) : $17f526922e4a857c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $17f526922e4a857c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $17f526922e4a857c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $17f526922e4a857c$var$Pg(h, f) : (f = $17f526922e4a857c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $17f526922e4a857c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $17f526922e4a857c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $17f526922e4a857c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $17f526922e4a857c$var$qj(a, b) {
    b = $17f526922e4a857c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $17f526922e4a857c$var$sj(a, b, c, d) {
    null !== d && $17f526922e4a857c$var$Jg(d);
    $17f526922e4a857c$var$Ug(b, a.child, null, c);
    a = $17f526922e4a857c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $17f526922e4a857c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(422))), $17f526922e4a857c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $17f526922e4a857c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $17f526922e4a857c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $17f526922e4a857c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $17f526922e4a857c$var$nj(g);
        b.memoizedState = $17f526922e4a857c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $17f526922e4a857c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($17f526922e4a857c$var$p(419));
        d = $17f526922e4a857c$var$Ki(f, d, void 0);
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($17f526922e4a857c$var$dh || h) {
        d = $17f526922e4a857c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $17f526922e4a857c$var$ih(a, e), $17f526922e4a857c$var$gi(d, a, e, -1));
        }
        $17f526922e4a857c$var$tj();
        d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(421)));
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $17f526922e4a857c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(e.nextSibling);
    $17f526922e4a857c$var$xg = b;
    $17f526922e4a857c$var$I = !0;
    $17f526922e4a857c$var$zg = null;
    null !== a && ($17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg, $17f526922e4a857c$var$rg = a.id, $17f526922e4a857c$var$sg = a.overflow, $17f526922e4a857c$var$qg = b);
    b = $17f526922e4a857c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $17f526922e4a857c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $17f526922e4a857c$var$bh(a.return, b, c);
}
function $17f526922e4a857c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $17f526922e4a857c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $17f526922e4a857c$var$Xi(a, b, d.children, c);
    d = $17f526922e4a857c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $17f526922e4a857c$var$vj(a, c, b);
            else if (19 === a.tag) $17f526922e4a857c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $17f526922e4a857c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $17f526922e4a857c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $17f526922e4a857c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $17f526922e4a857c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $17f526922e4a857c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $17f526922e4a857c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $17f526922e4a857c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($17f526922e4a857c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $17f526922e4a857c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $17f526922e4a857c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $17f526922e4a857c$var$kj(b);
            $17f526922e4a857c$var$Ig();
            break;
        case 5:
            $17f526922e4a857c$var$Ah(b);
            break;
        case 1:
            $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$cg(b);
            break;
        case 4:
            $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $17f526922e4a857c$var$oj(a, b, c);
                $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
                a = $17f526922e4a857c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $17f526922e4a857c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $17f526922e4a857c$var$dj(a, b, c);
    }
    return $17f526922e4a857c$var$Zi(a, b, c);
}
var $17f526922e4a857c$var$zj, $17f526922e4a857c$var$Aj, $17f526922e4a857c$var$Bj, $17f526922e4a857c$var$Cj;
$17f526922e4a857c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$17f526922e4a857c$var$Aj = function() {};
$17f526922e4a857c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $17f526922e4a857c$var$Ya(a, e);
                d = $17f526922e4a857c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $17f526922e4a857c$var$A({}, e, {
                    value: void 0
                });
                d = $17f526922e4a857c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $17f526922e4a857c$var$gb(a, e);
                d = $17f526922e4a857c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
        }
        $17f526922e4a857c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $17f526922e4a857c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$17f526922e4a857c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $17f526922e4a857c$var$Dj(a, b) {
    if (!$17f526922e4a857c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $17f526922e4a857c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $17f526922e4a857c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $17f526922e4a857c$var$S(b), null;
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $17f526922e4a857c$var$zh();
            $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
            $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
            $17f526922e4a857c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $17f526922e4a857c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null));
            $17f526922e4a857c$var$Aj(a, b);
            $17f526922e4a857c$var$S(b);
            return null;
        case 5:
            $17f526922e4a857c$var$Bh(b);
            var e = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $17f526922e4a857c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                    $17f526922e4a857c$var$S(b);
                    return null;
                }
                a = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    d[$17f526922e4a857c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $17f526922e4a857c$var$D("cancel", d);
                            $17f526922e4a857c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], d);
                            break;
                        case "source":
                            $17f526922e4a857c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $17f526922e4a857c$var$D("error", d);
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "details":
                            $17f526922e4a857c$var$D("toggle", d);
                            break;
                        case "input":
                            $17f526922e4a857c$var$Za(d, f);
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$hb(d, f), $17f526922e4a857c$var$D("invalid", d);
                    }
                    $17f526922e4a857c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $17f526922e4a857c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $17f526922e4a857c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $17f526922e4a857c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $17f526922e4a857c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$17f526922e4a857c$var$Of] = b;
                    a[$17f526922e4a857c$var$Pf] = d;
                    $17f526922e4a857c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $17f526922e4a857c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $17f526922e4a857c$var$D("cancel", a);
                                $17f526922e4a857c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $17f526922e4a857c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $17f526922e4a857c$var$D("error", a);
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $17f526922e4a857c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $17f526922e4a857c$var$Za(a, d);
                                e = $17f526922e4a857c$var$Ya(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $17f526922e4a857c$var$A({}, d, {
                                    value: void 0
                                });
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$hb(a, d);
                                e = $17f526922e4a857c$var$gb(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $17f526922e4a857c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $17f526922e4a857c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $17f526922e4a857c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $17f526922e4a857c$var$ob(a, k) : "number" === typeof k && $17f526922e4a857c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($17f526922e4a857c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $17f526922e4a857c$var$D("scroll", a) : null != k && $17f526922e4a857c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $17f526922e4a857c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $17f526922e4a857c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $17f526922e4a857c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $17f526922e4a857c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                c = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
                $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $17f526922e4a857c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$17f526922e4a857c$var$Of] = b, b.stateNode = d;
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($17f526922e4a857c$var$I && null !== $17f526922e4a857c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $17f526922e4a857c$var$Hg(), $17f526922e4a857c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $17f526922e4a857c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($17f526922e4a857c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($17f526922e4a857c$var$p(317));
                        f[$17f526922e4a857c$var$Of] = b;
                    } else $17f526922e4a857c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $17f526922e4a857c$var$S(b);
                    f = !1;
                } else null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($17f526922e4a857c$var$L.current & 1) ? 0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 3) : $17f526922e4a857c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $17f526922e4a857c$var$S(b);
            return null;
        case 4:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$Aj(a, b), null === a && $17f526922e4a857c$var$sf(b.stateNode.containerInfo), $17f526922e4a857c$var$S(b), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), $17f526922e4a857c$var$S(b), null;
        case 17:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 19:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            f = b.memoizedState;
            if (null === f) return $17f526922e4a857c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $17f526922e4a857c$var$Dj(f, !1);
                else {
                    if (0 !== $17f526922e4a857c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $17f526922e4a857c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $17f526922e4a857c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $17f526922e4a857c$var$B() > $17f526922e4a857c$var$Gj && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $17f526922e4a857c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $17f526922e4a857c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$17f526922e4a857c$var$I) return $17f526922e4a857c$var$S(b), null;
                    } else 2 * $17f526922e4a857c$var$B() - f.renderingStartTime > $17f526922e4a857c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $17f526922e4a857c$var$B(), b.sibling = null, c = $17f526922e4a857c$var$L.current, $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d ? c & 1 | 2 : c & 1), b;
            $17f526922e4a857c$var$S(b);
            return null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($17f526922e4a857c$var$fj & 1073741824) && ($17f526922e4a857c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $17f526922e4a857c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
}
function $17f526922e4a857c$var$Ij(a, b) {
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $17f526922e4a857c$var$Bh(b), null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($17f526922e4a857c$var$p(340));
                $17f526922e4a857c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $17f526922e4a857c$var$E($17f526922e4a857c$var$L), null;
        case 4:
            return $17f526922e4a857c$var$zh(), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$Jj = !1, $17f526922e4a857c$var$U = !1, $17f526922e4a857c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $17f526922e4a857c$var$V = null;
function $17f526922e4a857c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $17f526922e4a857c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $17f526922e4a857c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $17f526922e4a857c$var$W(a, b, d);
    }
}
var $17f526922e4a857c$var$Nj = !1;
function $17f526922e4a857c$var$Oj(a, b) {
    $17f526922e4a857c$var$Cf = $17f526922e4a857c$var$dd;
    a = $17f526922e4a857c$var$Me();
    if ($17f526922e4a857c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $17f526922e4a857c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $17f526922e4a857c$var$dd = !1;
    for($17f526922e4a857c$var$V = b; null !== $17f526922e4a857c$var$V;)if (b = $17f526922e4a857c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $17f526922e4a857c$var$V = a;
    else for(; null !== $17f526922e4a857c$var$V;){
        b = $17f526922e4a857c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $17f526922e4a857c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(163));
            }
        } catch (F) {
            $17f526922e4a857c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $17f526922e4a857c$var$V = a;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
    n = $17f526922e4a857c$var$Nj;
    $17f526922e4a857c$var$Nj = !1;
    return n;
}
function $17f526922e4a857c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $17f526922e4a857c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $17f526922e4a857c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $17f526922e4a857c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $17f526922e4a857c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $17f526922e4a857c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$17f526922e4a857c$var$Of], delete b[$17f526922e4a857c$var$Pf], delete b[$17f526922e4a857c$var$of], delete b[$17f526922e4a857c$var$Qf], delete b[$17f526922e4a857c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $17f526922e4a857c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $17f526922e4a857c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $17f526922e4a857c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $17f526922e4a857c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $17f526922e4a857c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Vj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Vj(a, b, c), a = a.sibling;
}
function $17f526922e4a857c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Wj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Wj(a, b, c), a = a.sibling;
}
var $17f526922e4a857c$var$X = null, $17f526922e4a857c$var$Xj = !1;
function $17f526922e4a857c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$17f526922e4a857c$var$Zj(a, b, c), c = c.sibling;
}
function $17f526922e4a857c$var$Zj(a, b, c) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberUnmount) try {
        $17f526922e4a857c$var$lc.onCommitFiberUnmount($17f526922e4a857c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $17f526922e4a857c$var$U || $17f526922e4a857c$var$Lj(c, b);
        case 6:
            var d = $17f526922e4a857c$var$X, e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $17f526922e4a857c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? $17f526922e4a857c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $17f526922e4a857c$var$Kf(a, c), $17f526922e4a857c$var$bd(a)) : $17f526922e4a857c$var$Kf($17f526922e4a857c$var$X, c.stateNode));
            break;
        case 4:
            d = $17f526922e4a857c$var$X;
            e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = c.stateNode.containerInfo;
            $17f526922e4a857c$var$Xj = !0;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$17f526922e4a857c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $17f526922e4a857c$var$Mj(c, b, g) : 0 !== (f & 4) && $17f526922e4a857c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$17f526922e4a857c$var$U && ($17f526922e4a857c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $17f526922e4a857c$var$W(c, b, h);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 21:
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($17f526922e4a857c$var$U = (d = $17f526922e4a857c$var$U) || null !== c.memoizedState, $17f526922e4a857c$var$Yj(a, b, c), $17f526922e4a857c$var$U = d) : $17f526922e4a857c$var$Yj(a, b, c);
            break;
        default:
            $17f526922e4a857c$var$Yj(a, b, c);
    }
}
function $17f526922e4a857c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $17f526922e4a857c$var$Kj);
        b.forEach(function(b) {
            var d = $17f526922e4a857c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $17f526922e4a857c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $17f526922e4a857c$var$X = h.stateNode;
                        $17f526922e4a857c$var$Xj = !1;
                        break a;
                    case 3:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                    case 4:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $17f526922e4a857c$var$X) throw Error($17f526922e4a857c$var$p(160));
            $17f526922e4a857c$var$Zj(f, g, e);
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $17f526922e4a857c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$17f526922e4a857c$var$dk(b, a), b = b.sibling;
}
function $17f526922e4a857c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                try {
                    $17f526922e4a857c$var$Pj(3, a, a.return), $17f526922e4a857c$var$Qj(3, a);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
                try {
                    $17f526922e4a857c$var$Pj(5, a, a.return);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            break;
        case 5:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $17f526922e4a857c$var$ob(e, "");
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $17f526922e4a857c$var$ab(e, f);
                    $17f526922e4a857c$var$vb(h, g);
                    var l = $17f526922e4a857c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $17f526922e4a857c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $17f526922e4a857c$var$nb(e, q) : "children" === m ? $17f526922e4a857c$var$ob(e, q) : $17f526922e4a857c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $17f526922e4a857c$var$bb(e, f);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $17f526922e4a857c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $17f526922e4a857c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $17f526922e4a857c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$17f526922e4a857c$var$Pf] = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($17f526922e4a857c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $17f526922e4a857c$var$bd(b.containerInfo);
            } catch (t) {
                $17f526922e4a857c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            break;
        case 13:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($17f526922e4a857c$var$fk = $17f526922e4a857c$var$B()));
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($17f526922e4a857c$var$U = (l = $17f526922e4a857c$var$U) || m, $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$U = l) : $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($17f526922e4a857c$var$V = a, m = a.child; null !== m;){
                    for(q = $17f526922e4a857c$var$V = m; null !== $17f526922e4a857c$var$V;){
                        r = $17f526922e4a857c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $17f526922e4a857c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $17f526922e4a857c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $17f526922e4a857c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $17f526922e4a857c$var$V = y) : $17f526922e4a857c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $17f526922e4a857c$var$rb("display", g));
                            } catch (t) {
                                $17f526922e4a857c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $17f526922e4a857c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$ek(a);
    }
}
function $17f526922e4a857c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($17f526922e4a857c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($17f526922e4a857c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($17f526922e4a857c$var$ob(e, ""), d.flags &= -33);
                    var f = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(161));
            }
        } catch (k) {
            $17f526922e4a857c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $17f526922e4a857c$var$hk(a, b, c) {
    $17f526922e4a857c$var$V = a;
    $17f526922e4a857c$var$ik(a, b, c);
}
function $17f526922e4a857c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $17f526922e4a857c$var$V;){
        var e = $17f526922e4a857c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $17f526922e4a857c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $17f526922e4a857c$var$U;
                h = $17f526922e4a857c$var$Jj;
                var l = $17f526922e4a857c$var$U;
                $17f526922e4a857c$var$Jj = g;
                if (($17f526922e4a857c$var$U = k) && !l) for($17f526922e4a857c$var$V = e; null !== $17f526922e4a857c$var$V;)g = $17f526922e4a857c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $17f526922e4a857c$var$jk(e) : null !== k ? (k.return = g, $17f526922e4a857c$var$V = k) : $17f526922e4a857c$var$jk(e);
                for(; null !== f;)$17f526922e4a857c$var$V = f, $17f526922e4a857c$var$ik(f, b, c), f = f.sibling;
                $17f526922e4a857c$var$V = e;
                $17f526922e4a857c$var$Jj = h;
                $17f526922e4a857c$var$U = l;
            }
            $17f526922e4a857c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $17f526922e4a857c$var$V = f) : $17f526922e4a857c$var$kk(a, b, c);
    }
}
function $17f526922e4a857c$var$kk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $17f526922e4a857c$var$U || $17f526922e4a857c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$17f526922e4a857c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $17f526922e4a857c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $17f526922e4a857c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $17f526922e4a857c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $17f526922e4a857c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($17f526922e4a857c$var$p(163));
                }
                $17f526922e4a857c$var$U || b.flags & 512 && $17f526922e4a857c$var$Rj(b);
            } catch (r) {
                $17f526922e4a857c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$gk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$jk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $17f526922e4a857c$var$Qj(4, b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $17f526922e4a857c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $17f526922e4a857c$var$W(b, b.return, k);
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $17f526922e4a857c$var$V = h;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
var $17f526922e4a857c$var$lk = Math.ceil, $17f526922e4a857c$var$mk = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$nk = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$ok = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$K = 0, $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Y = null, $17f526922e4a857c$var$Z = 0, $17f526922e4a857c$var$fj = 0, $17f526922e4a857c$var$ej = $17f526922e4a857c$var$Uf(0), $17f526922e4a857c$var$T = 0, $17f526922e4a857c$var$pk = null, $17f526922e4a857c$var$rh = 0, $17f526922e4a857c$var$qk = 0, $17f526922e4a857c$var$rk = 0, $17f526922e4a857c$var$sk = null, $17f526922e4a857c$var$tk = null, $17f526922e4a857c$var$fk = 0, $17f526922e4a857c$var$Gj = Infinity, $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Oi = !1, $17f526922e4a857c$var$Pi = null, $17f526922e4a857c$var$Ri = null, $17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = null, $17f526922e4a857c$var$xk = 0, $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, $17f526922e4a857c$var$Ak = -1, $17f526922e4a857c$var$Bk = 0;
function $17f526922e4a857c$var$R() {
    return 0 !== ($17f526922e4a857c$var$K & 6) ? $17f526922e4a857c$var$B() : -1 !== $17f526922e4a857c$var$Ak ? $17f526922e4a857c$var$Ak : $17f526922e4a857c$var$Ak = $17f526922e4a857c$var$B();
}
function $17f526922e4a857c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($17f526922e4a857c$var$K & 2) && 0 !== $17f526922e4a857c$var$Z) return $17f526922e4a857c$var$Z & -$17f526922e4a857c$var$Z;
    if (null !== $17f526922e4a857c$var$Kg.transition) return 0 === $17f526922e4a857c$var$Bk && ($17f526922e4a857c$var$Bk = $17f526922e4a857c$var$yc()), $17f526922e4a857c$var$Bk;
    a = $17f526922e4a857c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $17f526922e4a857c$var$jd(a.type);
    return a;
}
function $17f526922e4a857c$var$gi(a, b, c, d) {
    if (50 < $17f526922e4a857c$var$yk) throw $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, Error($17f526922e4a857c$var$p(185));
    $17f526922e4a857c$var$Ac(a, c, d);
    if (0 === ($17f526922e4a857c$var$K & 2) || a !== $17f526922e4a857c$var$Q) a === $17f526922e4a857c$var$Q && (0 === ($17f526922e4a857c$var$K & 2) && ($17f526922e4a857c$var$qk |= c), 4 === $17f526922e4a857c$var$T && $17f526922e4a857c$var$Ck(a, $17f526922e4a857c$var$Z)), $17f526922e4a857c$var$Dk(a, d), 1 === c && 0 === $17f526922e4a857c$var$K && 0 === (b.mode & 1) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
}
function $17f526922e4a857c$var$Dk(a, b) {
    var c = a.callbackNode;
    $17f526922e4a857c$var$wc(a, b);
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) null !== c && $17f526922e4a857c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $17f526922e4a857c$var$bc(c);
        if (1 === b) 0 === a.tag ? $17f526922e4a857c$var$ig($17f526922e4a857c$var$Ek.bind(null, a)) : $17f526922e4a857c$var$hg($17f526922e4a857c$var$Ek.bind(null, a)), $17f526922e4a857c$var$Jf(function() {
            0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
        }), c = null;
        else {
            switch($17f526922e4a857c$var$Dc(d)){
                case 1:
                    c = $17f526922e4a857c$var$fc;
                    break;
                case 4:
                    c = $17f526922e4a857c$var$gc;
                    break;
                case 16:
                    c = $17f526922e4a857c$var$hc;
                    break;
                case 536870912:
                    c = $17f526922e4a857c$var$jc;
                    break;
                default:
                    c = $17f526922e4a857c$var$hc;
            }
            c = $17f526922e4a857c$var$Fk(c, $17f526922e4a857c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $17f526922e4a857c$var$Gk(a, b) {
    $17f526922e4a857c$var$Ak = -1;
    $17f526922e4a857c$var$Bk = 0;
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    var c = a.callbackNode;
    if ($17f526922e4a857c$var$Hk() && a.callbackNode !== c) return null;
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $17f526922e4a857c$var$Ik(a, d);
    else {
        b = d;
        var e = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 2;
        var f = $17f526922e4a857c$var$Jk();
        if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$Kk(a, b);
        for(;;)try {
            $17f526922e4a857c$var$Lk();
            break;
        } catch (h) {
            $17f526922e4a857c$var$Mk(a, h);
        }
        $17f526922e4a857c$var$$g();
        $17f526922e4a857c$var$mk.current = f;
        $17f526922e4a857c$var$K = e;
        null !== $17f526922e4a857c$var$Y ? b = 0 : ($17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0, b = $17f526922e4a857c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $17f526922e4a857c$var$xc(a), 0 !== e && (d = e, b = $17f526922e4a857c$var$Nk(a, e)));
        if (1 === b) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
        if (6 === b) $17f526922e4a857c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$17f526922e4a857c$var$Ok(e) && (b = $17f526922e4a857c$var$Ik(a, d), 2 === b && (f = $17f526922e4a857c$var$xc(a), 0 !== f && (d = f, b = $17f526922e4a857c$var$Nk(a, f))), 1 === b)) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($17f526922e4a857c$var$p(345));
                case 2:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 3:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $17f526922e4a857c$var$fk + 500 - $17f526922e4a857c$var$B(), 10 < b)) {
                        if (0 !== $17f526922e4a857c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $17f526922e4a857c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), b);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 4:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $17f526922e4a857c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $17f526922e4a857c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $17f526922e4a857c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), d);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 5:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(329));
            }
        }
    }
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return a.callbackNode === c ? $17f526922e4a857c$var$Gk.bind(null, a) : null;
}
function $17f526922e4a857c$var$Nk(a, b) {
    var c = $17f526922e4a857c$var$sk;
    a.current.memoizedState.isDehydrated && ($17f526922e4a857c$var$Kk(a, b).flags |= 256);
    a = $17f526922e4a857c$var$Ik(a, b);
    2 !== a && (b = $17f526922e4a857c$var$tk, $17f526922e4a857c$var$tk = c, null !== b && $17f526922e4a857c$var$Fj(b));
    return a;
}
function $17f526922e4a857c$var$Fj(a) {
    null === $17f526922e4a857c$var$tk ? $17f526922e4a857c$var$tk = a : $17f526922e4a857c$var$tk.push.apply($17f526922e4a857c$var$tk, a);
}
function $17f526922e4a857c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$17f526922e4a857c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $17f526922e4a857c$var$Ck(a, b) {
    b &= ~$17f526922e4a857c$var$rk;
    b &= ~$17f526922e4a857c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $17f526922e4a857c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $17f526922e4a857c$var$Ek(a) {
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$uc(a, 0);
    if (0 === (b & 1)) return $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), null;
    var c = $17f526922e4a857c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $17f526922e4a857c$var$xc(a);
        0 !== d && (b = d, c = $17f526922e4a857c$var$Nk(a, d));
    }
    if (1 === c) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, b), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
    if (6 === c) throw Error($17f526922e4a857c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return null;
}
function $17f526922e4a857c$var$Qk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $17f526922e4a857c$var$K = c, 0 === $17f526922e4a857c$var$K && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
    }
}
function $17f526922e4a857c$var$Rk(a) {
    null !== $17f526922e4a857c$var$wk && 0 === $17f526922e4a857c$var$wk.tag && 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    var c = $17f526922e4a857c$var$ok.transition, d = $17f526922e4a857c$var$C;
    try {
        if ($17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, a) return a();
    } finally{
        $17f526922e4a857c$var$C = d, $17f526922e4a857c$var$ok.transition = c, $17f526922e4a857c$var$K = b, 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
    }
}
function $17f526922e4a857c$var$Hj() {
    $17f526922e4a857c$var$fj = $17f526922e4a857c$var$ej.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$ej);
}
function $17f526922e4a857c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $17f526922e4a857c$var$Gf(c));
    if (null !== $17f526922e4a857c$var$Y) for(c = $17f526922e4a857c$var$Y.return; null !== c;){
        var d = c;
        $17f526922e4a857c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $17f526922e4a857c$var$$f();
                break;
            case 3:
                $17f526922e4a857c$var$zh();
                $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
                $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
                $17f526922e4a857c$var$Eh();
                break;
            case 5:
                $17f526922e4a857c$var$Bh(d);
                break;
            case 4:
                $17f526922e4a857c$var$zh();
                break;
            case 13:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 19:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 10:
                $17f526922e4a857c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $17f526922e4a857c$var$Hj();
        }
        c = c.return;
    }
    $17f526922e4a857c$var$Q = a;
    $17f526922e4a857c$var$Y = a = $17f526922e4a857c$var$Pg(a.current, null);
    $17f526922e4a857c$var$Z = $17f526922e4a857c$var$fj = b;
    $17f526922e4a857c$var$T = 0;
    $17f526922e4a857c$var$pk = null;
    $17f526922e4a857c$var$rk = $17f526922e4a857c$var$qk = $17f526922e4a857c$var$rh = 0;
    $17f526922e4a857c$var$tk = $17f526922e4a857c$var$sk = null;
    if (null !== $17f526922e4a857c$var$fh) {
        for(b = 0; b < $17f526922e4a857c$var$fh.length; b++)if (c = $17f526922e4a857c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $17f526922e4a857c$var$fh = null;
    }
    return a;
}
function $17f526922e4a857c$var$Mk(a, b) {
    do {
        var c = $17f526922e4a857c$var$Y;
        try {
            $17f526922e4a857c$var$$g();
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
            if ($17f526922e4a857c$var$Ih) {
                for(var d = $17f526922e4a857c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $17f526922e4a857c$var$Ih = !1;
            }
            $17f526922e4a857c$var$Hh = 0;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            $17f526922e4a857c$var$nk.current = null;
            if (null === c || null === c.return) {
                $17f526922e4a857c$var$T = 1;
                $17f526922e4a857c$var$pk = b;
                $17f526922e4a857c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $17f526922e4a857c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $17f526922e4a857c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $17f526922e4a857c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $17f526922e4a857c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $17f526922e4a857c$var$Si(f, l, b);
                            $17f526922e4a857c$var$tj();
                            break a;
                        }
                        k = Error($17f526922e4a857c$var$p(426));
                    }
                } else if ($17f526922e4a857c$var$I && h.mode & 1) {
                    var J = $17f526922e4a857c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $17f526922e4a857c$var$Vi(J, g, h, f, b);
                        $17f526922e4a857c$var$Jg($17f526922e4a857c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $17f526922e4a857c$var$Ji(k, h);
                4 !== $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 2);
                null === $17f526922e4a857c$var$sk ? $17f526922e4a857c$var$sk = [
                    f
                ] : $17f526922e4a857c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $17f526922e4a857c$var$Ni(f, k, b);
                            $17f526922e4a857c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $17f526922e4a857c$var$Qi(f, h, b);
                                $17f526922e4a857c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $17f526922e4a857c$var$Sk(c);
        } catch (na) {
            b = na;
            $17f526922e4a857c$var$Y === c && null !== c && ($17f526922e4a857c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $17f526922e4a857c$var$Jk() {
    var a = $17f526922e4a857c$var$mk.current;
    $17f526922e4a857c$var$mk.current = $17f526922e4a857c$var$Rh;
    return null === a ? $17f526922e4a857c$var$Rh : a;
}
function $17f526922e4a857c$var$tj() {
    if (0 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T || 2 === $17f526922e4a857c$var$T) $17f526922e4a857c$var$T = 4;
    null === $17f526922e4a857c$var$Q || 0 === ($17f526922e4a857c$var$rh & 268435455) && 0 === ($17f526922e4a857c$var$qk & 268435455) || $17f526922e4a857c$var$Ck($17f526922e4a857c$var$Q, $17f526922e4a857c$var$Z);
}
function $17f526922e4a857c$var$Ik(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 2;
    var d = $17f526922e4a857c$var$Jk();
    if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Kk(a, b);
    for(;;)try {
        $17f526922e4a857c$var$Tk();
        break;
    } catch (e) {
        $17f526922e4a857c$var$Mk(a, e);
    }
    $17f526922e4a857c$var$$g();
    $17f526922e4a857c$var$K = c;
    $17f526922e4a857c$var$mk.current = d;
    if (null !== $17f526922e4a857c$var$Y) throw Error($17f526922e4a857c$var$p(261));
    $17f526922e4a857c$var$Q = null;
    $17f526922e4a857c$var$Z = 0;
    return $17f526922e4a857c$var$T;
}
function $17f526922e4a857c$var$Tk() {
    for(; null !== $17f526922e4a857c$var$Y;)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Lk() {
    for(; null !== $17f526922e4a857c$var$Y && !$17f526922e4a857c$var$cc();)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Uk(a) {
    var b = $17f526922e4a857c$var$Vk(a.alternate, a, $17f526922e4a857c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $17f526922e4a857c$var$Sk(a) : $17f526922e4a857c$var$Y = b;
    $17f526922e4a857c$var$nk.current = null;
}
function $17f526922e4a857c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $17f526922e4a857c$var$Ej(c, b, $17f526922e4a857c$var$fj), null !== c) {
                $17f526922e4a857c$var$Y = c;
                return;
            }
        } else {
            c = $17f526922e4a857c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $17f526922e4a857c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $17f526922e4a857c$var$T = 6;
                $17f526922e4a857c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $17f526922e4a857c$var$Y = b;
            return;
        }
        $17f526922e4a857c$var$Y = b = a;
    }while (null !== b);
    0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 5);
}
function $17f526922e4a857c$var$Pk(a, b, c) {
    var d = $17f526922e4a857c$var$C, e = $17f526922e4a857c$var$ok.transition;
    try {
        $17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$Wk(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$ok.transition = e, $17f526922e4a857c$var$C = d;
    }
    return null;
}
function $17f526922e4a857c$var$Wk(a, b, c, d) {
    do $17f526922e4a857c$var$Hk();
    while (null !== $17f526922e4a857c$var$wk);
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($17f526922e4a857c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $17f526922e4a857c$var$Bc(a, f);
    a === $17f526922e4a857c$var$Q && ($17f526922e4a857c$var$Y = $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $17f526922e4a857c$var$vk || ($17f526922e4a857c$var$vk = !0, $17f526922e4a857c$var$Fk($17f526922e4a857c$var$hc, function() {
        $17f526922e4a857c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $17f526922e4a857c$var$ok.transition;
        $17f526922e4a857c$var$ok.transition = null;
        var g = $17f526922e4a857c$var$C;
        $17f526922e4a857c$var$C = 1;
        var h = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 4;
        $17f526922e4a857c$var$nk.current = null;
        $17f526922e4a857c$var$Oj(a, c);
        $17f526922e4a857c$var$dk(c, a);
        $17f526922e4a857c$var$Oe($17f526922e4a857c$var$Df);
        $17f526922e4a857c$var$dd = !!$17f526922e4a857c$var$Cf;
        $17f526922e4a857c$var$Df = $17f526922e4a857c$var$Cf = null;
        a.current = c;
        $17f526922e4a857c$var$hk(c, a, e);
        $17f526922e4a857c$var$dc();
        $17f526922e4a857c$var$K = h;
        $17f526922e4a857c$var$C = g;
        $17f526922e4a857c$var$ok.transition = f;
    } else a.current = c;
    $17f526922e4a857c$var$vk && ($17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = a, $17f526922e4a857c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($17f526922e4a857c$var$Ri = null);
    $17f526922e4a857c$var$mc(c.stateNode, d);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($17f526922e4a857c$var$Oi) throw $17f526922e4a857c$var$Oi = !1, a = $17f526922e4a857c$var$Pi, $17f526922e4a857c$var$Pi = null, a;
    0 !== ($17f526922e4a857c$var$xk & 1) && 0 !== a.tag && $17f526922e4a857c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $17f526922e4a857c$var$zk ? $17f526922e4a857c$var$yk++ : ($17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = a) : $17f526922e4a857c$var$yk = 0;
    $17f526922e4a857c$var$jg();
    return null;
}
function $17f526922e4a857c$var$Hk() {
    if (null !== $17f526922e4a857c$var$wk) {
        var a = $17f526922e4a857c$var$Dc($17f526922e4a857c$var$xk), b = $17f526922e4a857c$var$ok.transition, c = $17f526922e4a857c$var$C;
        try {
            $17f526922e4a857c$var$ok.transition = null;
            $17f526922e4a857c$var$C = 16 > a ? 16 : a;
            if (null === $17f526922e4a857c$var$wk) var d = !1;
            else {
                a = $17f526922e4a857c$var$wk;
                $17f526922e4a857c$var$wk = null;
                $17f526922e4a857c$var$xk = 0;
                if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(331));
                var e = $17f526922e4a857c$var$K;
                $17f526922e4a857c$var$K |= 4;
                for($17f526922e4a857c$var$V = a.current; null !== $17f526922e4a857c$var$V;){
                    var f = $17f526922e4a857c$var$V, g = f.child;
                    if (0 !== ($17f526922e4a857c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($17f526922e4a857c$var$V = l; null !== $17f526922e4a857c$var$V;){
                                    var m = $17f526922e4a857c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $17f526922e4a857c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $17f526922e4a857c$var$V = q;
                                    else for(; null !== $17f526922e4a857c$var$V;){
                                        m = $17f526922e4a857c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $17f526922e4a857c$var$Sj(m);
                                        if (m === l) {
                                            $17f526922e4a857c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $17f526922e4a857c$var$V = r;
                                            break;
                                        }
                                        $17f526922e4a857c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $17f526922e4a857c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $17f526922e4a857c$var$V = g;
                    else b: for(; null !== $17f526922e4a857c$var$V;){
                        f = $17f526922e4a857c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $17f526922e4a857c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $17f526922e4a857c$var$V = x;
                            break b;
                        }
                        $17f526922e4a857c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($17f526922e4a857c$var$V = w; null !== $17f526922e4a857c$var$V;){
                    g = $17f526922e4a857c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $17f526922e4a857c$var$V = u;
                    else b: for(g = w; null !== $17f526922e4a857c$var$V;){
                        h = $17f526922e4a857c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $17f526922e4a857c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $17f526922e4a857c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $17f526922e4a857c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $17f526922e4a857c$var$V = F;
                            break b;
                        }
                        $17f526922e4a857c$var$V = h.return;
                    }
                }
                $17f526922e4a857c$var$K = e;
                $17f526922e4a857c$var$jg();
                if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onPostCommitFiberRoot) try {
                    $17f526922e4a857c$var$lc.onPostCommitFiberRoot($17f526922e4a857c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$ok.transition = b;
        }
    }
    return !1;
}
function $17f526922e4a857c$var$Xk(a, b, c) {
    b = $17f526922e4a857c$var$Ji(c, b);
    b = $17f526922e4a857c$var$Ni(a, b, 1);
    a = $17f526922e4a857c$var$nh(a, b, 1);
    b = $17f526922e4a857c$var$R();
    null !== a && ($17f526922e4a857c$var$Ac(a, 1, b), $17f526922e4a857c$var$Dk(a, b));
}
function $17f526922e4a857c$var$W(a, b, c) {
    if (3 === a.tag) $17f526922e4a857c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $17f526922e4a857c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(d))) {
                a = $17f526922e4a857c$var$Ji(c, a);
                a = $17f526922e4a857c$var$Qi(b, a, 1);
                b = $17f526922e4a857c$var$nh(b, a, 1);
                a = $17f526922e4a857c$var$R();
                null !== b && ($17f526922e4a857c$var$Ac(b, 1, a), $17f526922e4a857c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $17f526922e4a857c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $17f526922e4a857c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $17f526922e4a857c$var$Q === a && ($17f526922e4a857c$var$Z & c) === c && (4 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$Z & 130023424) === $17f526922e4a857c$var$Z && 500 > $17f526922e4a857c$var$B() - $17f526922e4a857c$var$fk ? $17f526922e4a857c$var$Kk(a, 0) : $17f526922e4a857c$var$rk |= c);
    $17f526922e4a857c$var$Dk(a, b);
}
function $17f526922e4a857c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $17f526922e4a857c$var$sc, $17f526922e4a857c$var$sc <<= 1, 0 === ($17f526922e4a857c$var$sc & 130023424) && ($17f526922e4a857c$var$sc = 4194304)));
    var c = $17f526922e4a857c$var$R();
    a = $17f526922e4a857c$var$ih(a, b);
    null !== a && ($17f526922e4a857c$var$Ac(a, b, c), $17f526922e4a857c$var$Dk(a, c));
}
function $17f526922e4a857c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $17f526922e4a857c$var$Yk(a, c);
}
function $17f526922e4a857c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($17f526922e4a857c$var$p(314));
    }
    null !== d && d.delete(b);
    $17f526922e4a857c$var$Yk(a, c);
}
var $17f526922e4a857c$var$Vk;
$17f526922e4a857c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $17f526922e4a857c$var$Wf.current) $17f526922e4a857c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$yj(a, b, c);
            $17f526922e4a857c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$I && 0 !== (b.flags & 1048576) && $17f526922e4a857c$var$ug(b, $17f526922e4a857c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $17f526922e4a857c$var$ij(a, b);
            a = b.pendingProps;
            var e = $17f526922e4a857c$var$Yf(b, $17f526922e4a857c$var$H.current);
            $17f526922e4a857c$var$ch(b, c);
            e = $17f526922e4a857c$var$Nh(null, b, d, a, e, c);
            var f = $17f526922e4a857c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $17f526922e4a857c$var$Zf(d) ? (f = !0, $17f526922e4a857c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $17f526922e4a857c$var$kh(b), e.updater = $17f526922e4a857c$var$Ei, b.stateNode = e, e._reactInternals = b, $17f526922e4a857c$var$Ii(b, d, a, c), b = $17f526922e4a857c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $17f526922e4a857c$var$I && f && $17f526922e4a857c$var$vg(b), $17f526922e4a857c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $17f526922e4a857c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $17f526922e4a857c$var$Zk(d);
                a = $17f526922e4a857c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $17f526922e4a857c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $17f526922e4a857c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $17f526922e4a857c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $17f526922e4a857c$var$$i(null, b, d, $17f526922e4a857c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($17f526922e4a857c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $17f526922e4a857c$var$kj(b);
                if (null === a) throw Error($17f526922e4a857c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $17f526922e4a857c$var$lh(a, b);
                $17f526922e4a857c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(423)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(424)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.stateNode.containerInfo.firstChild), $17f526922e4a857c$var$xg = b, $17f526922e4a857c$var$I = !0, $17f526922e4a857c$var$zg = null, c = $17f526922e4a857c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $17f526922e4a857c$var$Ig();
                    if (d === e) {
                        b = $17f526922e4a857c$var$Zi(a, b, c);
                        break a;
                    }
                    $17f526922e4a857c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $17f526922e4a857c$var$Ah(b), null === a && $17f526922e4a857c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $17f526922e4a857c$var$Ef(d, e) ? g = null : null !== f && $17f526922e4a857c$var$Ef(d, f) && (b.flags |= 32), $17f526922e4a857c$var$gj(a, b), $17f526922e4a857c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $17f526922e4a857c$var$Eg(b), null;
        case 13:
            return $17f526922e4a857c$var$oj(a, b, c);
        case 4:
            return $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $17f526922e4a857c$var$Ug(b, null, d, c) : $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$Yi(a, b, d, e, c);
        case 7:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($17f526922e4a857c$var$He(f.value, g)) {
                        if (f.children === e.children && !$17f526922e4a857c$var$Wf.current) {
                            b = $17f526922e4a857c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $17f526922e4a857c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $17f526922e4a857c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($17f526922e4a857c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $17f526922e4a857c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $17f526922e4a857c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $17f526922e4a857c$var$ch(b, c), e = $17f526922e4a857c$var$eh(e), d = d(e), b.flags |= 1, $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $17f526922e4a857c$var$Ci(d, b.pendingProps), e = $17f526922e4a857c$var$Ci(d.type, e), $17f526922e4a857c$var$$i(a, b, d, e, c);
        case 15:
            return $17f526922e4a857c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$ij(a, b), b.tag = 1, $17f526922e4a857c$var$Zf(d) ? (a = !0, $17f526922e4a857c$var$cg(b)) : a = !1, $17f526922e4a857c$var$ch(b, c), $17f526922e4a857c$var$Gi(b, d, e), $17f526922e4a857c$var$Ii(b, d, e, c), $17f526922e4a857c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $17f526922e4a857c$var$xj(a, b, c);
        case 22:
            return $17f526922e4a857c$var$dj(a, b, c);
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
};
function $17f526922e4a857c$var$Fk(a, b) {
    return $17f526922e4a857c$var$ac(a, b);
}
function $17f526922e4a857c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $17f526922e4a857c$var$Bg(a, b, c, d) {
    return new $17f526922e4a857c$var$$k(a, b, c, d);
}
function $17f526922e4a857c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $17f526922e4a857c$var$Zk(a) {
    if ("function" === typeof a) return $17f526922e4a857c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $17f526922e4a857c$var$Da) return 11;
        if (a === $17f526922e4a857c$var$Ga) return 14;
    }
    return 2;
}
function $17f526922e4a857c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $17f526922e4a857c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $17f526922e4a857c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $17f526922e4a857c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $17f526922e4a857c$var$ya:
            return $17f526922e4a857c$var$Tg(c.children, e, f, b);
        case $17f526922e4a857c$var$za:
            g = 8;
            e |= 8;
            break;
        case $17f526922e4a857c$var$Aa:
            return a = $17f526922e4a857c$var$Bg(12, c, b, e | 2), a.elementType = $17f526922e4a857c$var$Aa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ea:
            return a = $17f526922e4a857c$var$Bg(13, c, b, e), a.elementType = $17f526922e4a857c$var$Ea, a.lanes = f, a;
        case $17f526922e4a857c$var$Fa:
            return a = $17f526922e4a857c$var$Bg(19, c, b, e), a.elementType = $17f526922e4a857c$var$Fa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ia:
            return $17f526922e4a857c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $17f526922e4a857c$var$Ba:
                    g = 10;
                    break a;
                case $17f526922e4a857c$var$Ca:
                    g = 9;
                    break a;
                case $17f526922e4a857c$var$Da:
                    g = 11;
                    break a;
                case $17f526922e4a857c$var$Ga:
                    g = 14;
                    break a;
                case $17f526922e4a857c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($17f526922e4a857c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $17f526922e4a857c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $17f526922e4a857c$var$Tg(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$pj(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(22, a, d, b);
    a.elementType = $17f526922e4a857c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $17f526922e4a857c$var$Qg(a, b, c) {
    a = $17f526922e4a857c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$Sg(a, b, c) {
    b = $17f526922e4a857c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $17f526922e4a857c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $17f526922e4a857c$var$zc(0);
    this.expirationTimes = $17f526922e4a857c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $17f526922e4a857c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $17f526922e4a857c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $17f526922e4a857c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $17f526922e4a857c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $17f526922e4a857c$var$kh(f);
    return a;
}
function $17f526922e4a857c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17f526922e4a857c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $17f526922e4a857c$var$dl(a) {
    if (!a) return $17f526922e4a857c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($17f526922e4a857c$var$Vb(a) !== a || 1 !== a.tag) throw Error($17f526922e4a857c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($17f526922e4a857c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($17f526922e4a857c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($17f526922e4a857c$var$Zf(c)) return $17f526922e4a857c$var$bg(a, c, b);
    }
    return b;
}
function $17f526922e4a857c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $17f526922e4a857c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $17f526922e4a857c$var$dl(null);
    c = a.current;
    d = $17f526922e4a857c$var$R();
    e = $17f526922e4a857c$var$yi(c);
    f = $17f526922e4a857c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $17f526922e4a857c$var$nh(c, f, e);
    a.current.lanes = e;
    $17f526922e4a857c$var$Ac(a, e, d);
    $17f526922e4a857c$var$Dk(a, d);
    return a;
}
function $17f526922e4a857c$var$fl(a, b, c, d) {
    var e = b.current, f = $17f526922e4a857c$var$R(), g = $17f526922e4a857c$var$yi(e);
    c = $17f526922e4a857c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $17f526922e4a857c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $17f526922e4a857c$var$nh(e, b, g);
    null !== a && ($17f526922e4a857c$var$gi(a, e, g, f), $17f526922e4a857c$var$oh(a, e, g));
    return g;
}
function $17f526922e4a857c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $17f526922e4a857c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $17f526922e4a857c$var$il(a, b) {
    $17f526922e4a857c$var$hl(a, b);
    (a = a.alternate) && $17f526922e4a857c$var$hl(a, b);
}
function $17f526922e4a857c$var$jl() {
    return null;
}
var $17f526922e4a857c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $17f526922e4a857c$var$ll(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.render = $17f526922e4a857c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($17f526922e4a857c$var$p(409));
    $17f526922e4a857c$var$fl(a, b, null, null);
};
$17f526922e4a857c$var$ml.prototype.unmount = $17f526922e4a857c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $17f526922e4a857c$var$Rk(function() {
            $17f526922e4a857c$var$fl(null, a, null, null);
        });
        b[$17f526922e4a857c$var$uf] = null;
    }
};
function $17f526922e4a857c$var$ml(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $17f526922e4a857c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $17f526922e4a857c$var$Qc.length && 0 !== b && b < $17f526922e4a857c$var$Qc[c].priority; c++);
        $17f526922e4a857c$var$Qc.splice(c, 0, a);
        0 === c && $17f526922e4a857c$var$Vc(a);
    }
};
function $17f526922e4a857c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $17f526922e4a857c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $17f526922e4a857c$var$pl() {}
function $17f526922e4a857c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $17f526922e4a857c$var$gl(g);
                f.call(a);
            };
        }
        var g = $17f526922e4a857c$var$el(b, d, a, 0, null, !1, !1, "", $17f526922e4a857c$var$pl);
        a._reactRootContainer = g;
        a[$17f526922e4a857c$var$uf] = g.current;
        $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $17f526922e4a857c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $17f526922e4a857c$var$gl(k);
            h.call(a);
        };
    }
    var k = $17f526922e4a857c$var$bl(a, 0, !1, null, null, !1, !1, "", $17f526922e4a857c$var$pl);
    a._reactRootContainer = k;
    a[$17f526922e4a857c$var$uf] = k.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$fl(b, k, c, d);
    });
    return k;
}
function $17f526922e4a857c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $17f526922e4a857c$var$gl(g);
                h.call(a);
            };
        }
        $17f526922e4a857c$var$fl(b, g, a, e);
    } else g = $17f526922e4a857c$var$ql(c, b, a, e, d);
    return $17f526922e4a857c$var$gl(g);
}
$17f526922e4a857c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $17f526922e4a857c$var$tc(b.pendingLanes);
                0 !== c && ($17f526922e4a857c$var$Cc(b, c | 1), $17f526922e4a857c$var$Dk(b, $17f526922e4a857c$var$B()), 0 === ($17f526922e4a857c$var$K & 6) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$jg()));
            }
            break;
        case 13:
            $17f526922e4a857c$var$Rk(function() {
                var b = $17f526922e4a857c$var$ih(a, 1);
                if (null !== b) {
                    var c = $17f526922e4a857c$var$R();
                    $17f526922e4a857c$var$gi(b, a, 1, c);
                }
            }), $17f526922e4a857c$var$il(a, 1);
    }
};
$17f526922e4a857c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(b, a, 134217728, c);
        }
        $17f526922e4a857c$var$il(a, 134217728);
    }
};
$17f526922e4a857c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$yi(a), c = $17f526922e4a857c$var$ih(a, b);
        if (null !== c) {
            var d = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(c, a, b, d);
        }
        $17f526922e4a857c$var$il(a, b);
    }
};
$17f526922e4a857c$var$Hc = function() {
    return $17f526922e4a857c$var$C;
};
$17f526922e4a857c$var$Ic = function(a, b) {
    var c = $17f526922e4a857c$var$C;
    try {
        return $17f526922e4a857c$var$C = a, b();
    } finally{
        $17f526922e4a857c$var$C = c;
    }
};
$17f526922e4a857c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $17f526922e4a857c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $17f526922e4a857c$var$Db(d);
                        if (!e) throw Error($17f526922e4a857c$var$p(90));
                        $17f526922e4a857c$var$Wa(d);
                        $17f526922e4a857c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $17f526922e4a857c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $17f526922e4a857c$var$fb(a, !!c.multiple, b, !1);
    }
};
$17f526922e4a857c$var$Gb = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$var$Hb = $17f526922e4a857c$var$Rk;
var $17f526922e4a857c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $17f526922e4a857c$var$Cb,
        $17f526922e4a857c$var$ue,
        $17f526922e4a857c$var$Db,
        $17f526922e4a857c$var$Eb,
        $17f526922e4a857c$var$Fb,
        $17f526922e4a857c$var$Qk
    ]
}, $17f526922e4a857c$var$tl = {
    findFiberByHostInstance: $17f526922e4a857c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $17f526922e4a857c$var$ul = {
    bundleType: $17f526922e4a857c$var$tl.bundleType,
    version: $17f526922e4a857c$var$tl.version,
    rendererPackageName: $17f526922e4a857c$var$tl.rendererPackageName,
    rendererConfig: $17f526922e4a857c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $17f526922e4a857c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $17f526922e4a857c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $17f526922e4a857c$var$tl.findFiberByHostInstance || $17f526922e4a857c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $17f526922e4a857c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$17f526922e4a857c$var$vl.isDisabled && $17f526922e4a857c$var$vl.supportsFiber) try {
        $17f526922e4a857c$var$kc = $17f526922e4a857c$var$vl.inject($17f526922e4a857c$var$ul), $17f526922e4a857c$var$lc = $17f526922e4a857c$var$vl;
    } catch (a) {}
}
$17f526922e4a857c$export$ae55be85d98224ed = $17f526922e4a857c$var$sl;
$17f526922e4a857c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$17f526922e4a857c$var$nl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$cl(a, b, null, c);
};
$17f526922e4a857c$export$882461b6382ed46c = function(a, b) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(299));
    var c = !1, d = "", e = $17f526922e4a857c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $17f526922e4a857c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $17f526922e4a857c$var$ll(b);
};
$17f526922e4a857c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($17f526922e4a857c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($17f526922e4a857c$var$p(268, a));
    }
    a = $17f526922e4a857c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$17f526922e4a857c$export$cd75ccfd720a3cd4 = function(a) {
    return $17f526922e4a857c$var$Rk(a);
};
$17f526922e4a857c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !0, c);
};
$17f526922e4a857c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $17f526922e4a857c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $17f526922e4a857c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $17f526922e4a857c$var$ml(b);
};
$17f526922e4a857c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !1, c);
};
$17f526922e4a857c$export$502457920280e6be = function(a) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(40));
    return a._reactRootContainer ? ($17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$17f526922e4a857c$var$uf] = null;
        });
    }), !0) : !1;
};
$17f526922e4a857c$export$c78a37762a8d58e1 = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$17f526922e4a857c$var$ol(c)) throw Error($17f526922e4a857c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($17f526922e4a857c$var$p(38));
    return $17f526922e4a857c$var$rl(a, b, c, !1, d);
};
$17f526922e4a857c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
'use strict';
function $3d3ce0c592af0505$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3d3ce0c592af0505$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3d3ce0c592af0505$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3d3ce0c592af0505$var$g(C, c)) n < e && 0 > $3d3ce0c592af0505$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3d3ce0c592af0505$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3d3ce0c592af0505$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
var $3d3ce0c592af0505$var$r = [], $3d3ce0c592af0505$var$t = [], $3d3ce0c592af0505$var$u = 1, $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = 3, $3d3ce0c592af0505$var$z = !1, $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$D = "function" === typeof setTimeout ? setTimeout : null, $3d3ce0c592af0505$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3d3ce0c592af0505$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3d3ce0c592af0505$var$G(a) {
    for(var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, b);
        else break;
        b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
    }
}
function $3d3ce0c592af0505$var$H(a) {
    $3d3ce0c592af0505$var$B = !1;
    $3d3ce0c592af0505$var$G(a);
    if (!$3d3ce0c592af0505$var$A) {
        if (null !== $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r)) $3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J);
        else {
            var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== b && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$J(a, b) {
    $3d3ce0c592af0505$var$A = !1;
    $3d3ce0c592af0505$var$B && ($3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1);
    $3d3ce0c592af0505$var$z = !0;
    var c = $3d3ce0c592af0505$var$y;
    try {
        $3d3ce0c592af0505$var$G(b);
        for($3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r); null !== $3d3ce0c592af0505$var$v && (!($3d3ce0c592af0505$var$v.expirationTime > b) || a && !$3d3ce0c592af0505$var$M());){
            var d = $3d3ce0c592af0505$var$v.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$v.callback = null;
                $3d3ce0c592af0505$var$y = $3d3ce0c592af0505$var$v.priorityLevel;
                var e = d($3d3ce0c592af0505$var$v.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$v.callback = e : $3d3ce0c592af0505$var$v === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
                $3d3ce0c592af0505$var$G(b);
            } else $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
            $3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
        }
        if (null !== $3d3ce0c592af0505$var$v) var w = !0;
        else {
            var m = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== m && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = c, $3d3ce0c592af0505$var$z = !1;
    }
}
var $3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$L = -1, $3d3ce0c592af0505$var$P = 5, $3d3ce0c592af0505$var$Q = -1;
function $3d3ce0c592af0505$var$M() {
    return $3d3ce0c592af0505$export$c4744153514ff05d() - $3d3ce0c592af0505$var$Q < $3d3ce0c592af0505$var$P ? !1 : !0;
}
function $3d3ce0c592af0505$var$R() {
    if (null !== $3d3ce0c592af0505$var$O) {
        var a = $3d3ce0c592af0505$export$c4744153514ff05d();
        $3d3ce0c592af0505$var$Q = a;
        var b = !0;
        try {
            b = $3d3ce0c592af0505$var$O(!0, a);
        } finally{
            b ? $3d3ce0c592af0505$var$S() : ($3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null);
        }
    } else $3d3ce0c592af0505$var$N = !1;
}
var $3d3ce0c592af0505$var$S;
if ("function" === typeof $3d3ce0c592af0505$var$F) $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$F($3d3ce0c592af0505$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$T = new MessageChannel, $3d3ce0c592af0505$var$U = $3d3ce0c592af0505$var$T.port2;
    $3d3ce0c592af0505$var$T.port1.onmessage = $3d3ce0c592af0505$var$R;
    $3d3ce0c592af0505$var$S = function() {
        $3d3ce0c592af0505$var$U.postMessage(null);
    };
} else $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$D($3d3ce0c592af0505$var$R, 0);
};
function $3d3ce0c592af0505$var$I(a) {
    $3d3ce0c592af0505$var$O = a;
    $3d3ce0c592af0505$var$N || ($3d3ce0c592af0505$var$N = !0, $3d3ce0c592af0505$var$S());
}
function $3d3ce0c592af0505$var$K(a, b) {
    $3d3ce0c592af0505$var$L = $3d3ce0c592af0505$var$D(function() {
        a($3d3ce0c592af0505$export$c4744153514ff05d());
    }, b);
}
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J));
};
$3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$y;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$y;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = function() {};
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$t, a), null === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && a === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t) && ($3d3ce0c592af0505$var$B ? ($3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1) : $3d3ce0c592af0505$var$B = !0, $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, a), $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J)));
    return a;
};
$3d3ce0c592af0505$export$b5836b71941fa3ed = $3d3ce0c592af0505$var$M;
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$y;
    return function() {
        var c = $3d3ce0c592af0505$var$y;
        $3d3ce0c592af0505$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$y = c;
        }
    };
};

});



parcelRegister("6DzO8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iz60K = parcelRequire("iz60K");
function $4d52293a79bcab4c$var$emptyFunction() {}
function $4d52293a79bcab4c$var$emptyFunctionWithReset() {}
$4d52293a79bcab4c$var$emptyFunctionWithReset.resetWarningCache = $4d52293a79bcab4c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iz60K) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4d52293a79bcab4c$var$emptyFunctionWithReset,
        resetWarningCache: $4d52293a79bcab4c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iz60K", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $d840288929500773$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $d840288929500773$var$ReactPropTypesSecret;

});


parcelRegister("lBRDc", function(module, exports) {
function $fbb6a7bc8836e7ee$var$_extends() {
    return module.exports = $fbb6a7bc8836e7ee$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fbb6a7bc8836e7ee$var$_extends.apply(null, arguments);
}
module.exports = $fbb6a7bc8836e7ee$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6oOAi", function(module, exports) {
function $4a8c38fb0b611662$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $4a8c38fb0b611662$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("91MX1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $692a2db83a568a31$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $692a2db83a568a31$export$e00380445f2b9e0c);
$parcel$export(module.exports, "internal_serializeStyles", () => $692a2db83a568a31$export$13a2d3ef13012b32);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("iSBXh")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("9XmJK")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("9XmJK")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("hFXU8")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("hvbO6")).default);
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $jE0f9 = parcelRequire("jE0f9");

var $gLVll = parcelRequire("gLVll");

var $9XmJK = parcelRequire("9XmJK");
var $iSBXh = parcelRequire("iSBXh");

var $hFXU8 = parcelRequire("hFXU8");

var $hvbO6 = parcelRequire("hvbO6");
'use client';
function $692a2db83a568a31$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $jE0f9.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $692a2db83a568a31$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $692a2db83a568a31$var$wrapper = [];
function $692a2db83a568a31$export$13a2d3ef13012b32(styles) {
    $692a2db83a568a31$var$wrapper[0] = styles;
    return (0, $gLVll.serializeStyles)($692a2db83a568a31$var$wrapper);
}

});
parcelRegister("jE0f9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d1f1143f0576fb$export$2e2bcd8739ae039);

var $acdsL = parcelRequire("acdsL");
parcelRequire("lBRDc");

parcelRequire("gLVll");
parcelRequire("gwJ0Y");
parcelRequire("i1Adn");
parcelRequire("8NFma");
parcelRequire("hcFfS");
var $e4d1f1143f0576fb$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $e4d1f1143f0576fb$export$2e2bcd8739ae039 = (0, $acdsL.default).bind(null);
$e4d1f1143f0576fb$var$tags.forEach(function(tagName) {
    $e4d1f1143f0576fb$export$2e2bcd8739ae039[tagName] = $e4d1f1143f0576fb$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("acdsL", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c577d4a53a87dd$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");
parcelRequire("9XmJK");
var $iSBXh = parcelRequire("iSBXh");

var $gLVll = parcelRequire("gLVll");

var $gwJ0Y = parcelRequire("gwJ0Y");

var $i1Adn = parcelRequire("i1Adn");

var $8NFma = parcelRequire("8NFma");

var $hcFfS = parcelRequire("hcFfS");
var $76c577d4a53a87dd$var$isBrowser = typeof document !== 'undefined';
var $76c577d4a53a87dd$var$isDevelopment = false;
var $76c577d4a53a87dd$var$testOmitPropsOnStringTag = (0, $hcFfS.default);
var $76c577d4a53a87dd$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $76c577d4a53a87dd$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $76c577d4a53a87dd$var$testOmitPropsOnStringTag : $76c577d4a53a87dd$var$testOmitPropsOnComponent;
};
var $76c577d4a53a87dd$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $76c577d4a53a87dd$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $i1Adn.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gwJ0Y.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $i1Adn.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$76c577d4a53a87dd$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $76c577d4a53a87dd$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $76c577d4a53a87dd$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $76c577d4a53a87dd$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $iSBXh.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8NFma.useContext((0, $iSBXh.T));
            }
            if (typeof props.className === 'string') className = (0, $i1Adn.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $gLVll.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $76c577d4a53a87dd$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($76c577d4a53a87dd$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $8NFma.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $76c577d4a53a87dd$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $jz4iA.default)({}, options, nextOptions, {
                shouldForwardProp: $76c577d4a53a87dd$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("jz4iA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e49ed681292e30$export$2e2bcd8739ae039);
function $e3e49ed681292e30$export$2e2bcd8739ae039() {
    return $e3e49ed681292e30$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e3e49ed681292e30$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("9XmJK", function(module, exports) {

$parcel$export(module.exports, "Global", () => $01dee42c9ca53feb$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $01dee42c9ca53feb$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $01dee42c9ca53feb$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("iSBXh")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("iSBXh")).w);

var $iSBXh = parcelRequire("iSBXh");

var $8NFma = parcelRequire("8NFma");

var $i1Adn = parcelRequire("i1Adn");

var $gwJ0Y = parcelRequire("gwJ0Y");

var $gLVll = parcelRequire("gLVll");
parcelRequire("dMiGn");
parcelRequire("lBRDc");
parcelRequire("dBNhP");

parcelRequire("l3NX5");
var $01dee42c9ca53feb$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $iSBXh.h).call(props, 'css')) return $8NFma.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $iSBXh.E);
    createElementArgArray[1] = (0, $iSBXh.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $8NFma.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($01dee42c9ca53feb$export$c8a8987d4410bf2d || ($01dee42c9ca53feb$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $01dee42c9ca53feb$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $iSBXh.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $gLVll.serializeStyles)([
        styles
    ], undefined, $8NFma.useContext((0, $iSBXh.T)));
    if (!(0, $iSBXh.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8NFma.useRef();
    (0, $gwJ0Y.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gwJ0Y.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $i1Adn.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $01dee42c9ca53feb$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $gLVll.serializeStyles)(args);
}
function $01dee42c9ca53feb$export$d25ddfdf17c3ad3e() {
    var insertable = $01dee42c9ca53feb$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $01dee42c9ca53feb$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $01dee42c9ca53feb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $i1Adn.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $01dee42c9ca53feb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $gwJ0Y.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $i1Adn.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $iSBXh.i) && res !== undefined) rules += res;
        }
        if (!(0, $iSBXh.i)) return rules;
    });
    if (!(0, $iSBXh.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $01dee42c9ca53feb$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $iSBXh.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $iSBXh.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $gLVll.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $i1Adn.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $iSBXh.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $01dee42c9ca53feb$var$merge(cache.registered, css, $01dee42c9ca53feb$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8NFma.useContext((0, $iSBXh.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($01dee42c9ca53feb$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("iSBXh", function(module, exports) {

$parcel$export(module.exports, "a", () => $dbeab63edf3287cf$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $dbeab63edf3287cf$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $dbeab63edf3287cf$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $dbeab63edf3287cf$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $dbeab63edf3287cf$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $dbeab63edf3287cf$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $dbeab63edf3287cf$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $dbeab63edf3287cf$export$a9c23c6ac3fc3eca);

var $8NFma = parcelRequire("8NFma");

var $dMiGn = parcelRequire("dMiGn");

var $jz4iA = parcelRequire("jz4iA");

var $dBNhP = parcelRequire("dBNhP");

var $69vM6 = parcelRequire("69vM6");

var $i1Adn = parcelRequire("i1Adn");

var $gLVll = parcelRequire("gLVll");

var $gwJ0Y = parcelRequire("gwJ0Y");
var $dbeab63edf3287cf$export$407448d2b89b1813 = false;
var $dbeab63edf3287cf$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $dbeab63edf3287cf$var$EmotionCacheContext = /* #__PURE__ */ $8NFma.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $dMiGn.default)({
    key: 'css'
}) : null);
var $dbeab63edf3287cf$export$e7094788287c5e9b = $dbeab63edf3287cf$var$EmotionCacheContext.Provider;
var $dbeab63edf3287cf$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8NFma.useContext)($dbeab63edf3287cf$var$EmotionCacheContext);
};
var $dbeab63edf3287cf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $8NFma.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8NFma.useContext)($dbeab63edf3287cf$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$dbeab63edf3287cf$export$23f2a1d2818174ef) $dbeab63edf3287cf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8NFma.useContext)($dbeab63edf3287cf$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $dMiGn.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8NFma.createElement($dbeab63edf3287cf$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $dbeab63edf3287cf$export$971d5caa766a69d7 = /* #__PURE__ */ $8NFma.createContext({});
var $dbeab63edf3287cf$export$3b14a55fb2447963 = function useTheme() {
    return $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7);
};
var $dbeab63edf3287cf$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $jz4iA.default)({}, outerTheme, theme);
};
var $dbeab63edf3287cf$var$createCacheWithTheme = /* #__PURE__ */ (0, $dBNhP.default)(function(outerTheme) {
    return (0, $dBNhP.default)(function(theme) {
        return $dbeab63edf3287cf$var$getTheme(outerTheme, theme);
    });
});
var $dbeab63edf3287cf$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $dbeab63edf3287cf$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8NFma.createElement($dbeab63edf3287cf$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $dbeab63edf3287cf$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $8NFma.forwardRef(function render(props, ref) {
        var theme = $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8NFma.createElement(Component, (0, $jz4iA.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $69vM6.default)(WithTheme, Component);
}
var $dbeab63edf3287cf$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $dbeab63edf3287cf$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $dbeab63edf3287cf$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($dbeab63edf3287cf$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$dbeab63edf3287cf$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $dbeab63edf3287cf$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $i1Adn.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gwJ0Y.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $i1Adn.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$dbeab63edf3287cf$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $dbeab63edf3287cf$var$Emotion = /* #__PURE__ */ $dbeab63edf3287cf$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$dbeab63edf3287cf$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $i1Adn.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $gLVll.serializeStyles)(registeredStyles, undefined, $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($dbeab63edf3287cf$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $dbeab63edf3287cf$var$typePropName && !$dbeab63edf3287cf$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($dbeab63edf3287cf$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8NFma.createElement(WrappedComponent, newProps));
});
var $dbeab63edf3287cf$export$a9c23c6ac3fc3eca = $dbeab63edf3287cf$var$Emotion;

});
parcelRegister("dMiGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07e4002c0412599$export$2e2bcd8739ae039);

var $2Dt2A = parcelRequire("2Dt2A");

var $5ZhKJ = parcelRequire("5ZhKJ");

var $dBNhP = parcelRequire("dBNhP");

var $b9Xpj = parcelRequire("b9Xpj");
var $a07e4002c0412599$var$isBrowser = typeof document !== 'undefined';
var $a07e4002c0412599$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $5ZhKJ.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $5ZhKJ.token)(character)) break;
        (0, $5ZhKJ.next)();
    }
    return (0, $5ZhKJ.slice)(begin, (0, $5ZhKJ.position));
};
var $a07e4002c0412599$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $5ZhKJ.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $5ZhKJ.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $a07e4002c0412599$var$identifierWithPointTracking((0, $5ZhKJ.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $5ZhKJ.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $5ZhKJ.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5ZhKJ.from)(character);
    }
    while (character = (0, $5ZhKJ.next)());
    return parsed;
};
var $a07e4002c0412599$var$getRules = function getRules(value, points) {
    return (0, $5ZhKJ.dealloc)($a07e4002c0412599$var$toRules((0, $5ZhKJ.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $a07e4002c0412599$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $a07e4002c0412599$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$a07e4002c0412599$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $a07e4002c0412599$var$fixedElements.set(element, true);
    var points = [];
    var rules = $a07e4002c0412599$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $a07e4002c0412599$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $a07e4002c0412599$var$prefix(value, length) {
    switch((0, $5ZhKJ.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $5ZhKJ.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $5ZhKJ.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MOZ) + value + (0, $5ZhKJ.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + value + value;
        // order
        case 6165:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.replace)(value, /(\w+).+(:[^]+)/, (0, $5ZhKJ.WEBKIT) + 'box-$1$2' + (0, $5ZhKJ.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + 'flex-item-' + (0, $5ZhKJ.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + 'flex-line-pack' + (0, $5ZhKJ.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $5ZhKJ.WEBKIT) + 'box-' + (0, $5ZhKJ.replace)(value, '-grow', '') + (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $5ZhKJ.WEBKIT) + (0, $5ZhKJ.replace)(value, /([^-])(transform)/g, '$1' + (0, $5ZhKJ.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5ZhKJ.replace)((0, $5ZhKJ.replace)((0, $5ZhKJ.replace)(value, /(zoom-|grab)/, (0, $5ZhKJ.WEBKIT) + '$1'), /(image-set)/, (0, $5ZhKJ.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5ZhKJ.replace)(value, /(image-set\([^]*)/, (0, $5ZhKJ.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5ZhKJ.replace)((0, $5ZhKJ.replace)(value, /(.+:)(flex-)?(.*)/, (0, $5ZhKJ.WEBKIT) + 'box-pack:$3' + (0, $5ZhKJ.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $5ZhKJ.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5ZhKJ.replace)(value, /(.+)-inline(.+)/, (0, $5ZhKJ.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5ZhKJ.strlen)(value) - 1 - length > 6) switch((0, $5ZhKJ.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5ZhKJ.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5ZhKJ.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $5ZhKJ.WEBKIT) + '$2-$3' + '$1' + (0, $5ZhKJ.MOZ) + ((0, $5ZhKJ.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5ZhKJ.indexof)(value, 'stretch') ? $a07e4002c0412599$var$prefix((0, $5ZhKJ.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5ZhKJ.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5ZhKJ.charat)(value, (0, $5ZhKJ.strlen)(value) - 3 - (~(0, $5ZhKJ.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $5ZhKJ.replace)(value, ':', ':' + (0, $5ZhKJ.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5ZhKJ.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $5ZhKJ.WEBKIT) + ((0, $5ZhKJ.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $5ZhKJ.WEBKIT) + '$2$3' + '$1' + (0, $5ZhKJ.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5ZhKJ.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + value + value;
    }
    return value;
}
var $a07e4002c0412599$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $5ZhKJ.DECLARATION:
                element["return"] = $a07e4002c0412599$var$prefix(element.value, element.length);
                break;
            case 0, $5ZhKJ.KEYFRAMES:
                return (0, $5ZhKJ.serialize)([
                    (0, $5ZhKJ.copy)(element, {
                        value: (0, $5ZhKJ.replace)(element.value, '@', '@' + (0, $5ZhKJ.WEBKIT))
                    })
                ], callback);
            case 0, $5ZhKJ.RULESET:
                if (element.length) return (0, $5ZhKJ.combine)(element.props, function(value) {
                    switch((0, $5ZhKJ.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $5ZhKJ.serialize)([
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(read-\w+)/, ':' + (0, $5ZhKJ.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $5ZhKJ.serialize)([
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(plac\w+)/, ':' + (0, $5ZhKJ.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(plac\w+)/, ':' + (0, $5ZhKJ.MOZ) + '$1')
                                    ]
                                }),
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(plac\w+)/, (0, $5ZhKJ.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $a07e4002c0412599$var$getServerStylisCache = $a07e4002c0412599$var$isBrowser ? undefined : (0, $dBNhP.default)(function() {
    return (0, $b9Xpj.default)(function() {
        return {};
    });
});
var $a07e4002c0412599$var$defaultStylisPlugins = [
    $a07e4002c0412599$var$prefixer
];
var $a07e4002c0412599$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($a07e4002c0412599$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $a07e4002c0412599$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($a07e4002c0412599$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $a07e4002c0412599$var$compat,
        $a07e4002c0412599$var$removeLabel
    ];
    if (!$a07e4002c0412599$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $5ZhKJ.stringify),
            (0, $5ZhKJ.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $5ZhKJ.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $5ZhKJ.serialize)((0, $5ZhKJ.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $5ZhKJ.stringify)
        ];
        var _serializer = (0, $5ZhKJ.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $5ZhKJ.serialize)((0, $5ZhKJ.compile)(styles), _serializer);
        };
        var serverStylisCache = $a07e4002c0412599$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $2Dt2A.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("2Dt2A", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $1eb5c02cfaf58a20$export$9d753cd7ae895cce);
var $1eb5c02cfaf58a20$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $1eb5c02cfaf58a20$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $1eb5c02cfaf58a20$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $1eb5c02cfaf58a20$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$1eb5c02cfaf58a20$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($1eb5c02cfaf58a20$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $1eb5c02cfaf58a20$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("5ZhKJ", function(module, exports) {

$parcel$export(module.exports, "MS", () => $e36f1de21b27a557$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $e36f1de21b27a557$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $e36f1de21b27a557$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $e36f1de21b27a557$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $e36f1de21b27a557$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $e36f1de21b27a557$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $e36f1de21b27a557$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $e36f1de21b27a557$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $e36f1de21b27a557$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $e36f1de21b27a557$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $e36f1de21b27a557$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $e36f1de21b27a557$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $e36f1de21b27a557$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $e36f1de21b27a557$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $e36f1de21b27a557$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $e36f1de21b27a557$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $e36f1de21b27a557$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $e36f1de21b27a557$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $e36f1de21b27a557$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $e36f1de21b27a557$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $e36f1de21b27a557$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $e36f1de21b27a557$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $e36f1de21b27a557$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $e36f1de21b27a557$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $e36f1de21b27a557$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $e36f1de21b27a557$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $e36f1de21b27a557$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $e36f1de21b27a557$export$38bcb760f1d4871c);
var $e36f1de21b27a557$export$71ad59f2e432cfe8 = "-ms-";
var $e36f1de21b27a557$export$2c0f367103c8d01c = "-moz-";
var $e36f1de21b27a557$export$39dfd62a25e0fe93 = "-webkit-";
var $e36f1de21b27a557$export$a29989082612d0d9 = "comm";
var $e36f1de21b27a557$export$aa3a2e812ca8570d = "rule";
var $e36f1de21b27a557$export$527d108ccf083c2b = "decl";
var $e36f1de21b27a557$export$d3d35020fa5b54f0 = "@page";
var $e36f1de21b27a557$export$500415a86c544f73 = "@media";
var $e36f1de21b27a557$export$a763edbf796b780a = "@import";
var $e36f1de21b27a557$export$2790aeb8b4e5c826 = "@charset";
var $e36f1de21b27a557$export$1cc683e23b84b133 = "@viewport";
var $e36f1de21b27a557$export$9447a5efea57e862 = "@supports";
var $e36f1de21b27a557$export$ef011b4e114b1fba = "@document";
var $e36f1de21b27a557$export$6aad947bda0f3f46 = "@namespace";
var $e36f1de21b27a557$export$b44a8529a35fcb60 = "@keyframes";
var $e36f1de21b27a557$export$2c16de31893252e6 = "@font-face";
var $e36f1de21b27a557$export$3d846dd52e150c6f = "@counter-style";
var $e36f1de21b27a557$export$22314bfbb57653fe = "@font-feature-values";
var $e36f1de21b27a557$export$d773506282b3cfe6 = "@layer";
var $e36f1de21b27a557$export$2335f513bbd82c6d = Math.abs;
var $e36f1de21b27a557$export$6788812c4e6611e6 = String.fromCharCode;
var $e36f1de21b27a557$export$e6e34fd1f2686227 = Object.assign;
function $e36f1de21b27a557$export$d6af199866bfb566(e, r) {
    return $e36f1de21b27a557$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 0)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 1)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 2)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 3) : 0;
}
function $e36f1de21b27a557$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $e36f1de21b27a557$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $e36f1de21b27a557$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $e36f1de21b27a557$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $e36f1de21b27a557$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $e36f1de21b27a557$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $e36f1de21b27a557$export$36776f635604f274(e) {
    return e.length;
}
function $e36f1de21b27a557$export$f9084667e487ed46(e) {
    return e.length;
}
function $e36f1de21b27a557$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $e36f1de21b27a557$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $e36f1de21b27a557$export$53f1d5ea8de3d7c = 1;
var $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1;
var $e36f1de21b27a557$export$f24224f1c91d8156 = 0;
var $e36f1de21b27a557$export$5880b8b5730aff45 = 0;
var $e36f1de21b27a557$export$c0306caf338ac095 = 0;
var $e36f1de21b27a557$export$30a86d91af8ff6e6 = "";
function $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $e36f1de21b27a557$export$53f1d5ea8de3d7c,
        column: $e36f1de21b27a557$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $e36f1de21b27a557$export$784d13d8ee351f07(e, r) {
    return $e36f1de21b27a557$export$e6e34fd1f2686227($e36f1de21b27a557$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $e36f1de21b27a557$export$eba6f6f03b0a92e7() {
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$232faf9add678146() {
    $e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$5880b8b5730aff45 > 0 ? $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, --$e36f1de21b27a557$export$5880b8b5730aff45) : 0;
    if ($e36f1de21b27a557$export$4e0c71f277ca26b3--, $e36f1de21b27a557$export$c0306caf338ac095 === 10) $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$53f1d5ea8de3d7c--;
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$48cfd1e771a65c4f() {
    $e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$5880b8b5730aff45 < $e36f1de21b27a557$export$f24224f1c91d8156 ? $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, $e36f1de21b27a557$export$5880b8b5730aff45++) : 0;
    if ($e36f1de21b27a557$export$4e0c71f277ca26b3++, $e36f1de21b27a557$export$c0306caf338ac095 === 10) $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$53f1d5ea8de3d7c++;
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$4d3fb11e950abb9e() {
    return $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, $e36f1de21b27a557$export$5880b8b5730aff45);
}
function $e36f1de21b27a557$export$e88cb2efb12ae807() {
    return $e36f1de21b27a557$export$5880b8b5730aff45;
}
function $e36f1de21b27a557$export$58adb3bec8346d0f(e, r) {
    return $e36f1de21b27a557$export$2f35ab04d2335697($e36f1de21b27a557$export$30a86d91af8ff6e6, e, r);
}
function $e36f1de21b27a557$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e36f1de21b27a557$export$2de70f21292aac9e(e) {
    return $e36f1de21b27a557$export$53f1d5ea8de3d7c = $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$f24224f1c91d8156 = $e36f1de21b27a557$export$36776f635604f274($e36f1de21b27a557$export$30a86d91af8ff6e6 = e), $e36f1de21b27a557$export$5880b8b5730aff45 = 0, [];
}
function $e36f1de21b27a557$export$45918ac1574455b1(e) {
    return $e36f1de21b27a557$export$30a86d91af8ff6e6 = "", e;
}
function $e36f1de21b27a557$export$410ac95b9ec204b8(e) {
    return $e36f1de21b27a557$export$87c2784dc9fc4ab($e36f1de21b27a557$export$58adb3bec8346d0f($e36f1de21b27a557$export$5880b8b5730aff45 - 1, $e36f1de21b27a557$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $e36f1de21b27a557$export$660b2ee2d4fb4eff(e) {
    return $e36f1de21b27a557$export$45918ac1574455b1($e36f1de21b27a557$export$5f8c09e3ae6f64e1($e36f1de21b27a557$export$2de70f21292aac9e(e)));
}
function $e36f1de21b27a557$export$7af1228ff777d175(e) {
    while($e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$4d3fb11e950abb9e())if ($e36f1de21b27a557$export$c0306caf338ac095 < 33) $e36f1de21b27a557$export$48cfd1e771a65c4f();
    else break;
    return $e36f1de21b27a557$export$9e1725a4cfeada27(e) > 2 || $e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $e36f1de21b27a557$export$5f8c09e3ae6f64e1(e) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())switch($e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$c0306caf338ac095)){
        case 0:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$c2ab62c7bf24634($e36f1de21b27a557$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$410ac95b9ec204b8($e36f1de21b27a557$export$c0306caf338ac095), e);
            break;
        default:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$6788812c4e6611e6($e36f1de21b27a557$export$c0306caf338ac095), e);
    }
    return e;
}
function $e36f1de21b27a557$export$955ba06d119e085e(e, r) {
    while(--r && $e36f1de21b27a557$export$48cfd1e771a65c4f())if ($e36f1de21b27a557$export$c0306caf338ac095 < 48 || $e36f1de21b27a557$export$c0306caf338ac095 > 102 || $e36f1de21b27a557$export$c0306caf338ac095 > 57 && $e36f1de21b27a557$export$c0306caf338ac095 < 65 || $e36f1de21b27a557$export$c0306caf338ac095 > 70 && $e36f1de21b27a557$export$c0306caf338ac095 < 97) break;
    return $e36f1de21b27a557$export$58adb3bec8346d0f(e, $e36f1de21b27a557$export$e88cb2efb12ae807() + (r < 6 && $e36f1de21b27a557$export$4d3fb11e950abb9e() == 32 && $e36f1de21b27a557$export$48cfd1e771a65c4f() == 32));
}
function $e36f1de21b27a557$export$c889f2fcc19dbf12(e) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())switch($e36f1de21b27a557$export$c0306caf338ac095){
        case e:
            return $e36f1de21b27a557$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $e36f1de21b27a557$export$c889f2fcc19dbf12($e36f1de21b27a557$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $e36f1de21b27a557$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $e36f1de21b27a557$export$48cfd1e771a65c4f();
            break;
    }
    return $e36f1de21b27a557$export$5880b8b5730aff45;
}
function $e36f1de21b27a557$export$4254d4e2b3745c4c(e, r) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())if (e + $e36f1de21b27a557$export$c0306caf338ac095 === 57) break;
    else if (e + $e36f1de21b27a557$export$c0306caf338ac095 === 84 && $e36f1de21b27a557$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $e36f1de21b27a557$export$58adb3bec8346d0f(r, $e36f1de21b27a557$export$5880b8b5730aff45 - 1) + "*" + $e36f1de21b27a557$export$6788812c4e6611e6(e === 47 ? e : $e36f1de21b27a557$export$48cfd1e771a65c4f());
}
function $e36f1de21b27a557$export$c2ab62c7bf24634(e) {
    while(!$e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$4d3fb11e950abb9e()))$e36f1de21b27a557$export$48cfd1e771a65c4f();
    return $e36f1de21b27a557$export$58adb3bec8346d0f(e, $e36f1de21b27a557$export$5880b8b5730aff45);
}
function $e36f1de21b27a557$export$ef7acd7185315e22(e) {
    return $e36f1de21b27a557$export$45918ac1574455b1($e36f1de21b27a557$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $e36f1de21b27a557$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $e36f1de21b27a557$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $e36f1de21b27a557$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $e36f1de21b27a557$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($e36f1de21b27a557$export$f8e21b1e77979a08(j += $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $e36f1de21b27a557$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $e36f1de21b27a557$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $e36f1de21b27a557$export$955ba06d119e085e($e36f1de21b27a557$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($e36f1de21b27a557$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$4a34f930e789283c($e36f1de21b27a557$export$4254d4e2b3745c4c($e36f1de21b27a557$export$48cfd1e771a65c4f(), $e36f1de21b27a557$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $e36f1de21b27a557$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $e36f1de21b27a557$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $e36f1de21b27a557$export$36776f635604f274(j) - l) $e36f1de21b27a557$export$10d8903dec122b9d(p > 32 ? $e36f1de21b27a557$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $e36f1de21b27a557$export$f8483753829ec8f3($e36f1de21b27a557$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $e36f1de21b27a557$export$10d8903dec122b9d(y = $e36f1de21b27a557$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $e36f1de21b27a557$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $e36f1de21b27a557$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $e36f1de21b27a557$export$98e6a39c04603d36(e, y, y, n && $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $e36f1de21b27a557$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $e36f1de21b27a557$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $e36f1de21b27a557$export$232faf9add678146() == 125) continue;
            }
            switch(j += $e36f1de21b27a557$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($e36f1de21b27a557$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($e36f1de21b27a557$export$4d3fb11e950abb9e() === 45) j += $e36f1de21b27a557$export$410ac95b9ec204b8($e36f1de21b27a557$export$48cfd1e771a65c4f());
                    v = $e36f1de21b27a557$export$4d3fb11e950abb9e(), o = l = $e36f1de21b27a557$export$36776f635604f274(g = j += $e36f1de21b27a557$export$c2ab62c7bf24634($e36f1de21b27a557$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $e36f1de21b27a557$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $e36f1de21b27a557$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $e36f1de21b27a557$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $e36f1de21b27a557$export$2f35ab04d2335697(e, v + 1, v = $e36f1de21b27a557$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $e36f1de21b27a557$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $e36f1de21b27a557$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, s === 0 ? $e36f1de21b27a557$export$aa3a2e812ca8570d : i, f, o, l);
}
function $e36f1de21b27a557$export$4a34f930e789283c(e, r, a) {
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, $e36f1de21b27a557$export$a29989082612d0d9, $e36f1de21b27a557$export$6788812c4e6611e6($e36f1de21b27a557$export$eba6f6f03b0a92e7()), $e36f1de21b27a557$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $e36f1de21b27a557$export$f8483753829ec8f3(e, r, a, n) {
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, $e36f1de21b27a557$export$527d108ccf083c2b, $e36f1de21b27a557$export$2f35ab04d2335697(e, 0, n), $e36f1de21b27a557$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $e36f1de21b27a557$export$82e9f45cca5ba907(n, c, s) {
    switch($e36f1de21b27a557$export$d6af199866bfb566(n, c)){
        case 5103:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $e36f1de21b27a557$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$2c0f367103c8d01c + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($e36f1de21b27a557$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-$1$2" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-item-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$e36f1de21b27a557$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-row-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-line-pack" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-grow", "") + $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-pack:$3" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$e36f1de21b27a557$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-column-align" + $e36f1de21b27a557$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $e36f1de21b27a557$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$e36f1de21b27a557$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$e36f1de21b27a557$export$f8e21b1e77979a08(s, "span") ? $e36f1de21b27a557$export$4659b591c19bdf3d(s, /\d+/) : +$e36f1de21b27a557$export$4659b591c19bdf3d(s, /\d+/) - +$e36f1de21b27a557$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $e36f1de21b27a557$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($e36f1de21b27a557$export$36776f635604f274(n) - 1 - c > 6) switch($e36f1de21b27a557$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $e36f1de21b27a557$export$2c0f367103c8d01c + ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$e36f1de21b27a557$export$f8e21b1e77979a08(n, "stretch") ? $e36f1de21b27a557$export$82e9f45cca5ba907($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $e36f1de21b27a557$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $e36f1de21b27a557$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 6) === 121) return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, ":", ":" + $e36f1de21b27a557$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($e36f1de21b27a557$export$a9db5e087081082d(n, $e36f1de21b27a557$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + ($e36f1de21b27a557$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, ":", ":" + $e36f1de21b27a557$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $e36f1de21b27a557$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $e36f1de21b27a557$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $e36f1de21b27a557$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $e36f1de21b27a557$export$a763edbf796b780a:
        case $e36f1de21b27a557$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $e36f1de21b27a557$export$a29989082612d0d9:
            return "";
        case $e36f1de21b27a557$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $e36f1de21b27a557$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $e36f1de21b27a557$export$36776f635604f274(a = $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $e36f1de21b27a557$export$5a7767152ae0305f(e) {
    var r = $e36f1de21b27a557$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $e36f1de21b27a557$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $e36f1de21b27a557$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $e36f1de21b27a557$export$527d108ccf083c2b:
                n.return = $e36f1de21b27a557$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $e36f1de21b27a557$export$b44a8529a35fcb60:
                return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                    $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                        value: $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $e36f1de21b27a557$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $e36f1de21b27a557$export$aa3a2e812ca8570d:
                if (n.length) return $e36f1de21b27a557$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($e36f1de21b27a557$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $e36f1de21b27a557$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e36f1de21b27a557$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $e36f1de21b27a557$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $e36f1de21b27a557$export$76a88f7de6507443(e) {
    switch(e.type){
        case $e36f1de21b27a557$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $e36f1de21b27a557$export$1be1fc439b849fdf($e36f1de21b27a557$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($e36f1de21b27a557$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $e36f1de21b27a557$export$2f35ab04d2335697(r, 1, $e36f1de21b27a557$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $e36f1de21b27a557$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $e36f1de21b27a557$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $e36f1de21b27a557$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("dBNhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e84f658cb2e4b7e$export$2e2bcd8739ae039);
var $9e84f658cb2e4b7e$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("b9Xpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $81fe9e0845417c5e$export$2e2bcd8739ae039);
function $81fe9e0845417c5e$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("69vM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ac3b2531c94e30$export$2e2bcd8739ae039);

var $l3NX5 = parcelRequire("l3NX5");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $47ac3b2531c94e30$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l3NX5)))(targetComponent, sourceComponent);
};

});
parcelRegister("l3NX5", function(module, exports) {
'use strict';

var $eLJDK = parcelRequire("eLJDK");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f550a03ccbc02dc9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f550a03ccbc02dc9$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f550a03ccbc02dc9$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$TYPE_STATICS = {};
$f550a03ccbc02dc9$var$TYPE_STATICS[$eLJDK.ForwardRef] = $f550a03ccbc02dc9$var$FORWARD_REF_STATICS;
$f550a03ccbc02dc9$var$TYPE_STATICS[$eLJDK.Memo] = $f550a03ccbc02dc9$var$MEMO_STATICS;
function $f550a03ccbc02dc9$var$getStatics(component) {
    // React v16.11 and below
    if ($eLJDK.isMemo(component)) return $f550a03ccbc02dc9$var$MEMO_STATICS;
     // React v16.12 and above
    return $f550a03ccbc02dc9$var$TYPE_STATICS[component['$$typeof']] || $f550a03ccbc02dc9$var$REACT_STATICS;
}
var $f550a03ccbc02dc9$var$defineProperty = Object.defineProperty;
var $f550a03ccbc02dc9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f550a03ccbc02dc9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f550a03ccbc02dc9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f550a03ccbc02dc9$var$getPrototypeOf = Object.getPrototypeOf;
var $f550a03ccbc02dc9$var$objectPrototype = Object.prototype;
function $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($f550a03ccbc02dc9$var$objectPrototype) {
            var inheritedComponent = $f550a03ccbc02dc9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f550a03ccbc02dc9$var$objectPrototype) $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f550a03ccbc02dc9$var$getOwnPropertyNames(sourceComponent);
        if ($f550a03ccbc02dc9$var$getOwnPropertySymbols) keys = keys.concat($f550a03ccbc02dc9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f550a03ccbc02dc9$var$getStatics(targetComponent);
        var sourceStatics = $f550a03ccbc02dc9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f550a03ccbc02dc9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f550a03ccbc02dc9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f550a03ccbc02dc9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $f550a03ccbc02dc9$var$hoistNonReactStatics;

});
parcelRegister("eLJDK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gpUM7"));

});
parcelRegister("gpUM7", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $bf3b0579824ef26a$export$2b8d127b894957b9, (v) => $bf3b0579824ef26a$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $bf3b0579824ef26a$export$cea3a54a6425200c, (v) => $bf3b0579824ef26a$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $bf3b0579824ef26a$export$a7c73072b1a182ae, (v) => $bf3b0579824ef26a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $bf3b0579824ef26a$export$9f27bc3417b4524d, (v) => $bf3b0579824ef26a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $bf3b0579824ef26a$export$db77ccec0bb4ccac, (v) => $bf3b0579824ef26a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $bf3b0579824ef26a$export$8392c0c9d3dcbd35, (v) => $bf3b0579824ef26a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $bf3b0579824ef26a$export$ffb0004e005737fa, (v) => $bf3b0579824ef26a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $bf3b0579824ef26a$export$b624eff549462981, (v) => $bf3b0579824ef26a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $bf3b0579824ef26a$export$7897aa7841a5380c, (v) => $bf3b0579824ef26a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $bf3b0579824ef26a$export$602eac185826482c, (v) => $bf3b0579824ef26a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $bf3b0579824ef26a$export$e2c29f18771995cb, (v) => $bf3b0579824ef26a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $bf3b0579824ef26a$export$5f8d39834fd61797, (v) => $bf3b0579824ef26a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $bf3b0579824ef26a$export$74bf444e3cd11ea5, (v) => $bf3b0579824ef26a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $bf3b0579824ef26a$export$92387174baf9b227, (v) => $bf3b0579824ef26a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $bf3b0579824ef26a$export$ec112efeb987d9c6, (v) => $bf3b0579824ef26a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $bf3b0579824ef26a$export$b706b080d889d2c9, (v) => $bf3b0579824ef26a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $bf3b0579824ef26a$export$5be5a87408f70ddc, (v) => $bf3b0579824ef26a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $bf3b0579824ef26a$export$45a5e7f76e0caa8d, (v) => $bf3b0579824ef26a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $bf3b0579824ef26a$export$455c2e768291efa6, (v) => $bf3b0579824ef26a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $bf3b0579824ef26a$export$9522e17588c12572, (v) => $bf3b0579824ef26a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $bf3b0579824ef26a$export$2110ac352bb060b9, (v) => $bf3b0579824ef26a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $bf3b0579824ef26a$export$56885ab8b9c456ab, (v) => $bf3b0579824ef26a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $bf3b0579824ef26a$export$d927fcb6adf8f9de, (v) => $bf3b0579824ef26a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $bf3b0579824ef26a$export$b82d16f27459e05a, (v) => $bf3b0579824ef26a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $bf3b0579824ef26a$export$522c17b4f5e123e8, (v) => $bf3b0579824ef26a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $bf3b0579824ef26a$export$1aabd8a0274ecfd6, (v) => $bf3b0579824ef26a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $bf3b0579824ef26a$export$9b621391a187a31a, (v) => $bf3b0579824ef26a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $bf3b0579824ef26a$export$f5bbd400c2f4426f, (v) => $bf3b0579824ef26a$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bf3b0579824ef26a$export$2b8d127b894957b9;
var $bf3b0579824ef26a$export$cea3a54a6425200c;
var $bf3b0579824ef26a$export$a7c73072b1a182ae;
var $bf3b0579824ef26a$export$9f27bc3417b4524d;
var $bf3b0579824ef26a$export$db77ccec0bb4ccac;
var $bf3b0579824ef26a$export$8392c0c9d3dcbd35;
var $bf3b0579824ef26a$export$ffb0004e005737fa;
var $bf3b0579824ef26a$export$b624eff549462981;
var $bf3b0579824ef26a$export$7897aa7841a5380c;
var $bf3b0579824ef26a$export$602eac185826482c;
var $bf3b0579824ef26a$export$e2c29f18771995cb;
var $bf3b0579824ef26a$export$5f8d39834fd61797;
var $bf3b0579824ef26a$export$74bf444e3cd11ea5;
var $bf3b0579824ef26a$export$92387174baf9b227;
var $bf3b0579824ef26a$export$ec112efeb987d9c6;
var $bf3b0579824ef26a$export$b706b080d889d2c9;
var $bf3b0579824ef26a$export$5be5a87408f70ddc;
var $bf3b0579824ef26a$export$45a5e7f76e0caa8d;
var $bf3b0579824ef26a$export$455c2e768291efa6;
var $bf3b0579824ef26a$export$9522e17588c12572;
var $bf3b0579824ef26a$export$2110ac352bb060b9;
var $bf3b0579824ef26a$export$56885ab8b9c456ab;
var $bf3b0579824ef26a$export$d927fcb6adf8f9de;
var $bf3b0579824ef26a$export$b82d16f27459e05a;
var $bf3b0579824ef26a$export$522c17b4f5e123e8;
var $bf3b0579824ef26a$export$1aabd8a0274ecfd6;
var $bf3b0579824ef26a$export$9b621391a187a31a;
var $bf3b0579824ef26a$export$f5bbd400c2f4426f;
'use strict';
var $bf3b0579824ef26a$var$b = "function" === typeof Symbol && Symbol.for, $bf3b0579824ef26a$var$c = $bf3b0579824ef26a$var$b ? Symbol.for("react.element") : 60103, $bf3b0579824ef26a$var$d = $bf3b0579824ef26a$var$b ? Symbol.for("react.portal") : 60106, $bf3b0579824ef26a$var$e = $bf3b0579824ef26a$var$b ? Symbol.for("react.fragment") : 60107, $bf3b0579824ef26a$var$f = $bf3b0579824ef26a$var$b ? Symbol.for("react.strict_mode") : 60108, $bf3b0579824ef26a$var$g = $bf3b0579824ef26a$var$b ? Symbol.for("react.profiler") : 60114, $bf3b0579824ef26a$var$h = $bf3b0579824ef26a$var$b ? Symbol.for("react.provider") : 60109, $bf3b0579824ef26a$var$k = $bf3b0579824ef26a$var$b ? Symbol.for("react.context") : 60110, $bf3b0579824ef26a$var$l = $bf3b0579824ef26a$var$b ? Symbol.for("react.async_mode") : 60111, $bf3b0579824ef26a$var$m = $bf3b0579824ef26a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $bf3b0579824ef26a$var$n = $bf3b0579824ef26a$var$b ? Symbol.for("react.forward_ref") : 60112, $bf3b0579824ef26a$var$p = $bf3b0579824ef26a$var$b ? Symbol.for("react.suspense") : 60113, $bf3b0579824ef26a$var$q = $bf3b0579824ef26a$var$b ? Symbol.for("react.suspense_list") : 60120, $bf3b0579824ef26a$var$r = $bf3b0579824ef26a$var$b ? Symbol.for("react.memo") : 60115, $bf3b0579824ef26a$var$t = $bf3b0579824ef26a$var$b ? Symbol.for("react.lazy") : 60116, $bf3b0579824ef26a$var$v = $bf3b0579824ef26a$var$b ? Symbol.for("react.block") : 60121, $bf3b0579824ef26a$var$w = $bf3b0579824ef26a$var$b ? Symbol.for("react.fundamental") : 60117, $bf3b0579824ef26a$var$x = $bf3b0579824ef26a$var$b ? Symbol.for("react.responder") : 60118, $bf3b0579824ef26a$var$y = $bf3b0579824ef26a$var$b ? Symbol.for("react.scope") : 60119;
function $bf3b0579824ef26a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $bf3b0579824ef26a$var$c:
                switch(a = a.type, a){
                    case $bf3b0579824ef26a$var$l:
                    case $bf3b0579824ef26a$var$m:
                    case $bf3b0579824ef26a$var$e:
                    case $bf3b0579824ef26a$var$g:
                    case $bf3b0579824ef26a$var$f:
                    case $bf3b0579824ef26a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bf3b0579824ef26a$var$k:
                            case $bf3b0579824ef26a$var$n:
                            case $bf3b0579824ef26a$var$t:
                            case $bf3b0579824ef26a$var$r:
                            case $bf3b0579824ef26a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $bf3b0579824ef26a$var$d:
                return u;
        }
    }
}
function $bf3b0579824ef26a$var$A(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$m;
}
$bf3b0579824ef26a$export$2b8d127b894957b9 = $bf3b0579824ef26a$var$l;
$bf3b0579824ef26a$export$cea3a54a6425200c = $bf3b0579824ef26a$var$m;
$bf3b0579824ef26a$export$a7c73072b1a182ae = $bf3b0579824ef26a$var$k;
$bf3b0579824ef26a$export$9f27bc3417b4524d = $bf3b0579824ef26a$var$h;
$bf3b0579824ef26a$export$db77ccec0bb4ccac = $bf3b0579824ef26a$var$c;
$bf3b0579824ef26a$export$8392c0c9d3dcbd35 = $bf3b0579824ef26a$var$n;
$bf3b0579824ef26a$export$ffb0004e005737fa = $bf3b0579824ef26a$var$e;
$bf3b0579824ef26a$export$b624eff549462981 = $bf3b0579824ef26a$var$t;
$bf3b0579824ef26a$export$7897aa7841a5380c = $bf3b0579824ef26a$var$r;
$bf3b0579824ef26a$export$602eac185826482c = $bf3b0579824ef26a$var$d;
$bf3b0579824ef26a$export$e2c29f18771995cb = $bf3b0579824ef26a$var$g;
$bf3b0579824ef26a$export$5f8d39834fd61797 = $bf3b0579824ef26a$var$f;
$bf3b0579824ef26a$export$74bf444e3cd11ea5 = $bf3b0579824ef26a$var$p;
$bf3b0579824ef26a$export$92387174baf9b227 = function(a) {
    return $bf3b0579824ef26a$var$A(a) || $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$l;
};
$bf3b0579824ef26a$export$ec112efeb987d9c6 = $bf3b0579824ef26a$var$A;
$bf3b0579824ef26a$export$b706b080d889d2c9 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$k;
};
$bf3b0579824ef26a$export$5be5a87408f70ddc = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$h;
};
$bf3b0579824ef26a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bf3b0579824ef26a$var$c;
};
$bf3b0579824ef26a$export$455c2e768291efa6 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$n;
};
$bf3b0579824ef26a$export$9522e17588c12572 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$e;
};
$bf3b0579824ef26a$export$2110ac352bb060b9 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$t;
};
$bf3b0579824ef26a$export$56885ab8b9c456ab = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$r;
};
$bf3b0579824ef26a$export$d927fcb6adf8f9de = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$d;
};
$bf3b0579824ef26a$export$b82d16f27459e05a = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$g;
};
$bf3b0579824ef26a$export$522c17b4f5e123e8 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$f;
};
$bf3b0579824ef26a$export$1aabd8a0274ecfd6 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$p;
};
$bf3b0579824ef26a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bf3b0579824ef26a$var$e || a === $bf3b0579824ef26a$var$m || a === $bf3b0579824ef26a$var$g || a === $bf3b0579824ef26a$var$f || a === $bf3b0579824ef26a$var$p || a === $bf3b0579824ef26a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $bf3b0579824ef26a$var$t || a.$$typeof === $bf3b0579824ef26a$var$r || a.$$typeof === $bf3b0579824ef26a$var$h || a.$$typeof === $bf3b0579824ef26a$var$k || a.$$typeof === $bf3b0579824ef26a$var$n || a.$$typeof === $bf3b0579824ef26a$var$w || a.$$typeof === $bf3b0579824ef26a$var$x || a.$$typeof === $bf3b0579824ef26a$var$y || a.$$typeof === $bf3b0579824ef26a$var$v);
};
$bf3b0579824ef26a$export$f5bbd400c2f4426f = $bf3b0579824ef26a$var$z;

});




parcelRegister("i1Adn", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $d1f46976782075db$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $d1f46976782075db$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $d1f46976782075db$export$6f077d94b33a01aa);
var $d1f46976782075db$var$isBrowser = typeof document !== 'undefined';
function $d1f46976782075db$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $d1f46976782075db$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d1f46976782075db$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d1f46976782075db$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d1f46976782075db$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$d1f46976782075db$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$d1f46976782075db$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("gLVll", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $c35d8451a28681ad$export$6321afa313b251b5);

var $ei1c3 = parcelRequire("ei1c3");

var $ia3Zd = parcelRequire("ia3Zd");

var $b9Xpj = parcelRequire("b9Xpj");
var $c35d8451a28681ad$var$isDevelopment = false;
var $c35d8451a28681ad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $c35d8451a28681ad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $c35d8451a28681ad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $c35d8451a28681ad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $c35d8451a28681ad$var$processStyleName = /* #__PURE__ */ (0, $b9Xpj.default)(function(styleName) {
    return $c35d8451a28681ad$var$isCustomProperty(styleName) ? styleName : styleName.replace($c35d8451a28681ad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $c35d8451a28681ad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($c35d8451a28681ad$var$animationRegex, function(match, p1, p2) {
                $c35d8451a28681ad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $c35d8451a28681ad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $ia3Zd.default)[key] !== 1 && !$c35d8451a28681ad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $c35d8451a28681ad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $c35d8451a28681ad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $c35d8451a28681ad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $c35d8451a28681ad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $c35d8451a28681ad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $c35d8451a28681ad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $c35d8451a28681ad$var$cursor;
                var result = interpolation(mergedProps);
                $c35d8451a28681ad$var$cursor = previousCursor;
                return $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $c35d8451a28681ad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($c35d8451a28681ad$var$isProcessableValue(asString)) string += $c35d8451a28681ad$var$processStyleName(key) + ":" + $c35d8451a28681ad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $c35d8451a28681ad$var$isDevelopment) throw new Error($c35d8451a28681ad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($c35d8451a28681ad$var$isProcessableValue(value[_i])) string += $c35d8451a28681ad$var$processStyleName(key) + ":" + $c35d8451a28681ad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $c35d8451a28681ad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $c35d8451a28681ad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $c35d8451a28681ad$var$cursor;
function $c35d8451a28681ad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $c35d8451a28681ad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $c35d8451a28681ad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $c35d8451a28681ad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $ei1c3.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $c35d8451a28681ad$var$cursor
    };
}

});
parcelRegister("ei1c3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a673ac1d41d20e76$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $a673ac1d41d20e76$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("ia3Zd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38c40c43cea0c69$export$2e2bcd8739ae039);
var $d38c40c43cea0c69$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("gwJ0Y", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $c0828d75d37a5f18$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $c0828d75d37a5f18$export$811a713a7276cb9d);

var $8NFma = parcelRequire("8NFma");
var $c0828d75d37a5f18$var$isBrowser = typeof document !== 'undefined';
var $c0828d75d37a5f18$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c0828d75d37a5f18$var$useInsertionEffect = $8NFma.useInsertionEffect ? $8NFma.useInsertionEffect : false;
var $c0828d75d37a5f18$export$db21c7ffa21794e7 = !$c0828d75d37a5f18$var$isBrowser ? $c0828d75d37a5f18$var$syncFallback : $c0828d75d37a5f18$var$useInsertionEffect || $c0828d75d37a5f18$var$syncFallback;
var $c0828d75d37a5f18$export$811a713a7276cb9d = $c0828d75d37a5f18$var$useInsertionEffect || $8NFma.useLayoutEffect;

});



parcelRegister("hcFfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8638f08acca5456$export$2e2bcd8739ae039);

var $b9Xpj = parcelRequire("b9Xpj");
// eslint-disable-next-line no-undef
var $c8638f08acca5456$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $c8638f08acca5456$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $b9Xpj.default)(function(prop) {
    return $c8638f08acca5456$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("hFXU8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cde4bbcad92a9de7$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");


var $iSBXh = parcelRequire("iSBXh");

var $dMiGn = parcelRequire("dMiGn");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $cde4bbcad92a9de7$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $dMiGn.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $cde4bbcad92a9de7$var$cacheMap = new Map();
function $cde4bbcad92a9de7$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $8NFma.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $cde4bbcad92a9de7$var$cacheMap.has(cacheKey)) return $cde4bbcad92a9de7$var$cacheMap.get(cacheKey);
        const fresh = $cde4bbcad92a9de7$var$getCache(injectFirst, enableCssLayer);
        $cde4bbcad92a9de7$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $iSBXh.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("1IdZj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("89wqa"));

});


parcelRegister("hvbO6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbde7d8b5ea8c970$export$2e2bcd8739ae039);
parcelRequire("8NFma");


var $9XmJK = parcelRequire("9XmJK");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $cbde7d8b5ea8c970$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $cbde7d8b5ea8c970$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($cbde7d8b5ea8c970$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9XmJK.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("lLrTz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("em3Bd")).default);

var $em3Bd = parcelRequire("em3Bd");

});
parcelRegister("em3Bd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a735e97f62346f26$export$2e2bcd8739ae039);

var $6T5ne = parcelRequire("6T5ne");
function $a735e97f62346f26$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $6T5ne.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("6T5ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $503c0c39b18940dc$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $503c0c39b18940dc$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});



parcelRegister("kpMWV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("5FZXi")).default);

var $5FZXi = parcelRequire("5FZXi");
$parcel$exportWildcard(module.exports, $5FZXi);

});
parcelRegister("5FZXi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $4220d721651e98d2$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $4220d721651e98d2$export$2e2bcd8739ae039);

var $1TAMD = parcelRequire("1TAMD");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $4220d721651e98d2$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $4220d721651e98d2$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($4220d721651e98d2$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $4220d721651e98d2$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $4220d721651e98d2$export$aad197c7121a6651(Component) || fallback;
}
function $4220d721651e98d2$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $4220d721651e98d2$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $4220d721651e98d2$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $4220d721651e98d2$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $1TAMD.ForwardRef:
            return $4220d721651e98d2$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $1TAMD.Memo:
            return $4220d721651e98d2$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("1TAMD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cGq6Z"));

});
parcelRegister("cGq6Z", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $93bda98a65f2a027$export$a7c73072b1a182ae, (v) => $93bda98a65f2a027$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $93bda98a65f2a027$export$9f27bc3417b4524d, (v) => $93bda98a65f2a027$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $93bda98a65f2a027$export$db77ccec0bb4ccac, (v) => $93bda98a65f2a027$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $93bda98a65f2a027$export$8392c0c9d3dcbd35, (v) => $93bda98a65f2a027$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $93bda98a65f2a027$export$ffb0004e005737fa, (v) => $93bda98a65f2a027$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $93bda98a65f2a027$export$b624eff549462981, (v) => $93bda98a65f2a027$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $93bda98a65f2a027$export$7897aa7841a5380c, (v) => $93bda98a65f2a027$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $93bda98a65f2a027$export$602eac185826482c, (v) => $93bda98a65f2a027$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $93bda98a65f2a027$export$e2c29f18771995cb, (v) => $93bda98a65f2a027$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $93bda98a65f2a027$export$5f8d39834fd61797, (v) => $93bda98a65f2a027$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $93bda98a65f2a027$export$74bf444e3cd11ea5, (v) => $93bda98a65f2a027$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $93bda98a65f2a027$export$998bcd577473dd93, (v) => $93bda98a65f2a027$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $93bda98a65f2a027$export$b706b080d889d2c9, (v) => $93bda98a65f2a027$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $93bda98a65f2a027$export$5be5a87408f70ddc, (v) => $93bda98a65f2a027$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $93bda98a65f2a027$export$45a5e7f76e0caa8d, (v) => $93bda98a65f2a027$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $93bda98a65f2a027$export$455c2e768291efa6, (v) => $93bda98a65f2a027$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $93bda98a65f2a027$export$9522e17588c12572, (v) => $93bda98a65f2a027$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $93bda98a65f2a027$export$2110ac352bb060b9, (v) => $93bda98a65f2a027$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $93bda98a65f2a027$export$56885ab8b9c456ab, (v) => $93bda98a65f2a027$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $93bda98a65f2a027$export$d927fcb6adf8f9de, (v) => $93bda98a65f2a027$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $93bda98a65f2a027$export$b82d16f27459e05a, (v) => $93bda98a65f2a027$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $93bda98a65f2a027$export$522c17b4f5e123e8, (v) => $93bda98a65f2a027$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $93bda98a65f2a027$export$1aabd8a0274ecfd6, (v) => $93bda98a65f2a027$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $93bda98a65f2a027$export$3d6c20d97e46b957, (v) => $93bda98a65f2a027$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $93bda98a65f2a027$export$9b621391a187a31a, (v) => $93bda98a65f2a027$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $93bda98a65f2a027$export$f5bbd400c2f4426f, (v) => $93bda98a65f2a027$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $93bda98a65f2a027$export$a7c73072b1a182ae;
var $93bda98a65f2a027$export$9f27bc3417b4524d;
var $93bda98a65f2a027$export$db77ccec0bb4ccac;
var $93bda98a65f2a027$export$8392c0c9d3dcbd35;
var $93bda98a65f2a027$export$ffb0004e005737fa;
var $93bda98a65f2a027$export$b624eff549462981;
var $93bda98a65f2a027$export$7897aa7841a5380c;
var $93bda98a65f2a027$export$602eac185826482c;
var $93bda98a65f2a027$export$e2c29f18771995cb;
var $93bda98a65f2a027$export$5f8d39834fd61797;
var $93bda98a65f2a027$export$74bf444e3cd11ea5;
var $93bda98a65f2a027$export$998bcd577473dd93;
var $93bda98a65f2a027$export$b706b080d889d2c9;
var $93bda98a65f2a027$export$5be5a87408f70ddc;
var $93bda98a65f2a027$export$45a5e7f76e0caa8d;
var $93bda98a65f2a027$export$455c2e768291efa6;
var $93bda98a65f2a027$export$9522e17588c12572;
var $93bda98a65f2a027$export$2110ac352bb060b9;
var $93bda98a65f2a027$export$56885ab8b9c456ab;
var $93bda98a65f2a027$export$d927fcb6adf8f9de;
var $93bda98a65f2a027$export$b82d16f27459e05a;
var $93bda98a65f2a027$export$522c17b4f5e123e8;
var $93bda98a65f2a027$export$1aabd8a0274ecfd6;
var $93bda98a65f2a027$export$3d6c20d97e46b957;
var $93bda98a65f2a027$export$9b621391a187a31a;
var $93bda98a65f2a027$export$f5bbd400c2f4426f;
"use strict";
var $93bda98a65f2a027$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $93bda98a65f2a027$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $93bda98a65f2a027$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $93bda98a65f2a027$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $93bda98a65f2a027$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $93bda98a65f2a027$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $93bda98a65f2a027$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $93bda98a65f2a027$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $93bda98a65f2a027$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $93bda98a65f2a027$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $93bda98a65f2a027$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE:
                    case $93bda98a65f2a027$var$REACT_PROFILER_TYPE:
                    case $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE:
                    case $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE:
                    case $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE:
                    case $93bda98a65f2a027$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $93bda98a65f2a027$var$REACT_CONTEXT_TYPE:
                            case $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE:
                            case $93bda98a65f2a027$var$REACT_LAZY_TYPE:
                            case $93bda98a65f2a027$var$REACT_MEMO_TYPE:
                                return object;
                            case $93bda98a65f2a027$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $93bda98a65f2a027$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$93bda98a65f2a027$export$a7c73072b1a182ae = $93bda98a65f2a027$var$REACT_CONSUMER_TYPE;
$93bda98a65f2a027$export$9f27bc3417b4524d = $93bda98a65f2a027$var$REACT_CONTEXT_TYPE;
$93bda98a65f2a027$export$db77ccec0bb4ccac = $93bda98a65f2a027$var$REACT_ELEMENT_TYPE;
$93bda98a65f2a027$export$8392c0c9d3dcbd35 = $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE;
$93bda98a65f2a027$export$ffb0004e005737fa = $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE;
$93bda98a65f2a027$export$b624eff549462981 = $93bda98a65f2a027$var$REACT_LAZY_TYPE;
$93bda98a65f2a027$export$7897aa7841a5380c = $93bda98a65f2a027$var$REACT_MEMO_TYPE;
$93bda98a65f2a027$export$602eac185826482c = $93bda98a65f2a027$var$REACT_PORTAL_TYPE;
$93bda98a65f2a027$export$e2c29f18771995cb = $93bda98a65f2a027$var$REACT_PROFILER_TYPE;
$93bda98a65f2a027$export$5f8d39834fd61797 = $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE;
$93bda98a65f2a027$export$74bf444e3cd11ea5 = $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE;
$93bda98a65f2a027$export$998bcd577473dd93 = $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE;
$93bda98a65f2a027$export$b706b080d889d2c9 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_CONSUMER_TYPE;
};
$93bda98a65f2a027$export$5be5a87408f70ddc = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_CONTEXT_TYPE;
};
$93bda98a65f2a027$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $93bda98a65f2a027$var$REACT_ELEMENT_TYPE;
};
$93bda98a65f2a027$export$455c2e768291efa6 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE;
};
$93bda98a65f2a027$export$9522e17588c12572 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE;
};
$93bda98a65f2a027$export$2110ac352bb060b9 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_LAZY_TYPE;
};
$93bda98a65f2a027$export$56885ab8b9c456ab = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_MEMO_TYPE;
};
$93bda98a65f2a027$export$d927fcb6adf8f9de = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_PORTAL_TYPE;
};
$93bda98a65f2a027$export$b82d16f27459e05a = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_PROFILER_TYPE;
};
$93bda98a65f2a027$export$522c17b4f5e123e8 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE;
};
$93bda98a65f2a027$export$1aabd8a0274ecfd6 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE;
};
$93bda98a65f2a027$export$3d6c20d97e46b957 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE;
};
$93bda98a65f2a027$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE || type === $93bda98a65f2a027$var$REACT_PROFILER_TYPE || type === $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE || type === $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE || type === $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE || type === $93bda98a65f2a027$var$REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $93bda98a65f2a027$var$REACT_LAZY_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_MEMO_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_CONTEXT_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_CONSUMER_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$93bda98a65f2a027$export$f5bbd400c2f4426f = $93bda98a65f2a027$var$typeOf;

});




parcelRegister("8WYKi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9dxf1")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("jYzsf")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("5eonk")).default);

var $9dxf1 = parcelRequire("9dxf1");

var $jYzsf = parcelRequire("jYzsf");

var $5eonk = parcelRequire("5eonk");

});
parcelRegister("9dxf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b5f1cf5d7cbf4a1$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $5eWZU = parcelRequire("5eWZU");

var $jYzsf = parcelRequire("jYzsf");

var $6eamM = parcelRequire("6eamM");

var $i5JqR = parcelRequire("i5JqR");

var $lfmQj = parcelRequire("lfmQj");

var $7exGP = parcelRequire("7exGP");

var $5eonk = parcelRequire("5eonk");
const $6b5f1cf5d7cbf4a1$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $6b5f1cf5d7cbf4a1$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $hQtye.default)(options, $6b5f1cf5d7cbf4a1$var$_excluded);
    const breakpoints = (0, $jYzsf.default)(breakpointsInput);
    const spacing = (0, $i5JqR.default)(spacingInput);
    let muiTheme = (0, $5eWZU.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $jz4iA.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $jz4iA.default)({}, (0, $6eamM.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $5eonk.default);
    muiTheme = args.reduce((acc, argument)=>(0, $5eWZU.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $jz4iA.default)({}, (0, $7exGP.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $lfmQj.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $6b5f1cf5d7cbf4a1$export$2e2bcd8739ae039 = $6b5f1cf5d7cbf4a1$var$createTheme;

});
parcelRegister("hQtye", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfde373be945f92b$export$2e2bcd8739ae039);
function $cfde373be945f92b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("5eWZU", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $3d0c0639d3a1b210$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $3d0c0639d3a1b210$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");
function $3d0c0639d3a1b210$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $3d0c0639d3a1b210$var$deepClone(source) {
    if (/*#__PURE__*/ $8NFma.isValidElement(source) || !$3d0c0639d3a1b210$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $3d0c0639d3a1b210$var$deepClone(source[key]);
    });
    return output;
}
function $3d0c0639d3a1b210$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $jz4iA.default)({}, target) : target;
    if ($3d0c0639d3a1b210$export$53b83ca8eaab0383(target) && $3d0c0639d3a1b210$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $8NFma.isValidElement(source[key])) output[key] = source[key];
        else if ($3d0c0639d3a1b210$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $3d0c0639d3a1b210$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $3d0c0639d3a1b210$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $3d0c0639d3a1b210$export$53b83ca8eaab0383(source[key]) ? $3d0c0639d3a1b210$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("jYzsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c0c2927a761bfa$export$2e2bcd8739ae039);

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");
const $03c0c2927a761bfa$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $03c0c2927a761bfa$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $03c0c2927a761bfa$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $jz4iA.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $03c0c2927a761bfa$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $hQtye.default)(breakpoints, $03c0c2927a761bfa$var$_excluded);
    const sortedValues = $03c0c2927a761bfa$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $jz4iA.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("6eamM", function(module, exports) {

$parcel$export(module.exports, "default", () => $488c176ef0c68b6e$export$2e2bcd8739ae039);
const $488c176ef0c68b6e$var$shape = {
    borderRadius: 4
};
var $488c176ef0c68b6e$export$2e2bcd8739ae039 = $488c176ef0c68b6e$var$shape;

});

parcelRegister("i5JqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2bbef864c7c0d32$export$2e2bcd8739ae039);

var $8IzS5 = parcelRequire("8IzS5");
function $d2bbef864c7c0d32$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $8IzS5.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("8IzS5", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $658e421437242550$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $658e421437242550$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $658e421437242550$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $658e421437242550$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $658e421437242550$export$6f98e8eaf0be1996);


var $kNOM9 = parcelRequire("kNOM9");

var $dkiNS = parcelRequire("dkiNS");

var $fwFVX = parcelRequire("fwFVX");

var $lJAZL = parcelRequire("lJAZL");
const $658e421437242550$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $658e421437242550$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $658e421437242550$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $658e421437242550$var$getCssProperties = (0, $lJAZL.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($658e421437242550$var$aliases[prop]) prop = $658e421437242550$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $658e421437242550$var$properties[a];
    const direction = $658e421437242550$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $658e421437242550$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $658e421437242550$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $658e421437242550$var$spacingKeys = [
    ...$658e421437242550$export$aab52a0dde05ad8a,
    ...$658e421437242550$export$f8397d44f03ab6ad
];
function $658e421437242550$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $dkiNS.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $658e421437242550$export$1def6f833384e3d1(theme) {
    return $658e421437242550$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $658e421437242550$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $658e421437242550$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $658e421437242550$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $658e421437242550$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $658e421437242550$var$getCssProperties(prop);
    const styleFromPropValue = $658e421437242550$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $kNOM9.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $658e421437242550$var$style(props, keys) {
    const transformer = $658e421437242550$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$658e421437242550$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $fwFVX.default), {});
}
function $658e421437242550$export$7ede87f9b603dd3c(props) {
    return $658e421437242550$var$style(props, $658e421437242550$export$aab52a0dde05ad8a);
}
$658e421437242550$export$7ede87f9b603dd3c.propTypes = {};
$658e421437242550$export$7ede87f9b603dd3c.filterProps = $658e421437242550$export$aab52a0dde05ad8a;
function $658e421437242550$export$6f98e8eaf0be1996(props) {
    return $658e421437242550$var$style(props, $658e421437242550$export$f8397d44f03ab6ad);
}
$658e421437242550$export$6f98e8eaf0be1996.propTypes = {};
$658e421437242550$export$6f98e8eaf0be1996.filterProps = $658e421437242550$export$f8397d44f03ab6ad;
function $658e421437242550$var$spacing(props) {
    return $658e421437242550$var$style(props, $658e421437242550$var$spacingKeys);
}
$658e421437242550$var$spacing.propTypes = {};
$658e421437242550$var$spacing.filterProps = $658e421437242550$var$spacingKeys;
var $658e421437242550$export$2e2bcd8739ae039 = $658e421437242550$var$spacing;

});
parcelRegister("kNOM9", function(module, exports) {

$parcel$export(module.exports, "values", () => $f24fc53fd2851c67$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $f24fc53fd2851c67$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $f24fc53fd2851c67$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $f24fc53fd2851c67$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $f24fc53fd2851c67$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $f24fc53fd2851c67$export$980e6a259d807490);

var $jz4iA = parcelRequire("jz4iA");


var $5eWZU = parcelRequire("5eWZU");

var $fwFVX = parcelRequire("fwFVX");
const $f24fc53fd2851c67$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $f24fc53fd2851c67$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$f24fc53fd2851c67$export$68c286be0e7e55b7[key]}px)`
};
function $f24fc53fd2851c67$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $f24fc53fd2851c67$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $f24fc53fd2851c67$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $f24fc53fd2851c67$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $f24fc53fd2851c67$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $f24fc53fd2851c67$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $jz4iA.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $fwFVX.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $f24fc53fd2851c67$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $f24fc53fd2851c67$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $f24fc53fd2851c67$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $f24fc53fd2851c67$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $5eWZU.default)(prev, next), {});
    return $f24fc53fd2851c67$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $f24fc53fd2851c67$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $f24fc53fd2851c67$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $f24fc53fd2851c67$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $f24fc53fd2851c67$export$2e2bcd8739ae039 = $f24fc53fd2851c67$var$breakpoints;

});
parcelRegister("fwFVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4da5f608fcea495$export$2e2bcd8739ae039);

var $5eWZU = parcelRequire("5eWZU");
function $b4da5f608fcea495$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $5eWZU.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $b4da5f608fcea495$export$2e2bcd8739ae039 = $b4da5f608fcea495$var$merge;

});


parcelRegister("dkiNS", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $9b3bba9e281a56b9$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $9b3bba9e281a56b9$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $9b3bba9e281a56b9$export$2e2bcd8739ae039);

var $em3Bd = parcelRequire("em3Bd");


var $kNOM9 = parcelRequire("kNOM9");
function $9b3bba9e281a56b9$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $9b3bba9e281a56b9$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $9b3bba9e281a56b9$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $9b3bba9e281a56b9$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $9b3bba9e281a56b9$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $9b3bba9e281a56b9$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $9b3bba9e281a56b9$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $em3Bd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $kNOM9.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $9b3bba9e281a56b9$export$2e2bcd8739ae039 = $9b3bba9e281a56b9$var$style;

});

parcelRegister("lJAZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd2a7f6721d02f7a$export$2e2bcd8739ae039);
function $fd2a7f6721d02f7a$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("lfmQj", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $f77cb7c6335afad4$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $f77cb7c6335afad4$export$2e2bcd8739ae039);

var $em3Bd = parcelRequire("em3Bd");

var $fwFVX = parcelRequire("fwFVX");

var $dkiNS = parcelRequire("dkiNS");

var $kNOM9 = parcelRequire("kNOM9");

var $7exGP = parcelRequire("7exGP");
function $f77cb7c6335afad4$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $f77cb7c6335afad4$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $f77cb7c6335afad4$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $dkiNS.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $dkiNS.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $dkiNS.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $em3Bd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $kNOM9.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $7exGP.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $kNOM9.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $f77cb7c6335afad4$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $fwFVX.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $kNOM9.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($f77cb7c6335afad4$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $fwFVX.default)(css, breakpointsValues);
                        }
                    } else css = (0, $fwFVX.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $kNOM9.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $kNOM9.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $f77cb7c6335afad4$var$styleFunctionSx = $f77cb7c6335afad4$export$7d53d8bf2911e013();
$f77cb7c6335afad4$var$styleFunctionSx.filterProps = [
    'sx'
];
var $f77cb7c6335afad4$export$2e2bcd8739ae039 = $f77cb7c6335afad4$var$styleFunctionSx;

});
parcelRegister("7exGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5443f94dd242e6a8$export$2e2bcd8739ae039);

var $8IzS5 = parcelRequire("8IzS5");

var $eg4LU = parcelRequire("eg4LU");

var $3Bfgv = parcelRequire("3Bfgv");

var $eeeGZ = parcelRequire("eeeGZ");

var $gCSwL = parcelRequire("gCSwL");
const $5443f94dd242e6a8$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $eg4LU.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $eg4LU.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $eg4LU.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $eg4LU.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $eg4LU.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $eg4LU.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $eg4LU.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $eeeGZ.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $eeeGZ.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $eeeGZ.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $8IzS5.padding)
    },
    pt: {
        style: (0, $8IzS5.padding)
    },
    pr: {
        style: (0, $8IzS5.padding)
    },
    pb: {
        style: (0, $8IzS5.padding)
    },
    pl: {
        style: (0, $8IzS5.padding)
    },
    px: {
        style: (0, $8IzS5.padding)
    },
    py: {
        style: (0, $8IzS5.padding)
    },
    padding: {
        style: (0, $8IzS5.padding)
    },
    paddingTop: {
        style: (0, $8IzS5.padding)
    },
    paddingRight: {
        style: (0, $8IzS5.padding)
    },
    paddingBottom: {
        style: (0, $8IzS5.padding)
    },
    paddingLeft: {
        style: (0, $8IzS5.padding)
    },
    paddingX: {
        style: (0, $8IzS5.padding)
    },
    paddingY: {
        style: (0, $8IzS5.padding)
    },
    paddingInline: {
        style: (0, $8IzS5.padding)
    },
    paddingInlineStart: {
        style: (0, $8IzS5.padding)
    },
    paddingInlineEnd: {
        style: (0, $8IzS5.padding)
    },
    paddingBlock: {
        style: (0, $8IzS5.padding)
    },
    paddingBlockStart: {
        style: (0, $8IzS5.padding)
    },
    paddingBlockEnd: {
        style: (0, $8IzS5.padding)
    },
    m: {
        style: (0, $8IzS5.margin)
    },
    mt: {
        style: (0, $8IzS5.margin)
    },
    mr: {
        style: (0, $8IzS5.margin)
    },
    mb: {
        style: (0, $8IzS5.margin)
    },
    ml: {
        style: (0, $8IzS5.margin)
    },
    mx: {
        style: (0, $8IzS5.margin)
    },
    my: {
        style: (0, $8IzS5.margin)
    },
    margin: {
        style: (0, $8IzS5.margin)
    },
    marginTop: {
        style: (0, $8IzS5.margin)
    },
    marginRight: {
        style: (0, $8IzS5.margin)
    },
    marginBottom: {
        style: (0, $8IzS5.margin)
    },
    marginLeft: {
        style: (0, $8IzS5.margin)
    },
    marginX: {
        style: (0, $8IzS5.margin)
    },
    marginY: {
        style: (0, $8IzS5.margin)
    },
    marginInline: {
        style: (0, $8IzS5.margin)
    },
    marginInlineStart: {
        style: (0, $8IzS5.margin)
    },
    marginInlineEnd: {
        style: (0, $8IzS5.margin)
    },
    marginBlock: {
        style: (0, $8IzS5.margin)
    },
    marginBlockStart: {
        style: (0, $8IzS5.margin)
    },
    marginBlockEnd: {
        style: (0, $8IzS5.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $3Bfgv.gap)
    },
    rowGap: {
        style: (0, $3Bfgv.rowGap)
    },
    columnGap: {
        style: (0, $3Bfgv.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $gCSwL.sizingTransform)
    },
    maxWidth: {
        style: (0, $gCSwL.maxWidth)
    },
    minWidth: {
        transform: (0, $gCSwL.sizingTransform)
    },
    height: {
        transform: (0, $gCSwL.sizingTransform)
    },
    maxHeight: {
        transform: (0, $gCSwL.sizingTransform)
    },
    minHeight: {
        transform: (0, $gCSwL.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $5443f94dd242e6a8$export$2e2bcd8739ae039 = $5443f94dd242e6a8$var$defaultSxConfig;

});
parcelRegister("eg4LU", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $a61642db3dc29729$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $a61642db3dc29729$export$7a57f79000377ca2);


var $dkiNS = parcelRequire("dkiNS");

var $4nocs = parcelRequire("4nocs");

var $8IzS5 = parcelRequire("8IzS5");

var $kNOM9 = parcelRequire("kNOM9");
function $a61642db3dc29729$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $a61642db3dc29729$var$createBorderStyle(prop, transform) {
    return (0, $dkiNS.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $a61642db3dc29729$export$1edee58a52776cd9 = $a61642db3dc29729$var$createBorderStyle('border', $a61642db3dc29729$export$34e2febe53ae29cc);
const $a61642db3dc29729$export$f9a7b6bd24892946 = $a61642db3dc29729$var$createBorderStyle('borderTop', $a61642db3dc29729$export$34e2febe53ae29cc);
const $a61642db3dc29729$export$5abca33e6be905d2 = $a61642db3dc29729$var$createBorderStyle('borderRight', $a61642db3dc29729$export$34e2febe53ae29cc);
const $a61642db3dc29729$export$e2ce9f12a980a822 = $a61642db3dc29729$var$createBorderStyle('borderBottom', $a61642db3dc29729$export$34e2febe53ae29cc);
const $a61642db3dc29729$export$47658cca1a909427 = $a61642db3dc29729$var$createBorderStyle('borderLeft', $a61642db3dc29729$export$34e2febe53ae29cc);
const $a61642db3dc29729$export$e7fb0694ba2404fc = $a61642db3dc29729$var$createBorderStyle('borderColor');
const $a61642db3dc29729$export$126a92c968acdb85 = $a61642db3dc29729$var$createBorderStyle('borderTopColor');
const $a61642db3dc29729$export$85cc51cb8fbb8c0e = $a61642db3dc29729$var$createBorderStyle('borderRightColor');
const $a61642db3dc29729$export$340b0327727f6d1a = $a61642db3dc29729$var$createBorderStyle('borderBottomColor');
const $a61642db3dc29729$export$60beef91a985b4bf = $a61642db3dc29729$var$createBorderStyle('borderLeftColor');
const $a61642db3dc29729$export$f9258c55612cbed7 = $a61642db3dc29729$var$createBorderStyle('outline', $a61642db3dc29729$export$34e2febe53ae29cc);
const $a61642db3dc29729$export$621fe586efeb64b9 = $a61642db3dc29729$var$createBorderStyle('outlineColor');
const $a61642db3dc29729$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $8IzS5.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $8IzS5.getValue)(transformer, propValue)
            });
        return (0, $kNOM9.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$a61642db3dc29729$export$7a57f79000377ca2.propTypes = {};
$a61642db3dc29729$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $a61642db3dc29729$var$borders = (0, $4nocs.default)($a61642db3dc29729$export$1edee58a52776cd9, $a61642db3dc29729$export$f9a7b6bd24892946, $a61642db3dc29729$export$5abca33e6be905d2, $a61642db3dc29729$export$e2ce9f12a980a822, $a61642db3dc29729$export$47658cca1a909427, $a61642db3dc29729$export$e7fb0694ba2404fc, $a61642db3dc29729$export$126a92c968acdb85, $a61642db3dc29729$export$85cc51cb8fbb8c0e, $a61642db3dc29729$export$340b0327727f6d1a, $a61642db3dc29729$export$60beef91a985b4bf, $a61642db3dc29729$export$7a57f79000377ca2, $a61642db3dc29729$export$f9258c55612cbed7, $a61642db3dc29729$export$621fe586efeb64b9);
var $a61642db3dc29729$export$2e2bcd8739ae039 = $a61642db3dc29729$var$borders;

});
parcelRegister("4nocs", function(module, exports) {

$parcel$export(module.exports, "default", () => $32fc1503e83531be$export$2e2bcd8739ae039);

var $fwFVX = parcelRequire("fwFVX");
function $32fc1503e83531be$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $fwFVX.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $32fc1503e83531be$export$2e2bcd8739ae039 = $32fc1503e83531be$var$compose;

});


parcelRegister("3Bfgv", function(module, exports) {

$parcel$export(module.exports, "gap", () => $29f0ab2b0d75a28d$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $29f0ab2b0d75a28d$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $29f0ab2b0d75a28d$export$8a833ffa5f5dbeda);

var $dkiNS = parcelRequire("dkiNS");

var $4nocs = parcelRequire("4nocs");

var $8IzS5 = parcelRequire("8IzS5");

var $kNOM9 = parcelRequire("kNOM9");

const $29f0ab2b0d75a28d$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $8IzS5.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $8IzS5.getValue)(transformer, propValue)
            });
        return (0, $kNOM9.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$29f0ab2b0d75a28d$export$5df9adcb0db95e1e.propTypes = {};
$29f0ab2b0d75a28d$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $29f0ab2b0d75a28d$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $8IzS5.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $8IzS5.getValue)(transformer, propValue)
            });
        return (0, $kNOM9.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$29f0ab2b0d75a28d$export$ec60d70ff941a580.propTypes = {};
$29f0ab2b0d75a28d$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $29f0ab2b0d75a28d$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $8IzS5.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $8IzS5.getValue)(transformer, propValue)
            });
        return (0, $kNOM9.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$29f0ab2b0d75a28d$export$8a833ffa5f5dbeda.propTypes = {};
$29f0ab2b0d75a28d$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $29f0ab2b0d75a28d$export$baf44164ca3a34e8 = (0, $dkiNS.default)({
    prop: 'gridColumn'
});
const $29f0ab2b0d75a28d$export$8f7213a1cd01e832 = (0, $dkiNS.default)({
    prop: 'gridRow'
});
const $29f0ab2b0d75a28d$export$b0e0abbc49ba668 = (0, $dkiNS.default)({
    prop: 'gridAutoFlow'
});
const $29f0ab2b0d75a28d$export$bcd8b929d4b4142 = (0, $dkiNS.default)({
    prop: 'gridAutoColumns'
});
const $29f0ab2b0d75a28d$export$e5039a674e14c828 = (0, $dkiNS.default)({
    prop: 'gridAutoRows'
});
const $29f0ab2b0d75a28d$export$42bd9088661ffb03 = (0, $dkiNS.default)({
    prop: 'gridTemplateColumns'
});
const $29f0ab2b0d75a28d$export$920682ae05b999bc = (0, $dkiNS.default)({
    prop: 'gridTemplateRows'
});
const $29f0ab2b0d75a28d$export$1b88fbdd482fd33a = (0, $dkiNS.default)({
    prop: 'gridTemplateAreas'
});
const $29f0ab2b0d75a28d$export$bdb486e40d52d26f = (0, $dkiNS.default)({
    prop: 'gridArea'
});
const $29f0ab2b0d75a28d$var$grid = (0, $4nocs.default)($29f0ab2b0d75a28d$export$5df9adcb0db95e1e, $29f0ab2b0d75a28d$export$ec60d70ff941a580, $29f0ab2b0d75a28d$export$8a833ffa5f5dbeda, $29f0ab2b0d75a28d$export$baf44164ca3a34e8, $29f0ab2b0d75a28d$export$8f7213a1cd01e832, $29f0ab2b0d75a28d$export$b0e0abbc49ba668, $29f0ab2b0d75a28d$export$bcd8b929d4b4142, $29f0ab2b0d75a28d$export$e5039a674e14c828, $29f0ab2b0d75a28d$export$42bd9088661ffb03, $29f0ab2b0d75a28d$export$920682ae05b999bc, $29f0ab2b0d75a28d$export$1b88fbdd482fd33a, $29f0ab2b0d75a28d$export$bdb486e40d52d26f);
var $29f0ab2b0d75a28d$export$2e2bcd8739ae039 = $29f0ab2b0d75a28d$var$grid;

});

parcelRegister("eeeGZ", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $a5bdc51b72af6f40$export$dbaffd4420ea0ac6);

var $dkiNS = parcelRequire("dkiNS");

var $4nocs = parcelRequire("4nocs");
function $a5bdc51b72af6f40$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $a5bdc51b72af6f40$export$35e9368ef982300f = (0, $dkiNS.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $a5bdc51b72af6f40$export$dbaffd4420ea0ac6
});
const $a5bdc51b72af6f40$export$2506f56c10355b33 = (0, $dkiNS.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $a5bdc51b72af6f40$export$dbaffd4420ea0ac6
});
const $a5bdc51b72af6f40$export$8c5a050822fd698c = (0, $dkiNS.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $a5bdc51b72af6f40$export$dbaffd4420ea0ac6
});
const $a5bdc51b72af6f40$var$palette = (0, $4nocs.default)($a5bdc51b72af6f40$export$35e9368ef982300f, $a5bdc51b72af6f40$export$2506f56c10355b33, $a5bdc51b72af6f40$export$8c5a050822fd698c);
var $a5bdc51b72af6f40$export$2e2bcd8739ae039 = $a5bdc51b72af6f40$var$palette;

});

parcelRegister("gCSwL", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $c1aa7df946071014$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $c1aa7df946071014$export$488fda99655ff65a);

var $dkiNS = parcelRequire("dkiNS");

var $4nocs = parcelRequire("4nocs");

var $kNOM9 = parcelRequire("kNOM9");
function $c1aa7df946071014$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $c1aa7df946071014$export$7e3df82ee760448c = (0, $dkiNS.default)({
    prop: 'width',
    transform: $c1aa7df946071014$export$8afece71750ec241
});
const $c1aa7df946071014$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $kNOM9.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $c1aa7df946071014$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $kNOM9.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$c1aa7df946071014$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $c1aa7df946071014$export$ee148fbbe8357dd2 = (0, $dkiNS.default)({
    prop: 'minWidth',
    transform: $c1aa7df946071014$export$8afece71750ec241
});
const $c1aa7df946071014$export$ac607276a8fe9f0a = (0, $dkiNS.default)({
    prop: 'height',
    transform: $c1aa7df946071014$export$8afece71750ec241
});
const $c1aa7df946071014$export$dc0d8bd0b94f8570 = (0, $dkiNS.default)({
    prop: 'maxHeight',
    transform: $c1aa7df946071014$export$8afece71750ec241
});
const $c1aa7df946071014$export$a43cf604e12f3b17 = (0, $dkiNS.default)({
    prop: 'minHeight',
    transform: $c1aa7df946071014$export$8afece71750ec241
});
const $c1aa7df946071014$export$ffed9f14fb65e276 = (0, $dkiNS.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $c1aa7df946071014$export$8afece71750ec241
});
const $c1aa7df946071014$export$905076ed6620e671 = (0, $dkiNS.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $c1aa7df946071014$export$8afece71750ec241
});
const $c1aa7df946071014$export$6ccc93f785106a58 = (0, $dkiNS.default)({
    prop: 'boxSizing'
});
const $c1aa7df946071014$var$sizing = (0, $4nocs.default)($c1aa7df946071014$export$7e3df82ee760448c, $c1aa7df946071014$export$488fda99655ff65a, $c1aa7df946071014$export$ee148fbbe8357dd2, $c1aa7df946071014$export$ac607276a8fe9f0a, $c1aa7df946071014$export$dc0d8bd0b94f8570, $c1aa7df946071014$export$a43cf604e12f3b17, $c1aa7df946071014$export$6ccc93f785106a58);
var $c1aa7df946071014$export$2e2bcd8739ae039 = $c1aa7df946071014$var$sizing;

});



parcelRegister("5eonk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cf12af3afe74f97$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $3cf12af3afe74f97$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("vZRH3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("lfmQj")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("lfmQj")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("3fjJg")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("7exGP")).default);

var $lfmQj = parcelRequire("lfmQj");

var $3fjJg = parcelRequire("3fjJg");

var $7exGP = parcelRequire("7exGP");

});
parcelRegister("3fjJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $25d21392ef6a7ebd$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $5eWZU = parcelRequire("5eWZU");

var $7exGP = parcelRequire("7exGP");
const $25d21392ef6a7ebd$var$_excluded = [
    "sx"
];
const $25d21392ef6a7ebd$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $7exGP.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $25d21392ef6a7ebd$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $hQtye.default)(props, $25d21392ef6a7ebd$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $25d21392ef6a7ebd$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $5eWZU.isPlainObject)(result)) return systemProps;
        return (0, $jz4iA.default)({}, systemProps, result);
    };
    else finalSx = (0, $jz4iA.default)({}, systemProps, inSx);
    return (0, $jz4iA.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("ejyEb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6T5ne")).default);

var $6T5ne = parcelRequire("6T5ne");

});

parcelRegister("iB2j3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("aKSKj")).default);

var $aKSKj = parcelRequire("aKSKj");

});
parcelRegister("aKSKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d48aaaa456e2107$export$2e2bcd8739ae039);
function $7d48aaaa456e2107$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $7d48aaaa456e2107$export$2e2bcd8739ae039 = $7d48aaaa456e2107$var$clamp;

});


parcelRegister("64yct", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3vCKb.default;
    }
});

var $3vCKb = parcelRequire("3vCKb");

});
parcelRegister("3vCKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e252194ad09a4b$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");

var $6FrBk = parcelRequire("6FrBk");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $28e252194ad09a4b$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6FrBk.default), (0, $jz4iA.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $6FrBk.default).muiName;
    return /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(Component));
}

});
parcelRegister("6FrBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dabfb68e3c68c57$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");

var $fzbVi = parcelRequire("fzbVi");

var $aBf7M = parcelRequire("aBf7M");

var $32Puv = parcelRequire("32Puv");

var $4PkUS = parcelRequire("4PkUS");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $4dabfb68e3c68c57$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $4dabfb68e3c68c57$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $fzbVi.default)(color)}`,
            `fontSize${(0, $fzbVi.default)(fontSize)}`
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $4PkUS.getSvgIconUtilityClass), classes);
};
const $4dabfb68e3c68c57$var$SvgIconRoot = (0, $32Puv.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $fzbVi.default)(ownerState.color)}`],
            styles[`fontSize${(0, $fzbVi.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $4dabfb68e3c68c57$var$SvgIcon = /*#__PURE__*/ $8NFma.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $hQtye.default)(props, $4dabfb68e3c68c57$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $8NFma.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $jz4iA.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $4dabfb68e3c68c57$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($4dabfb68e3c68c57$var$SvgIconRoot, (0, $jz4iA.default)({
        as: component,
        className: (0, $ase04.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $1IdZj.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$4dabfb68e3c68c57$var$SvgIcon.muiName = 'SvgIcon';
var $4dabfb68e3c68c57$export$2e2bcd8739ae039 = $4dabfb68e3c68c57$var$SvgIcon;

});
parcelRegister("ase04", function(module, exports) {

$parcel$export(module.exports, "default", () => $4944fe05cfdb1e2e$export$2e2bcd8739ae039);
function $4944fe05cfdb1e2e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $4944fe05cfdb1e2e$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $4944fe05cfdb1e2e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $4944fe05cfdb1e2e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4944fe05cfdb1e2e$export$2e2bcd8739ae039 = $4944fe05cfdb1e2e$export$4f5d2d50c9deca37;

});

parcelRegister("2jLNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b026db85de7605c$export$2e2bcd8739ae039);
function $1b026db85de7605c$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("fzbVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5535f9aacf9747f$export$2e2bcd8739ae039);

var $em3Bd = parcelRequire("em3Bd");
var $b5535f9aacf9747f$export$2e2bcd8739ae039 = (0, $em3Bd.default);

});

parcelRegister("aBf7M", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $7b791778fe98c57f$export$2440da353cedad43);

var $jz4iA = parcelRequire("jz4iA");
parcelRequire("8NFma");


var $1cG7Z = parcelRequire("1cG7Z");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $7b791778fe98c57f$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1cG7Z.default), (0, $jz4iA.default)({}, props));
}
var $7b791778fe98c57f$export$2e2bcd8739ae039 = $7b791778fe98c57f$var$DefaultPropsProvider;
function $7b791778fe98c57f$export$2440da353cedad43(params) {
    return (0, $1cG7Z.useDefaultProps)(params);
}

});
parcelRegister("1cG7Z", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0e07972afc77d76d$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $0e07972afc77d76d$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");


var $lPDGF = parcelRequire("lPDGF");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $0e07972afc77d76d$var$PropsContext = /*#__PURE__*/ $8NFma.createContext(undefined);
function $0e07972afc77d76d$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)($0e07972afc77d76d$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $0e07972afc77d76d$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $lPDGF.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $lPDGF.default)(config, props);
    return props;
}
function $0e07972afc77d76d$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $8NFma.useContext($0e07972afc77d76d$var$PropsContext);
    return $0e07972afc77d76d$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $0e07972afc77d76d$export$2e2bcd8739ae039 = $0e07972afc77d76d$var$DefaultPropsProvider;

});
parcelRegister("lPDGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe4d2574a0dfbe93$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");
function $fe4d2574a0dfbe93$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $jz4iA.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $jz4iA.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $jz4iA.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $fe4d2574a0dfbe93$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("32Puv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2379800afbd58d98$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rootShouldForwardProp", () => (parcelRequire("fwZkm")).default);

var $67WQ8 = parcelRequire("67WQ8");

var $7PtT3 = parcelRequire("7PtT3");

var $9cYDa = parcelRequire("9cYDa");

var $fwZkm = parcelRequire("fwZkm");

var $2Uk0X = parcelRequire("2Uk0X");
'use client';
const $2379800afbd58d98$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($67WQ8)))({
    themeId: (0, $9cYDa.default),
    defaultTheme: $7PtT3.default,
    rootShouldForwardProp: $fwZkm.default
});
var $2379800afbd58d98$export$2e2bcd8739ae039 = $2379800afbd58d98$var$styled;

});
parcelRegister("67WQ8", function(module, exports) {
"use strict";

var $4jcgx = parcelRequire("4jcgx");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $476109e29bc43fc0$var$createStyled;
module.exports.shouldForwardProp = $476109e29bc43fc0$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $476109e29bc43fc0$var$_extends2 = $4jcgx((parcelRequire("lBRDc")));

var $476109e29bc43fc0$var$_objectWithoutPropertiesLoose2 = $4jcgx((parcelRequire("6oOAi")));

var $476109e29bc43fc0$var$_styledEngine = $476109e29bc43fc0$var$_interopRequireWildcard((parcelRequire("91MX1")));

var $5eWZU = parcelRequire("5eWZU");

var $476109e29bc43fc0$var$_capitalize = $4jcgx((parcelRequire("lLrTz")));

var $476109e29bc43fc0$var$_getDisplayName = $4jcgx((parcelRequire("kpMWV")));

var $476109e29bc43fc0$var$_createTheme = $4jcgx((parcelRequire("8WYKi")));

var $476109e29bc43fc0$var$_styleFunctionSx = $4jcgx((parcelRequire("vZRH3")));
const $476109e29bc43fc0$var$_excluded = [
    "ownerState"
], $476109e29bc43fc0$var$_excluded2 = [
    "variants"
], $476109e29bc43fc0$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $476109e29bc43fc0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($476109e29bc43fc0$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $476109e29bc43fc0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $476109e29bc43fc0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $476109e29bc43fc0$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $476109e29bc43fc0$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $476109e29bc43fc0$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $476109e29bc43fc0$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $476109e29bc43fc0$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $476109e29bc43fc0$var$_createTheme.default)();
const $476109e29bc43fc0$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $476109e29bc43fc0$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $476109e29bc43fc0$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $476109e29bc43fc0$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $476109e29bc43fc0$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $476109e29bc43fc0$var$_objectWithoutPropertiesLoose2.default)(_ref, $476109e29bc43fc0$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $476109e29bc43fc0$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$476109e29bc43fc0$var$processStyleArg(resolvedStyle, (0, $476109e29bc43fc0$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $476109e29bc43fc0$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $476109e29bc43fc0$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $476109e29bc43fc0$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $476109e29bc43fc0$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $476109e29bc43fc0$var$shallowLayer((0, $476109e29bc43fc0$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $476109e29bc43fc0$var$shallowLayer((0, $476109e29bc43fc0$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $476109e29bc43fc0$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $476109e29bc43fc0$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $476109e29bc43fc0$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $476109e29bc43fc0$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $476109e29bc43fc0$var$_styleFunctionSx.default)((0, $476109e29bc43fc0$var$_extends2.default)({}, props, {
            theme: $476109e29bc43fc0$var$resolveTheme((0, $476109e29bc43fc0$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $476109e29bc43fc0$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $476109e29bc43fc0$var$defaultOverridesResolver($476109e29bc43fc0$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $476109e29bc43fc0$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $476109e29bc43fc0$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $476109e29bc43fc0$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($476109e29bc43fc0$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $476109e29bc43fc0$var$_styledEngine.default)(tag, (0, $476109e29bc43fc0$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $5eWZU.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $476109e29bc43fc0$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $476109e29bc43fc0$var$processStyleArg(stylesArg, (0, $476109e29bc43fc0$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $476109e29bc43fc0$var$resolveTheme((0, $476109e29bc43fc0$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $476109e29bc43fc0$var$processStyleArg(slotStyle, (0, $476109e29bc43fc0$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $476109e29bc43fc0$var$resolveTheme((0, $476109e29bc43fc0$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $476109e29bc43fc0$var$processStyleArg({
                    variants: themeVariants
                }, (0, $476109e29bc43fc0$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("4jcgx", function(module, exports) {
function $32327384249c777c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $32327384249c777c$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7PtT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b347ac3ba7d187a$export$2e2bcd8739ae039);

var $f1l7f = parcelRequire("f1l7f");
'use client';
const $5b347ac3ba7d187a$var$defaultTheme = (0, $f1l7f.default)();
var $5b347ac3ba7d187a$export$2e2bcd8739ae039 = $5b347ac3ba7d187a$var$defaultTheme;

});
parcelRegister("f1l7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $aef7542ad817395e$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $6T5ne = parcelRequire("6T5ne");

var $5eWZU = parcelRequire("5eWZU");

var $lfmQj = parcelRequire("lfmQj");
var $7exGP = parcelRequire("7exGP");

var $9dxf1 = parcelRequire("9dxf1");


var $gOJfx = parcelRequire("gOJfx");

var $3hG7S = parcelRequire("3hG7S");

var $9oVbD = parcelRequire("9oVbD");

var $bQvWd = parcelRequire("bQvWd");

var $fqKKo = parcelRequire("fqKKo");

var $f6nlM = parcelRequire("f6nlM");
const $aef7542ad817395e$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $aef7542ad817395e$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $hQtye.default)(options, $aef7542ad817395e$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $6T5ne.default)(18));
    const palette = (0, $3hG7S.default)(paletteInput);
    const systemTheme = (0, $9dxf1.default)(options);
    let muiTheme = (0, $5eWZU.default)(systemTheme, {
        mixins: (0, $gOJfx.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $bQvWd.default).slice(),
        typography: (0, $9oVbD.default)(palette, typographyInput),
        transitions: (0, $fqKKo.default)(transitionsInput),
        zIndex: (0, $jz4iA.default)({}, (0, $f6nlM.default))
    });
    muiTheme = (0, $5eWZU.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $5eWZU.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $jz4iA.default)({}, (0, $7exGP.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $lfmQj.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $aef7542ad817395e$var$warnedOnce = false;
function $aef7542ad817395e$export$c469355549431d9b(...args) {
    return $aef7542ad817395e$var$createTheme(...args);
}
var $aef7542ad817395e$export$2e2bcd8739ae039 = $aef7542ad817395e$var$createTheme;

});
parcelRegister("gOJfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3e46a7a3c550973$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");
function $c3e46a7a3c550973$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $jz4iA.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("3hG7S", function(module, exports) {

$parcel$export(module.exports, "default", () => $2643a2fd3dce9d9c$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $6T5ne = parcelRequire("6T5ne");

var $5eWZU = parcelRequire("5eWZU");

var $jJYy4 = parcelRequire("jJYy4");

var $1w5P5 = parcelRequire("1w5P5");

var $7un9M = parcelRequire("7un9M");

var $3NoxN = parcelRequire("3NoxN");

var $1hiZN = parcelRequire("1hiZN");

var $lDCcx = parcelRequire("lDCcx");

var $7NjxO = parcelRequire("7NjxO");

var $gW80u = parcelRequire("gW80u");

var $51U56 = parcelRequire("51U56");
const $2643a2fd3dce9d9c$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $2643a2fd3dce9d9c$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $1w5P5.default).white,
        default: (0, $1w5P5.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $2643a2fd3dce9d9c$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $1w5P5.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $1w5P5.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $2643a2fd3dce9d9c$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $jJYy4.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $jJYy4.darken)(intent.main, tonalOffsetDark);
    }
}
function $2643a2fd3dce9d9c$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $7NjxO.default)[200],
        light: (0, $7NjxO.default)[50],
        dark: (0, $7NjxO.default)[400]
    };
    return {
        main: (0, $7NjxO.default)[700],
        light: (0, $7NjxO.default)[400],
        dark: (0, $7NjxO.default)[800]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3NoxN.default)[200],
        light: (0, $3NoxN.default)[50],
        dark: (0, $3NoxN.default)[400]
    };
    return {
        main: (0, $3NoxN.default)[500],
        light: (0, $3NoxN.default)[300],
        dark: (0, $3NoxN.default)[700]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $1hiZN.default)[500],
        light: (0, $1hiZN.default)[300],
        dark: (0, $1hiZN.default)[700]
    };
    return {
        main: (0, $1hiZN.default)[700],
        light: (0, $1hiZN.default)[400],
        dark: (0, $1hiZN.default)[800]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gW80u.default)[400],
        light: (0, $gW80u.default)[300],
        dark: (0, $gW80u.default)[700]
    };
    return {
        main: (0, $gW80u.default)[700],
        light: (0, $gW80u.default)[500],
        dark: (0, $gW80u.default)[900]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $51U56.default)[400],
        light: (0, $51U56.default)[300],
        dark: (0, $51U56.default)[700]
    };
    return {
        main: (0, $51U56.default)[800],
        light: (0, $51U56.default)[500],
        dark: (0, $51U56.default)[900]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $lDCcx.default)[400],
        light: (0, $lDCcx.default)[300],
        dark: (0, $lDCcx.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $lDCcx.default)[500],
        dark: (0, $lDCcx.default)[900]
    };
}
function $2643a2fd3dce9d9c$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $hQtye.default)(palette, $2643a2fd3dce9d9c$var$_excluded);
    const primary = palette.primary || $2643a2fd3dce9d9c$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $2643a2fd3dce9d9c$var$getDefaultSecondary(mode);
    const error = palette.error || $2643a2fd3dce9d9c$var$getDefaultError(mode);
    const info = palette.info || $2643a2fd3dce9d9c$var$getDefaultInfo(mode);
    const success = palette.success || $2643a2fd3dce9d9c$var$getDefaultSuccess(mode);
    const warning = palette.warning || $2643a2fd3dce9d9c$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $jJYy4.getContrastRatio)(background, $2643a2fd3dce9d9c$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $2643a2fd3dce9d9c$export$55ce6f3a06c59543.text.primary : $2643a2fd3dce9d9c$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $jz4iA.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $6T5ne.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $6T5ne.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $2643a2fd3dce9d9c$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $2643a2fd3dce9d9c$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $2643a2fd3dce9d9c$export$55ce6f3a06c59543,
        light: $2643a2fd3dce9d9c$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $5eWZU.default)((0, $jz4iA.default)({
        // A collection of common colors.
        common: (0, $jz4iA.default)({}, (0, $1w5P5.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $7un9M.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("jJYy4", function(module, exports) {
"use strict";

var $4jcgx = parcelRequire("4jcgx");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $e5f12ff302467b53$var$alpha;
module.exports.blend = $e5f12ff302467b53$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $e5f12ff302467b53$var$darken;
module.exports.decomposeColor = $e5f12ff302467b53$var$decomposeColor;
module.exports.emphasize = $e5f12ff302467b53$var$emphasize;
module.exports.getContrastRatio = $e5f12ff302467b53$var$getContrastRatio;
module.exports.getLuminance = $e5f12ff302467b53$var$getLuminance;
module.exports.hexToRgb = $e5f12ff302467b53$var$hexToRgb;
module.exports.hslToRgb = $e5f12ff302467b53$var$hslToRgb;
module.exports.lighten = $e5f12ff302467b53$var$lighten;
module.exports.private_safeAlpha = $e5f12ff302467b53$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $e5f12ff302467b53$var$private_safeDarken;
module.exports.private_safeEmphasize = $e5f12ff302467b53$var$private_safeEmphasize;
module.exports.private_safeLighten = $e5f12ff302467b53$var$private_safeLighten;
module.exports.recomposeColor = $e5f12ff302467b53$var$recomposeColor;
module.exports.rgbToHex = $e5f12ff302467b53$var$rgbToHex;

var $e5f12ff302467b53$var$_formatMuiErrorMessage2 = $4jcgx((parcelRequire("ejyEb")));

var $e5f12ff302467b53$var$_clamp = $4jcgx((parcelRequire("iB2j3")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $e5f12ff302467b53$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $e5f12ff302467b53$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $e5f12ff302467b53$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $e5f12ff302467b53$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $e5f12ff302467b53$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $e5f12ff302467b53$var$decomposeColor($e5f12ff302467b53$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $e5f12ff302467b53$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $e5f12ff302467b53$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $e5f12ff302467b53$var$colorChannel = (color)=>{
    const decomposedColor = $e5f12ff302467b53$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $e5f12ff302467b53$var$colorChannel;
const $e5f12ff302467b53$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $e5f12ff302467b53$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $e5f12ff302467b53$var$private_safeColorChannel;
function $e5f12ff302467b53$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $e5f12ff302467b53$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $e5f12ff302467b53$var$decomposeColor(color);
    return `#${values.map((n, i)=>$e5f12ff302467b53$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $e5f12ff302467b53$var$hslToRgb(color) {
    color = $e5f12ff302467b53$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $e5f12ff302467b53$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $e5f12ff302467b53$var$getLuminance(color) {
    color = $e5f12ff302467b53$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $e5f12ff302467b53$var$decomposeColor($e5f12ff302467b53$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $e5f12ff302467b53$var$getContrastRatio(foreground, background) {
    const lumA = $e5f12ff302467b53$var$getLuminance(foreground);
    const lumB = $e5f12ff302467b53$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $e5f12ff302467b53$var$alpha(color, value) {
    color = $e5f12ff302467b53$var$decomposeColor(color);
    value = $e5f12ff302467b53$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $e5f12ff302467b53$var$recomposeColor(color);
}
function $e5f12ff302467b53$var$private_safeAlpha(color, value, warning) {
    try {
        return $e5f12ff302467b53$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $e5f12ff302467b53$var$darken(color, coefficient) {
    color = $e5f12ff302467b53$var$decomposeColor(color);
    coefficient = $e5f12ff302467b53$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $e5f12ff302467b53$var$recomposeColor(color);
}
function $e5f12ff302467b53$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $e5f12ff302467b53$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $e5f12ff302467b53$var$lighten(color, coefficient) {
    color = $e5f12ff302467b53$var$decomposeColor(color);
    coefficient = $e5f12ff302467b53$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $e5f12ff302467b53$var$recomposeColor(color);
}
function $e5f12ff302467b53$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $e5f12ff302467b53$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $e5f12ff302467b53$var$emphasize(color, coefficient = 0.15) {
    return $e5f12ff302467b53$var$getLuminance(color) > 0.5 ? $e5f12ff302467b53$var$darken(color, coefficient) : $e5f12ff302467b53$var$lighten(color, coefficient);
}
function $e5f12ff302467b53$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $e5f12ff302467b53$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $e5f12ff302467b53$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $e5f12ff302467b53$var$decomposeColor(background);
    const overlayColor = $e5f12ff302467b53$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $e5f12ff302467b53$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("1w5P5", function(module, exports) {

$parcel$export(module.exports, "default", () => $11ad4beec672042a$export$2e2bcd8739ae039);
const $11ad4beec672042a$var$common = {
    black: '#000',
    white: '#fff'
};
var $11ad4beec672042a$export$2e2bcd8739ae039 = $11ad4beec672042a$var$common;

});

parcelRegister("7un9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $573d4c3554a3feba$export$2e2bcd8739ae039);
const $573d4c3554a3feba$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $573d4c3554a3feba$export$2e2bcd8739ae039 = $573d4c3554a3feba$var$grey;

});

parcelRegister("3NoxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c38fca6c8d165ee$export$2e2bcd8739ae039);
const $2c38fca6c8d165ee$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $2c38fca6c8d165ee$export$2e2bcd8739ae039 = $2c38fca6c8d165ee$var$purple;

});

parcelRegister("1hiZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee61d24a788d83d$export$2e2bcd8739ae039);
const $0ee61d24a788d83d$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $0ee61d24a788d83d$export$2e2bcd8739ae039 = $0ee61d24a788d83d$var$red;

});

parcelRegister("lDCcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc0adf7233d5e51f$export$2e2bcd8739ae039);
const $fc0adf7233d5e51f$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $fc0adf7233d5e51f$export$2e2bcd8739ae039 = $fc0adf7233d5e51f$var$orange;

});

parcelRegister("7NjxO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5acc452236058cea$export$2e2bcd8739ae039);
const $5acc452236058cea$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $5acc452236058cea$export$2e2bcd8739ae039 = $5acc452236058cea$var$blue;

});

parcelRegister("gW80u", function(module, exports) {

$parcel$export(module.exports, "default", () => $c548461d7baf0d5f$export$2e2bcd8739ae039);
const $c548461d7baf0d5f$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $c548461d7baf0d5f$export$2e2bcd8739ae039 = $c548461d7baf0d5f$var$lightBlue;

});

parcelRegister("51U56", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a988c4fae84ab2b$export$2e2bcd8739ae039);
const $3a988c4fae84ab2b$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $3a988c4fae84ab2b$export$2e2bcd8739ae039 = $3a988c4fae84ab2b$var$green;

});


parcelRegister("9oVbD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d82b707c923b73a$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $5eWZU = parcelRequire("5eWZU");
const $6d82b707c923b73a$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $6d82b707c923b73a$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $6d82b707c923b73a$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $6d82b707c923b73a$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $6d82b707c923b73a$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $6d82b707c923b73a$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $hQtye.default)(_ref, $6d82b707c923b73a$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $jz4iA.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $6d82b707c923b73a$var$defaultFontFamily ? {
            letterSpacing: `${$6d82b707c923b73a$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $6d82b707c923b73a$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $6d82b707c923b73a$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $5eWZU.default)((0, $jz4iA.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("bQvWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $89fd534632cf1937$export$2e2bcd8739ae039);
const $89fd534632cf1937$var$shadowKeyUmbraOpacity = 0.2;
const $89fd534632cf1937$var$shadowKeyPenumbraOpacity = 0.14;
const $89fd534632cf1937$var$shadowAmbientShadowOpacity = 0.12;
function $89fd534632cf1937$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$89fd534632cf1937$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$89fd534632cf1937$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$89fd534632cf1937$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $89fd534632cf1937$var$shadows = [
    'none',
    $89fd534632cf1937$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $89fd534632cf1937$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $89fd534632cf1937$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $89fd534632cf1937$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $89fd534632cf1937$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $89fd534632cf1937$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $89fd534632cf1937$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $89fd534632cf1937$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $89fd534632cf1937$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $89fd534632cf1937$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $89fd534632cf1937$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $89fd534632cf1937$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $89fd534632cf1937$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $89fd534632cf1937$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $89fd534632cf1937$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $89fd534632cf1937$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $89fd534632cf1937$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $89fd534632cf1937$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $89fd534632cf1937$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $89fd534632cf1937$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $89fd534632cf1937$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $89fd534632cf1937$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $89fd534632cf1937$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $89fd534632cf1937$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $89fd534632cf1937$export$2e2bcd8739ae039 = $89fd534632cf1937$var$shadows;

});

parcelRegister("fqKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3bd8bc81df264a5$export$2e2bcd8739ae039);

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");
const $b3bd8bc81df264a5$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $b3bd8bc81df264a5$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $b3bd8bc81df264a5$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b3bd8bc81df264a5$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $b3bd8bc81df264a5$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $b3bd8bc81df264a5$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $jz4iA.default)({}, $b3bd8bc81df264a5$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $jz4iA.default)({}, $b3bd8bc81df264a5$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $hQtye.default)(options, $b3bd8bc81df264a5$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $b3bd8bc81df264a5$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $b3bd8bc81df264a5$var$formatMs(delay)}`).join(',');
    };
    return (0, $jz4iA.default)({
        getAutoHeightDuration: $b3bd8bc81df264a5$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("f6nlM", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe9876d7dbd431a$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $afe9876d7dbd431a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $afe9876d7dbd431a$export$2e2bcd8739ae039 = $afe9876d7dbd431a$var$zIndex;

});



parcelRegister("9cYDa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b44440c4cabd1a9$export$2e2bcd8739ae039);
var $6b44440c4cabd1a9$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("fwZkm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4e96a8ac947c82c$export$2e2bcd8739ae039);

var $2Uk0X = parcelRequire("2Uk0X");
const $b4e96a8ac947c82c$var$rootShouldForwardProp = (prop)=>(0, $2Uk0X.default)(prop) && prop !== 'classes';
var $b4e96a8ac947c82c$export$2e2bcd8739ae039 = $b4e96a8ac947c82c$var$rootShouldForwardProp;

});
parcelRegister("2Uk0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $21e05629fbdcc825$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $21e05629fbdcc825$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $21e05629fbdcc825$export$2e2bcd8739ae039 = $21e05629fbdcc825$var$slotShouldForwardProp;

});



parcelRegister("4PkUS", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $383c266ae554f20b$export$c7c50641356bdfa5);

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $383c266ae554f20b$export$c7c50641356bdfa5(slot) {
    return (0, $guzMP.default)('MuiSvgIcon', slot);
}
const $383c266ae554f20b$var$svgIconClasses = (0, $bnCUV.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $383c266ae554f20b$export$2e2bcd8739ae039 = $383c266ae554f20b$var$svgIconClasses;

});
parcelRegister("bnCUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $849007d053493250$export$2e2bcd8739ae039);

var $guzMP = parcelRequire("guzMP");
function $849007d053493250$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $guzMP.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("guzMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c01b352325a406cf$export$2e2bcd8739ae039);

var $dhBhw = parcelRequire("dhBhw");
const $c01b352325a406cf$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $c01b352325a406cf$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $c01b352325a406cf$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $dhBhw.default).generate(componentName)}-${slot}`;
}
function $c01b352325a406cf$export$34c0130b1f3e8ae3(slot) {
    return $c01b352325a406cf$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("dhBhw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ab9c83b20d59c88$export$2e2bcd8739ae039);
const $9ab9c83b20d59c88$var$defaultGenerator = (componentName)=>componentName;
const $9ab9c83b20d59c88$var$createClassNameGenerator = ()=>{
    let generate = $9ab9c83b20d59c88$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $9ab9c83b20d59c88$var$defaultGenerator;
        }
    };
};
const $9ab9c83b20d59c88$var$ClassNameGenerator = $9ab9c83b20d59c88$var$createClassNameGenerator();
var $9ab9c83b20d59c88$export$2e2bcd8739ae039 = $9ab9c83b20d59c88$var$ClassNameGenerator;

});







parcelRegister("fb0st", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0c83d16b421d7f5$var$ReactIs, $b0c83d16b421d7f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6DzO8"))();

});


var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");
var $503937b663c395c4$exports = {};

$parcel$export($503937b663c395c4$exports, "createRoot", () => $503937b663c395c4$export$882461b6382ed46c, (v) => $503937b663c395c4$export$882461b6382ed46c = v);
$parcel$export($503937b663c395c4$exports, "hydrateRoot", () => $503937b663c395c4$export$757ceba2d55c277e, (v) => $503937b663c395c4$export$757ceba2d55c277e = v);
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
'use strict';
var $1c0f1e610963dfb8$exports = {};
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

$1c0f1e610963dfb8$exports = (parcelRequire("23wBm"));


var $503937b663c395c4$var$i;
$503937b663c395c4$export$882461b6382ed46c = $1c0f1e610963dfb8$exports.createRoot;
$503937b663c395c4$export$757ceba2d55c277e = $1c0f1e610963dfb8$exports.hydrateRoot;


/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8NFma = parcelRequire("8NFma");

/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $47039de3e9f0864a$var$_extends() {
    return $47039de3e9f0864a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $47039de3e9f0864a$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $47039de3e9f0864a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($47039de3e9f0864a$export$e19cd5f9376f8cee || ($47039de3e9f0864a$export$e19cd5f9376f8cee = {}));
const $47039de3e9f0864a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $47039de3e9f0864a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $47039de3e9f0864a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $47039de3e9f0864a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $47039de3e9f0864a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $47039de3e9f0864a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to);
    }
    return $47039de3e9f0864a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $47039de3e9f0864a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $47039de3e9f0864a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $47039de3e9f0864a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $47039de3e9f0864a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $47039de3e9f0864a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $47039de3e9f0864a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $47039de3e9f0864a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $47039de3e9f0864a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $47039de3e9f0864a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $47039de3e9f0864a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $47039de3e9f0864a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $47039de3e9f0864a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $47039de3e9f0864a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $47039de3e9f0864a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $47039de3e9f0864a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($47039de3e9f0864a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
        let location = $47039de3e9f0864a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $47039de3e9f0864a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
        let location = $47039de3e9f0864a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $47039de3e9f0864a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $47039de3e9f0864a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($47039de3e9f0864a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($47039de3e9f0864a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $47039de3e9f0864a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($47039de3e9f0864a$var$ResultType || ($47039de3e9f0864a$var$ResultType = {}));
const $47039de3e9f0864a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $47039de3e9f0864a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $47039de3e9f0864a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $47039de3e9f0864a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $47039de3e9f0864a$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($47039de3e9f0864a$var$isIndexRoute(route)) {
            let indexRoute = $47039de3e9f0864a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $47039de3e9f0864a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $47039de3e9f0864a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $47039de3e9f0864a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $47039de3e9f0864a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $47039de3e9f0864a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $47039de3e9f0864a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $47039de3e9f0864a$var$flattenRoutes(routes);
    $47039de3e9f0864a$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $47039de3e9f0864a$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $47039de3e9f0864a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $47039de3e9f0864a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $47039de3e9f0864a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $47039de3e9f0864a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $47039de3e9f0864a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $47039de3e9f0864a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $47039de3e9f0864a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $47039de3e9f0864a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $47039de3e9f0864a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $47039de3e9f0864a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $47039de3e9f0864a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $47039de3e9f0864a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $47039de3e9f0864a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $47039de3e9f0864a$var$paramRe = /^:[\w-]+$/;
const $47039de3e9f0864a$var$dynamicSegmentValue = 3;
const $47039de3e9f0864a$var$indexRouteValue = 2;
const $47039de3e9f0864a$var$emptySegmentValue = 1;
const $47039de3e9f0864a$var$staticSegmentValue = 10;
const $47039de3e9f0864a$var$splatPenalty = -2;
const $47039de3e9f0864a$var$isSplat = (s)=>s === "*";
function $47039de3e9f0864a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($47039de3e9f0864a$var$isSplat)) initialScore += $47039de3e9f0864a$var$splatPenalty;
    if (index) initialScore += $47039de3e9f0864a$var$indexRouteValue;
    return segments.filter((s)=>!$47039de3e9f0864a$var$isSplat(s)).reduce((score, segment)=>score + ($47039de3e9f0864a$var$paramRe.test(segment) ? $47039de3e9f0864a$var$dynamicSegmentValue : segment === "" ? $47039de3e9f0864a$var$emptySegmentValue : $47039de3e9f0864a$var$staticSegmentValue), initialScore);
}
function $47039de3e9f0864a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $47039de3e9f0864a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $47039de3e9f0864a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $47039de3e9f0864a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $47039de3e9f0864a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $47039de3e9f0864a$export$a5c6d149b50c1d86($47039de3e9f0864a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $47039de3e9f0864a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $47039de3e9f0864a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $47039de3e9f0864a$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $47039de3e9f0864a$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $47039de3e9f0864a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $47039de3e9f0864a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $47039de3e9f0864a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $47039de3e9f0864a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $47039de3e9f0864a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $47039de3e9f0864a$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $47039de3e9f0864a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $47039de3e9f0864a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $47039de3e9f0864a$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $47039de3e9f0864a$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $47039de3e9f0864a$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $47039de3e9f0864a$var$normalizeSearch(search),
        hash: $47039de3e9f0864a$var$normalizeHash(hash)
    };
}
function $47039de3e9f0864a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $47039de3e9f0864a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $47039de3e9f0864a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $47039de3e9f0864a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $47039de3e9f0864a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $47039de3e9f0864a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $47039de3e9f0864a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $47039de3e9f0864a$var$_extends({}, toArg);
        $47039de3e9f0864a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $47039de3e9f0864a$var$getInvalidPathError("?", "pathname", "search", to));
        $47039de3e9f0864a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $47039de3e9f0864a$var$getInvalidPathError("#", "pathname", "hash", to));
        $47039de3e9f0864a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $47039de3e9f0864a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $47039de3e9f0864a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $47039de3e9f0864a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $47039de3e9f0864a$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $47039de3e9f0864a$export$86d9a7913e44197e = (paths)=>$47039de3e9f0864a$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $47039de3e9f0864a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $47039de3e9f0864a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $47039de3e9f0864a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $47039de3e9f0864a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $47039de3e9f0864a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $47039de3e9f0864a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $47039de3e9f0864a$export$4051a07651545597(data, init) {
    return new $47039de3e9f0864a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $47039de3e9f0864a$export$42a99a7a4bc0e76a extends Error {
}
class $47039de3e9f0864a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $47039de3e9f0864a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $47039de3e9f0864a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $47039de3e9f0864a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $47039de3e9f0864a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $47039de3e9f0864a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $47039de3e9f0864a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $47039de3e9f0864a$var$unwrapTrackedPromise(value) {
    if (!$47039de3e9f0864a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $47039de3e9f0864a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $47039de3e9f0864a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $47039de3e9f0864a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $47039de3e9f0864a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $47039de3e9f0864a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $47039de3e9f0864a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $47039de3e9f0864a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $47039de3e9f0864a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $47039de3e9f0864a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $47039de3e9f0864a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $47039de3e9f0864a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $47039de3e9f0864a$var$validMutationMethods = new Set($47039de3e9f0864a$var$validMutationMethodsArr);
const $47039de3e9f0864a$var$validRequestMethodsArr = [
    "get",
    ...$47039de3e9f0864a$var$validMutationMethodsArr
];
const $47039de3e9f0864a$var$validRequestMethods = new Set($47039de3e9f0864a$var$validRequestMethodsArr);
const $47039de3e9f0864a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $47039de3e9f0864a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $47039de3e9f0864a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $47039de3e9f0864a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $47039de3e9f0864a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $47039de3e9f0864a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $47039de3e9f0864a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $47039de3e9f0864a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $47039de3e9f0864a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $47039de3e9f0864a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $47039de3e9f0864a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $47039de3e9f0864a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $47039de3e9f0864a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $47039de3e9f0864a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$47039de3e9f0864a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$47039de3e9f0864a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $47039de3e9f0864a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $47039de3e9f0864a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $47039de3e9f0864a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $47039de3e9f0864a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$47039de3e9f0864a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($47039de3e9f0864a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $47039de3e9f0864a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $47039de3e9f0864a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $47039de3e9f0864a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $47039de3e9f0864a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $47039de3e9f0864a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($47039de3e9f0864a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $47039de3e9f0864a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $47039de3e9f0864a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $47039de3e9f0864a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $47039de3e9f0864a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $47039de3e9f0864a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $47039de3e9f0864a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $47039de3e9f0864a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $47039de3e9f0864a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $47039de3e9f0864a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $47039de3e9f0864a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $47039de3e9f0864a$var$findNearestBoundary(matches).route.id,
            {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $47039de3e9f0864a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($47039de3e9f0864a$var$isErrorResult(result) && $47039de3e9f0864a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $47039de3e9f0864a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $47039de3e9f0864a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $47039de3e9f0864a$var$_extends({
            matches: updatedMatches || matches
        }, $47039de3e9f0864a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $47039de3e9f0864a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $47039de3e9f0864a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $47039de3e9f0864a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $47039de3e9f0864a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $47039de3e9f0864a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($47039de3e9f0864a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $47039de3e9f0864a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($47039de3e9f0864a$var$isDeferredResult(result)) throw $47039de3e9f0864a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $47039de3e9f0864a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $47039de3e9f0864a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($47039de3e9f0864a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $47039de3e9f0864a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $47039de3e9f0864a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $47039de3e9f0864a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $47039de3e9f0864a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $47039de3e9f0864a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $47039de3e9f0864a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $47039de3e9f0864a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $47039de3e9f0864a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $47039de3e9f0864a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$47039de3e9f0864a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $47039de3e9f0864a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $47039de3e9f0864a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $47039de3e9f0864a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $47039de3e9f0864a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $47039de3e9f0864a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $47039de3e9f0864a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $47039de3e9f0864a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $47039de3e9f0864a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $47039de3e9f0864a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($47039de3e9f0864a$var$isRedirectResult(actionResult) || $47039de3e9f0864a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($47039de3e9f0864a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $47039de3e9f0864a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($47039de3e9f0864a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($47039de3e9f0864a$var$isDeferredResult(actionResult)) throw $47039de3e9f0864a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $47039de3e9f0864a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $47039de3e9f0864a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $47039de3e9f0864a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $47039de3e9f0864a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $47039de3e9f0864a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $47039de3e9f0864a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $47039de3e9f0864a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $47039de3e9f0864a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $47039de3e9f0864a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $47039de3e9f0864a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $47039de3e9f0864a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $47039de3e9f0864a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $47039de3e9f0864a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($47039de3e9f0864a$var$isDeferredResult(result)) result = await $47039de3e9f0864a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($47039de3e9f0864a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $47039de3e9f0864a$export$3e9cee6b33872309(!$47039de3e9f0864a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $47039de3e9f0864a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $47039de3e9f0864a$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $47039de3e9f0864a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($47039de3e9f0864a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $47039de3e9f0864a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace : $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $47039de3e9f0864a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($47039de3e9f0864a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $47039de3e9f0864a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $47039de3e9f0864a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $47039de3e9f0864a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $47039de3e9f0864a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $47039de3e9f0864a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($47039de3e9f0864a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $47039de3e9f0864a$var$ResultType.redirect,
                response: $47039de3e9f0864a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $47039de3e9f0864a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $47039de3e9f0864a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $47039de3e9f0864a$var$ResultType.error,
                    error: $47039de3e9f0864a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $47039de3e9f0864a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $47039de3e9f0864a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $47039de3e9f0864a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $47039de3e9f0864a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $47039de3e9f0864a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $47039de3e9f0864a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $47039de3e9f0864a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $47039de3e9f0864a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $47039de3e9f0864a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $47039de3e9f0864a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $47039de3e9f0864a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$47039de3e9f0864a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $47039de3e9f0864a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $47039de3e9f0864a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $47039de3e9f0864a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $47039de3e9f0864a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $47039de3e9f0864a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $47039de3e9f0864a$export$4d0306f8f6a4585b = Symbol("deferred");
function $47039de3e9f0864a$export$3336b097a6fbc59a(routes, opts) {
    $47039de3e9f0864a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $47039de3e9f0864a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $47039de3e9f0864a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $47039de3e9f0864a$var$createLocation("", $47039de3e9f0864a$export$fe53371bee54353d(url), null, "default");
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$47039de3e9f0864a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($47039de3e9f0864a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $47039de3e9f0864a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $47039de3e9f0864a$var$createLocation("", $47039de3e9f0864a$export$fe53371bee54353d(url), null, "default");
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$47039de3e9f0864a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $47039de3e9f0864a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $47039de3e9f0864a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $47039de3e9f0864a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($47039de3e9f0864a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$47039de3e9f0864a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $47039de3e9f0864a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($47039de3e9f0864a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $47039de3e9f0864a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $47039de3e9f0864a$var$isResponse(result) ? result : $47039de3e9f0864a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($47039de3e9f0864a$var$isDataStrategyResult(e) && $47039de3e9f0864a$var$isResponse(e.result)) {
                if (e.type === $47039de3e9f0864a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($47039de3e9f0864a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $47039de3e9f0864a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($47039de3e9f0864a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($47039de3e9f0864a$var$isDeferredResult(result)) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($47039de3e9f0864a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $47039de3e9f0864a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $47039de3e9f0864a$var$_extends({}, context, {
                statusCode: $47039de3e9f0864a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $47039de3e9f0864a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $47039de3e9f0864a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $47039de3e9f0864a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $47039de3e9f0864a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $47039de3e9f0864a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $47039de3e9f0864a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $47039de3e9f0864a$var$callDataStrategyImpl(dataStrategy || $47039de3e9f0864a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($47039de3e9f0864a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $47039de3e9f0864a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($47039de3e9f0864a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $47039de3e9f0864a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $47039de3e9f0864a$export$fec11da027c70692(routes, context, error) {
    let newContext = $47039de3e9f0864a$var$_extends({}, context, {
        statusCode: $47039de3e9f0864a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $47039de3e9f0864a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $47039de3e9f0864a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $47039de3e9f0864a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $47039de3e9f0864a$export$cae722b0cc860f13(to ? to : ".", $47039de3e9f0864a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $47039de3e9f0864a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $47039de3e9f0864a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $47039de3e9f0864a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $47039de3e9f0864a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $47039de3e9f0864a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$47039de3e9f0864a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$47039de3e9f0864a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $47039de3e9f0864a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $47039de3e9f0864a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $47039de3e9f0864a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$47039de3e9f0864a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$47039de3e9f0864a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $47039de3e9f0864a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $47039de3e9f0864a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $47039de3e9f0864a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $47039de3e9f0864a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $47039de3e9f0864a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($47039de3e9f0864a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $47039de3e9f0864a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $47039de3e9f0864a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $47039de3e9f0864a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $47039de3e9f0864a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $47039de3e9f0864a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($47039de3e9f0864a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $47039de3e9f0864a$var$shouldRevalidateLoader(match, $47039de3e9f0864a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $47039de3e9f0864a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $47039de3e9f0864a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $47039de3e9f0864a$var$shouldRevalidateLoader(fetcherMatch, $47039de3e9f0864a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $47039de3e9f0864a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $47039de3e9f0864a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $47039de3e9f0864a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $47039de3e9f0864a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $47039de3e9f0864a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $47039de3e9f0864a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$47039de3e9f0864a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $47039de3e9f0864a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$47039de3e9f0864a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $47039de3e9f0864a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $47039de3e9f0864a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $47039de3e9f0864a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$47039de3e9f0864a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $47039de3e9f0864a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $47039de3e9f0864a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $47039de3e9f0864a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $47039de3e9f0864a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $47039de3e9f0864a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $47039de3e9f0864a$var$ResultType.data,
                result: undefined
            });
        };
        return $47039de3e9f0864a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $47039de3e9f0864a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $47039de3e9f0864a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $47039de3e9f0864a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $47039de3e9f0864a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $47039de3e9f0864a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $47039de3e9f0864a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($47039de3e9f0864a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: e
            };
        }
        if (type === $47039de3e9f0864a$var$ResultType.error) return {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: new $47039de3e9f0864a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $47039de3e9f0864a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $47039de3e9f0864a$var$ResultType.error) {
        if ($47039de3e9f0864a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $47039de3e9f0864a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: new $47039de3e9f0864a$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $47039de3e9f0864a$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: result,
            statusCode: $47039de3e9f0864a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($47039de3e9f0864a$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $47039de3e9f0864a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($47039de3e9f0864a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $47039de3e9f0864a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $47039de3e9f0864a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $47039de3e9f0864a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $47039de3e9f0864a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$47039de3e9f0864a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $47039de3e9f0864a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $47039de3e9f0864a$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($47039de3e9f0864a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $47039de3e9f0864a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $47039de3e9f0864a$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $47039de3e9f0864a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($47039de3e9f0864a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $47039de3e9f0864a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $47039de3e9f0864a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $47039de3e9f0864a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $47039de3e9f0864a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $47039de3e9f0864a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $47039de3e9f0864a$export$3e9cee6b33872309(!$47039de3e9f0864a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $47039de3e9f0864a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($47039de3e9f0864a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $47039de3e9f0864a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $47039de3e9f0864a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $47039de3e9f0864a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($47039de3e9f0864a$var$isErrorResult(result)) {
            let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $47039de3e9f0864a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($47039de3e9f0864a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $47039de3e9f0864a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($47039de3e9f0864a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $47039de3e9f0864a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $47039de3e9f0864a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $47039de3e9f0864a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $47039de3e9f0864a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $47039de3e9f0864a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $47039de3e9f0864a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $47039de3e9f0864a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $47039de3e9f0864a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $47039de3e9f0864a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $47039de3e9f0864a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($47039de3e9f0864a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $47039de3e9f0864a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(path) : path;
    return $47039de3e9f0864a$export$fe53371bee54353d($47039de3e9f0864a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $47039de3e9f0864a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $47039de3e9f0864a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $47039de3e9f0864a$var$ResultType.data || result.type === $47039de3e9f0864a$var$ResultType.error);
}
function $47039de3e9f0864a$var$isRedirectDataStrategyResultResult(result) {
    return $47039de3e9f0864a$var$isResponse(result.result) && $47039de3e9f0864a$var$redirectStatusCodes.has(result.result.status);
}
function $47039de3e9f0864a$var$isDeferredResult(result) {
    return result.type === $47039de3e9f0864a$var$ResultType.deferred;
}
function $47039de3e9f0864a$var$isErrorResult(result) {
    return result.type === $47039de3e9f0864a$var$ResultType.error;
}
function $47039de3e9f0864a$var$isRedirectResult(result) {
    return (result && result.type) === $47039de3e9f0864a$var$ResultType.redirect;
}
function $47039de3e9f0864a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $47039de3e9f0864a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $47039de3e9f0864a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $47039de3e9f0864a$var$isRedirectResponse(result) {
    if (!$47039de3e9f0864a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $47039de3e9f0864a$var$isValidMethod(method) {
    return $47039de3e9f0864a$var$validRequestMethods.has(method.toLowerCase());
}
function $47039de3e9f0864a$var$isMutationMethod(method) {
    return $47039de3e9f0864a$var$validMutationMethods.has(method.toLowerCase());
}
async function $47039de3e9f0864a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$47039de3e9f0864a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($47039de3e9f0864a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $47039de3e9f0864a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $47039de3e9f0864a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($47039de3e9f0864a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $47039de3e9f0864a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $47039de3e9f0864a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $47039de3e9f0864a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $47039de3e9f0864a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $47039de3e9f0864a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $47039de3e9f0864a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $47039de3e9f0864a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $47039de3e9f0864a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $47039de3e9f0864a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $47039de3e9f0864a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $47039de3e9f0864a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $47039de3e9f0864a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $47039de3e9f0864a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $47039de3e9f0864a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $47039de3e9f0864a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $47039de3e9f0864a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($47039de3e9f0864a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $47039de3e9f0864a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($47039de3e9f0864a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $47039de3e9f0864a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8NFma = parcelRequire("8NFma");

function $7b8d8d3adba9a65c$var$_extends() {
    return $7b8d8d3adba9a65c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7b8d8d3adba9a65c$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7b8d8d3adba9a65c$export$3add0d5dce533e2e = /*#__PURE__*/ $8NFma.createContext(null);
const $7b8d8d3adba9a65c$export$145dfa71566a64dc = /*#__PURE__*/ $8NFma.createContext(null);
const $7b8d8d3adba9a65c$var$AwaitContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7b8d8d3adba9a65c$export$26749e8557646306 = /*#__PURE__*/ $8NFma.createContext(null);
const $7b8d8d3adba9a65c$export$c7914228fb69b0f5 = /*#__PURE__*/ $8NFma.createContext(null);
const $7b8d8d3adba9a65c$export$9072aa6dd1f93057 = /*#__PURE__*/ $8NFma.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7b8d8d3adba9a65c$var$RouteErrorContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7b8d8d3adba9a65c$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7b8d8d3adba9a65c$export$9c954a9d03d32f4a() {
    return $8NFma.useContext($7b8d8d3adba9a65c$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7b8d8d3adba9a65c$export$45d76561a5302f2b() {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return $8NFma.useContext($7b8d8d3adba9a65c$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7b8d8d3adba9a65c$export$1b3f31771c5d07c() {
    return $8NFma.useContext($7b8d8d3adba9a65c$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7b8d8d3adba9a65c$export$6c330e8992e8a295(pattern) {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    return $8NFma.useMemo(()=>(0, $47039de3e9f0864a$export$81336c211d5ff295)(pattern, (0, $47039de3e9f0864a$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7b8d8d3adba9a65c$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7b8d8d3adba9a65c$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8NFma.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7b8d8d3adba9a65c$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7b8d8d3adba9a65c$var$useNavigateStable() : $7b8d8d3adba9a65c$var$useNavigateUnstable();
}
function $7b8d8d3adba9a65c$var$useNavigateUnstable() {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8NFma.useContext($7b8d8d3adba9a65c$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $47039de3e9f0864a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8NFma.useRef(false);
    $7b8d8d3adba9a65c$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8NFma.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $47039de3e9f0864a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7b8d8d3adba9a65c$var$OutletContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7b8d8d3adba9a65c$export$4138103a3ae699cc() {
    return $8NFma.useContext($7b8d8d3adba9a65c$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7b8d8d3adba9a65c$export$a3be3530d8e40d0b(context) {
    let outlet = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7b8d8d3adba9a65c$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $47039de3e9f0864a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8NFma.useMemo(()=>(0, $47039de3e9f0864a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7b8d8d3adba9a65c$export$5d3fca4a98652595(routes, locationArg) {
    return $7b8d8d3adba9a65c$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7b8d8d3adba9a65c$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: parentMatches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $47039de3e9f0864a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $47039de3e9f0864a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7b8d8d3adba9a65c$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7b8d8d3adba9a65c$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $47039de3e9f0864a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7b8d8d3adba9a65c$var$DefaultErrorComponent() {
    let error = $7b8d8d3adba9a65c$export$ed527bf60f6e05f2();
    let message = (0, $47039de3e9f0864a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8NFma.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8NFma.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7b8d8d3adba9a65c$var$defaultErrorElement = /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$DefaultErrorComponent, null);
class $7b8d8d3adba9a65c$var$RenderErrorBoundary extends $8NFma.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7b8d8d3adba9a65c$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8NFma.useContext($7b8d8d3adba9a65c$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7b8d8d3adba9a65c$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7b8d8d3adba9a65c$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7b8d8d3adba9a65c$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8NFma.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7b8d8d3adba9a65c$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7b8d8d3adba9a65c$var$DataRouterHook || {});
var $7b8d8d3adba9a65c$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7b8d8d3adba9a65c$var$DataRouterStateHook || {});
function $7b8d8d3adba9a65c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7b8d8d3adba9a65c$var$useDataRouterContext(hookName) {
    let ctx = $8NFma.useContext($7b8d8d3adba9a65c$export$3add0d5dce533e2e);
    !ctx && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7b8d8d3adba9a65c$var$useDataRouterState(hookName) {
    let state = $8NFma.useContext($7b8d8d3adba9a65c$export$145dfa71566a64dc);
    !state && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return state;
}
function $7b8d8d3adba9a65c$var$useRouteContext(hookName) {
    let route = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    !route && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7b8d8d3adba9a65c$var$useCurrentRouteId(hookName) {
    let route = $7b8d8d3adba9a65c$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7b8d8d3adba9a65c$export$5fc8298006ad9e58() {
    return $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7b8d8d3adba9a65c$export$d0fd4b7106de2769() {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7b8d8d3adba9a65c$export$600dc272ed516c15() {
    let dataRouterContext = $7b8d8d3adba9a65c$var$useDataRouterContext($7b8d8d3adba9a65c$var$DataRouterHook.UseRevalidator);
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRevalidator);
    return $8NFma.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7b8d8d3adba9a65c$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseMatches);
    return $8NFma.useMemo(()=>matches.map((m)=>(0, $47039de3e9f0864a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7b8d8d3adba9a65c$export$1448a5050d252c4d() {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7b8d8d3adba9a65c$export$fd5d37484eab868d(routeId) {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7b8d8d3adba9a65c$export$fdc00f3f26066d5e() {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseActionData);
    let routeId = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7b8d8d3adba9a65c$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8NFma.useContext($7b8d8d3adba9a65c$var$RouteErrorContext);
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteError);
    let routeId = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7b8d8d3adba9a65c$export$78a72ddb39bdd145() {
    let value = $8NFma.useContext($7b8d8d3adba9a65c$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7b8d8d3adba9a65c$export$17f53340677d5831() {
    let value = $8NFma.useContext($7b8d8d3adba9a65c$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7b8d8d3adba9a65c$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7b8d8d3adba9a65c$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7b8d8d3adba9a65c$var$useDataRouterContext($7b8d8d3adba9a65c$var$DataRouterHook.UseBlocker);
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8NFma.useState("");
    let blockerFunction = $8NFma.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7b8d8d3adba9a65c$var$_extends({}, currentLocation, {
                pathname: (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7b8d8d3adba9a65c$var$_extends({}, nextLocation, {
                pathname: (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8NFma.useEffect(()=>{
        let key = String(++$7b8d8d3adba9a65c$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8NFma.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $47039de3e9f0864a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7b8d8d3adba9a65c$var$useNavigateStable() {
    let { router: router } = $7b8d8d3adba9a65c$var$useDataRouterContext($7b8d8d3adba9a65c$var$DataRouterHook.UseNavigateStable);
    let id = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8NFma.useRef(false);
    $7b8d8d3adba9a65c$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8NFma.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7b8d8d3adba9a65c$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7b8d8d3adba9a65c$var$alreadyWarned$1 = {};
function $7b8d8d3adba9a65c$var$warningOnce(key, cond, message) {
    if (!cond && !$7b8d8d3adba9a65c$var$alreadyWarned$1[key]) $7b8d8d3adba9a65c$var$alreadyWarned$1[key] = true;
}
const $7b8d8d3adba9a65c$var$alreadyWarned = {};
function $7b8d8d3adba9a65c$var$warnOnce(key, message) {}
const $7b8d8d3adba9a65c$var$logDeprecation = (flag, msg, link)=>$7b8d8d3adba9a65c$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7b8d8d3adba9a65c$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7b8d8d3adba9a65c$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7b8d8d3adba9a65c$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7b8d8d3adba9a65c$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7b8d8d3adba9a65c$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7b8d8d3adba9a65c$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7b8d8d3adba9a65c$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7b8d8d3adba9a65c$var$START_TRANSITION = "startTransition";
const $7b8d8d3adba9a65c$var$startTransitionImpl = $8NFma[$7b8d8d3adba9a65c$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7b8d8d3adba9a65c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8NFma.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        if (v7_startTransition && $7b8d8d3adba9a65c$var$startTransitionImpl) $7b8d8d3adba9a65c$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8NFma.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8NFma.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8NFma.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8NFma.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8NFma.useEffect(()=>$7b8d8d3adba9a65c$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7b8d8d3adba9a65c$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7b8d8d3adba9a65c$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7b8d8d3adba9a65c$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8NFma.useRef();
    if (historyRef.current == null) historyRef.current = (0, $47039de3e9f0864a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $7b8d8d3adba9a65c$var$startTransitionImpl ? $7b8d8d3adba9a65c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8NFma.useEffect(()=>$7b8d8d3adba9a65c$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7b8d8d3adba9a65c$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let navigate = $7b8d8d3adba9a65c$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $47039de3e9f0864a$export$cae722b0cc860f13)(to, (0, $47039de3e9f0864a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8NFma.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7b8d8d3adba9a65c$export$910ae8079b2c2852(props) {
    return $7b8d8d3adba9a65c$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7b8d8d3adba9a65c$export$e7b0ac011bb776c6(_props) {
    (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7b8d8d3adba9a65c$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $47039de3e9f0864a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8NFma.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7b8d8d3adba9a65c$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $47039de3e9f0864a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8NFma.useMemo(()=>{
        let trailingPathname = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7b8d8d3adba9a65c$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7b8d8d3adba9a65c$export$5d3fca4a98652595($7b8d8d3adba9a65c$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7b8d8d3adba9a65c$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$ResolveAwait, null, children));
}
var $7b8d8d3adba9a65c$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7b8d8d3adba9a65c$var$AwaitRenderStatus || {});
const $7b8d8d3adba9a65c$var$neverSettledPromise = new Promise(()=>{});
class $7b8d8d3adba9a65c$var$AwaitErrorBoundary extends $8NFma.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7b8d8d3adba9a65c$var$AwaitRenderStatus.error : "_data" in promise ? $7b8d8d3adba9a65c$var$AwaitRenderStatus.success : $7b8d8d3adba9a65c$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.error && promise._error instanceof (0, $47039de3e9f0864a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7b8d8d3adba9a65c$var$neverSettledPromise;
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7b8d8d3adba9a65c$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7b8d8d3adba9a65c$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7b8d8d3adba9a65c$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8NFma.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8NFma.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8NFma.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7b8d8d3adba9a65c$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7b8d8d3adba9a65c$export$e7b0ac011bb776c6) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7b8d8d3adba9a65c$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7b8d8d3adba9a65c$export$daf73786167a7f72(matches) {
    return $7b8d8d3adba9a65c$var$_renderMatches(matches);
}
function $7b8d8d3adba9a65c$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8NFma.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8NFma.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8NFma.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7b8d8d3adba9a65c$export$f30f7e456d254e83(routes, opts) {
    return (0, $47039de3e9f0864a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7b8d8d3adba9a65c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $47039de3e9f0864a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7b8d8d3adba9a65c$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $a8cea113a6044695$var$_extends() {
    return $a8cea113a6044695$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a8cea113a6044695$var$_extends.apply(null, arguments);
}
function $a8cea113a6044695$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $a8cea113a6044695$var$defaultMethod = "get";
const $a8cea113a6044695$var$defaultEncType = "application/x-www-form-urlencoded";
function $a8cea113a6044695$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a8cea113a6044695$var$isButtonElement(object) {
    return $a8cea113a6044695$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a8cea113a6044695$var$isFormElement(object) {
    return $a8cea113a6044695$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a8cea113a6044695$var$isInputElement(object) {
    return $a8cea113a6044695$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a8cea113a6044695$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a8cea113a6044695$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a8cea113a6044695$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a8cea113a6044695$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a8cea113a6044695$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a8cea113a6044695$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a8cea113a6044695$var$_formDataSupportsSubmitter = null;
function $a8cea113a6044695$var$isFormDataSubmitterSupported() {
    if ($a8cea113a6044695$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a8cea113a6044695$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a8cea113a6044695$var$_formDataSupportsSubmitter = true;
    }
    return $a8cea113a6044695$var$_formDataSupportsSubmitter;
}
const $a8cea113a6044695$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a8cea113a6044695$var$getFormEncType(encType) {
    if (encType != null && !$a8cea113a6044695$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a8cea113a6044695$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a8cea113a6044695$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a8cea113a6044695$var$defaultMethod;
        encType = $a8cea113a6044695$var$getFormEncType(target.getAttribute("enctype")) || $a8cea113a6044695$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a8cea113a6044695$var$isButtonElement(target) || $a8cea113a6044695$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a8cea113a6044695$var$defaultMethod;
        encType = $a8cea113a6044695$var$getFormEncType(target.getAttribute("formenctype")) || $a8cea113a6044695$var$getFormEncType(form.getAttribute("enctype")) || $a8cea113a6044695$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a8cea113a6044695$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a8cea113a6044695$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a8cea113a6044695$var$defaultMethod;
        action = null;
        encType = $a8cea113a6044695$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a8cea113a6044695$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $a8cea113a6044695$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $a8cea113a6044695$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a8cea113a6044695$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a8cea113a6044695$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a8cea113a6044695$export$1f3f55432a00e06d(routes, opts) {
    return (0, $47039de3e9f0864a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a8cea113a6044695$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $47039de3e9f0864a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a8cea113a6044695$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7b8d8d3adba9a65c$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a8cea113a6044695$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $47039de3e9f0864a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a8cea113a6044695$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $47039de3e9f0864a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a8cea113a6044695$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7b8d8d3adba9a65c$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a8cea113a6044695$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a8cea113a6044695$var$_extends({}, state, {
        errors: $a8cea113a6044695$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a8cea113a6044695$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $47039de3e9f0864a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a8cea113a6044695$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8NFma.createContext({
    isTransitioning: false
});
const $a8cea113a6044695$export$148fd98d095596d4 = /*#__PURE__*/ $8NFma.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a8cea113a6044695$var$START_TRANSITION = "startTransition";
const $a8cea113a6044695$var$startTransitionImpl = $8NFma[$a8cea113a6044695$var$START_TRANSITION];
const $a8cea113a6044695$var$FLUSH_SYNC = "flushSync";
const $a8cea113a6044695$var$flushSyncImpl = $1c0f1e610963dfb8$exports[$a8cea113a6044695$var$FLUSH_SYNC];
const $a8cea113a6044695$var$USE_ID = "useId";
const $a8cea113a6044695$var$useIdImpl = $8NFma[$a8cea113a6044695$var$USE_ID];
function $a8cea113a6044695$var$startTransitionSafe(cb) {
    if ($a8cea113a6044695$var$startTransitionImpl) $a8cea113a6044695$var$startTransitionImpl(cb);
    else cb();
}
function $a8cea113a6044695$var$flushSyncSafe(cb) {
    if ($a8cea113a6044695$var$flushSyncImpl) $a8cea113a6044695$var$flushSyncImpl(cb);
    else cb();
}
class $a8cea113a6044695$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a8cea113a6044695$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8NFma.useState(router.state);
    let [pendingState, setPendingState] = $8NFma.useState();
    let [vtContext, setVtContext] = $8NFma.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8NFma.useState();
    let [transition, setTransition] = $8NFma.useState();
    let [interruption, setInterruption] = $8NFma.useState();
    let fetcherData = $8NFma.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8NFma.useCallback((cb)=>{
        if (v7_startTransition) $a8cea113a6044695$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8NFma.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a8cea113a6044695$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a8cea113a6044695$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a8cea113a6044695$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a8cea113a6044695$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a8cea113a6044695$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8NFma.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8NFma.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a8cea113a6044695$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8NFma.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8NFma.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8NFma.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8NFma.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8NFma.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8NFma.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8NFma.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8NFma.useEffect(()=>(0, $7b8d8d3adba9a65c$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $a8cea113a6044695$var$MemoizedDataRoutes = /*#__PURE__*/ $8NFma.memo($a8cea113a6044695$var$DataRoutes);
function $a8cea113a6044695$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7b8d8d3adba9a65c$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a8cea113a6044695$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8NFma.useRef();
    if (historyRef.current == null) historyRef.current = (0, $47039de3e9f0864a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $a8cea113a6044695$var$startTransitionImpl ? $a8cea113a6044695$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8NFma.useEffect(()=>(0, $7b8d8d3adba9a65c$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a8cea113a6044695$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8NFma.useRef();
    if (historyRef.current == null) historyRef.current = (0, $47039de3e9f0864a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $a8cea113a6044695$var$startTransitionImpl ? $a8cea113a6044695$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8NFma.useEffect(()=>(0, $7b8d8d3adba9a65c$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a8cea113a6044695$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $a8cea113a6044695$var$startTransitionImpl ? $a8cea113a6044695$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8NFma.useEffect(()=>(0, $7b8d8d3adba9a65c$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a8cea113a6044695$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a8cea113a6044695$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a8cea113a6044695$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8NFma.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $a8cea113a6044695$var$_objectWithoutPropertiesLoose(_ref7, $a8cea113a6044695$var$_excluded);
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a8cea113a6044695$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a8cea113a6044695$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7b8d8d3adba9a65c$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a8cea113a6044695$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8NFma.createElement("a", $a8cea113a6044695$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a8cea113a6044695$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8NFma.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $a8cea113a6044695$var$_objectWithoutPropertiesLoose(_ref8, $a8cea113a6044695$var$_excluded2);
    let path = (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let routerState = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a8cea113a6044695$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$a6c7ac8248d6e38a, $a8cea113a6044695$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a8cea113a6044695$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8NFma.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a8cea113a6044695$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $a8cea113a6044695$var$_objectWithoutPropertiesLoose(_ref9, $a8cea113a6044695$var$_excluded3);
    let submit = $a8cea113a6044695$export$47c85c6e3a081d3();
    let formAction = $a8cea113a6044695$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8NFma.createElement("form", $a8cea113a6044695$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a8cea113a6044695$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $a8cea113a6044695$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a8cea113a6044695$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a8cea113a6044695$var$DataRouterHook || ($a8cea113a6044695$var$DataRouterHook = {}));
var $a8cea113a6044695$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a8cea113a6044695$var$DataRouterStateHook || ($a8cea113a6044695$var$DataRouterStateHook = {}));
// Internal hooks
function $a8cea113a6044695$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a8cea113a6044695$var$useDataRouterContext(hookName) {
    let ctx = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$3add0d5dce533e2e));
    !ctx && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a8cea113a6044695$var$useDataRouterState(hookName) {
    let state = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$145dfa71566a64dc));
    !state && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a8cea113a6044695$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let path = (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8NFma.useCallback((event)=>{
        if ($a8cea113a6044695$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $47039de3e9f0864a$export$fe53371bee54353d)(location) === (0, $47039de3e9f0864a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a8cea113a6044695$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8NFma.useRef($a8cea113a6044695$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8NFma.useRef(false);
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let searchParams = $8NFma.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a8cea113a6044695$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    let setSearchParams = $8NFma.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a8cea113a6044695$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a8cea113a6044695$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a8cea113a6044695$var$fetcherId = 0;
let $a8cea113a6044695$var$getUniqueFetcherId = ()=>"__" + String(++$a8cea113a6044695$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a8cea113a6044695$export$47c85c6e3a081d3() {
    let { router: router } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let currentRouteId = (0, $7b8d8d3adba9a65c$export$5fc8298006ad9e58)();
    return $8NFma.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a8cea113a6044695$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a8cea113a6044695$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a8cea113a6044695$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a8cea113a6044695$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let routeContext = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$9072aa6dd1f93057));
    !routeContext && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a8cea113a6044695$var$_extends({}, (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $47039de3e9f0864a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a8cea113a6044695$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.UseFetcher);
    let state = $a8cea113a6044695$var$useDataRouterState($a8cea113a6044695$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8NFma.useContext($a8cea113a6044695$export$148fd98d095596d4);
    let route = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    !route && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a8cea113a6044695$var$useIdImpl ? $a8cea113a6044695$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8NFma.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a8cea113a6044695$var$getUniqueFetcherId());
    // Registration/cleanup
    $8NFma.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8NFma.useCallback((href, opts)=>{
        !routeId && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a8cea113a6044695$export$47c85c6e3a081d3();
    let submit = $8NFma.useCallback((target, opts)=>{
        submitImpl(target, $a8cea113a6044695$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8NFma.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8NFma.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$a7fed597f4b8afd8, $a8cea113a6044695$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $47039de3e9f0864a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8NFma.useMemo(()=>$a8cea113a6044695$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a8cea113a6044695$export$fa996778a3a31087() {
    let state = $a8cea113a6044695$var$useDataRouterState($a8cea113a6044695$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $a8cea113a6044695$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a8cea113a6044695$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a8cea113a6044695$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a8cea113a6044695$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a8cea113a6044695$var$useDataRouterState($a8cea113a6044695$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let matches = (0, $7b8d8d3adba9a65c$export$2378eb7f5ff86053)();
    let navigation = (0, $7b8d8d3adba9a65c$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8NFma.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a8cea113a6044695$var$usePageHide($8NFma.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a8cea113a6044695$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a8cea113a6044695$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a8cea113a6044695$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8NFma.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a8cea113a6044695$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a8cea113a6044695$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8NFma.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a8cea113a6044695$var$_extends({}, location, {
                    pathname: (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a8cea113a6044695$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8NFma.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a8cea113a6044695$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8NFma.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a8cea113a6044695$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8NFma.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a8cea113a6044695$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $7b8d8d3adba9a65c$export$b273b3273281a049)(when);
    $8NFma.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8NFma.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a8cea113a6044695$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8NFma.useContext($a8cea113a6044695$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $47039de3e9f0864a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $47039de3e9f0864a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

function $3e7b3d722a3264c2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7b8d8d3adba9a65c$export$910ae8079b2c2852), {});
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
/**
 * Formats business size string
 * If businessSizes string contains something other than 'Small Business',
 * remove 'Small Business' text from string
 * @param {string} businessSizes
 * @returns {string} Formatted businessSizes
 */ const $3da708ea9eb0f551$export$2195adc73d2f5a2f = (businessSizes)=>{
    let businessSizesArray = businessSizes.split(",").map((size)=>size.trim());
    const omit = businessSizesArray.find((size)=>size !== "Small Business");
    if (omit) businessSizesArray = businessSizesArray.filter((size)=>size.trim() !== "Small Business");
    const result = businessSizesArray.reduce((resultString, size)=>resultString === "" ? size : resultString + ", " + size, "");
    return result;
};
const $3da708ea9eb0f551$export$f176fecabc1d6df7 = (text)=>text.toLowerCase().replaceAll(/[\\\^\$\*\+\?\.\[\]\|\(\)\{\}\-\<\>\=\_]/g, "\\$&");
const $3da708ea9eb0f551$export$bbbd05c900f3568d = (singularWord, count)=>count === 1 ? singularWord : `${singularWord}s`;


function $2d5068e2e47f0a0c$export$2e2bcd8739ae039({ contractHolder: contractHolder }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                role: "rowheader",
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("a", {
                    href: `#/detail/${contractHolder.chInfoSeq}`,
                    title: `Go to the detail page for ${contractHolder.displayName}`,
                    children: [
                        contractHolder.companyName,
                        " (",
                        contractHolder.displayName,
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                style: {
                    whiteSpace: "pre"
                },
                role: "gridcell",
                children: contractHolder.sewpContractNumber
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                style: {
                    whiteSpace: "pre"
                },
                role: "gridcell",
                children: contractHolder.setAside
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: (0, $3da708ea9eb0f551$export$2195adc73d2f5a2f)(contractHolder.businessSizes)
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $e889a8eb4a1c50f8$export$2e2bcd8739ae039({ id: id, summary: summary, caption: caption, condensed: condensed = true, children: children }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("table", {
        id: id,
        className: `table table-bordered${condensed ? " table-condensed" : ""}`,
        role: "grid",
        summary: summary,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("caption", {
                id: "caption",
                className: "sr-only",
                role: "alert",
                "aria-live": "polite",
                children: caption
            }),
            children
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
const $53cc2e000314a49f$export$38b260a518ad57e5 = 12;
const $53cc2e000314a49f$export$34435eaa37e14f8c = 13;
const $53cc2e000314a49f$export$99c6d95f8d1e53ad = 15;
const $53cc2e000314a49f$export$1597d3d79f36bd09 = 16;
const $53cc2e000314a49f$export$b9e81d98424fb77d = 17;
const $53cc2e000314a49f$export$adcfeb78a0beb383 = 18;
const $53cc2e000314a49f$export$9ccb2e9a070eb88c = 19;
const $53cc2e000314a49f$export$ffd3fcd096096076 = 20;
const $53cc2e000314a49f$export$11b547de87f695ab = 23;
const $53cc2e000314a49f$export$81efd80c12b8d600 = 24;
const $53cc2e000314a49f$export$c988202ff52ee262 = 25;
const $53cc2e000314a49f$export$707eb7df8802a474 = 26;
const $53cc2e000314a49f$export$55116c87c5f31497 = 27;
const $53cc2e000314a49f$export$10bb27af362e4701 = 28;
const $53cc2e000314a49f$export$257390c21a53d74a = 29;
const $53cc2e000314a49f$export$bb197327b04c878b = 30;
const $53cc2e000314a49f$export$ed2a6d7a3e4814c4 = 31;
const $53cc2e000314a49f$export$5637c64aa29c45b0 = 32;
const $53cc2e000314a49f$export$9baa2088803503a2 = 33;
const $53cc2e000314a49f$export$d791af190ad3ce03 = 34;
const $53cc2e000314a49f$export$f43d343eb3d605c5 = 35;
const $53cc2e000314a49f$export$258047127fa9a409 = 36;
const $53cc2e000314a49f$export$b0f9ed8296bcaf46 = 37;
const $53cc2e000314a49f$export$5252ff91cdd72fe4 = 38;
const $53cc2e000314a49f$export$8c96a12f79ba687e = 39;
const $53cc2e000314a49f$export$bb33f37e01d8da72 = 40;
const $53cc2e000314a49f$export$8ce0397586013bef = 41;
const $53cc2e000314a49f$export$d5fcf051c75fdb4b = 42;
const $53cc2e000314a49f$export$feb7a771147f9ff4 = 43;
const $53cc2e000314a49f$export$eb335583752f8a = 44;
const $53cc2e000314a49f$export$5a7a5b700e65824d = 45;
const $53cc2e000314a49f$export$5d9a7f268c32987e = 46;
const $53cc2e000314a49f$export$633943fdd4494e9a = 21;
const $53cc2e000314a49f$export$9744c5e588117ff = 22;
const $53cc2e000314a49f$export$76faf05cf78c8000 = 6;
const $53cc2e000314a49f$export$c62e1e68e9b129bf = "detail";
const $53cc2e000314a49f$export$bc65c5f8ae8c9619 = "contractholderslist";
const $53cc2e000314a49f$export$d4daa26c757f8f98 = "programmanagers";
const $53cc2e000314a49f$export$1ac8347527ea5cf5 = "smallbusinesslist";
const $53cc2e000314a49f$export$3dbfd7c861adfb40 = "businessbreakdown";
const $53cc2e000314a49f$export$fa0874104c3ed09a = "orderslist";
const $53cc2e000314a49f$export$cdd9dd1559ccd593 = "334111";
const $53cc2e000314a49f$export$80874287d10adbdc = "541519";
const $53cc2e000314a49f$export$1bcb160374152198 = "Group A";
const $53cc2e000314a49f$export$38a2a6401a5f93bc = "Groups B,C,D";
const $53cc2e000314a49f$export$7c348a803745d78e = "WOSB";
const $53cc2e000314a49f$export$3bcd420ba04975ee = "HUBZone";
const $53cc2e000314a49f$export$b1e026515d1d95eb = "SDVOSB";
const $53cc2e000314a49f$export$b857b8c49d989e3d = "EDWOSB";
const $53cc2e000314a49f$export$bf642b3f485bd68d = "VOSB";
const $53cc2e000314a49f$export$1631de6f5ca5af24 = "Small Business";
const $53cc2e000314a49f$export$f1e0d6d47dca11c2 = "Other Than Small";
const $53cc2e000314a49f$export$bd0866f92493be24 = "Y";
const $53cc2e000314a49f$export$4d283cc08bd303bc = "N";
const $53cc2e000314a49f$export$c301ac165f7ea788 = "A";
const $53cc2e000314a49f$export$5f69ad12da2b3386 = "B";
const $53cc2e000314a49f$export$481c9ca0ca713d34 = "C";
const $53cc2e000314a49f$export$f34d25e159e83813 = "D";
const $53cc2e000314a49f$export$c1ca7e6bbbf87d26 = "Total";
const $53cc2e000314a49f$export$277e573a58a6778 = 0;
const $53cc2e000314a49f$export$33aefca0406d6f9c = 1;
const $53cc2e000314a49f$export$b64db5ccea72c387 = 2;
const $53cc2e000314a49f$export$6bec1cb94a439bf6 = "An error has occurred. Please contact the helpdesk at help@sewp.nasa.gov for support.";
const $53cc2e000314a49f$export$b8f07f75698d8349 = "Loading data...";
const $53cc2e000314a49f$export$562da893ccc08e12 = [
    "agencyCatalog"
];
const $53cc2e000314a49f$export$b93db1c84990f2fa = "help@sewp.nasa.gov";
const $53cc2e000314a49f$export$17e3d0a570f32865 = 10;
const $53cc2e000314a49f$export$887255b691095f6f = "active";
const $53cc2e000314a49f$export$8ff3b730ee8bcf3d = "disabled";
const $53cc2e000314a49f$export$e201258e0e3ffa55 = "clickable";
const $53cc2e000314a49f$export$f03aa4aa3e16b9e = [];
const $53cc2e000314a49f$export$3934bd4722d03882 = "whitelist";
const $53cc2e000314a49f$export$3d8ea6cece8525ba = "blacklist";
const $53cc2e000314a49f$export$ddffaa7057c7de39 = "Enter";
const $53cc2e000314a49f$export$9eefcf79c7a8029 = 1;
const $53cc2e000314a49f$export$81a04a199bfcd9b9 = 10;
const $53cc2e000314a49f$export$8d7e9ed02c80b994 = "drilldown";
const $53cc2e000314a49f$export$898078e133860236 = "pn search";
const $53cc2e000314a49f$export$ee1b402aec5ab0c6 = "A";
const $53cc2e000314a49f$export$8c3da1ec196801ac = "L";
const $53cc2e000314a49f$export$ba962fa048def503 = "S";
const $53cc2e000314a49f$export$6ec38bc343ddab4 = "F";
const $53cc2e000314a49f$export$87831422c385b409 = "C";
const $53cc2e000314a49f$export$f7df5b6be3b775c = "P";
const $53cc2e000314a49f$export$3a690199b3d03af8 = "A";
const $53cc2e000314a49f$export$8bcc95d84aa607cf = "Excellent";
const $53cc2e000314a49f$export$26de73030d1d38 = "Very Good";
const $53cc2e000314a49f$export$df3e15a50e220b07 = "Good";
const $53cc2e000314a49f$export$88ae318293b73480 = "Fair";
const $53cc2e000314a49f$export$5bec3bdf283420e5 = "Poor";
const $53cc2e000314a49f$export$ac52cdfd4853e221 = "Neutral";
const $53cc2e000314a49f$export$78028dc6dbce46e8 = "JWT-SEWP";


const $90eb12c1be8763cc$export$1387eae18edfb550 = (sortType)=>typeof sortType === "number" && sortType % 2 === 1;
const $90eb12c1be8763cc$export$c56d9c82f8c9489 = (sortType)=>sortType + ($90eb12c1be8763cc$export$1387eae18edfb550(sortType) ? 1 : -1);
const $90eb12c1be8763cc$export$ed6bdb0d0cb503ff = (descendingSort, setSortOption)=>()=>{
        const ascendingSort = $90eb12c1be8763cc$export$c56d9c82f8c9489(descendingSort);
        setSortOption((prevState)=>prevState === ascendingSort ? descendingSort : ascendingSort);
    };
const $90eb12c1be8763cc$export$718a89977d68c72c = ({ chAddressType: at1 }, { chAddressType: at2 })=>{
    if (at1 < at2) return -1;
    else if (at2 > at1) return 1;
    else return 0;
};
const $90eb12c1be8763cc$export$fedc88eb1169724 = ({ sortingNumber: sn1 }, { sortingNumber: sn2 })=>{
    if (sn1 < sn2) return -1;
    else if (sn2 > sn1) return 1;
    else return 0;
};
const $90eb12c1be8763cc$export$ce0df3b43b927bce = ({ group: g1 }, { group: g2 })=>{
    if (g1 < g2) return -1;
    else if (g1 > g2) return 1;
    else return 0;
};
const $90eb12c1be8763cc$export$7f57ec4a048f5e9 = ({ contractModNumber: cmn1 }, { contractModNumber: cmn2 })=>{
    if (cmn1 === 0) return -1;
    else if (cmn2 === 0) return 1;
    else if (cmn1 > cmn2) return -1;
    else if (cmn2 > cmn1) return 1;
    else return 0;
};
const $90eb12c1be8763cc$export$fc31cca2a34a723f = ({ defaultFlag: df1, typeFlag: tf1 }, { defaultFlag: df2, typeFlag: tf2 })=>{
    if (df1 === (0, $53cc2e000314a49f$export$bd0866f92493be24) && df2 !== (0, $53cc2e000314a49f$export$bd0866f92493be24)) return -1;
    else if (df2 === (0, $53cc2e000314a49f$export$bd0866f92493be24) && df1 !== (0, $53cc2e000314a49f$export$bd0866f92493be24)) return 1;
    else {
        if (tf1 === "Phone") return -1;
        else if (tf2 === "Phone") return 1;
        else return 0;
    }
};
const $90eb12c1be8763cc$export$89a1f01f2a7cb2a1 = (a, b, key, direction)=>{
    if (!a || !b || !key || !a[key] || !b[key] || direction !== "asc" && direction !== "desc") throw new Error("Invalid Parameters");
    if (direction === "asc") {
        if (a[key].trim().toLowerCase() < b[key].trim().toLowerCase()) return -1;
        else if (a[key].trim().toLowerCase() > b[key].trim().toLowerCase()) return 1;
        else return 0;
    } else {
        if (a[key].trim().toLowerCase() < b[key].trim().toLowerCase()) return 1;
        else if (a[key].trim().toLowerCase() > b[key].trim().toLowerCase()) return -1;
        else return 0;
    }
};
const $90eb12c1be8763cc$export$127a787ff8838faf = (a, b, key, direction)=>{
    if (!a || !b || !key || !a[key] || !b[key] || direction !== "asc" && direction !== "desc") throw new Error("Invalid Parameters");
    if (direction === "asc") return a[key] < b[key] ? -1 : 1;
    else return a[key] < b[key] ? 1 : -1;
};
const $90eb12c1be8763cc$export$93761ee88997c37f = (a, b, key, direction)=>{
    if (!a || !b || !key || typeof a !== "object" || typeof a !== "object" || direction !== "asc" && direction !== "desc") throw new Error("Invalid Parameters");
    if (a[key] === null || a[key] === undefined) return 1;
    else if (b[key] === null || b[key] === undefined) return -1;
    if (direction === "asc") return a[key] < b[key] ? -1 : 1;
    else return a[key] < b[key] ? 1 : -1;
};
const $90eb12c1be8763cc$export$561c904c0986fb2e = {
    [(0, $53cc2e000314a49f$export$99c6d95f8d1e53ad)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "fullName", "asc"),
    [(0, $53cc2e000314a49f$export$1597d3d79f36bd09)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "fullName", "desc"),
    [(0, $53cc2e000314a49f$export$b9e81d98424fb77d)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "sewpContractNumber", "asc"),
    [(0, $53cc2e000314a49f$export$adcfeb78a0beb383)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "sewpContractNumber", "desc"),
    [(0, $53cc2e000314a49f$export$9ccb2e9a070eb88c)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "setAside", "asc"),
    [(0, $53cc2e000314a49f$export$ffd3fcd096096076)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "setAside", "desc"),
    [(0, $53cc2e000314a49f$export$11b547de87f695ab)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "lastName", "asc"),
    [(0, $53cc2e000314a49f$export$81efd80c12b8d600)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "lastName", "desc"),
    [(0, $53cc2e000314a49f$export$c988202ff52ee262)]: (ch1, ch2)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(ch1, ch2, "email", "asc"),
    [(0, $53cc2e000314a49f$export$707eb7df8802a474)]: (ch1, ch2)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(ch1, ch2, "email", "desc")
};
const $90eb12c1be8763cc$export$697f390c5b62ec81 = {
    [(0, $53cc2e000314a49f$export$55116c87c5f31497)]: (a, b)=>$90eb12c1be8763cc$export$127a787ff8838faf(a, b, "stnSeq", "asc"),
    [(0, $53cc2e000314a49f$export$10bb27af362e4701)]: (a, b)=>$90eb12c1be8763cc$export$127a787ff8838faf(a, b, "stnSeq", "desc"),
    [(0, $53cc2e000314a49f$export$257390c21a53d74a)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "orderNumber", "asc"),
    [(0, $53cc2e000314a49f$export$bb197327b04c878b)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "orderNumber", "desc"),
    [(0, $53cc2e000314a49f$export$ed2a6d7a3e4814c4)]: (a, b)=>$90eb12c1be8763cc$export$93761ee88997c37f(a, b, "rfqSeq", "asc"),
    [(0, $53cc2e000314a49f$export$5637c64aa29c45b0)]: (a, b)=>$90eb12c1be8763cc$export$93761ee88997c37f(a, b, "rfqSeq", "desc"),
    [(0, $53cc2e000314a49f$export$99c6d95f8d1e53ad)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "companyName", "asc"),
    [(0, $53cc2e000314a49f$export$1597d3d79f36bd09)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "companyName", "desc"),
    [(0, $53cc2e000314a49f$export$9baa2088803503a2)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "awardDate", "asc"),
    [(0, $53cc2e000314a49f$export$d791af190ad3ce03)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "awardDate", "desc"),
    [(0, $53cc2e000314a49f$export$f43d343eb3d605c5)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "expDeliveryDate", "asc"),
    [(0, $53cc2e000314a49f$export$258047127fa9a409)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "expDeliveryDate", "desc"),
    [(0, $53cc2e000314a49f$export$b0f9ed8296bcaf46)]: (a, b)=>$90eb12c1be8763cc$export$127a787ff8838faf(a, b, "totalAmount", "asc"),
    [(0, $53cc2e000314a49f$export$5252ff91cdd72fe4)]: (a, b)=>$90eb12c1be8763cc$export$127a787ff8838faf(a, b, "totalAmount", "desc"),
    [(0, $53cc2e000314a49f$export$8c96a12f79ba687e)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "orderStatusDisplay", "asc"),
    [(0, $53cc2e000314a49f$export$bb33f37e01d8da72)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "orderStatusDisplay", "desc")
};
const $90eb12c1be8763cc$export$3d77ba5b4995b76e = {
    [(0, $53cc2e000314a49f$export$8ce0397586013bef)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "name", "asc"),
    [(0, $53cc2e000314a49f$export$d5fcf051c75fdb4b)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "name", "desc"),
    [(0, $53cc2e000314a49f$export$b9e81d98424fb77d)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "federalContractNumber", "asc"),
    [(0, $53cc2e000314a49f$export$adcfeb78a0beb383)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "federalContractNumber", "desc"),
    [(0, $53cc2e000314a49f$export$feb7a771147f9ff4)]: (a, b)=>$90eb12c1be8763cc$export$127a787ff8838faf(a, b, "contractPopDate", "asc"),
    [(0, $53cc2e000314a49f$export$eb335583752f8a)]: (a, b)=>$90eb12c1be8763cc$export$127a787ff8838faf(a, b, "contractPopDate", "desc"),
    [(0, $53cc2e000314a49f$export$5a7a5b700e65824d)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "shortAgencyName", "asc"),
    [(0, $53cc2e000314a49f$export$5d9a7f268c32987e)]: (a, b)=>$90eb12c1be8763cc$export$89a1f01f2a7cb2a1(a, b, "shortAgencyName", "desc")
};


function $ddbf4334159f7ead$export$2e2bcd8739ae039({ id: id, className: className, text: text, onClick: onClick, title: title, sortOption: sortOption, sortDesc: sortDesc }) {
    let ariaSort, icon, ariaLabel, showIcon;
    if (sortOption && (sortOption === sortDesc || sortOption === (0, $90eb12c1be8763cc$export$c56d9c82f8c9489)(sortDesc))) {
        const isAscending = (0, $90eb12c1be8763cc$export$1387eae18edfb550)(sortOption);
        const isDescending = (0, $90eb12c1be8763cc$export$1387eae18edfb550)((0, $90eb12c1be8763cc$export$c56d9c82f8c9489)(sortOption));
        if (isAscending) {
            ariaSort = "ascending";
            icon = "glyphicon glyphicon-arrow-up";
            ariaLabel = "sorted in A to Z order";
            showIcon = true;
        } else if (isDescending) {
            ariaSort = "descending";
            icon = "glyphicon glyphicon-arrow-down";
            ariaLabel = "sorted in Z to A order";
            showIcon = true;
        } else ariaSort = "none";
    }
    if (title && sortOption) {
        if (sortOption === sortDesc) title = `Sort by ${title} ascending`;
        else title = `Sort by ${title} descending`;
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
        id: id,
        className: className,
        role: "columnheader",
        children: onClick ? /*#__PURE__*/ (0, $1IdZj.jsxs)("a", {
            role: "button",
            title: title,
            "aria-sort": ariaSort,
            onClick: onClick,
            className: "clickable",
            href: "javascript:;",
            children: [
                text,
                showIcon && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                    "aria-label": ariaLabel,
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                        className: icon
                    })
                })
            ]
        }) : text
    });
}



const $3be763ee166b6d84$export$ab4ae02812b15a92 = (path)=>{
    const pathArray = path.split("/");
    if (pathArray.length === 3 && pathArray[1] === (0, $53cc2e000314a49f$export$c62e1e68e9b129bf) && Number.isInteger(Number(pathArray[2]))) return {
        type: (0, $53cc2e000314a49f$export$c62e1e68e9b129bf),
        id: Number(pathArray[2])
    };
    else if (pathArray.length === 1 && pathArray[0] === "" || pathArray.length === 2 && pathArray[1] === (0, $53cc2e000314a49f$export$bc65c5f8ae8c9619)) return {
        type: (0, $53cc2e000314a49f$export$bc65c5f8ae8c9619)
    };
    else if (pathArray.length === 2 && pathArray[1] === (0, $53cc2e000314a49f$export$d4daa26c757f8f98)) return {
        type: (0, $53cc2e000314a49f$export$d4daa26c757f8f98)
    };
    else if (pathArray.length === 2 && pathArray[1] === (0, $53cc2e000314a49f$export$1ac8347527ea5cf5)) return {
        type: (0, $53cc2e000314a49f$export$1ac8347527ea5cf5)
    };
    else if (pathArray.length === 2 && pathArray[1] === (0, $53cc2e000314a49f$export$3dbfd7c861adfb40)) return {
        type: (0, $53cc2e000314a49f$export$3dbfd7c861adfb40)
    };
    else return {
        type: null
    };
};
const $3be763ee166b6d84$export$ed0d8fc5748b64e4 = (contractHolders, options)=>{
    const { groupOptions: groupOptions, otherOptions: otherOptions } = options;
    if (otherOptions.includes((0, $53cc2e000314a49f$export$38b260a518ad57e5))) contractHolders = contractHolders.filter(({ isoCertified: isoCertified })=>isoCertified === (0, $53cc2e000314a49f$export$bd0866f92493be24));
    if (otherOptions.includes((0, $53cc2e000314a49f$export$34435eaa37e14f8c))) contractHolders = contractHolders.filter(({ sbaCertified: sbaCertified })=>sbaCertified === (0, $53cc2e000314a49f$export$bd0866f92493be24));
    if (groupOptions.group) {
        contractHolders = contractHolders.filter(({ group: group })=>group === groupOptions.group);
        if (groupOptions.facet) contractHolders = contractHolders.filter(({ businessSizes: businessSizes })=>businessSizes.split(",").map((size)=>size.trim()).includes(groupOptions.facet));
    }
    return contractHolders;
};
const $3be763ee166b6d84$export$a4619c99a41ecb1c = ({ group: group = "All Groups", facet: facet = "" })=>`${group} ${facet}`;





const $0e837c6bf3cdd191$var$filterByText = (contractHolders, text, searchOption)=>{
    const reg = new RegExp((0, $3da708ea9eb0f551$export$f176fecabc1d6df7)(text));
    if (searchOption === (0, $53cc2e000314a49f$export$633943fdd4494e9a)) //only search fullName
    contractHolders = contractHolders.filter(({ fullName: fullName })=>reg.test(fullName.toLowerCase()));
    else //search everything
    contractHolders = contractHolders.filter(({ group: group, naicsCode: naicsCode, fullName: fullName, sewpContractNumber: sewpContractNumber, businessSizes: businessSizes, setAside: setAside })=>reg.test(group.toLowerCase()) || reg.test(naicsCode.toLowerCase()) || reg.test(fullName.toLowerCase()) || reg.test(sewpContractNumber.toLowerCase()) || reg.test(businessSizes.toLowerCase()) || reg.test(setAside.toLowerCase()));
    return contractHolders;
};
function $0e837c6bf3cdd191$export$2e2bcd8739ae039({ options: options, searchType: searchType, searchValue: searchValue, contractHolderListData: contractHolderListData }) {
    //init state
    const [sortOption, setSortOption] = (0, $8NFma.useState)((0, $53cc2e000314a49f$export$99c6d95f8d1e53ad));
    //define onClick handlers
    const setCompanySort = ()=>{
        setSortOption((prevState)=>prevState === (0, $53cc2e000314a49f$export$99c6d95f8d1e53ad) ? (0, $53cc2e000314a49f$export$1597d3d79f36bd09) : (0, $53cc2e000314a49f$export$99c6d95f8d1e53ad));
    };
    const setContractSort = ()=>{
        setSortOption((prevState)=>prevState === (0, $53cc2e000314a49f$export$b9e81d98424fb77d) ? (0, $53cc2e000314a49f$export$adcfeb78a0beb383) : (0, $53cc2e000314a49f$export$b9e81d98424fb77d));
    };
    const setGroupSort = ()=>{
        setSortOption((prevState)=>prevState === (0, $53cc2e000314a49f$export$9ccb2e9a070eb88c) ? (0, $53cc2e000314a49f$export$ffd3fcd096096076) : (0, $53cc2e000314a49f$export$9ccb2e9a070eb88c));
    };
    //if search input has text, first handle search
    if (searchValue !== "") contractHolderListData = $0e837c6bf3cdd191$var$filterByText(contractHolderListData, searchValue, searchType);
    //filter and then sort list
    const filteredContractHolders = (0, $3be763ee166b6d84$export$ed0d8fc5748b64e4)(contractHolderListData, options);
    const groupA = filteredContractHolders.filter(({ naicsCode: naicsCode })=>naicsCode === (0, $53cc2e000314a49f$export$cdd9dd1559ccd593));
    const groupBCD = filteredContractHolders.filter(({ naicsCode: naicsCode })=>naicsCode === (0, $53cc2e000314a49f$export$80874287d10adbdc));
    const sortedGroupA = groupA.sort((0, $90eb12c1be8763cc$export$561c904c0986fb2e)[sortOption]);
    const sortedGroupBCD = groupBCD.sort((0, $90eb12c1be8763cc$export$561c904c0986fb2e)[sortOption]);
    let tableContent = [
        /*#__PURE__*/ (0, $1IdZj.jsxs)("tbody", {
            role: "rowgroup",
            children: [
                //only display if there are Group A contract holders
                sortedGroupA.length > 0 && /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                    className: "groupheader",
                    role: "row",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                            colSpan: "3",
                            role: "columnheader",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "Group A:"
                            })
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                            role: "columnheader",
                            className: "text-right",
                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("strong", {
                                children: [
                                    "NAICS Code: ",
                                    (0, $53cc2e000314a49f$export$cdd9dd1559ccd593)
                                ]
                            })
                        })
                    ]
                }),
                sortedGroupA.map((item)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $2d5068e2e47f0a0c$export$2e2bcd8739ae039), {
                        contractHolder: item
                    }, item.sewpContractNumber))
            ]
        }, "GROUP A"),
        /*#__PURE__*/ (0, $1IdZj.jsxs)("tbody", {
            role: "rowgroup",
            children: [
                //only display if there are Group B,C,D contract holders
                sortedGroupBCD.length > 0 && /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                    className: "groupheader",
                    role: "row",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                            colSpan: "3",
                            role: "columnheader",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "Groups B,C,D:"
                            })
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                            role: "columnheader",
                            className: "text-right",
                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("strong", {
                                children: [
                                    "NAICS Code: ",
                                    (0, $53cc2e000314a49f$export$80874287d10adbdc)
                                ]
                            })
                        })
                    ]
                }),
                sortedGroupBCD.map((item)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $2d5068e2e47f0a0c$export$2e2bcd8739ae039), {
                        contractHolder: item
                    }, item.sewpContractNumber))
            ]
        }, "GROUP B,C,D")
    ];
    // need to show group b,c,d table first when sorted by group asc
    if (sortOption === (0, $53cc2e000314a49f$export$ffd3fcd096096076)) tableContent = tableContent.reverse();
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
        id: "contractholderlist",
        summary: "List of Contract Holders in " + (0, $3be763ee166b6d84$export$a4619c99a41ecb1c)(options.groupOptions),
        caption: "Contract Holders sorted by group then company name",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                role: "rowgroup",
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                    role: "row",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                            id: "company-head",
                            className: "col-xs-6",
                            text: "Company",
                            onClick: setCompanySort,
                            title: "company name",
                            sortOption: sortOption,
                            sortDesc: (0, $53cc2e000314a49f$export$1597d3d79f36bd09)
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                            id: "contract-head",
                            className: "col-xs-2 text-center",
                            text: "Contract(s)",
                            onClick: setContractSort,
                            title: "contract number",
                            sortOption: sortOption,
                            sortDesc: (0, $53cc2e000314a49f$export$adcfeb78a0beb383)
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                            id: "setAside-head",
                            className: "col-xs-1 text-center",
                            text: "Group(s)",
                            onClick: setGroupSort,
                            title: "group",
                            sortOption: sortOption,
                            sortDesc: (0, $53cc2e000314a49f$export$ffd3fcd096096076)
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                            id: "business-head",
                            className: "col-xs-3 text-center",
                            text: "Business Designation"
                        })
                    ]
                })
            }),
            tableContent
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

function $8ffe95232de5408d$export$2e2bcd8739ae039({ searchType: searchType, setSearchType: setSearchType, searchValue: searchValue, setSearchValue: setSearchValue }) {
    const handleSearchType = (e)=>setSearchType(Number(e.target.value));
    const handleSearchInput = (e)=>setSearchValue(e.target.value);
    const handleClearSearch = ()=>setSearchValue("");
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        id: "search",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            className: "col-sm-5",
            children: /*#__PURE__*/ (0, $1IdZj.jsx)("form", {
                role: "search",
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("legend", {
                            children: "Search:"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "row form-group text-left",
                            id: "searchoptions",
                            role: "radiogroup",
                            "aria-label": "search options",
                            "aria-controls": "contractholderlist",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                                    className: "radio-inline",
                                    htmlFor: "choption",
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                            type: "radio",
                                            id: "choption",
                                            role: "radio",
                                            name: "filterValue",
                                            value: (0, $53cc2e000314a49f$export$633943fdd4494e9a),
                                            onChange: handleSearchType,
                                            checked: searchType === (0, $53cc2e000314a49f$export$633943fdd4494e9a)
                                        }),
                                        "Contract Holder Name"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                                    className: "radio-inline",
                                    htmlFor: "allfieldsoption",
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                            type: "radio",
                                            id: "allfieldsoption",
                                            role: "radio",
                                            name: "filterValue",
                                            value: (0, $53cc2e000314a49f$export$9744c5e588117ff),
                                            onChange: handleSearchType,
                                            checked: searchType === (0, $53cc2e000314a49f$export$9744c5e588117ff)
                                        }),
                                        "All Fields"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "row text-right search",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                    className: "glyphicon glyphicon-search",
                                    "aria-hidden": "true",
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                    id: "searchBox",
                                    type: "text",
                                    value: searchValue,
                                    onChange: handleSearchInput,
                                    title: "Search: Enter text to search for a contract holder in the table below",
                                    name: "searchValue",
                                    placeholder: "Contract Holder"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                    className: "text-right clickable",
                                    onClick: handleClearSearch,
                                    children: "clear search"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $eab38a03778ac033$export$2e2bcd8739ae039({ id: id, children: children }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        id: id,
        className: "row",
        children: children
    });
}


function $54e9a24a55063132$export$2e2bcd8739ae039({ searchType: searchType, setSearchType: setSearchType, searchValue: searchValue, setSearchValue: setSearchValue }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "contract-holders-options col-sm-7",
                title: "help text",
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                            children: "Select the Company Name to display the detailed information page for the specified Contract Holder."
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                            children: "Select the column heading 'Company' or 'Contract' to sort the table by that column - select it again to reverse the sort."
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                            children: "Select a group below to only show Contract Holders within the specified group."
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                            children: "Enter text in the search field to search within the table. Select from the radio buttons above the field to restrict your search. Select clear search to clear the search field."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8ffe95232de5408d$export$2e2bcd8739ae039), {
                searchType: searchType,
                setSearchType: setSearchType,
                searchValue: searchValue,
                setSearchValue: setSearchValue
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $88c31b0f97777ae0$export$2e2bcd8739ae039({ contractHolderGroup: contractHolderGroup, handleChangeGroup: handleChangeGroup, options: options }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("table", {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("td", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                className: "set-aside-group-name",
                                children: `${contractHolderGroup.group}:`
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                                className: "set-aside-radio-label",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                        className: "set-aside-radio",
                                        type: "radio",
                                        role: "radio",
                                        name: "filterValue",
                                        onChange: ()=>handleChangeGroup({
                                                group: contractHolderGroup.group
                                            }),
                                        checked: !options.groupOptions.facet && options.groupOptions.group === contractHolderGroup.group
                                    }),
                                    "All Contract Holders"
                                ]
                            })
                        ]
                    }),
                    contractHolderGroup.setAsidesList.map((setAside)=>/*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                                className: "set-aside-radio-label",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                        className: "set-aside-radio",
                                        type: "radio",
                                        role: "radio",
                                        name: "filterValue",
                                        value: setAside.facetSeq,
                                        onChange: ()=>handleChangeGroup({
                                                group: contractHolderGroup.group,
                                                facet: setAside.facetName
                                            }),
                                        checked: options.groupOptions.group === contractHolderGroup.group && options.groupOptions.facet === setAside.facetName
                                    }),
                                    setAside.facetName
                                ]
                            })
                        }, setAside.facetSeq))
                ]
            })
        })
    });
}


function $647ef61829fbbe12$export$2e2bcd8739ae039({ contractHoldersGroups: contractHoldersGroups, options: options, setOptions: setOptions, children: children }) {
    const handleChangeGroup = (groupOptions)=>{
        setOptions({
            otherOptions: [],
            groupOptions: groupOptions
        });
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "col-xs-12",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("form", {
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("legend", {
                        className: "sr-only",
                        children: "Select a group to display in the table below"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "row form-group",
                        id: "groupfilter1",
                        role: "radiogroup",
                        "aria-label": "contract holder list filtering options",
                        "aria-controls": "contractholderlist",
                        children: [
                            contractHoldersGroups.map((contractHoldersGroup)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $88c31b0f97777ae0$export$2e2bcd8739ae039), {
                                    contractHolderGroup: contractHoldersGroup,
                                    handleChangeGroup: handleChangeGroup,
                                    options: options
                                }, contractHoldersGroup.naicsCode)),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                                className: "radio-inline",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                        type: "radio",
                                        id: "allgroups",
                                        role: "radio",
                                        name: "filterValue",
                                        onChange: ()=>handleChangeGroup({}),
                                        checked: !options.groupOptions.group && !options.groupOptions.facet
                                    }),
                                    "All Contract Holders / All Groups"
                                ]
                            }),
                            children
                        ]
                    })
                ]
            })
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

function $63232690911a09af$export$2e2bcd8739ae039({ options: options, setOptions: setOptions }) {
    const handleChangeGroupCheckbox = (e)=>{
        setOptions((prevState)=>{
            if (prevState.otherOptions.includes(Number(e.target.value))) return {
                ...prevState,
                otherOptions: prevState.otherOptions.filter((option)=>option !== Number(e.target.value))
            };
            else return {
                ...prevState,
                otherOptions: [
                    ...prevState.otherOptions,
                    Number(e.target.value)
                ]
            };
        });
    };
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                className: "set-aside-group-name",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        className: "isoCheckBox",
                        type: "checkbox",
                        id: "isogroup",
                        role: "checkbox",
                        name: "filterValue",
                        value: (0, $53cc2e000314a49f$export$38b260a518ad57e5),
                        onChange: handleChangeGroupCheckbox,
                        checked: options.otherOptions.includes((0, $53cc2e000314a49f$export$38b260a518ad57e5))
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                        href: "/iso_20243.shtml",
                        id: "isoDetails",
                        title: "select to see more details about ISO-20243",
                        target: "_blank",
                        className: "isoLinkDisplay",
                        children: "ISO-20243"
                    }),
                    " ",
                    "Certified"
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                className: "set-aside-group-name",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        className: "sbaWosbCheckBox",
                        type: "checkbox",
                        id: "sbawosbgroup",
                        role: "checkbox",
                        name: "filterValue",
                        value: (0, $53cc2e000314a49f$export$34435eaa37e14f8c),
                        onChange: handleChangeGroupCheckbox,
                        checked: options.otherOptions.includes((0, $53cc2e000314a49f$export$34435eaa37e14f8c))
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                        href: "/WOSBs.shtml",
                        id: "sbaWosbDetails",
                        title: "select to see more details about SBA-certified WOSBs",
                        target: "_blank",
                        className: "sbaWosbLinkDisplay",
                        children: "SBA"
                    }),
                    " ",
                    "Certified WOSBs"
                ]
            })
        ]
    });
}


function $6756b5d9dffbbdd2$export$2e2bcd8739ae039({ contractHoldersGroups: contractHoldersGroups, options: options, setOptions: setOptions }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        id: "filtergroup",
        className: "row",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $647ef61829fbbe12$export$2e2bcd8739ae039), {
            contractHoldersGroups: contractHoldersGroups,
            options: options,
            setOptions: setOptions,
            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $63232690911a09af$export$2e2bcd8739ae039), {
                options: options,
                setOptions: setOptions
            })
        })
    });
}


function $84d2b92ab5069554$export$2e2bcd8739ae039({ contractHoldersGroups: contractHoldersGroups, options: options, setOptions: setOptions, searchType: searchType, setSearchType: setSearchType, searchValue: searchValue, setSearchValue: setSearchValue }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "contract-holders-header",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                className: "page_title",
                children: "NASA SEWP Contract Holders"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $54e9a24a55063132$export$2e2bcd8739ae039), {
                options: options,
                setOptions: setOptions,
                searchType: searchType,
                setSearchType: setSearchType,
                searchValue: searchValue,
                setSearchValue: setSearchValue
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6756b5d9dffbbdd2$export$2e2bcd8739ae039), {
                contractHoldersGroups: contractHoldersGroups,
                options: options,
                setOptions: setOptions
            })
        ]
    });
}


'use strict';
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const { iterator: $aace3e920a0f1e4d$var$iterator, toStringTag: $aace3e920a0f1e4d$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $aace3e920a0f1e4d$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $aace3e920a0f1e4d$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $aace3e920a0f1e4d$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($aace3e920a0f1e4d$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $aace3e920a0f1e4d$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(obj);
        if ($aace3e920a0f1e4d$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($aace3e920a0f1e4d$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $aace3e920a0f1e4d$var$getSafeProp = (obj, prop)=>obj != null && $aace3e920a0f1e4d$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $aace3e920a0f1e4d$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $aace3e920a0f1e4d$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $aace3e920a0f1e4d$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $aace3e920a0f1e4d$var$getPrototypeOf(current);
        if ($aace3e920a0f1e4d$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($aace3e920a0f1e4d$var$isUnsafeObjectKey(prop)) continue;
            if (!$aace3e920a0f1e4d$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if (!$aace3e920a0f1e4d$var$isObject(val)) return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $aace3e920a0f1e4d$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$aace3e920a0f1e4d$var$hasOwnInPrototypeChain(val, $aace3e920a0f1e4d$var$toStringTag) && !$aace3e920a0f1e4d$var$hasOwnInPrototypeChain(val, $aace3e920a0f1e4d$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $aace3e920a0f1e4d$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$aace3e920a0f1e4d$var$isObject(val) || $aace3e920a0f1e4d$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $aace3e920a0f1e4d$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest('FileList');
const $aace3e920a0f1e4d$var$isSet = $aace3e920a0f1e4d$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $aace3e920a0f1e4d$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $aace3e920a0f1e4d$var$G = $aace3e920a0f1e4d$var$getGlobal();
const $aace3e920a0f1e4d$var$FormDataCtor = typeof $aace3e920a0f1e4d$var$G.FormData !== 'undefined' ? $aace3e920a0f1e4d$var$G.FormData : undefined;
const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($aace3e920a0f1e4d$var$FormDataCtor && thing instanceof $aace3e920a0f1e4d$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $aace3e920a0f1e4d$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$aace3e920a0f1e4d$var$isFunction(thing.append)) return false;
    const kind = $aace3e920a0f1e4d$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest('URLSearchParams');
const [$aace3e920a0f1e4d$var$isReadableStream, $aace3e920a0f1e4d$var$isRequest, $aace3e920a0f1e4d$var$isResponse, $aace3e920a0f1e4d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($aace3e920a0f1e4d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($aace3e920a0f1e4d$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $aace3e920a0f1e4d$var$findKey(obj, key) {
    if ($aace3e920a0f1e4d$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $aace3e920a0f1e4d$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($aace3e920a0f1e4d$var$isPlainObject(existing) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(existing, val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$aace3e920a0f1e4d$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $aace3e920a0f1e4d$var$isBuffer(source)) continue;
        $aace3e920a0f1e4d$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $aace3e920a0f1e4d$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($aace3e920a0f1e4d$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$aace3e920a0f1e4d$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest('HTMLFormElement');
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $aace3e920a0f1e4d$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest('RegExp');
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[$aace3e920a0f1e4d$var$toStringTag] === 'FormData' && thing[$aace3e920a0f1e4d$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($aace3e920a0f1e4d$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($aace3e920a0f1e4d$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                    $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $aace3e920a0f1e4d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $aace3e920a0f1e4d$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $aace3e920a0f1e4d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $aace3e920a0f1e4d$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $aace3e920a0f1e4d$var$isFunction($aace3e920a0f1e4d$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $aace3e920a0f1e4d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($aace3e920a0f1e4d$var$_global) : $aace3e920a0f1e4d$var$_setImmediate;
// *********************
const $aace3e920a0f1e4d$var$isIterable = (thing)=>thing != null && $aace3e920a0f1e4d$var$isFunction(thing[$aace3e920a0f1e4d$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $aace3e920a0f1e4d$var$isSafeIterable = (thing)=>thing != null && $aace3e920a0f1e4d$var$hasOwnInPrototypeChain(thing, $aace3e920a0f1e4d$var$iterator) && $aace3e920a0f1e4d$var$isIterable(thing);
var $aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isEmptyObject: $aace3e920a0f1e4d$var$isEmptyObject,
    isReadableStream: $aace3e920a0f1e4d$var$isReadableStream,
    isRequest: $aace3e920a0f1e4d$var$isRequest,
    isResponse: $aace3e920a0f1e4d$var$isResponse,
    isHeaders: $aace3e920a0f1e4d$var$isHeaders,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isReactNativeBlob: $aace3e920a0f1e4d$var$isReactNativeBlob,
    isReactNative: $aace3e920a0f1e4d$var$isReactNative,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnInPrototypeChain: $aace3e920a0f1e4d$var$hasOwnInPrototypeChain,
    getSafeProp: $aace3e920a0f1e4d$var$getSafeProp,
    toSafeFlatObject: $aace3e920a0f1e4d$var$toSafeFlatObject,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable,
    setImmediate: $aace3e920a0f1e4d$var$_setImmediate,
    asap: $aace3e920a0f1e4d$var$asap,
    isIterable: $aace3e920a0f1e4d$var$isIterable,
    isSafeIterable: $aace3e920a0f1e4d$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp($36eacf0f5ae88424$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $0e9de7e2c09a763b$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $0e9de7e2c09a763b$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $0e9de7e2c09a763b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $0e9de7e2c09a763b$var$sanitizeValue(value, invalidChars) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$0e9de7e2c09a763b$var$sanitizeValue(item, invalidChars));
    return $0e9de7e2c09a763b$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $0e9de7e2c09a763b$export$9e344cffce061a22 = (value)=>$0e9de7e2c09a763b$var$sanitizeValue(value, $0e9de7e2c09a763b$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $0e9de7e2c09a763b$export$59dd66c2a12d8f62 = (value)=>$0e9de7e2c09a763b$var$sanitizeValue(value, $0e9de7e2c09a763b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $0e9de7e2c09a763b$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $0e9de7e2c09a763b$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $54e5234108b8e954$var$$internals = Symbol('internals');
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : (0, $0e9de7e2c09a763b$export$9e344cffce061a22)(String(value));
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $54e5234108b8e954$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $54e5234108b8e954$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $54e5234108b8e954$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $54e5234108b8e954$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $54e5234108b8e954$var$trimOWS(part.slice(0, equals));
        if (!$54e5234108b8e954$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $54e5234108b8e954$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $54e5234108b8e954$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $36eacf0f5ae88424$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(header) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $54e5234108b8e954$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;


'use strict';
const $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $0139f1d30f4d6bd5$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $0139f1d30f4d6bd5$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source) && $0139f1d30f4d6bd5$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $0139f1d30f4d6bd5$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $0139f1d30f4d6bd5$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $0139f1d30f4d6bd5$var$stringifySafely(entry.message) : $0139f1d30f4d6bd5$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $0139f1d30f4d6bd5$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $0139f1d30f4d6bd5$var$aggregateErrorMessage(error);
        const axiosError = new $0139f1d30f4d6bd5$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $0139f1d30f4d6bd5$var$redactConfig(config, redactKeys) : (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$0139f1d30f4d6bd5$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$0139f1d30f4d6bd5$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$0139f1d30f4d6bd5$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$0139f1d30f4d6bd5$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$0139f1d30f4d6bd5$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$0139f1d30f4d6bd5$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$0139f1d30f4d6bd5$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$0139f1d30f4d6bd5$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$0139f1d30f4d6bd5$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$0139f1d30f4d6bd5$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;


// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;



'use strict';
const $fd07b9cb0132c1f6$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(options, name);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $fd07b9cb0132c1f6$export$659081b45d03227d);
    const useBlob = _Blob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) && (0, $86ebf0c810395e29$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $86ebf0c810395e29$export$2e2bcd8739ae039).from(value);
            throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReactNative(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $344cf8e4292137b6$var$encode) : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;


'use strict';
function $db2f05ec923f2ee7$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $db2f05ec923f2ee7$export$c564cdbbe6da493;
    const serializeFn = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $344cf8e4292137b6$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
const $01c17f80085c95b1$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $01c17f80085c95b1$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $01c17f80085c95b1$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $01c17f80085c95b1$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $01c17f80085c95b1$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$01c17f80085c95b1$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$01c17f80085c95b1$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $01c17f80085c95b1$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$01c17f80085c95b1$var$$internals];
        $01c17f80085c95b1$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $01c17f80085c95b1$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $01c17f80085c95b1$var$syncHandlerEntries(this, this[$01c17f80085c95b1$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$01c17f80085c95b1$var$$internals];
        $01c17f80085c95b1$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $01c17f80085c95b1$var$syncHandlerEntries(this, internals);
                $01c17f80085c95b1$var$trimHandlers(this.handlers);
                internals.handlersLength = $01c17f80085c95b1$var$countHandlers(this.handlers);
            }
        }
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;





'use strict';
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $344cf8e4292137b6$export$2e2bcd8739ae039);


'use strict';
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a85e5bed82430d61$export$2e2bcd8739ae039,
        FormData: $46b12d255f217052$export$2e2bcd8739ae039,
        Blob: $2e4211376cea43e6$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $232de52881daaba8$exports = {};

$parcel$export($232de52881daaba8$exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export($232de52881daaba8$exports, "navigator", () => $232de52881daaba8$export$ec7c8efa7f5790ae);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
$parcel$export($232de52881daaba8$exports, "origin", () => $232de52881daaba8$export$f710a83a91838a36);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $232de52881daaba8$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = $232de52881daaba8$export$c4996c4b7b93b0bf && (!$232de52881daaba8$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($232de52881daaba8$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $232de52881daaba8$export$f710a83a91838a36 = $232de52881daaba8$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$232de52881daaba8$exports,
    ...(0, $fb24c6d0b2a74508$export$2e2bcd8739ae039)
};


'use strict';
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(data, new (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).isNode && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $cb8fe7f388dc4432$var$MAX_DEPTH = (0, $fd07b9cb0132c1f6$export$659081b45d03227d);
function $cb8fe7f388dc4432$var$throwIfDepthExceeded(index) {
    if (index > $cb8fe7f388dc4432$var$MAX_DEPTH) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $cb8fe7f388dc4432$var$MAX_DEPTH, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $cb8fe7f388dc4432$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $cb8fe7f388dc4432$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;


'use strict';
const $646cd75d44c49c4c$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $646cd75d44c49c4c$export$2e2bcd8739ae039 = $646cd75d44c49c4c$var$methodList;


'use strict';
const $e30871f78dcd7f19$var$own = (obj, key)=>obj != null && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $3075bac9f30e7782$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFile(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $e30871f78dcd7f19$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $aa000567d8bb5ae2$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $e30871f78dcd7f19$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $e30871f78dcd7f19$var$own(this, 'transitional') || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $e30871f78dcd7f19$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isResponse(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $e30871f78dcd7f19$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $e30871f78dcd7f19$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach((0, $646cd75d44c49c4c$export$2e2bcd8739ae039), (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;



'use strict';
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $63b8b72909769bf2$var$CanceledError extends (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;







'use strict';
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
const $833fb3017515f4b1$var$urlParserControlCharacters = /[\t\n\r]/g;
function $833fb3017515f4b1$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($833fb3017515f4b1$var$urlParserControlCharacters, '');
}


'use strict';
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $bab2be24834f7155$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $bab2be24834f7155$export$2e2bcd8739ae039 = $bab2be24834f7155$var$throttle;



const $a01f222f203440ec$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $48a8aeed25ee768a$export$2e2bcd8739ae039)(50, 250);
    return (0, $bab2be24834f7155$export$2e2bcd8739ae039)((e)=>{
        if (!e || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $a01f222f203440ec$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $a01f222f203440ec$export$5d35863c355a22a9 = (fn, scheduler = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin), (0, $852831b4a152a7ad$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $852831b4a152a7ad$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}



'use strict';
const $8ed3292b1f9dccb5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $8ed3292b1f9dccb5$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b}`;
    });
}
function $8ed3292b1f9dccb5$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$8ed3292b1f9dccb5$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $8ed3292b1f9dccb5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $833fb3017515f4b1$export$2e2bcd8739ae039)(url);
        if ($8ed3292b1f9dccb5$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($8ed3292b1f9dccb5$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $8ed3292b1f9dccb5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $05bf269bfca011f3$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $8ed3292b1f9dccb5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $7c49e720f6231ba2$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
const $20ede3a7e8b675d4$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), prop, true)
    };
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($20ede3a7e8b675d4$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $33eeece7a5eadfb1$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $33eeece7a5eadfb1$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($33eeece7a5eadfb1$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $f612969e780f42a0$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $f612969e780f42a0$var$resolveConfig(config) {
    const newConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)((0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $f612969e780f42a0$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data)) {
        const getHeaders = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(data, 'getHeaders');
        if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $33eeece7a5eadfb1$export$2e2bcd8739ae039)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $3a08e3bf7b3045fa$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $4d3cf801f7fd4dc6$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $f612969e780f42a0$export$2e2bcd8739ae039 = $f612969e780f42a0$var$resolveConfig;



const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)((0, $833fb3017515f4b1$export$2e2bcd8739ae039)(_config.url)) || (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request aborted', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request aborted', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(msg, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach((0, $0e9de7e2c09a763b$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $a01f222f203440ec$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $a01f222f203440ec$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $852831b4a152a7ad$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $8bc8ab02f7e95517$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039) ? err : new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $8bc8ab02f7e95517$export$2e2bcd8739ae039 = $8bc8ab02f7e95517$var$composeSignals;


const $ac31e9e363273572$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ac31e9e363273572$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ac31e9e363273572$var$readStream(iterable))yield* $ac31e9e363273572$export$71b051935044bd5d(chunk, chunkSize);
};
const $ac31e9e363273572$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ac31e9e363273572$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ac31e9e363273572$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $9da0c0d713764234$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $9da0c0d713764234$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $9da0c0d713764234$var$isHexDigit(str.charCodeAt(i + 1)) && $9da0c0d713764234$var$isHexDigit(str.charCodeAt(i + 2));
const $9da0c0d713764234$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $9da0c0d713764234$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $9da0c0d713764234$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $9da0c0d713764234$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $9da0c0d713764234$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $9da0c0d713764234$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $9da0c0d713764234$var$isPercentEncodedByte(body, i, len)) {
            code = $9da0c0d713764234$var$hexValue(body.charCodeAt(i + 1)) * 16 + $9da0c0d713764234$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($9da0c0d713764234$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$9da0c0d713764234$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $9da0c0d713764234$var$estimateBase64BufferAllocation(body);
    return $9da0c0d713764234$var$base64Bytes(significant);
};
const $9da0c0d713764234$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $9da0c0d713764234$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $9da0c0d713764234$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $9da0c0d713764234$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $9da0c0d713764234$var$estimatePercentDecodedBase64Bytes);
}
function $9da0c0d713764234$export$1f39e64b554a246f(url) {
    return $9da0c0d713764234$var$estimateDataURLBytes(url, $9da0c0d713764234$var$estimateBase64BufferAllocation);
}


const $4c74d331112ba968$export$a4ad2735b021c132 = "1.20.0";



const $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE = 65536;
const $4b9898a31eea6843$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $4b9898a31eea6843$var$isFunction } = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $4b9898a31eea6843$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $4b9898a31eea6843$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $4b9898a31eea6843$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $4b9898a31eea6843$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $4b9898a31eea6843$var$factory = (env)=>{
    const globalObject = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).global !== undefined && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).global !== null ? (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $4b9898a31eea6843$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $4b9898a31eea6843$var$isFunction(Request);
    const isResponseSupported = $4b9898a31eea6843$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $4b9898a31eea6843$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $8bc8ab02f7e95517$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($4b9898a31eea6843$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $4b9898a31eea6843$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $4b9898a31eea6843$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($4b9898a31eea6843$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $9da0c0d713764234$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $ac31e9e363273572$export$b0119225647bd83)(stream, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $a01f222f203440ec$export$d9fadd12586c18d6)(requestContentLength, (0, $a01f222f203440ec$export$c1b28109d46c3592)((0, $a01f222f203440ec$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $4c74d331112ba968$export$a4ad2735b021c132), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $0e9de7e2c09a763b$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($4b9898a31eea6843$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $a01f222f203440ec$export$d9fadd12586c18d6)(responseContentLength, (0, $a01f222f203440ec$export$c1b28109d46c3592)((0, $a01f222f203440ec$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $ac31e9e363273572$export$b0119225647bd83)(response.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Network Error', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $4b9898a31eea6843$var$seedCache = new Map();
const $4b9898a31eea6843$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $4b9898a31eea6843$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $4b9898a31eea6843$var$factory(env));
        map = target;
    }
    return target;
};
const $4b9898a31eea6843$var$adapter = $4b9898a31eea6843$export$3105c6651375d4fa();
var $4b9898a31eea6843$export$2e2bcd8739ae039 = $4b9898a31eea6843$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $86ebf0c810395e29$export$2e2bcd8739ae039),
    xhr: (0, $61abd1574bd1dd32$export$2e2bcd8739ae039),
    fetch: {
        get: $4b9898a31eea6843$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $d570c100e0cb7a05$var$getAdapter(adapters, config) {
    adapters = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($d570c100e0cb7a05$var$renderReason).join('\n') : ' ' + $d570c100e0cb7a05$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $d570c100e0cb7a05$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $d570c100e0cb7a05$var$knownAdapters
};



'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toSafeFlatObject(_config);
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}







'use strict';
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $4c74d331112ba968$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$63efb8494987aa98$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('options must be an object', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};




'use strict';
const $cd0b8e3cbef64068$var$validators = (0, $63efb8494987aa98$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)(),
            response: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            legacyInterceptorReqResOrdering: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            advertiseZstdAcceptEncoding: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            validateStatusUndefinedResolves: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $cd0b8e3cbef64068$var$validators.spelling('baseURL'),
            withXsrfToken: $cd0b8e3cbef64068$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(config, 'method') || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach((0, $646cd75d44c49c4c$export$2e2bcd8739ae039).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $96666136aaccd2e5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $cd0b8e3cbef64068$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;






'use strict';
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    if ($edd7ef3f6e3b67e5$var$HttpStatusCode[value] === undefined) $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)((0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $e30871f78dcd7f19$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $63b8b72909769bf2$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $3218dd97b5460664$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $4c74d331112ba968$export$a4ad2735b021c132);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $7874d702b64e6994$export$2e2bcd8739ae039);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $16f479813f4fb9c8$export$2e2bcd8739ae039);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a, create: $125d1ceb57662f9a$export$185802fd694ee1f5 } = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);


const $218703de6b4a0d50$var$basePath = "/sewpvi";
const $218703de6b4a0d50$var$withBasePath = (endpoint)=>`${$218703de6b4a0d50$var$basePath}${endpoint}`;
const $218703de6b4a0d50$var$handleCSRF = async ()=>{
    try {
        await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get("/api/security/csrf");
    } catch (error) {
        throw new Error("CSRF token retrieval failed");
    }
};
const $218703de6b4a0d50$export$3988ae62b71be9a3 = (endpoint, expectedStatusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get($218703de6b4a0d50$var$withBasePath(endpoint)).then((response)=>{
            resolve(response);
        }).catch((error)=>{
            if (expectedStatusCodes.includes(error.response?.status)) resolve(error);
            else {
                console.error(error);
                reject(error);
            }
        });
    });
};
const $218703de6b4a0d50$export$299ba2dee77727e9 = (endpoint, requestBody, expectedStatusCodes = [])=>{
    return new Promise(async (resolve, reject)=>{
        await $218703de6b4a0d50$var$handleCSRF();
        (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post($218703de6b4a0d50$var$withBasePath(endpoint), requestBody).then((response)=>{
            resolve(response);
        }).catch((error)=>{
            if (expectedStatusCodes.includes(error.response?.status)) resolve(error);
            else {
                console.error(error);
                reject(error);
            }
        });
    });
};
const $218703de6b4a0d50$export$f1fcd40115df98ce = async (endpoint, expectedStatusCodes = [])=>{
    return new Promise(async (resolve, reject)=>{
        await $218703de6b4a0d50$var$handleCSRF();
        (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).delete($218703de6b4a0d50$var$withBasePath(endpoint)).then((response)=>{
            resolve(response);
        }).catch((error)=>{
            if (expectedStatusCodes.includes(error.response?.status)) resolve(error);
            else {
                console.error(error);
                reject(error);
            }
        });
    });
};
const $218703de6b4a0d50$export$2a88462d58de88be = (endpoint, success, error = ()=>{}, expectedStatusCodes = [])=>{
    (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get($218703de6b4a0d50$var$withBasePath(endpoint)).then((response)=>{
        success(response);
    }).catch((err)=>{
        if (expectedStatusCodes.includes(err.response?.status)) success(err);
        else {
            console.error(err);
            error(err);
        }
    });
};
const $218703de6b4a0d50$export$199a6833ee2cba6a = async (endpoint, requestBody, success = ()=>{}, error = ()=>{}, expectedStatusCodes = [])=>{
    await $218703de6b4a0d50$var$handleCSRF();
    (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post($218703de6b4a0d50$var$withBasePath(endpoint), requestBody).then((response)=>{
        success(response);
    }).catch((err)=>{
        if (expectedStatusCodes.includes(err.response?.status)) success(err);
        else {
            console.error(err);
            error(err);
        }
    });
};


const $bcddd5910c38d878$export$340ab0228aab1784 = ()=>(0, $218703de6b4a0d50$export$3988ae62b71be9a3)("/sewppublic/contractholders/contractholderslist").then(({ data: data })=>data);
const $bcddd5910c38d878$export$ca61d323fa476ae8 = (fedRamp = false)=>{
    if (fedRamp) return (0, $218703de6b4a0d50$export$3988ae62b71be9a3)("/sewppublic/contractholders/groups?page=FedRamp").then(({ data: data })=>data);
    else return (0, $218703de6b4a0d50$export$3988ae62b71be9a3)("/sewppublic/contractholders/groups").then(({ data: data })=>data);
};
const $bcddd5910c38d878$export$6e1c562dca14a8d6 = (contractHolderId)=>(0, $218703de6b4a0d50$export$3988ae62b71be9a3)(`/sewppublic/contractholders/contractholder/${contractHolderId}`).then(({ data: data })=>data);
const $bcddd5910c38d878$export$186923dd19cf6a51 = ()=>(0, $218703de6b4a0d50$export$3988ae62b71be9a3)("/sewppublic/contractholders/programmanagerslist").then(({ data: data })=>data);
const $bcddd5910c38d878$export$6810f6d900bef694 = ()=>(0, $218703de6b4a0d50$export$3988ae62b71be9a3)("/sewppublic/contractholders/smallbusinesslist").then(({ data: data })=>data);
const $bcddd5910c38d878$export$5a5e822ad28a37c5 = ()=>(0, $218703de6b4a0d50$export$3988ae62b71be9a3)("/sewppublic/contractholders/groupcounts").then(({ data: data })=>data);
const $bcddd5910c38d878$export$5eae1f219b7ca1ee = ()=>(0, $218703de6b4a0d50$export$3988ae62b71be9a3)("/sewppublic/contractholders/businesssizecounts").then(({ data: data })=>data);



const $a8e74be0f5b0ad63$export$97aad63b59591a8f = (chList)=>chList.filter(({ displayName: displayName })=>!(0, $53cc2e000314a49f$export$f03aa4aa3e16b9e).find(({ displayName: bannedDisplayName })=>displayName === bannedDisplayName));



function $b14d2a971c83530e$export$2e2bcd8739ae039({ setFetchError: setFetchError = ()=>{} }) {
    /** @type {[ContractHolder[], React.Dispatch<React.SetActionState<ContractHolder[]>>]} */ const [contractHolderList, setContractHolderList] = (0, $8NFma.useState)([]);
    /** @type {[ContractHolderGroup[], React.Dispatch<React.SetActionState<ContractHolderGroup[]>>]} */ const [contractHoldersGroups, setContractHoldersGroups] = (0, $8NFma.useState)([]);
    const [options, setOptions] = (0, $8NFma.useState)({
        groupOptions: {},
        otherOptions: []
    });
    const [searchType, setSearchType] = (0, $8NFma.useState)((0, $53cc2e000314a49f$export$633943fdd4494e9a));
    const [searchValue, setSearchValue] = (0, $8NFma.useState)("");
    (0, $8NFma.useEffect)(()=>{
        (0, $bcddd5910c38d878$export$340ab0228aab1784)().then((contractHolderListData)=>{
            setContractHolderList((0, $a8e74be0f5b0ad63$export$97aad63b59591a8f)(contractHolderListData));
        }).catch((error)=>{
            setFetchError(error);
        });
    }, []);
    (0, $8NFma.useEffect)(()=>{
        (0, $bcddd5910c38d878$export$ca61d323fa476ae8)().then((contractHoldersGroups)=>{
            setContractHoldersGroups(contractHoldersGroups);
        }).catch((error)=>{
            setFetchError(error);
        });
    }, []);
    if (!contractHolderList.length) return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        children: "Loading Contract Holders Data..."
    });
    else return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "contract-holders",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $84d2b92ab5069554$export$2e2bcd8739ae039), {
                contractHoldersGroups: contractHoldersGroups,
                options: options,
                setOptions: setOptions,
                searchType: searchType,
                setSearchType: setSearchType,
                searchValue: searchValue,
                setSearchValue: setSearchValue
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $0e837c6bf3cdd191$export$2e2bcd8739ae039), {
                options: options,
                searchType: searchType,
                searchValue: searchValue,
                contractHolderListData: contractHolderList
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $8aa29b4e57afa215$export$2e2bcd8739ae039({ name: name, image: image }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                className: "page_title",
                role: "banner",
                tabIndex: "-1",
                children: `NASA SEWP Contract Holder Info for ${name}`
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                align: "center",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                    className: "logoCH",
                    alt: "Vendor logo",
                    border: "0",
                    src: `/images6/${image}`
                })
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $766452b12427dfa0$export$2e2bcd8739ae039() {
    const handleClickGeneralInfo = ()=>document.getElementById("CH_geninfo").scrollIntoView();
    const handleClickContacts = ()=>document.getElementById("CH_contacts").scrollIntoView();
    const handleClickAddresses = ()=>document.getElementById("CH_address").scrollIntoView();
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "tabs",
        className: "btn-group panel",
        role: "group",
        "aria-label": "Select the button to go directly to that section of the page",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                className: "btn-small navigation-button",
                onClick: handleClickGeneralInfo,
                children: "General Info"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                className: "btn-small navigation-button",
                onClick: handleClickContacts,
                children: "Contacts"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                className: "btn-small navigation-button",
                onClick: handleClickAddresses,
                children: "Addresses"
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $2715765958fac4b7$export$2e2bcd8739ae039({ id: id = null, primary: primary = false, children: children, className: className = false }) {
    const totalClass = `panel${primary ? " panel-primary" : ""}${className ? ` ${className}` : ""}`;
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        id: id ? id : "",
        className: totalClass,
        children: children
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $dd60dc182c32fb28$export$2e2bcd8739ae039({ title: title }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "panel-heading text-center",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
            children: title
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


function $a537d02d27735b38$export$2e2bcd8739ae039({ displayName: displayName, companyName: companyName, corpUrl: corpUrl, duns: duns, uei: uei, tin: tin, cage: cage, facets: facets, ottpFacet: ottpFacet, certifiedUrl: certifiedUrl, certifiedLogoUrl: certifiedLogoUrl }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "col-sm-3",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $2715765958fac4b7$export$2e2bcd8739ae039), {
            primary: false,
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-xs-12",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                            children: displayName
                        })
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-xs-12",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                            children: companyName
                        })
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-xs-12",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            target: "_blank",
                            href: `https://${corpUrl}`,
                            children: corpUrl
                        })
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "col-xs-12",
                        children: [
                            "DUNS: ",
                            duns
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "col-xs-12",
                        children: [
                            "UEI: ",
                            uei
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "col-xs-12",
                        children: [
                            "TIN: ",
                            tin
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "col-xs-12",
                        children: [
                            "CAGE: ",
                            cage
                        ]
                    })
                }),
                facets.find((facet)=>facet.facetValue === "SECTION-889") && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-xs-12",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            href: "/section_889.shtml",
                            target: "_blank",
                            children: "Section 889 Certified"
                        })
                    })
                }),
                ottpFacet && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-xs-12",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            href: certifiedUrl,
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                                className: "logoCertified",
                                alt: "ottp Certified",
                                src: certifiedLogoUrl,
                                border: "0"
                            })
                        })
                    })
                })
            ]
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


function $82a06b956b00ed77$export$2e2bcd8739ae039({ documents: documents, showAllDocuments: showAllDocuments }) {
    if (!showAllDocuments) documents = documents.sort((0, $90eb12c1be8763cc$export$7f57ec4a048f5e9)).slice(0, 5);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "panel-body",
        children: documents.map(({ chContractDocumentSeq: chContractDocumentSeq, contractModNumber: contractModNumber, modDesc: modDesc, effectiveDate: effectiveDate, savedFileName: savedFileName })=>contractModNumber > 0 ? /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-sm-5",
                        children: `Mod # ${contractModNumber} - ${modDesc}`
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-sm-4",
                        children: `Effective Date:  ${new Date(effectiveDate).toLocaleDateString(undefined, {
                            dateStyle: "long"
                        })}`
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-sm-3",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            target: "_blank",
                            href: `/documents/${savedFileName}`,
                            children: "Download PDF"
                        })
                    })
                ]
            }, chContractDocumentSeq) : /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "col-sm-5",
                        children: [
                            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0 ",
                            modDesc
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-sm-4",
                        children: `Effective Date:  ${new Date(effectiveDate).toLocaleDateString(undefined, {
                            dateStyle: "long"
                        })}`
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-sm-3",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            target: "_blank",
                            href: `/documents/${savedFileName}`,
                            children: "Download PDF"
                        })
                    })
                ]
            }, chContractDocumentSeq))
    });
}



function $d6088d5b8070757b$export$2e2bcd8739ae039({ contract: contract }) {
    const [showAllDocuments, setShowAllDocuments] = (0, $8NFma.useState)(false);
    const toggleShowAllDocuments = ()=>setShowAllDocuments((prevState)=>!prevState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "panel contract-display",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "panel-body",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "col-sm-5",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                        className: "col-md-12",
                                        children: [
                                            "Contract Number: ",
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                                children: contract.sewpContractNumber
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                        className: "col-md-12",
                                        children: [
                                            "Group: ",
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                                children: contract.group
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                        className: "col-md-12",
                                        children: [
                                            "NAICS: ",
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                                children: contract.naicsCode
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "col-sm-7",
                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                        className: "col-md-6",
                                        children: "Business Designation(s):"
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                        className: "col-md-6",
                                        children: contract.businessSizes.map(({ description: description, displayName: displayName })=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                                children: (contract.businessSizes.length === 1 || contract.businessSizes.length > 1 && description !== "Small Business") && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                                    className: "col-md-12",
                                                    title: displayName,
                                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                                        children: displayName
                                                    })
                                                })
                                            }, displayName))
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $2715765958fac4b7$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "panel-heading",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                    children: "Contract Document(s):\xa0\xa0"
                                }),
                                contract.contractDocuments.length > (0, $53cc2e000314a49f$export$76faf05cf78c8000) && /*#__PURE__*/ (0, $1IdZj.jsx)("small", {
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "showAll",
                                        children: showAllDocuments ? /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                            role: "button",
                                            "aria-label": "Select to show original and latest contract documents",
                                            onClick: toggleShowAllDocuments,
                                            children: "Show Fewer Contract Documents"
                                        }) : /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                            role: "button",
                                            "aria-label": "Select to show all contract documents",
                                            onClick: toggleShowAllDocuments,
                                            children: "Show All Contract Documents"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $82a06b956b00ed77$export$2e2bcd8739ae039), {
                            showAllDocuments: showAllDocuments,
                            documents: contract.contractDocuments
                        })
                    ]
                })
            ]
        })
    });
}



function $886d69beb57b58d9$export$2e2bcd8739ae039({ contracts: contracts }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "col-sm-9",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "panel panel-info",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "panel-heading",
                    children: [
                        "Contract(s):",
                        /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                            className: "text-right"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "panel-body",
                    children: [
                        contracts.sort((0, $90eb12c1be8763cc$export$ce0df3b43b927bce)).map((contract)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $d6088d5b8070757b$export$2e2bcd8739ae039), {
                                contract: contract
                            }, contract.chScnXrefSeq)),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "row text-center",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                href: "http://www.sewp.nasa.gov/contract_info.shtml",
                                children: "Download SOW and Contract Clauses"
                            })
                        })
                    ]
                })
            ]
        })
    });
}


function $3605143eb4516de0$export$2e2bcd8739ae039({ displayName: displayName, companyName: companyName, corpUrl: corpUrl, duns: duns, uei: uei, tin: tin, cage: cage, facets: facets, ottpFacet: ottpFacet, certifiedUrl: certifiedUrl, certifiedLogoUrl: certifiedLogoUrl, contracts: contracts }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "panel-body",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a537d02d27735b38$export$2e2bcd8739ae039), {
                    displayName: displayName,
                    companyName: companyName,
                    corpUrl: corpUrl,
                    duns: duns,
                    uei: uei,
                    tin: tin,
                    cage: cage,
                    facets: facets,
                    ottpFacet: ottpFacet,
                    certifiedUrl: certifiedUrl,
                    certifiedLogoUrl: certifiedLogoUrl
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $886d69beb57b58d9$export$2e2bcd8739ae039), {
                    contracts: contracts
                })
            ]
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

function $60e1f66759ff5e8f$export$2e2bcd8739ae039({ companyName: companyName, contacts: contacts }) {
    const openEmail = (email)=>{
        document.location = `mailto:${email}`;
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "panel-body",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("table", {
            id: "contactInfo",
            className: "table table-bordered",
            role: "grid",
            summary: `List of Contacts for ${companyName}`,
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                    role: "rowgroup",
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                        role: "row",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                id: "position-head",
                                role: "columnheader",
                                children: "Position"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                id: "name-head",
                                role: "columnheader",
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                id: "email-head",
                                role: "columnheader",
                                children: "Email Address"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                id: "phone-head",
                                role: "columnheader",
                                children: "Phone Numbers"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                    role: "rowgroup",
                    children: contacts.sort((0, $90eb12c1be8763cc$export$fedc88eb1169724)).map(({ sewperContactSeq: sewperContactSeq, position: position, firstName: firstName, lastName: lastName, email: email, phoneNumbers: phoneNumbers, pmFlag: pmFlag, altPmFlag: altPmFlag })=>/*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                            role: "row",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("th", {
                                    id: `${sewperContactSeq}-head`,
                                    role: "rowheader",
                                    headers: "position-head",
                                    children: [
                                        pmFlag && position !== "Program Manager" && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                            children: "Program Manager"
                                        }),
                                        altPmFlag && position !== "Deputy Program Manager" && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                            children: "Deputy Program Manager"
                                        }),
                                        position
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                    role: "gridcell",
                                    headers: "row-head name-head",
                                    children: `${firstName} ${lastName}`
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                    role: "gridcell",
                                    headers: "row-head email-head",
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                        className: "clickable",
                                        onClick: ()=>openEmail(email),
                                        children: email
                                    })
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                    role: "gridcell",
                                    headers: "row-head phone-head",
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                                        className: "list-unstyled",
                                        children: phoneNumbers.sort((0, $90eb12c1be8763cc$export$fc31cca2a34a723f)).map(({ phone: phone, typeFlag: typeFlag, contactPhoneSeq: contactPhoneSeq })=>/*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                                children: [
                                                    phone,
                                                    " ",
                                                    typeFlag !== "Phone" && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                                        children: typeFlag.toLowerCase()
                                                    })
                                                ]
                                            }, contactPhoneSeq))
                                    })
                                })
                            ]
                        }, sewperContactSeq))
                })
            ]
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


function $4dc22ba835afe1da$export$2e2bcd8739ae039({ addresses: addresses }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "panel-body",
        children: addresses.sort((0, $90eb12c1be8763cc$export$718a89977d68c72c)).map(({ chAddressSeq: chAddressSeq, chAddressType: chAddressType, address0: address0, address1: address1, address2: address2, address3: address3, city: city, state: state, zip: zip })=>/*#__PURE__*/ (0, $1IdZj.jsxs)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "col-xs-12",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "col-xs-12",
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: chAddressType
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                children: address0 && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "col-xs-11 col-sm-offset-1",
                                    children: address0
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                children: address1 && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "col-xs-11 col-sm-offset-1",
                                    children: address1
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                children: address2 && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "col-xs-11 col-sm-offset-1",
                                    children: address2
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                children: address3 && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "col-xs-11 col-sm-offset-1",
                                    children: address3
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "col-xs-11 col-sm-offset-1",
                                    children: `${city}, ${state}, ${zip}`
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "col-xs-12",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("br", {})
                        })
                    })
                ]
            }, chAddressSeq))
    });
}




function $29bead830478217e$export$2e2bcd8739ae039({ path: path, setFetchError: setFetchError = ()=>{} }) {
    /** @type {[ContractHolderDetails | {}, React.Dispatch<React.SetActionState<ContractHolderDetails>>]} */ const [contractHolderDetailsData, setContractHoldersDetailsData] = (0, $8NFma.useState)({});
    //get contract holder details data if needed
    (0, $8NFma.useEffect)(()=>{
        const display = (0, $3be763ee166b6d84$export$ab4ae02812b15a92)(path);
        // only get contract holder detail data if on a detail page AND we don't already have it
        if (contractHolderDetailsData.chInfoSeq !== display.id) (0, $bcddd5910c38d878$export$6e1c562dca14a8d6)(display.id).then(/** @param {ContractHolderDetails} contractHolderDetailsResponse */ (contractHolderDetailsResponse)=>{
            setContractHoldersDetailsData(contractHolderDetailsResponse);
        }).catch((error)=>{
            setFetchError(true);
        });
    }, [
        path
    ]);
    (0, $8NFma.useEffect)(()=>{
        const { id: id } = (0, $3be763ee166b6d84$export$ab4ae02812b15a92)(path);
        if (id && contractHolderDetailsData && contractHolderDetailsData.companyName) document.title = `NASA SEWP Contract Holders - ${contractHolderDetailsData.companyName}`;
    }, [
        contractHolderDetailsData
    ]);
    if (!contractHolderDetailsData || !contractHolderDetailsData.chInfoSeq) return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        children: "Loading Contract Holder Data..."
    });
    // using an onClick instead of href b/c url already contains a '#'
    const scrollToTop = ()=>document.getElementById("TOP").scrollIntoView();
    const scrollToTopElement = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "text-center link clickable",
        role: "link",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
            onClick: scrollToTop,
            children: "Back To Top"
        })
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "container-fluid",
        id: "inner",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                id: "TOP"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8aa29b4e57afa215$export$2e2bcd8739ae039), {
                name: contractHolderDetailsData.companyName,
                image: contractHolderDetailsData.logoFile
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $766452b12427dfa0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $2715765958fac4b7$export$2e2bcd8739ae039), {
                id: "CH_geninfo",
                primary: true,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dd60dc182c32fb28$export$2e2bcd8739ae039), {
                        title: "General Info"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3605143eb4516de0$export$2e2bcd8739ae039), {
                        displayName: contractHolderDetailsData.displayName,
                        companyName: contractHolderDetailsData.companyName,
                        corpUrl: contractHolderDetailsData.corpUrl,
                        duns: contractHolderDetailsData.duns,
                        uei: contractHolderDetailsData.uei,
                        tin: contractHolderDetailsData.tin,
                        cage: contractHolderDetailsData.cage,
                        facets: contractHolderDetailsData.facets,
                        ottpFacet: contractHolderDetailsData.ottpFacet,
                        certifiedUrl: contractHolderDetailsData.certifiedUrl,
                        certifiedLogoUrl: contractHolderDetailsData.certifiedLogoUrl,
                        contracts: contractHolderDetailsData.contracts
                    })
                ]
            }),
            scrollToTopElement,
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                id: "CH_contacts",
                className: "panel panel-primary table-responsive",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dd60dc182c32fb28$export$2e2bcd8739ae039), {
                        title: "Contacts"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $60e1f66759ff5e8f$export$2e2bcd8739ae039), {
                        companyName: contractHolderDetailsData.companyName,
                        contacts: contractHolderDetailsData.contacts
                    })
                ]
            }),
            scrollToTopElement,
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $2715765958fac4b7$export$2e2bcd8739ae039), {
                id: "CH_address",
                primary: true,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dd60dc182c32fb28$export$2e2bcd8739ae039), {
                        title: "Addresses"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4dc22ba835afe1da$export$2e2bcd8739ae039), {
                        addresses: contractHolderDetailsData.addresses
                    })
                ]
            }),
            scrollToTopElement
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");



function $b2f3bbe13af1033e$export$2e2bcd8739ae039({ contractHoldersGroups: contractHoldersGroups, options: options, setOptions: setOptions, searchType: searchType, setSearchType: setSearchType, searchValue: searchValue, setSearchValue: setSearchValue }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                className: "page_title",
                role: "banner",
                tabIndex: "-1",
                children: "NASA SEWP Program Managers and Deputy Program Managers Names and Numbers"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-sm-7",
                        title: "help text",
                        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                    children: "Select the Company Name to display the detailed information page for the specified Contract Holder."
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                    children: "Select the column heading 'ContractHolder', 'Name' or 'Email' to sort the table by that column - select it again to reverse the sort."
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                    children: "Enter text in the search field to search within the table. Select from the radio buttons above the field to restrict your search. Select clear search to clear the search field."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8ffe95232de5408d$export$2e2bcd8739ae039), {
                        searchType: searchType,
                        setSearchType: setSearchType,
                        searchValue: searchValue,
                        setSearchValue: setSearchValue
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                id: "filtergroup",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $647ef61829fbbe12$export$2e2bcd8739ae039), {
                    contractHoldersGroups: contractHoldersGroups,
                    options: options,
                    setOptions: setOptions
                })
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");


var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


function $e9a5de7a4c626168$export$2e2bcd8739ae039({ sortOption: sortOption, setSortOption: setSortOption }) {
    const companyOnClick = ()=>sortOption === (0, $53cc2e000314a49f$export$99c6d95f8d1e53ad) ? setSortOption((0, $53cc2e000314a49f$export$1597d3d79f36bd09)) : setSortOption((0, $53cc2e000314a49f$export$99c6d95f8d1e53ad));
    const nameOnClick = ()=>sortOption === (0, $53cc2e000314a49f$export$11b547de87f695ab) ? setSortOption((0, $53cc2e000314a49f$export$81efd80c12b8d600)) : setSortOption((0, $53cc2e000314a49f$export$11b547de87f695ab));
    const emailOnClick = ()=>sortOption === (0, $53cc2e000314a49f$export$c988202ff52ee262) ? setSortOption((0, $53cc2e000314a49f$export$707eb7df8802a474)) : setSortOption((0, $53cc2e000314a49f$export$c988202ff52ee262));
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                id: "company-head",
                text: "Contract Holder",
                onClick: companyOnClick,
                title: "company name",
                sortOption: sortOption,
                sortDesc: (0, $53cc2e000314a49f$export$1597d3d79f36bd09)
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                id: "contracts-head",
                text: "Contract(s)",
                className: "text-center"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                id: "position-head",
                text: "Position",
                className: "text-center"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                id: "name-head",
                text: "Name",
                className: "text-center",
                onClick: nameOnClick,
                title: "program manager",
                sortOption: sortOption,
                sortDesc: (0, $53cc2e000314a49f$export$81efd80c12b8d600)
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                id: "email-head",
                text: "Email",
                className: "text-center",
                onClick: emailOnClick,
                title: "email addresses",
                sortOption: sortOption,
                sortDesc: (0, $53cc2e000314a49f$export$707eb7df8802a474)
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                id: "phone-head",
                text: "Phone Numbers",
                className: "text-center"
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

function $e285a82551ed7ec6$export$2e2bcd8739ae039({ chInfoSeq: chInfoSeq, companyName: companyName, displayName: displayName, contracts: contracts, position: position, firstName: firstName, lastName: lastName, email: email, phoneNumbers: phoneNumbers }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center clickable",
                role: "gridcell",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                    href: `#/detail/${chInfoSeq}`,
                    title: `Go to the detail page for ${displayName}`,
                    children: `${companyName} (${displayName})`
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                    className: "list-unstyled",
                    children: contracts.map(({ chScnXrefSeq: chScnXrefSeq, sewpContractNumber: sewpContractNumber })=>/*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                            children: sewpContractNumber
                        }, chScnXrefSeq))
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: position
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: `${lastName}, ${firstName}`
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                    href: `mailto:${email}`,
                    children: email
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                role: "gridcell",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                    className: "list-unstyled",
                    children: phoneNumbers.sort((0, $90eb12c1be8763cc$export$fc31cca2a34a723f)).map(({ contactPhoneSeq: contactPhoneSeq, phone: phone, typeFlag: typeFlag })=>/*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                            children: [
                                phone,
                                " ",
                                typeFlag !== "Phone" && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                    children: typeFlag.toLowerCase()
                                })
                            ]
                        }, contactPhoneSeq))
                })
            })
        ]
    });
}






const $31cf61d71defa02e$export$4fd69129e4012bac = (programManagers, { groupOptions: groupOptions })=>{
    if (groupOptions.group) {
        if (groupOptions.facet) programManagers = programManagers.filter(({ contracts: contracts })=>contracts.find(({ group: group, businessSizes: businessSizes })=>(groupOptions.group === (0, $53cc2e000314a49f$export$1bcb160374152198) ? group === (0, $53cc2e000314a49f$export$1bcb160374152198) : group.match(/Group [BCD]/)) && businessSizes.find((businessSize)=>groupOptions.facet === businessSize.displayName)));
        else programManagers = programManagers.filter(({ contracts: contracts })=>contracts.find(({ group: group })=>groupOptions.group === (0, $53cc2e000314a49f$export$1bcb160374152198) ? group === (0, $53cc2e000314a49f$export$1bcb160374152198) : group.match(/Group [BCD]/)));
    }
    return programManagers;
};


/**
 * @typedef {import("../../../jsdoc/ProgramManager.js").ProgramManager} ProgramManager
 */ /**
 * Filters program manager list based on search text
 * @param {ProgramManager[]} programManagers
 * @param {string} text
 * @param {SEARCH_TYPE_NAME | SEARCH_TYPE_ALL} searchType
 * @returns {ProgramManager[]} filtered list of program managers
 */ const $2021ab152735f74a$var$filterByText = (programManagers, text, searchType)=>{
    const reg = new RegExp((0, $3da708ea9eb0f551$export$f176fecabc1d6df7)(text));
    if (searchType === (0, $53cc2e000314a49f$export$633943fdd4494e9a)) //only search fullName
    programManagers = programManagers.filter(({ fullName: fullName })=>reg.test(fullName.toLowerCase()));
    else //search everything
    programManagers = programManagers.filter(({ fullName: fullName, position: position, firstName: firstName, lastName: lastName, email: email, phoneNumbers: phoneNumbers, contracts: contracts })=>reg.test(fullName.toLowerCase()) || reg.test(position.toLowerCase()) || reg.test(firstName.toLowerCase()) || reg.test(lastName.toLowerCase()) || reg.test(email.toLowerCase()) || contracts.some(({ sewpContractNumber: sewpContractNumber })=>reg.test(sewpContractNumber.toLowerCase())) || phoneNumbers.some(({ phone: phone })=>reg.test(phone)));
    return programManagers;
};
function $2021ab152735f74a$export$2e2bcd8739ae039({ programManagers: programManagers, searchValue: searchValue, searchType: searchType, options: options }) {
    // Init state
    const [sortOption, setSortOption] = (0, $8NFma.useState)((0, $53cc2e000314a49f$export$99c6d95f8d1e53ad));
    // sort programManagers data based on sort type
    let sortedFilteredProgramManagers = programManagers.sort((0, $90eb12c1be8763cc$export$561c904c0986fb2e)[sortOption]);
    if (searchValue !== "") sortedFilteredProgramManagers = $2021ab152735f74a$var$filterByText(sortedFilteredProgramManagers, searchValue, searchType);
    sortedFilteredProgramManagers = (0, $31cf61d71defa02e$export$4fd69129e4012bac)(sortedFilteredProgramManagers, options);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
        id: "programmanagerslist",
        summary: "List of Program Managers for each Contract Holder",
        caption: "List of Program Managers for each Contract Holder",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                role: "rowgroup",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e9a5de7a4c626168$export$2e2bcd8739ae039), {
                    sortOption: sortOption,
                    setSortOption: setSortOption
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                role: "rowgroup",
                children: sortedFilteredProgramManagers.map(({ chInfoSeq: chInfoSeq, sewperContactSeq: sewperContactSeq, companyName: companyName, displayName: displayName, contracts: contracts, position: position, firstName: firstName, lastName: lastName, email: email, phoneNumbers: phoneNumbers })=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $e285a82551ed7ec6$export$2e2bcd8739ae039), {
                        chInfoSeq: chInfoSeq,
                        companyName: companyName,
                        displayName: displayName,
                        contracts: contracts,
                        position: position,
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phoneNumbers: phoneNumbers
                    }, `${chInfoSeq}-${sewperContactSeq}-${position}`))
            })
        ]
    });
}





function $bb7289fecdad5dc9$export$2e2bcd8739ae039({ setFetchError: setFetchError = ()=>{} }) {
    /** @type {[ProgramManager[], React.Dispatch<React.SetActionState<ProgramManager[]>>]} */ const [programManagers, setProgramManagers] = (0, $8NFma.useState)([]);
    /** @type {[ContractHolderGroup[], React.Dispatch<React.SetActionState<ContractHolderGroup[]>>]} */ const [contractHoldersGroups, setContractHoldersGroups] = (0, $8NFma.useState)([]);
    const [searchValue, setSearchValue] = (0, $8NFma.useState)("");
    const [searchType, setSearchType] = (0, $8NFma.useState)((0, $53cc2e000314a49f$export$633943fdd4494e9a));
    const [options, setOptions] = (0, $8NFma.useState)({
        groupOptions: {},
        otherOptions: []
    });
    (0, $8NFma.useEffect)(()=>{
        (0, $bcddd5910c38d878$export$186923dd19cf6a51)().then((programManagersData)=>{
            setProgramManagers((0, $a8e74be0f5b0ad63$export$97aad63b59591a8f)(programManagersData));
        }).catch((error)=>{
            setFetchError(error);
        });
    }, []);
    (0, $8NFma.useEffect)(()=>{
        (0, $bcddd5910c38d878$export$ca61d323fa476ae8)().then((contractHoldersGroups)=>{
            setContractHoldersGroups(contractHoldersGroups);
        }).catch((error)=>{
            setFetchError(error);
        });
    }, []);
    let content;
    if (!programManagers.length) content = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        children: "Loading Program Managers Data..."
    });
    else content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2021ab152735f74a$export$2e2bcd8739ae039), {
        programManagers: programManagers,
        searchValue: searchValue,
        searchType: searchType,
        options: options
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "container-fluid",
        id: "inner",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $b2f3bbe13af1033e$export$2e2bcd8739ae039), {
                contractHoldersGroups: contractHoldersGroups,
                options: options,
                setOptions: setOptions,
                searchType: searchType,
                setSearchType: setSearchType,
                searchValue: searchValue,
                setSearchValue: setSearchValue
            }),
            content
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


function $a19ba90b05eee952$export$2e2bcd8739ae039({ searchType: searchType, setSearchType: setSearchType, searchValue: searchValue, setSearchValue: setSearchValue }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                className: "page_title",
                role: "banner",
                tabIndex: "-1",
                children: "NASA SEWP Contract Holders - Small Business"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $eab38a03778ac033$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-sm-7",
                        title: "help text",
                        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                    children: "Select the Company Name to display the detailed information page for the specified Contract Holder."
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                    children: "Select the column heading 'Company' to sort the table by company name - select it again to reverse the sort."
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                    children: "Enter text in the search field to search within the table. Select from the radio buttons above the field to restrict your search. Select clear search to clear the search box."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8ffe95232de5408d$export$2e2bcd8739ae039), {
                        searchType: searchType,
                        setSearchType: setSearchType,
                        searchValue: searchValue,
                        setSearchValue: setSearchValue
                    })
                ]
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

function $78cb259fa393ada6$export$2e2bcd8739ae039({ chInfoSeq: chInfoSeq, fullName: fullName, displayName: displayName, contracts: contracts, businessSizes: businessSizes }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "clickable",
                role: "rowheader",
                headers: "company-head",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                    href: `#/detail/${chInfoSeq}`,
                    title: `Go to the detail page for ${displayName}`,
                    children: fullName
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                    className: "list-unstyled",
                    children: contracts.map((contract, index)=>/*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                            children: contract
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                children: (0, $3da708ea9eb0f551$export$2195adc73d2f5a2f)(businessSizes)
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


function $84638dd6cb5470a0$export$2e2bcd8739ae039({ sortOption: sortOption, setSortOption: setSortOption }) {
    const companyOnClick = ()=>sortOption === (0, $53cc2e000314a49f$export$99c6d95f8d1e53ad) ? setSortOption((0, $53cc2e000314a49f$export$1597d3d79f36bd09)) : setSortOption((0, $53cc2e000314a49f$export$99c6d95f8d1e53ad));
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                id: "company-head",
                text: "Company",
                onClick: companyOnClick,
                title: "company name",
                sortOption: sortOption,
                sortDesc: (0, $53cc2e000314a49f$export$1597d3d79f36bd09)
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                id: "company-head",
                className: "text-center",
                text: "Contract(s)"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                id: "company-head",
                className: "text-center",
                text: "Business Designation"
            })
        ]
    });
}






/**
 * Filter list of smallBusinesses by search text and search type (not case sensitive)
 * @param {Object[]} smallBusinesses
 * @param {string} text
 * @param {number} searchType
 * @returns {Object[]} filtered list of smallBusinesses
 */ const $01d486aa7f9439b2$var$filterByText = (smallBusinesses, text, searchType)=>{
    const reg = new RegExp((0, $3da708ea9eb0f551$export$f176fecabc1d6df7)(text));
    if (searchType === (0, $53cc2e000314a49f$export$633943fdd4494e9a)) //only search names
    smallBusinesses = smallBusinesses.filter(({ fullName: fullName })=>reg.test(fullName.toLowerCase()));
    else //search everything
    smallBusinesses = smallBusinesses.filter(({ fullName: fullName, businessSizes: businessSizes, contracts: contracts })=>reg.test(fullName.toLowerCase()) || contracts.some((contract)=>reg.test(contract.toLowerCase())) || reg.test(businessSizes.toLowerCase()));
    return smallBusinesses;
};
function $01d486aa7f9439b2$export$2e2bcd8739ae039({ smallBusinesses: smallBusinesses, searchValue: searchValue, searchType: searchType }) {
    // Init state
    const [sortOption, setSortOption] = (0, $8NFma.useState)((0, $53cc2e000314a49f$export$99c6d95f8d1e53ad));
    // sort smallBusinesses data based on sort type
    let sortedSmallBusinesses = smallBusinesses.sort((0, $90eb12c1be8763cc$export$561c904c0986fb2e)[sortOption]);
    if (searchValue !== "") sortedSmallBusinesses = $01d486aa7f9439b2$var$filterByText(sortedSmallBusinesses, searchValue, searchType);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
        id: "smallbusinesslist",
        summary: "List of Contract Holders that are classified as small businesses",
        caption: "List of Contract Holders that are classified as small businesses",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                role: "rowgroup",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $84638dd6cb5470a0$export$2e2bcd8739ae039), {
                    sortOption: sortOption,
                    setSortOption: setSortOption
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                role: "rowgroup",
                children: sortedSmallBusinesses.map(({ chInfoSeq: chInfoSeq, fullName: fullName, displayName: displayName, contracts: contracts, businessSizes: businessSizes })=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $78cb259fa393ada6$export$2e2bcd8739ae039), {
                        chInfoSeq: chInfoSeq,
                        fullName: fullName,
                        displayName: displayName,
                        contracts: contracts,
                        businessSizes: businessSizes
                    }, chInfoSeq))
            })
        ]
    });
}





/**
 * @typedef {import("../../../jsdoc/SmallBusiness.js").SmallBusiness} SmallBusiness
 */ /**
 * Adds a fullName field to the smallBusinesses data
 * @param {SmallBusiness[]} smallBusinesses
 * @returns {Object[]} smallBusinesses data with an added fullName attribute
 */ const $e92c23af69a0af58$var$addFullName = (smallBusinesses)=>smallBusinesses.map((smallBusiness)=>({
            ...smallBusiness,
            fullName: `${smallBusiness.companyName} (${smallBusiness.displayName})`
        }));
function $e92c23af69a0af58$export$2e2bcd8739ae039({ setFetchError: setFetchError = ()=>{} }) {
    // Init state
    const [smallBusinesses, setSmallBusinesses] = (0, $8NFma.useState)([]);
    const [searchValue, setSearchValue] = (0, $8NFma.useState)("");
    const [searchType, setSearchType] = (0, $8NFma.useState)((0, $53cc2e000314a49f$export$633943fdd4494e9a));
    // Fetch Small Business data
    (0, $8NFma.useEffect)(()=>{
        (0, $bcddd5910c38d878$export$6810f6d900bef694)().then((smallBusinessData)=>{
            setSmallBusinesses($e92c23af69a0af58$var$addFullName((0, $a8e74be0f5b0ad63$export$97aad63b59591a8f)(smallBusinessData)));
        }).catch((error)=>{
            setFetchError(error);
        });
    }, []);
    let content;
    if (!smallBusinesses.length) content = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        children: "Loading Small Businesses Data..."
    });
    else content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $01d486aa7f9439b2$export$2e2bcd8739ae039), {
        smallBusinesses: smallBusinesses,
        searchValue: searchValue,
        searchType: searchType
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "container-fluid",
        id: "inner",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a19ba90b05eee952$export$2e2bcd8739ae039), {
                searchType: searchType,
                setSearchType: setSearchType,
                searchValue: searchValue,
                setSearchValue: setSearchValue
            }),
            content
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $2cfb6f445215e2f0$export$2e2bcd8739ae039({ contractHolderCount: contractHolderCount, contractCount: contractCount }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                className: "page_title",
                role: "banner",
                tabIndex: "-1",
                children: "NASA SEWP Small Business Breakdown"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "panel-body",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-xs-12",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                            children: `Total number of Contract Holders: ${contractHolderCount}`
                        })
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "col-xs-12",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                            children: `Total number of Contracts: ${contractCount}`
                        })
                    })
                ]
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

function $4558cc3e14dd8f02$export$2e2bcd8739ae039({ category: category, group: group, groupClass: groupClass, contractHolderCount: contractHolderCount, contractCount: contractCount }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        "data-type": group,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                id: `${category}-${group}-${groupClass}`,
                role: "rowheader",
                headers: "group",
                children: group === "Total" && category !== (0, $53cc2e000314a49f$export$277e573a58a6778) ? category === (0, $53cc2e000314a49f$export$33aefca0406d6f9c) ? "Total Category 1 (Group A)" : "Total Category 2 (Groups B-D)" : group + (groupClass === null ? "" : ` - ${groupClass}`)
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                headers: `${group} ch`,
                children: contractHolderCount
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                headers: `${group} contract`,
                children: contractCount
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $c3f9f5af2d5c9131$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
        role: "rowgroup",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
            role: "row",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                    id: "group",
                    role: "columnheader",
                    children: "Group"
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                    id: "ch",
                    className: "text-center",
                    role: "columnheader",
                    children: "Contract Holders"
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                    id: "ch",
                    className: "text-center",
                    role: "columnheader",
                    children: "Contracts"
                })
            ]
        })
    });
}


function $70fad784dd0fdb8a$export$2e2bcd8739ae039({ groupCounts: groupCounts }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("table", {
        id: "Summary",
        role: "grid",
        className: "table table-bordered",
        summary: "Counts of contract holders and contracts by group",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $c3f9f5af2d5c9131$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                role: "rowgroup",
                children: groupCounts.map(({ category: category, group: group, groupClass: groupClass, contractHolderCount: contractHolderCount, contractCount: contractCount })=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $4558cc3e14dd8f02$export$2e2bcd8739ae039), {
                        category: category,
                        group: group,
                        groupClass: groupClass,
                        contractHolderCount: contractHolderCount,
                        contractCount: contractCount
                    }, `${category}${group}${groupClass}`))
            })
        ]
    });
}


function $eb4e4990725e1787$export$2e2bcd8739ae039({ groupCounts: groupCounts }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "panel panel-primary table-responsive",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "panel-heading text-center",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                    children: "Contract Holder/Contracts Summary"
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "panel-body",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $70fad784dd0fdb8a$export$2e2bcd8739ae039), {
                    groupCounts: groupCounts
                })
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $ec7b5f603a895a0e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("thead", {
        role: "rowgroup",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                role: "row",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        id: "group2",
                        role: "columnheader",
                        rowSpan: "2",
                        children: "Business Size Designation"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        id: "cat1",
                        className: "text-center",
                        role: "columnheader",
                        colSpan: "2",
                        children: "Category 1 (Group A)"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        id: "cat2",
                        className: "text-center",
                        role: "columnheader",
                        colSpan: "2",
                        children: "Category 2 (Groups B-D)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                role: "row",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        id: "ch1",
                        className: "text-center",
                        role: "columnheader",
                        children: "Contract Holders"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        id: "contract1",
                        className: "text-center",
                        role: "columnheader",
                        children: "Contracts"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        id: "ch2",
                        className: "text-center",
                        role: "columnheader",
                        children: "Contract Holders"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        id: "contract2",
                        className: "text-center",
                        role: "columnheader",
                        children: "Contracts"
                    })
                ]
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $ba4ae77d244465af$export$2e2bcd8739ae039({ group: group, groupsData: groupsData }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        "data-type": group,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                id: group,
                children: group
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                headers: "ch",
                children: groupsData.chsA
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                headers: "contract",
                children: groupsData.contractsA
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                headers: "ch",
                children: groupsData.chsB
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                headers: "contract",
                children: groupsData.contractsB
            })
        ]
    });
}


// Helper functions for BusinessBreakdown.jsx

const $8c81ef0a2d3779fd$export$873774e2e12a4123 = (groupCounts)=>{
    const { contractCount: contractCount, contractHolderCount: contractHolderCount } = groupCounts.find((group)=>group.category === (0, $53cc2e000314a49f$export$277e573a58a6778));
    return {
        contractCount: contractCount,
        contractHolderCount: contractHolderCount
    };
};
const $8c81ef0a2d3779fd$export$fdfc5f79f8a90592 = (businessSizeCounts)=>{
    const groupData = {
        [(0, $53cc2e000314a49f$export$7c348a803745d78e)]: {},
        [(0, $53cc2e000314a49f$export$3bcd420ba04975ee)]: {},
        [(0, $53cc2e000314a49f$export$b1e026515d1d95eb)]: {},
        [(0, $53cc2e000314a49f$export$b857b8c49d989e3d)]: {},
        [(0, $53cc2e000314a49f$export$bf642b3f485bd68d)]: {},
        [(0, $53cc2e000314a49f$export$1631de6f5ca5af24)]: {},
        [(0, $53cc2e000314a49f$export$f1e0d6d47dca11c2)]: {},
        [(0, $53cc2e000314a49f$export$c1ca7e6bbbf87d26)]: {}
    };
    businessSizeCounts.forEach(({ category: category, businessSize: businessSize, contractHolderCount: contractHolderCount, contractCount: contractCount })=>{
        if (category === (0, $53cc2e000314a49f$export$33aefca0406d6f9c)) {
            groupData[[
                businessSize
            ]].chsA = contractHolderCount;
            groupData[[
                businessSize
            ]].contractsA = contractCount;
        } else if (category === (0, $53cc2e000314a49f$export$b64db5ccea72c387)) {
            groupData[[
                businessSize
            ]].chsB = contractHolderCount;
            groupData[[
                businessSize
            ]].contractsB = contractCount;
        }
    });
    return groupData;
};



function $54029d23331506d1$export$2e2bcd8739ae039({ businessSizeCounts: businessSizeCounts }) {
    const [groupsData, setGroupData] = (0, $8NFma.useState)(null);
    (0, $8NFma.useEffect)(()=>{
        setGroupData((0, $8c81ef0a2d3779fd$export$fdfc5f79f8a90592)(businessSizeCounts));
    }, []);
    if (groupsData) return /*#__PURE__*/ (0, $1IdZj.jsxs)("table", {
        id: "Summary2",
        role: "grid",
        className: "table table-bordered",
        summary: "Counts of contract holders and contracts by business size",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ec7b5f603a895a0e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("tbody", {
                role: "rowgroup",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba4ae77d244465af$export$2e2bcd8739ae039), {
                        group: (0, $53cc2e000314a49f$export$b857b8c49d989e3d),
                        groupsData: groupsData[0, $53cc2e000314a49f$export$b857b8c49d989e3d]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba4ae77d244465af$export$2e2bcd8739ae039), {
                        group: (0, $53cc2e000314a49f$export$3bcd420ba04975ee),
                        groupsData: groupsData[0, $53cc2e000314a49f$export$3bcd420ba04975ee]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba4ae77d244465af$export$2e2bcd8739ae039), {
                        group: (0, $53cc2e000314a49f$export$f1e0d6d47dca11c2),
                        groupsData: groupsData[0, $53cc2e000314a49f$export$f1e0d6d47dca11c2]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba4ae77d244465af$export$2e2bcd8739ae039), {
                        group: (0, $53cc2e000314a49f$export$b1e026515d1d95eb),
                        groupsData: groupsData[0, $53cc2e000314a49f$export$b1e026515d1d95eb]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba4ae77d244465af$export$2e2bcd8739ae039), {
                        group: (0, $53cc2e000314a49f$export$1631de6f5ca5af24),
                        groupsData: groupsData[0, $53cc2e000314a49f$export$1631de6f5ca5af24]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba4ae77d244465af$export$2e2bcd8739ae039), {
                        group: (0, $53cc2e000314a49f$export$bf642b3f485bd68d),
                        groupsData: groupsData[0, $53cc2e000314a49f$export$bf642b3f485bd68d]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba4ae77d244465af$export$2e2bcd8739ae039), {
                        group: (0, $53cc2e000314a49f$export$7c348a803745d78e),
                        groupsData: groupsData[0, $53cc2e000314a49f$export$7c348a803745d78e]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba4ae77d244465af$export$2e2bcd8739ae039), {
                        group: (0, $53cc2e000314a49f$export$c1ca7e6bbbf87d26),
                        groupsData: groupsData[0, $53cc2e000314a49f$export$c1ca7e6bbbf87d26]
                    })
                ]
            })
        ]
    });
}


function $df64008ef0f485c5$export$2e2bcd8739ae039({ businessSizeCounts: businessSizeCounts }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "panel panel-primary table-responsive",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "panel-heading text-center",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                    children: "Business Size Set-aside Designation Breakdown"
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "panel-body",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $54029d23331506d1$export$2e2bcd8739ae039), {
                    businessSizeCounts: businessSizeCounts
                })
            })
        ]
    });
}




function $7932cafa4cd836e8$export$2e2bcd8739ae039({ setFetchError: setFetchError = ()=>{} }) {
    /** @type {[GroupCount[], React.Dispatch<React.SetActionState<GroupCount[]>>]} */ const [groupCounts, setGroupCounts] = (0, $8NFma.useState)([]);
    /** @type {[BusinessSizeCount[], React.Dispatch<React.SetActionState<BusinessSizeCount[]>>]} */ const [businessSizeCounts, setBusinessSizeCounts] = (0, $8NFma.useState)([]);
    /** @type {[{contractCount: number, contractHolderCount: number}?, React.Dispatch<React.SetActionState<{contractCount: number, contractHolderCount: number}>>]} */ const [contractCounts, setContractCounts] = (0, $8NFma.useState)({});
    (0, $8NFma.useEffect)(()=>{
        (0, $bcddd5910c38d878$export$5a5e822ad28a37c5)().then((groupCountData)=>{
            setContractCounts((0, $8c81ef0a2d3779fd$export$873774e2e12a4123)(groupCountData));
            setGroupCounts(groupCountData);
        }).catch((error)=>{
            setFetchError(error);
        });
    }, []);
    (0, $8NFma.useEffect)(()=>{
        (0, $bcddd5910c38d878$export$5eae1f219b7ca1ee)().then((businessSizeCountsData)=>{
            setBusinessSizeCounts(businessSizeCountsData);
        }).catch((error)=>{
            setFetchError(error);
        });
    }, []);
    if (businessSizeCounts.length > 0 && groupCounts.length > 0) return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "container-fluid",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2cfb6f445215e2f0$export$2e2bcd8739ae039), {
                contractHolderCount: contractCounts.contractHolderCount,
                contractCount: contractCounts.contractCount
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eb4e4990725e1787$export$2e2bcd8739ae039), {
                groupCounts: groupCounts
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $df64008ef0f485c5$export$2e2bcd8739ae039), {
                businessSizeCounts: businessSizeCounts
            })
        ]
    });
    else return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "container-fluid",
        children: "Loading Small Business Breakdown."
    });
}





function $7341fa3ebc5e1557$export$2e2bcd8739ae039() {
    const [path, setPath] = (0, $8NFma.useState)(window.location.hash);
    const [fetchError, setFetchError] = (0, $8NFma.useState)(false);
    //listen for hash changes to update path state
    (0, $8NFma.useEffect)(()=>{
        window.onhashchange = ()=>{
            setPath(window.location.hash);
        };
    }, []);
    //update document title
    (0, $8NFma.useEffect)(()=>{
        const { type: type } = (0, $3be763ee166b6d84$export$ab4ae02812b15a92)(path);
        // detail page title updates is handled in ContractHoldersDetails.jsx b/c CH name is needed
        switch(type){
            case 0, $53cc2e000314a49f$export$bc65c5f8ae8c9619:
                document.title = "NASA SEWP Contract Holders";
                break;
            case 0, $53cc2e000314a49f$export$d4daa26c757f8f98:
                document.title = "NASA SEWP Contract Holders - Program Managers";
                break;
            case 0, $53cc2e000314a49f$export$1ac8347527ea5cf5:
                document.title = "NASA SEWP Contract Holders - Small Businesses";
                break;
            case 0, $53cc2e000314a49f$export$3dbfd7c861adfb40:
                document.title = "NASA SEWP Contract Holders - Small Business Breakdown";
                break;
        }
    }, [
        path
    ]);
    const display = (0, $3be763ee166b6d84$export$ab4ae02812b15a92)(path);
    let content;
    if (fetchError) content = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        children: "Error loading data."
    });
    else if (display.type === (0, $53cc2e000314a49f$export$c62e1e68e9b129bf)) content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $29bead830478217e$export$2e2bcd8739ae039), {
        path: path,
        setFetchError: setFetchError
    });
    else if (display.type === (0, $53cc2e000314a49f$export$bc65c5f8ae8c9619)) content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $b14d2a971c83530e$export$2e2bcd8739ae039), {
        setFetchError: setFetchError
    });
    else if (display.type === (0, $53cc2e000314a49f$export$d4daa26c757f8f98)) content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bb7289fecdad5dc9$export$2e2bcd8739ae039), {
        setFetchError: setFetchError
    });
    else if (display.type === (0, $53cc2e000314a49f$export$1ac8347527ea5cf5)) content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e92c23af69a0af58$export$2e2bcd8739ae039), {
        setFetchError: setFetchError
    });
    else if (display.type === (0, $53cc2e000314a49f$export$3dbfd7c861adfb40)) content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7932cafa4cd836e8$export$2e2bcd8739ae039), {
        setFetchError: setFetchError
    });
    else content = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        children: "Page not found."
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        id: "contract-holders-wrapper",
        className: "container-fluid",
        children: content
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");
function $43a8155ee96f9f52$export$2e2bcd8739ae039({ blurred: blurred }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: blurred ? "blurred" : "",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                children: "The Federal Risk and Authorization Management Program (FedRAMP) is a government-wide program that provides a standardized approach to security assessment, authorization, and continuous monitoring for cloud products and services."
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                    href: "https://www.fedramp.gov/",
                    target: "_blank",
                    children: "https://www.fedramp.gov/"
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                children: "Disclaimer:"
            }),
            "The listing below is for general information \u2013 it is not updated in \u201Creal-time\u201D. It should be viewed as an overview to provide guidance on SEWP products identified as FedRAMP compliant. Please use the QRT tool and indicate which products need to be FedRAMP certified in your attachments and/or enter the requirements in the Summary text box.",
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {})
        ]
    });
}
$43a8155ee96f9f52$export$2e2bcd8739ae039.propTypes = {
    blurred: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired
};



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

function $ed66b1318d0410ff$export$2e2bcd8739ae039({ id: id, className: className, onClick: onClick, title: title, children: children }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        role: "button",
        id: id,
        className: className,
        title: title,
        onClick: onClick,
        tabIndex: 0,
        onKeyDown: (event)=>{
            if (event.key === (0, $53cc2e000314a49f$export$ddffaa7057c7de39)) onClick(event);
        },
        children: children
    });
}
$ed66b1318d0410ff$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node
};


function $a7fb2f270a33e1a3$export$2e2bcd8739ae039({ searchFilter: searchFilter, setSearchFilter: setSearchFilter, searchText: searchText, setSearchText: setSearchText }) {
    /**
   * @param {React.ChangeEvent<HTMLInputElement>} event
   */ function handleFilterChange(event) {
        setSearchFilter(event.target.value);
    }
    /**
   * @param {React.KeyboardEvent<HTMLInputElement>} event
   */ function handleSearchInputChange(event) {
        setSearchText(event.target.value);
    }
    /**
   * @param {React.MouseEvent<HTMLAnchorElement>} event
   */ function handleSearchClear(event) {
        //TODO focus on textbox
        setSearchFilter("Product");
        setSearchText("");
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
        className: "fieldSet",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("legend", {
                className: "legendOfFieldSet",
                children: "Search"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "To search for a product, select the Product radio button and enter all or part of the product name."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "To search for a provider, select the Provider radio button and enter all or part of the Provider's name."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "To search all data within the table, select the All radio button and enter all or part of your search criteria."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "To clear your search and start over, select Clear Search."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("hr", {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "filterOptionsWrapper",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        type: "radio",
                        name: "RadioBtn",
                        value: "Product",
                        checked: searchFilter === "Product",
                        id: "firstRadioBtn",
                        className: "searchModuleRadio",
                        onChange: handleFilterChange
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                        style: {
                            fontWeight: "normal",
                            margin: 0
                        },
                        id: "product",
                        htmlFor: "firstRadioBtn",
                        children: "Product"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        type: "radio",
                        name: "RadioBtn",
                        value: "Provider",
                        className: "searchModuleRadio",
                        id: "provider",
                        onChange: handleFilterChange,
                        checked: searchFilter === "Provider"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                        style: {
                            fontWeight: "normal",
                            margin: 0
                        },
                        htmlFor: "provider",
                        children: "Provider"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        type: "radio",
                        name: "RadioBtn",
                        value: "All",
                        className: "searchModuleRadio",
                        id: "all",
                        onChange: handleFilterChange,
                        checked: searchFilter === "All"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                        style: {
                            fontWeight: "normal",
                            margin: 0
                        },
                        htmlFor: "all",
                        children: "All"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                        className: "glyphicon glyphicon-search"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        type: "text",
                        id: "fedRampSearchBox",
                        onChange: handleSearchInputChange,
                        placeholder: "Product Search...",
                        "aria-label": "Product Search",
                        title: "Type in a product name",
                        value: searchText
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ed66b1318d0410ff$export$2e2bcd8739ae039), {
                        className: "clickable",
                        onClick: handleSearchClear,
                        children: "Clear Search"
                    })
                ]
            })
        ]
    });
}
$a7fb2f270a33e1a3$export$2e2bcd8739ae039.propTypes = {
    searchFilter: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    setSearchFilter: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    searchText: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    setSearchText: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};


function $b1d84336a1132a96$export$2e2bcd8739ae039({ isLoggedIn: isLoggedIn, searchFilter: searchFilter, setSearchFilter: setSearchFilter, searchText: searchText, setSearchText: setSearchText, hoverModal: hoverModal, blurred: blurred }) {
    const videoRef = (0, $8NFma.useRef)(null);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                className: `page_title${blurred ? " blurred" : ""}`,
                children: "FedRAMP"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $43a8155ee96f9f52$export$2e2bcd8739ae039), {
                blurred: blurred
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: `headerOptionsWrapper${blurred ? " blurred" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        id: "notesDiv",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                    children: "Notes:"
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: "To view Product details - select a Product name."
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: "To view Provider details - select a Provider name"
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: "For a list of Agency Authorizations that have authorized a product as FedRAMP compliant on the SEWP contract - select the \u201CDetails\u201D link."
                                    }),
                                    isLoggedIn && /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                            children: "For a list of Contract Holders that have indicated FedRAMP compliant products for a Provider - select a Contract Holder number."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: "To sort any column in ascending or descending order, select the up or down arrows next to the column heading."
                                    }),
                                    !isLoggedIn && /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                        children: [
                                            "Government Customers may ",
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                                href: "security/login/fedramp?from=/sewp5public/fedramp",
                                                children: "Login"
                                            }),
                                            " to view additional product details."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a7fb2f270a33e1a3$export$2e2bcd8739ae039), {
                        searchFilter: searchFilter,
                        setSearchFilter: setSearchFilter,
                        searchText: searchText,
                        setSearchText: setSearchText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                id: "fedRampVideo",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("a", {
                        className: "FEDRAMP",
                        target: "_blank",
                        href: "/documents/FEDRAMP.mp4",
                        ref: videoRef,
                        onClick: (event)=>{
                            event.preventDefault();
                            videoPlayerHandler(videoRef.current);
                        },
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                                src: "/images/PLAY_50px.png",
                                alt: "PLAY"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                            "Watch our clip explaining FedRAMP!"
                        ]
                    }),
                    hoverModal
                ]
            })
        ]
    });
}
$b1d84336a1132a96$export$2e2bcd8739ae039.propTypes = {
    isLoggedIn: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired,
    searchFilter: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    setSearchFilter: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    searchText: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    setSearchText: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    hoverModal: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).element,
    blurred: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired
};



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");

var $8NFma = parcelRequire("8NFma");
'use client';
/**
 * @ignore - internal component.
 */ const $3fb7aab04cb03de5$var$TableContext = /*#__PURE__*/ $8NFma.createContext();
var $3fb7aab04cb03de5$export$2e2bcd8739ae039 = $3fb7aab04cb03de5$var$TableContext;



var $aBf7M = parcelRequire("aBf7M");

var $32Puv = parcelRequire("32Puv");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $e1cdbdb795513020$export$315cb19215f77ce0(slot) {
    return (0, $guzMP.default)('MuiTable', slot);
}
const $e1cdbdb795513020$var$tableClasses = (0, $bnCUV.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $e1cdbdb795513020$export$2e2bcd8739ae039 = $e1cdbdb795513020$var$tableClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $9f1c958b2294e384$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $9f1c958b2294e384$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $e1cdbdb795513020$export$315cb19215f77ce0), classes);
};
const $9f1c958b2294e384$var$TableRoot = (0, $32Puv.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $jz4iA.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $9f1c958b2294e384$var$defaultComponent = 'table';
const $9f1c958b2294e384$var$Table = /*#__PURE__*/ $8NFma.forwardRef(function Table(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $9f1c958b2294e384$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $hQtye.default)(props, $9f1c958b2294e384$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $9f1c958b2294e384$var$useUtilityClasses(ownerState);
    const table = $8NFma.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3fb7aab04cb03de5$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)($9f1c958b2294e384$var$TableRoot, (0, $jz4iA.default)({
            as: component,
            role: component === $9f1c958b2294e384$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $ase04.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $9f1c958b2294e384$export$2e2bcd8739ae039 = $9f1c958b2294e384$var$Table;



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");

var $8NFma = parcelRequire("8NFma");
/**
 * @ignore - internal component.
 */ const $e69ddb0e5ef8a221$var$Tablelvl2Context = /*#__PURE__*/ $8NFma.createContext();
var $e69ddb0e5ef8a221$export$2e2bcd8739ae039 = $e69ddb0e5ef8a221$var$Tablelvl2Context;



var $aBf7M = parcelRequire("aBf7M");

var $32Puv = parcelRequire("32Puv");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $c0ec2189b802c8b7$export$98bd2a9b566ec665(slot) {
    return (0, $guzMP.default)('MuiTableBody', slot);
}
const $c0ec2189b802c8b7$var$tableBodyClasses = (0, $bnCUV.default)('MuiTableBody', [
    'root'
]);
var $c0ec2189b802c8b7$export$2e2bcd8739ae039 = $c0ec2189b802c8b7$var$tableBodyClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $2903d7170089040e$var$_excluded = [
    "className",
    "component"
];
const $2903d7170089040e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $c0ec2189b802c8b7$export$98bd2a9b566ec665), classes);
};
const $2903d7170089040e$var$TableBodyRoot = (0, $32Puv.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $2903d7170089040e$var$tablelvl2 = {
    variant: 'body'
};
const $2903d7170089040e$var$defaultComponent = 'tbody';
const $2903d7170089040e$var$TableBody = /*#__PURE__*/ $8NFma.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $2903d7170089040e$var$defaultComponent } = props, other = (0, $hQtye.default)(props, $2903d7170089040e$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        component: component
    });
    const classes = $2903d7170089040e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e69ddb0e5ef8a221$export$2e2bcd8739ae039).Provider, {
        value: $2903d7170089040e$var$tablelvl2,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)($2903d7170089040e$var$TableBodyRoot, (0, $jz4iA.default)({
            className: (0, $ase04.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $2903d7170089040e$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $2903d7170089040e$export$2e2bcd8739ae039 = $2903d7170089040e$var$TableBody;



var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");

var $jJYy4 = parcelRequire("jJYy4");

var $fzbVi = parcelRequire("fzbVi");



var $aBf7M = parcelRequire("aBf7M");

var $32Puv = parcelRequire("32Puv");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $fb59094c24aa0d71$export$33a0f07a16a10b1b(slot) {
    return (0, $guzMP.default)('MuiTableCell', slot);
}
const $fb59094c24aa0d71$var$tableCellClasses = (0, $bnCUV.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $fb59094c24aa0d71$export$2e2bcd8739ae039 = $fb59094c24aa0d71$var$tableCellClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $c76f5609e6b96f5a$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $c76f5609e6b96f5a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $fzbVi.default)(align)}`,
            padding !== 'normal' && `padding${(0, $fzbVi.default)(padding)}`,
            `size${(0, $fzbVi.default)(size)}`
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $fb59094c24aa0d71$export$33a0f07a16a10b1b), classes);
};
const $c76f5609e6b96f5a$var$TableCellRoot = (0, $32Puv.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $fzbVi.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $fzbVi.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $fzbVi.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $jJYy4.lighten)((0, $jJYy4.alpha)(theme.palette.divider, 1), 0.88) : (0, $jJYy4.darken)((0, $jJYy4.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $fb59094c24aa0d71$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $c76f5609e6b96f5a$var$TableCell = /*#__PURE__*/ $8NFma.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $hQtye.default)(props, $c76f5609e6b96f5a$var$_excluded);
    const table = $8NFma.useContext((0, $3fb7aab04cb03de5$export$2e2bcd8739ae039));
    const tablelvl2 = $8NFma.useContext((0, $e69ddb0e5ef8a221$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $jz4iA.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $c76f5609e6b96f5a$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $1IdZj.jsx)($c76f5609e6b96f5a$var$TableCellRoot, (0, $jz4iA.default)({
        as: component,
        ref: ref,
        className: (0, $ase04.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $c76f5609e6b96f5a$export$2e2bcd8739ae039 = $c76f5609e6b96f5a$var$TableCell;



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");


var $aBf7M = parcelRequire("aBf7M");

var $32Puv = parcelRequire("32Puv");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $80267700e7481d6c$export$2e731cea2d1c2392(slot) {
    return (0, $guzMP.default)('MuiTableHead', slot);
}
const $80267700e7481d6c$var$tableHeadClasses = (0, $bnCUV.default)('MuiTableHead', [
    'root'
]);
var $80267700e7481d6c$export$2e2bcd8739ae039 = $80267700e7481d6c$var$tableHeadClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $edfbea0634c21546$var$_excluded = [
    "className",
    "component"
];
const $edfbea0634c21546$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $80267700e7481d6c$export$2e731cea2d1c2392), classes);
};
const $edfbea0634c21546$var$TableHeadRoot = (0, $32Puv.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $edfbea0634c21546$var$tablelvl2 = {
    variant: 'head'
};
const $edfbea0634c21546$var$defaultComponent = 'thead';
const $edfbea0634c21546$var$TableHead = /*#__PURE__*/ $8NFma.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $edfbea0634c21546$var$defaultComponent } = props, other = (0, $hQtye.default)(props, $edfbea0634c21546$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        component: component
    });
    const classes = $edfbea0634c21546$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e69ddb0e5ef8a221$export$2e2bcd8739ae039).Provider, {
        value: $edfbea0634c21546$var$tablelvl2,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)($edfbea0634c21546$var$TableHeadRoot, (0, $jz4iA.default)({
            as: component,
            className: (0, $ase04.default)(classes.root, className),
            ref: ref,
            role: component === $edfbea0634c21546$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $edfbea0634c21546$export$2e2bcd8739ae039 = $edfbea0634c21546$var$TableHead;



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");

var $jJYy4 = parcelRequire("jJYy4");


var $aBf7M = parcelRequire("aBf7M");

var $32Puv = parcelRequire("32Puv");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $ff367b2c517aebb7$export$ba0a6d6c28940107(slot) {
    return (0, $guzMP.default)('MuiTableRow', slot);
}
const $ff367b2c517aebb7$var$tableRowClasses = (0, $bnCUV.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $ff367b2c517aebb7$export$2e2bcd8739ae039 = $ff367b2c517aebb7$var$tableRowClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $4811e46d7a2ffb1b$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $4811e46d7a2ffb1b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $ff367b2c517aebb7$export$ba0a6d6c28940107), classes);
};
const $4811e46d7a2ffb1b$var$TableRowRoot = (0, $32Puv.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $ff367b2c517aebb7$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $ff367b2c517aebb7$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $jJYy4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $jJYy4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $4811e46d7a2ffb1b$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $4811e46d7a2ffb1b$var$TableRow = /*#__PURE__*/ $8NFma.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $4811e46d7a2ffb1b$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $hQtye.default)(props, $4811e46d7a2ffb1b$var$_excluded);
    const tablelvl2 = $8NFma.useContext((0, $e69ddb0e5ef8a221$export$2e2bcd8739ae039));
    const ownerState = (0, $jz4iA.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $4811e46d7a2ffb1b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($4811e46d7a2ffb1b$var$TableRowRoot, (0, $jz4iA.default)({
        as: component,
        ref: ref,
        className: (0, $ase04.default)(classes.root, className),
        role: component === $4811e46d7a2ffb1b$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $4811e46d7a2ffb1b$export$2e2bcd8739ae039 = $4811e46d7a2ffb1b$var$TableRow;



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $2jLNc = parcelRequire("2jLNc");

var $ase04 = parcelRequire("ase04");


var $8NFma = parcelRequire("8NFma");

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");



var $2jLNc = parcelRequire("2jLNc");

var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");

var $8NFma = parcelRequire("8NFma");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $d4b20d6f9c62ec15$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $ab5db80457248826$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $8NFma.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $d4b20d6f9c62ec15$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $ebfa8c86b352582b$export$2e2bcd8739ae039 = (0, $ab5db80457248826$export$2e2bcd8739ae039);



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $2e091165f4c6c9c8$var$useEnhancedEffect = typeof window !== 'undefined' ? $8NFma.useLayoutEffect : $8NFma.useEffect;
var $2e091165f4c6c9c8$export$2e2bcd8739ae039 = $2e091165f4c6c9c8$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $6f8092f41eb661ae$var$useEventCallback(fn) {
    const ref = $8NFma.useRef(fn);
    (0, $2e091165f4c6c9c8$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $8NFma.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $6f8092f41eb661ae$export$2e2bcd8739ae039 = $6f8092f41eb661ae$var$useEventCallback;


'use client';
var $121b4ee3832af90d$export$2e2bcd8739ae039 = (0, $6f8092f41eb661ae$export$2e2bcd8739ae039);



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
'use client';
const $0446be6981d5b2cf$var$UNINITIALIZED = {};
function $0446be6981d5b2cf$export$2e2bcd8739ae039(init, initArg) {
    const ref = $8NFma.useRef($0446be6981d5b2cf$var$UNINITIALIZED);
    if (ref.current === $0446be6981d5b2cf$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $8NFma = parcelRequire("8NFma");
'use client';
const $f1941674d8bceec9$var$EMPTY = [];
function $f1941674d8bceec9$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $8NFma.useEffect(fn, $f1941674d8bceec9$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $6059c91578438ade$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $6059c91578438ade$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $6059c91578438ade$export$2e2bcd8739ae039() {
    const timeout = (0, $0446be6981d5b2cf$export$2e2bcd8739ae039)($6059c91578438ade$export$786b4da70f00938b.create).current;
    (0, $f1941674d8bceec9$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $ff7925d463489aa5$var$hadKeyboardEvent = true;
let $ff7925d463489aa5$var$hadFocusVisibleRecently = false;
const $ff7925d463489aa5$var$hadFocusVisibleRecentlyTimeout = new (0, $6059c91578438ade$export$786b4da70f00938b)();
const $ff7925d463489aa5$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $ff7925d463489aa5$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $ff7925d463489aa5$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $ff7925d463489aa5$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $ff7925d463489aa5$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $ff7925d463489aa5$var$handlePointerDown() {
    $ff7925d463489aa5$var$hadKeyboardEvent = false;
}
function $ff7925d463489aa5$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($ff7925d463489aa5$var$hadFocusVisibleRecently) $ff7925d463489aa5$var$hadKeyboardEvent = true;
    }
}
function $ff7925d463489aa5$var$prepare(doc) {
    doc.addEventListener('keydown', $ff7925d463489aa5$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $ff7925d463489aa5$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $ff7925d463489aa5$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $ff7925d463489aa5$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $ff7925d463489aa5$var$handleVisibilityChange, true);
}
function $ff7925d463489aa5$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $ff7925d463489aa5$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $ff7925d463489aa5$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $ff7925d463489aa5$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $ff7925d463489aa5$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $ff7925d463489aa5$var$handleVisibilityChange, true);
}
function $ff7925d463489aa5$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $ff7925d463489aa5$var$hadKeyboardEvent || $ff7925d463489aa5$var$focusTriggersKeyboardModality(target);
}
function $ff7925d463489aa5$export$2e2bcd8739ae039() {
    const ref = $8NFma.useCallback((node)=>{
        if (node != null) $ff7925d463489aa5$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $8NFma.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $ff7925d463489aa5$var$hadFocusVisibleRecently = true;
            $ff7925d463489aa5$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $ff7925d463489aa5$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($ff7925d463489aa5$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $92373e9d662618e2$export$2e2bcd8739ae039 = (0, $ff7925d463489aa5$export$2e2bcd8739ae039);



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");


var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");
function $1054abeafa6bc7e1$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $40f4c2feb843f2da$export$2e2bcd8739ae039(t, e) {
    return $40f4c2feb843f2da$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $40f4c2feb843f2da$export$2e2bcd8739ae039(t, e);
}


function $c04286edcac4109a$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $40f4c2feb843f2da$export$2e2bcd8739ae039)(t, o);
}




var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
var $4b9cff7e01ef990e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(null);



var $8NFma = parcelRequire("8NFma");
function $c5fe8fc78c4704a1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $8NFma.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $8NFma.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $c5fe8fc78c4704a1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $c5fe8fc78c4704a1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $c5fe8fc78c4704a1$export$fa71e2345c31d7a2(props, onExited) {
    return $c5fe8fc78c4704a1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $8NFma.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $c5fe8fc78c4704a1$var$getProp(child, 'appear', props),
            enter: $c5fe8fc78c4704a1$var$getProp(child, 'enter', props),
            exit: $c5fe8fc78c4704a1$var$getProp(child, 'exit', props)
        });
    });
}
function $c5fe8fc78c4704a1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $c5fe8fc78c4704a1$export$bbc8a025727ea824(nextProps.children);
    var children = $c5fe8fc78c4704a1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $8NFma.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $8NFma.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $8NFma.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $c5fe8fc78c4704a1$var$getProp(child, 'exit', nextProps),
            enter: $c5fe8fc78c4704a1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $8NFma.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $8NFma.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $8NFma.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $c5fe8fc78c4704a1$var$getProp(child, 'exit', nextProps),
            enter: $c5fe8fc78c4704a1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $bc975070b4f3fc58$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $bc975070b4f3fc58$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $bc975070b4f3fc58$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $c04286edcac4109a$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $1054abeafa6bc7e1$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $c5fe8fc78c4704a1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $c5fe8fc78c4704a1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $c5fe8fc78c4704a1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $jz4iA.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $hQtye.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $bc975070b4f3fc58$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $4b9cff7e01ef990e$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $4b9cff7e01ef990e$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$bc975070b4f3fc58$var$TransitionGroup.propTypes = {};
$bc975070b4f3fc58$var$TransitionGroup.defaultProps = $bc975070b4f3fc58$var$defaultProps;
var $bc975070b4f3fc58$export$2e2bcd8739ae039 = $bc975070b4f3fc58$var$TransitionGroup;



var $ase04 = parcelRequire("ase04");

var $9XmJK = parcelRequire("9XmJK");


var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $519ba9bc5a9ff913$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $8NFma.useState(false);
    const rippleClassName = (0, $ase04.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $ase04.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $8NFma.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
            className: childClassName
        })
    });
}
var $519ba9bc5a9ff913$export$2e2bcd8739ae039 = $519ba9bc5a9ff913$var$Ripple;



var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $35063acec76d9b9b$export$b464606f735ab902(slot) {
    return (0, $guzMP.default)('MuiTouchRipple', slot);
}
const $35063acec76d9b9b$var$touchRippleClasses = (0, $bnCUV.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $35063acec76d9b9b$export$2e2bcd8739ae039 = $35063acec76d9b9b$var$touchRippleClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $b69aeaa96fee2ed8$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $b69aeaa96fee2ed8$var$_ = (t)=>t, $b69aeaa96fee2ed8$var$_t, $b69aeaa96fee2ed8$var$_t2, $b69aeaa96fee2ed8$var$_t3, $b69aeaa96fee2ed8$var$_t4;
const $b69aeaa96fee2ed8$var$DURATION = 550;
const $b69aeaa96fee2ed8$export$95d0c9356b2231a3 = 80;
const $b69aeaa96fee2ed8$var$enterKeyframe = (0, $9XmJK.keyframes)($b69aeaa96fee2ed8$var$_t || ($b69aeaa96fee2ed8$var$_t = $b69aeaa96fee2ed8$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $b69aeaa96fee2ed8$var$exitKeyframe = (0, $9XmJK.keyframes)($b69aeaa96fee2ed8$var$_t2 || ($b69aeaa96fee2ed8$var$_t2 = $b69aeaa96fee2ed8$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $b69aeaa96fee2ed8$var$pulsateKeyframe = (0, $9XmJK.keyframes)($b69aeaa96fee2ed8$var$_t3 || ($b69aeaa96fee2ed8$var$_t3 = $b69aeaa96fee2ed8$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $b69aeaa96fee2ed8$export$f6b7418508c72c25 = (0, $32Puv.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $b69aeaa96fee2ed8$export$676cfe7b12693c4b = (0, $32Puv.default)((0, $519ba9bc5a9ff913$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($b69aeaa96fee2ed8$var$_t4 || ($b69aeaa96fee2ed8$var$_t4 = $b69aeaa96fee2ed8$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $35063acec76d9b9b$export$2e2bcd8739ae039).rippleVisible, $b69aeaa96fee2ed8$var$enterKeyframe, $b69aeaa96fee2ed8$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).child, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).childLeaving, $b69aeaa96fee2ed8$var$exitKeyframe, $b69aeaa96fee2ed8$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).childPulsate, $b69aeaa96fee2ed8$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $b69aeaa96fee2ed8$var$TouchRipple = /*#__PURE__*/ $8NFma.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $hQtye.default)(props, $b69aeaa96fee2ed8$var$_excluded);
    const [ripples, setRipples] = $8NFma.useState([]);
    const nextKey = $8NFma.useRef(0);
    const rippleCallback = $8NFma.useRef(null);
    $8NFma.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $8NFma.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $6059c91578438ade$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $8NFma.useRef(null);
    const container = $8NFma.useRef(null);
    const startCommit = $8NFma.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $1IdZj.jsx)($b69aeaa96fee2ed8$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $ase04.default)(classes.ripple, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $ase04.default)(classes.rippleVisible, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $ase04.default)(classes.ripplePulsate, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $ase04.default)(classes.child, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $ase04.default)(classes.childLeaving, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $ase04.default)(classes.childPulsate, (0, $35063acec76d9b9b$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $b69aeaa96fee2ed8$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $8NFma.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($b69aeaa96fee2ed8$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $8NFma.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $8NFma.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $8NFma.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($b69aeaa96fee2ed8$export$f6b7418508c72c25, (0, $jz4iA.default)({
        className: (0, $ase04.default)((0, $35063acec76d9b9b$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bc975070b4f3fc58$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $b69aeaa96fee2ed8$export$2e2bcd8739ae039 = $b69aeaa96fee2ed8$var$TouchRipple;



var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $cbe18475cf60491e$export$fccb0498dcd99783(slot) {
    return (0, $guzMP.default)('MuiButtonBase', slot);
}
const $cbe18475cf60491e$var$buttonBaseClasses = (0, $bnCUV.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $cbe18475cf60491e$export$2e2bcd8739ae039 = $cbe18475cf60491e$var$buttonBaseClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $6d674dfb4ea8dd71$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $6d674dfb4ea8dd71$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $2jLNc.default)(slots, (0, $cbe18475cf60491e$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $6d674dfb4ea8dd71$export$7ec0dcc5e3cdcd36 = (0, $32Puv.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $cbe18475cf60491e$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $6d674dfb4ea8dd71$var$ButtonBase = /*#__PURE__*/ $8NFma.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $hQtye.default)(props, $6d674dfb4ea8dd71$var$_excluded);
    const buttonRef = $8NFma.useRef(null);
    const rippleRef = $8NFma.useRef(null);
    const handleRippleRef = (0, $ebfa8c86b352582b$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $92373e9d662618e2$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $8NFma.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $8NFma.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $8NFma.useState(false);
    $8NFma.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $8NFma.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $121b4ee3832af90d$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $121b4ee3832af90d$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $8NFma.useRef(false);
    const handleKeyDown = (0, $121b4ee3832af90d$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $121b4ee3832af90d$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $ebfa8c86b352582b$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $jz4iA.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $6d674dfb4ea8dd71$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($6d674dfb4ea8dd71$export$7ec0dcc5e3cdcd36, (0, $jz4iA.default)({
        as: ComponentProp,
        className: (0, $ase04.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $1IdZj.jsx)((0, $b69aeaa96fee2ed8$export$2e2bcd8739ae039), (0, $jz4iA.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $6d674dfb4ea8dd71$export$2e2bcd8739ae039 = $6d674dfb4ea8dd71$var$ButtonBase;


parcelRequire("8NFma");

var $3vCKb = parcelRequire("3vCKb");

var $1IdZj = parcelRequire("1IdZj");
'use client';
var $9ed053e63640f873$export$2e2bcd8739ae039 = (0, $3vCKb.default)(/*#__PURE__*/ (0, $1IdZj.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');



var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");

var $fzbVi = parcelRequire("fzbVi");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $d2fe204f32cf071b$export$645d356c89a51794(slot) {
    return (0, $guzMP.default)('MuiTableSortLabel', slot);
}
const $d2fe204f32cf071b$var$tableSortLabelClasses = (0, $bnCUV.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc'
]);
var $d2fe204f32cf071b$export$2e2bcd8739ae039 = $d2fe204f32cf071b$var$tableSortLabelClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $737eb1403b08f029$var$_excluded = [
    "active",
    "children",
    "className",
    "direction",
    "hideSortIcon",
    "IconComponent"
];
const $737eb1403b08f029$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active'
        ],
        icon: [
            'icon',
            `iconDirection${(0, $fzbVi.default)(direction)}`
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $d2fe204f32cf071b$export$645d356c89a51794), classes);
};
const $737eb1403b08f029$var$TableSortLabelRoot = (0, $32Puv.default)((0, $6d674dfb4ea8dd71$export$2e2bcd8739ae039), {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})(({ theme: theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $d2fe204f32cf071b$export$2e2bcd8739ae039).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $d2fe204f32cf071b$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $d2fe204f32cf071b$export$2e2bcd8739ae039).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    }));
const $737eb1403b08f029$var$TableSortLabelIcon = (0, $32Puv.default)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $fzbVi.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none'
    }, ownerState.direction === 'desc' && {
        transform: 'rotate(0deg)'
    }, ownerState.direction === 'asc' && {
        transform: 'rotate(180deg)'
    }));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $737eb1403b08f029$var$TableSortLabel = /*#__PURE__*/ $8NFma.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active: active = false, children: children, className: className, direction: direction = 'asc', hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $9ed053e63640f873$export$2e2bcd8739ae039) } = props, other = (0, $hQtye.default)(props, $737eb1403b08f029$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    });
    const classes = $737eb1403b08f029$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($737eb1403b08f029$var$TableSortLabelRoot, (0, $jz4iA.default)({
        className: (0, $ase04.default)(classes.root, className),
        component: "span",
        disableRipple: true,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $1IdZj.jsx)($737eb1403b08f029$var$TableSortLabelIcon, {
                as: IconComponent,
                className: (0, $ase04.default)(classes.icon),
                ownerState: ownerState
            })
        ]
    }));
});
var $737eb1403b08f029$export$2e2bcd8739ae039 = $737eb1403b08f029$var$TableSortLabel;



var $32Puv = parcelRequire("32Puv");
const $ce1249d77703232a$var$CustomTableSortLabel = (0, $32Puv.default)((0, $737eb1403b08f029$export$2e2bcd8739ae039))(({ theme: theme })=>({
        "&.Mui-active, &:focus, &:hover": {
            color: "white",
            textDecoration: "underline"
        }
    }));
function $ce1249d77703232a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)($ce1249d77703232a$var$CustomTableSortLabel, {
        ...props,
        sx: {
            "& .MuiTableSortLabel-icon": {
                color: "white !important"
            }
        }
    });
}



function $523f6a4431def88f$export$2e2bcd8739ae039({ tableClassName: tableClassName, data: data, dataMapper: dataMapper, headerOptions: headerOptions, tableStyle: tableStyle, isSelected: isSelected = ()=>false, initialSort: initialSort = {
    col: null,
    dir: null
}, loading: loading = false, loadingMessage: loadingMessage = (0, $53cc2e000314a49f$export$b8f07f75698d8349), stickyHeader: stickyHeader = false }) {
    const [tableSort, setTableSort] = (0, $8NFma.useState)(initialSort);
    if (tableSort.col && tableSort.dir) data.sort(headerOptions.find(({ name: name })=>name === tableSort.col)[tableSort.dir]);
    let tableContent;
    if (loading) tableContent = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4811e46d7a2ffb1b$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $c76f5609e6b96f5a$export$2e2bcd8739ae039), {
            colSpan: headerOptions.length,
            children: loadingMessage
        })
    });
    else if (data.length === 0) tableContent = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4811e46d7a2ffb1b$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $c76f5609e6b96f5a$export$2e2bcd8739ae039), {
            colSpan: headerOptions.length
        })
    });
    else tableContent = data.map((dataRow)=>dataMapper(dataRow, isSelected(dataRow)));
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $9f1c958b2294e384$export$2e2bcd8739ae039), {
        sx: tableStyle,
        className: tableClassName,
        stickyHeader: stickyHeader,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $edfbea0634c21546$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4811e46d7a2ffb1b$export$2e2bcd8739ae039), {
                    children: headerOptions.map(({ name: name, asc: asc, desc: desc, alignment: alignment, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
                        let onClick;
                        if (asc && desc) {
                            onClick = ()=>{
                                setTableSort((prevState)=>{
                                    if (prevState.col === name) return {
                                        col: name,
                                        dir: prevState.dir === "asc" ? "desc" : "asc"
                                    };
                                    else return {
                                        col: name,
                                        dir: "asc"
                                    };
                                });
                            };
                            return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $c76f5609e6b96f5a$export$2e2bcd8739ae039), {
                                className: "sortable",
                                onMouseEnter: onMouseEnter,
                                onMouseLeave: onMouseLeave,
                                align: alignment ? alignment : "center",
                                sx: {
                                    fontWeight: "600",
                                    backgroundColor: "#2D5986",
                                    color: "white",
                                    fontSize: "14px"
                                },
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ce1249d77703232a$export$2e2bcd8739ae039), {
                                    onClick: onClick,
                                    active: tableSort.col === name,
                                    direction: tableSort.col === name ? tableSort.dir : "asc",
                                    children: name
                                })
                            }, name);
                        } else return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $c76f5609e6b96f5a$export$2e2bcd8739ae039), {
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            align: alignment ? alignment : "center",
                            sx: {
                                fontWeight: "600",
                                backgroundColor: "#2D5986",
                                color: "white",
                                fontSize: "14px"
                            },
                            children: name
                        }, name);
                    })
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2903d7170089040e$export$2e2bcd8739ae039), {
                children: tableContent
            })
        ]
    });
}
$523f6a4431def88f$export$2e2bcd8739ae039.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array.isRequired,
    dataMapper: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    headerOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).arrayOf(Object).isRequired,
    tableStyle: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func
};



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $32Puv = parcelRequire("32Puv");

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");



var $2jLNc = parcelRequire("2jLNc");

var $jJYy4 = parcelRequire("jJYy4");

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");


var $1IdZj = parcelRequire("1IdZj");
const $5486a1458684ba3c$var$_excluded = [
    "value"
];
const $5486a1458684ba3c$var$RtlContext = /*#__PURE__*/ $8NFma.createContext();
function $5486a1458684ba3c$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $hQtye.default)(_ref, $5486a1458684ba3c$var$_excluded);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($5486a1458684ba3c$var$RtlContext.Provider, (0, $jz4iA.default)({
        value: value != null ? value : true
    }, props));
}
const $5486a1458684ba3c$export$b2dd014b6c321cb = ()=>{
    const value = $8NFma.useContext($5486a1458684ba3c$var$RtlContext);
    return value != null ? value : false;
};
var $5486a1458684ba3c$export$2e2bcd8739ae039 = $5486a1458684ba3c$var$RtlProvider;



var $jz4iA = parcelRequire("jz4iA");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $802be062485bc572$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $802be062485bc572$export$2e2bcd8739ae039 = $802be062485bc572$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $271f7ba63ef2f4f1$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $802be062485bc572$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $jz4iA.default)({}, otherProps, {
        ownerState: (0, $jz4iA.default)({}, otherProps.ownerState, ownerState)
    });
}
var $271f7ba63ef2f4f1$export$2e2bcd8739ae039 = $271f7ba63ef2f4f1$var$appendOwnerState;



var $8NFma = parcelRequire("8NFma");
function $b57b0985065b35bb$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($8NFma.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}



var $32Puv = parcelRequire("32Puv");parcelRequire("8NFma");

var $9dxf1 = parcelRequire("9dxf1");

var $8NFma = parcelRequire("8NFma");
parcelRequire("9XmJK");
var $iSBXh = parcelRequire("iSBXh");
'use client';
function $9cd0241439e5a6eb$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $9cd0241439e5a6eb$var$useTheme(defaultTheme = null) {
    const contextTheme = $8NFma.useContext((0, $iSBXh.T));
    return !contextTheme || $9cd0241439e5a6eb$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $9cd0241439e5a6eb$export$2e2bcd8739ae039 = $9cd0241439e5a6eb$var$useTheme;


'use client';
const $723db732b3f9b5ff$export$35e57303dbd8a66 = (0, $9dxf1.default)();
function $723db732b3f9b5ff$var$useTheme(defaultTheme = $723db732b3f9b5ff$export$35e57303dbd8a66) {
    return (0, $9cd0241439e5a6eb$export$2e2bcd8739ae039)(defaultTheme);
}
var $723db732b3f9b5ff$export$2e2bcd8739ae039 = $723db732b3f9b5ff$var$useTheme;



var $7PtT3 = parcelRequire("7PtT3");

var $9cYDa = parcelRequire("9cYDa");
'use client';
function $123a3c99b3d84a25$export$2e2bcd8739ae039() {
    const theme = (0, $723db732b3f9b5ff$export$2e2bcd8739ae039)((0, $7PtT3.default));
    return theme[0, $9cYDa.default] || theme;
}



var $aBf7M = parcelRequire("aBf7M");

var $fzbVi = parcelRequire("fzbVi");

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");





var $hQtye = parcelRequire("hQtye");



var $8NFma = parcelRequire("8NFma");

var $771abc1b9c3ac5e0$export$2e2bcd8739ae039 = {
    disabled: false
};




var $b7c02f0ad3191e79$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $3a0de358fcee31a7$export$bb38bb9a1161268 = 'unmounted';
var $3a0de358fcee31a7$export$84cbff306f539230 = 'exited';
var $3a0de358fcee31a7$export$df38205c966be359 = 'entering';
var $3a0de358fcee31a7$export$78e9e6e3e014d60a = 'entered';
var $3a0de358fcee31a7$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3a0de358fcee31a7$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $c04286edcac4109a$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3a0de358fcee31a7$export$84cbff306f539230;
                _this.appearStatus = $3a0de358fcee31a7$export$df38205c966be359;
            } else initialStatus = $3a0de358fcee31a7$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3a0de358fcee31a7$export$bb38bb9a1161268;
        else initialStatus = $3a0de358fcee31a7$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3a0de358fcee31a7$export$bb38bb9a1161268) return {
            status: $3a0de358fcee31a7$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3a0de358fcee31a7$export$df38205c966be359 && status !== $3a0de358fcee31a7$export$78e9e6e3e014d60a) nextStatus = $3a0de358fcee31a7$export$df38205c966be359;
            } else if (status === $3a0de358fcee31a7$export$df38205c966be359 || status === $3a0de358fcee31a7$export$78e9e6e3e014d60a) nextStatus = $3a0de358fcee31a7$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3a0de358fcee31a7$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $b7c02f0ad3191e79$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3a0de358fcee31a7$export$84cbff306f539230) this.setState({
            status: $3a0de358fcee31a7$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $771abc1b9c3ac5e0$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $3a0de358fcee31a7$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3a0de358fcee31a7$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3a0de358fcee31a7$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $771abc1b9c3ac5e0$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $3a0de358fcee31a7$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3a0de358fcee31a7$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3a0de358fcee31a7$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3a0de358fcee31a7$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hQtye.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $4b9cff7e01ef990e$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$3a0de358fcee31a7$var$Transition.contextType = (0, $4b9cff7e01ef990e$export$2e2bcd8739ae039);
$3a0de358fcee31a7$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3a0de358fcee31a7$var$noop() {}
$3a0de358fcee31a7$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3a0de358fcee31a7$var$noop,
    onEntering: $3a0de358fcee31a7$var$noop,
    onEntered: $3a0de358fcee31a7$var$noop,
    onExit: $3a0de358fcee31a7$var$noop,
    onExiting: $3a0de358fcee31a7$var$noop,
    onExited: $3a0de358fcee31a7$var$noop
};
$3a0de358fcee31a7$var$Transition.UNMOUNTED = $3a0de358fcee31a7$export$bb38bb9a1161268;
$3a0de358fcee31a7$var$Transition.EXITED = $3a0de358fcee31a7$export$84cbff306f539230;
$3a0de358fcee31a7$var$Transition.ENTERING = $3a0de358fcee31a7$export$df38205c966be359;
$3a0de358fcee31a7$var$Transition.ENTERED = $3a0de358fcee31a7$export$78e9e6e3e014d60a;
$3a0de358fcee31a7$var$Transition.EXITING = $3a0de358fcee31a7$export$4aacc83d4d59139f;
var $3a0de358fcee31a7$export$2e2bcd8739ae039 = $3a0de358fcee31a7$var$Transition;



const $72f49021245a9e68$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $72f49021245a9e68$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $1IdZj = parcelRequire("1IdZj");
'use client';
const $4362317f9c531b02$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $4362317f9c531b02$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $4362317f9c531b02$var$styles = {
    entering: {
        opacity: 1,
        transform: $4362317f9c531b02$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $4362317f9c531b02$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4362317f9c531b02$var$Grow = /*#__PURE__*/ $8NFma.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $3a0de358fcee31a7$export$2e2bcd8739ae039) } = props, other = (0, $hQtye.default)(props, $4362317f9c531b02$var$_excluded);
    const timer = (0, $6059c91578438ade$export$2e2bcd8739ae039)();
    const autoTimeout = $8NFma.useRef();
    const theme = (0, $123a3c99b3d84a25$export$2e2bcd8739ae039)();
    const nodeRef = $8NFma.useRef(null);
    const handleRef = (0, $ebfa8c86b352582b$export$2e2bcd8739ae039)(nodeRef, (0, $b57b0985065b35bb$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $72f49021245a9e68$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $72f49021245a9e68$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $4362317f9c531b02$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $72f49021245a9e68$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $4362317f9c531b02$var$isWebKit154 ? duration : duration * 0.666,
                delay: $4362317f9c531b02$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $4362317f9c531b02$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)(TransitionComponent, (0, $jz4iA.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $8NFma.cloneElement(children, (0, $jz4iA.default)({
                style: (0, $jz4iA.default)({
                    opacity: 0,
                    transform: $4362317f9c531b02$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $4362317f9c531b02$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$4362317f9c531b02$var$Grow.muiSupportAuto = true;
var $4362317f9c531b02$export$2e2bcd8739ae039 = $4362317f9c531b02$var$Grow;



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");
var $0520fe606fff6891$exports = {};
"use strict";
'use client';
Object.defineProperty($0520fe606fff6891$exports, "__esModule", {
    value: true
});
$0520fe606fff6891$exports.default = void 0;

var $0520fe606fff6891$var$React = $0520fe606fff6891$var$_interopRequireWildcard((parcelRequire("8NFma")));
parcelRequire("9XmJK");
var $iSBXh = parcelRequire("iSBXh");
function $0520fe606fff6891$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0520fe606fff6891$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $0520fe606fff6891$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $0520fe606fff6891$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $0520fe606fff6891$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $0520fe606fff6891$var$useTheme(defaultTheme = null) {
    const contextTheme = $0520fe606fff6891$var$React.useContext($iSBXh.T);
    return !contextTheme || $0520fe606fff6891$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $0520fe606fff6891$var$_default = $0520fe606fff6891$exports.default = $0520fe606fff6891$var$useTheme;






var $8NFma = parcelRequire("8NFma");

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");
function $1c8b1a0d94ed49c3$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}


function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}







function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


var $f5c54167a3c62105$export$1e95b668f3b82d = 'top';
var $f5c54167a3c62105$export$40e543e69a8b3fbb = 'bottom';
var $f5c54167a3c62105$export$79ffe56a765070d2 = 'right';
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = 'left';
var $f5c54167a3c62105$export$dfb5619354ba860 = 'auto';
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = 'start';
var $f5c54167a3c62105$export$bd5df0f255a350f8 = 'end';
var $f5c54167a3c62105$export$390fd549c5303b4d = 'clippingParents';
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = 'viewport';
var $f5c54167a3c62105$export$ae5ab1c730825774 = 'popper';
var $f5c54167a3c62105$export$ca50aac9f3ba507f = 'reference';
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = 'beforeRead';
var $f5c54167a3c62105$export$aafa59e2e03f2942 = 'read';
var $f5c54167a3c62105$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = 'beforeMain';
var $f5c54167a3c62105$export$f22da7240b7add18 = 'main';
var $f5c54167a3c62105$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f5c54167a3c62105$export$68d8715fc104d294 = 'write';
var $f5c54167a3c62105$export$70a6e5159acce2e6 = 'afterWrite';
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};










var $c8f8eadcf7685dc5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $7c04da2e958a3fe8$var$offset
};


var $825ae98fe4f5d029$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: 'end',
    end: 'start'
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}







function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $174d14927bb4f43b$var$hide
};




var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $2jLNc = parcelRequire("2jLNc");

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");



var $jz4iA = parcelRequire("jz4iA");

var $ase04 = parcelRequire("ase04");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $5c18727d6ec444af$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $5c18727d6ec444af$export$2e2bcd8739ae039 = $5c18727d6ec444af$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $9cec72886e63b66c$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $9cec72886e63b66c$export$2e2bcd8739ae039 = $9cec72886e63b66c$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $9a437998670e2943$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $ase04.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $jz4iA.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $jz4iA.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $5c18727d6ec444af$export$2e2bcd8739ae039)((0, $jz4iA.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $9cec72886e63b66c$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $9cec72886e63b66c$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $ase04.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $jz4iA.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $jz4iA.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $9a437998670e2943$export$2e2bcd8739ae039 = $9a437998670e2943$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $f442001f377edb22$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $f442001f377edb22$export$2e2bcd8739ae039 = $f442001f377edb22$var$resolveComponentProps;


'use client';
const $d19db5950c4a317f$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $d19db5950c4a317f$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $hQtye.default)(parameters, $d19db5950c4a317f$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $f442001f377edb22$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $9a437998670e2943$export$2e2bcd8739ae039)((0, $jz4iA.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $ab5db80457248826$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $271f7ba63ef2f4f1$export$2e2bcd8739ae039)(elementType, (0, $jz4iA.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $d19db5950c4a317f$export$2e2bcd8739ae039 = $d19db5950c4a317f$var$useSlotProps;



var $8NFma = parcelRequire("8NFma");




var $1IdZj = parcelRequire("1IdZj");
'use client';
function $c165c485b51c6314$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $c165c485b51c6314$var$Portal = /*#__PURE__*/ $8NFma.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $8NFma.useState(null);
    const handleRef = (0, $ab5db80457248826$export$2e2bcd8739ae039)(/*#__PURE__*/ $8NFma.isValidElement(children) ? (0, $b57b0985065b35bb$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $2e091165f4c6c9c8$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($c165c485b51c6314$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $2e091165f4c6c9c8$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $d4b20d6f9c62ec15$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $d4b20d6f9c62ec15$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $8NFma.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $8NFma.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $1IdZj.jsx)($8NFma.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)($8NFma.Fragment, {
        children: mountNode ? /*#__PURE__*/ $1c0f1e610963dfb8$exports.createPortal(children, mountNode) : mountNode
    });
});
var $c165c485b51c6314$export$2e2bcd8739ae039 = $c165c485b51c6314$var$Portal;



var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $3e14c80a07c07875$export$1b69b6cd0fa638a1(slot) {
    return (0, $guzMP.default)('MuiPopper', slot);
}
const $3e14c80a07c07875$var$popperClasses = (0, $bnCUV.default)('MuiPopper', [
    'root'
]);
var $3e14c80a07c07875$export$2e2bcd8739ae039 = $3e14c80a07c07875$var$popperClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $42dcc518ff95ca8f$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $42dcc518ff95ca8f$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $42dcc518ff95ca8f$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $42dcc518ff95ca8f$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $42dcc518ff95ca8f$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $42dcc518ff95ca8f$var$isVirtualElement(element) {
    return !$42dcc518ff95ca8f$var$isHTMLElement(element);
}
const $42dcc518ff95ca8f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $3e14c80a07c07875$export$1b69b6cd0fa638a1), classes);
};
const $42dcc518ff95ca8f$var$defaultPopperOptions = {};
const $42dcc518ff95ca8f$var$PopperTooltip = /*#__PURE__*/ $8NFma.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $hQtye.default)(props, $42dcc518ff95ca8f$var$_excluded);
    const tooltipRef = $8NFma.useRef(null);
    const ownRef = (0, $ab5db80457248826$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $8NFma.useRef(null);
    const handlePopperRef = (0, $ab5db80457248826$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $8NFma.useRef(handlePopperRef);
    (0, $2e091165f4c6c9c8$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $8NFma.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $42dcc518ff95ca8f$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $8NFma.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $8NFma.useState($42dcc518ff95ca8f$var$resolveAnchorEl(anchorEl));
    $8NFma.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $8NFma.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($42dcc518ff95ca8f$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $2e091165f4c6c9c8$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $jz4iA.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $42dcc518ff95ca8f$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $d19db5950c4a317f$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Root, (0, $jz4iA.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $42dcc518ff95ca8f$var$Popper = /*#__PURE__*/ $8NFma.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $42dcc518ff95ca8f$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $hQtye.default)(props, $42dcc518ff95ca8f$var$_excluded2);
    const [exited, setExited] = $8NFma.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $42dcc518ff95ca8f$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $42dcc518ff95ca8f$var$isHTMLElement(resolvedAnchorEl) ? (0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $c165c485b51c6314$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)($42dcc518ff95ca8f$var$PopperTooltip, (0, $jz4iA.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $jz4iA.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $42dcc518ff95ca8f$export$2e2bcd8739ae039 = $42dcc518ff95ca8f$var$Popper;



var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $e3afd6b912cf1566$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $e3afd6b912cf1566$var$PopperRoot = (0, $32Puv.default)((0, $42dcc518ff95ca8f$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $e3afd6b912cf1566$var$Popper = /*#__PURE__*/ $8NFma.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($0520fe606fff6891$exports)))();
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $hQtye.default)(props, $e3afd6b912cf1566$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $jz4iA.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($e3afd6b912cf1566$var$PopperRoot, (0, $jz4iA.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $e3afd6b912cf1566$export$2e2bcd8739ae039 = $e3afd6b912cf1566$var$Popper;





var $8NFma = parcelRequire("8NFma");
'use client';
let $42cae6f168e9b9ae$var$globalId = 0;
function $42cae6f168e9b9ae$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $8NFma.useState(idOverride);
    const id = idOverride || defaultId;
    $8NFma.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $42cae6f168e9b9ae$var$globalId += 1;
            setDefaultId(`mui-${$42cae6f168e9b9ae$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $42cae6f168e9b9ae$var$maybeReactUseId = $8NFma['useId'.toString()];
function $42cae6f168e9b9ae$export$2e2bcd8739ae039(idOverride) {
    if ($42cae6f168e9b9ae$var$maybeReactUseId !== undefined) {
        const reactId = $42cae6f168e9b9ae$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $42cae6f168e9b9ae$var$useGlobalId(idOverride);
}


'use client';
var $7aa5f140c0dfb0e4$export$2e2bcd8739ae039 = (0, $42cae6f168e9b9ae$export$2e2bcd8739ae039);




var $8NFma = parcelRequire("8NFma");
'use client';
function $27d288aa953579ae$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $8NFma.useRef(controlled !== undefined);
    const [valueState, setValue] = $8NFma.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $8NFma.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $6e2d45f286b09de5$export$2e2bcd8739ae039 = (0, $27d288aa953579ae$export$2e2bcd8739ae039);



var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $4fdb1e9100b4503a$export$837848f5f6cee923(slot) {
    return (0, $guzMP.default)('MuiTooltip', slot);
}
const $4fdb1e9100b4503a$var$tooltipClasses = (0, $bnCUV.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $4fdb1e9100b4503a$export$2e2bcd8739ae039 = $4fdb1e9100b4503a$var$tooltipClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $8b68638d54c8b630$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $8b68638d54c8b630$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $8b68638d54c8b630$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $fzbVi.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $4fdb1e9100b4503a$export$837848f5f6cee923), classes);
};
const $8b68638d54c8b630$var$TooltipPopper = (0, $32Puv.default)((0, $e3afd6b912cf1566$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $jz4iA.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $4fdb1e9100b4503a$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $4fdb1e9100b4503a$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $4fdb1e9100b4503a$export$2e2bcd8739ae039).arrow}`]: (0, $jz4iA.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $4fdb1e9100b4503a$export$2e2bcd8739ae039).arrow}`]: (0, $jz4iA.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $8b68638d54c8b630$var$TooltipTooltip = (0, $32Puv.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $fzbVi.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $jJYy4.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$8b68638d54c8b630$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $4fdb1e9100b4503a$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $jz4iA.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $jz4iA.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $jz4iA.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $4fdb1e9100b4503a$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $jz4iA.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $jz4iA.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $jz4iA.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $4fdb1e9100b4503a$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $jz4iA.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $4fdb1e9100b4503a$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $jz4iA.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $8b68638d54c8b630$var$TooltipArrow = (0, $32Puv.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $jJYy4.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $8b68638d54c8b630$var$hystersisOpen = false;
const $8b68638d54c8b630$var$hystersisTimer = new (0, $6059c91578438ade$export$786b4da70f00938b)();
let $8b68638d54c8b630$var$cursorPosition = {
    x: 0,
    y: 0
};
function $8b68638d54c8b630$export$b9ee5a7ace0541f8() {
    $8b68638d54c8b630$var$hystersisOpen = false;
    $8b68638d54c8b630$var$hystersisTimer.clear();
}
function $8b68638d54c8b630$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $8b68638d54c8b630$var$Tooltip = /*#__PURE__*/ $8NFma.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $4362317f9c531b02$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $hQtye.default)(props, $8b68638d54c8b630$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $8NFma.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $123a3c99b3d84a25$export$2e2bcd8739ae039)();
    const isRtl = (0, $5486a1458684ba3c$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $8NFma.useState();
    const [arrowRef, setArrowRef] = $8NFma.useState(null);
    const ignoreNonTouchEvents = $8NFma.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $6059c91578438ade$export$2e2bcd8739ae039)();
    const enterTimer = (0, $6059c91578438ade$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $6059c91578438ade$export$2e2bcd8739ae039)();
    const touchTimer = (0, $6059c91578438ade$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $6e2d45f286b09de5$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $7aa5f140c0dfb0e4$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $8NFma.useRef();
    const stopTouchInteraction = (0, $121b4ee3832af90d$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $8NFma.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $8b68638d54c8b630$var$hystersisTimer.clear();
        $8b68638d54c8b630$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $121b4ee3832af90d$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $8b68638d54c8b630$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $8b68638d54c8b630$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $8b68638d54c8b630$var$hystersisOpen && enterNextDelay) enterTimer.start($8b68638d54c8b630$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $92373e9d662618e2$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $8NFma.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $8NFma.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $ebfa8c86b352582b$export$2e2bcd8739ae039)((0, $b57b0985065b35bb$export$2e2bcd8739ae039)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $8NFma.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $8b68638d54c8b630$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $jz4iA.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $ase04.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $8b68638d54c8b630$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $8b68638d54c8b630$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $8b68638d54c8b630$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $8b68638d54c8b630$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $8NFma.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $jz4iA.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $jz4iA.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $8b68638d54c8b630$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $8b68638d54c8b630$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $4362317f9c531b02$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $8b68638d54c8b630$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $8b68638d54c8b630$var$TooltipArrow;
    const popperProps = (0, $271f7ba63ef2f4f1$export$2e2bcd8739ae039)(PopperComponent, (0, $jz4iA.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $ase04.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $271f7ba63ef2f4f1$export$2e2bcd8739ae039)(TransitionComponent, (0, $jz4iA.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $271f7ba63ef2f4f1$export$2e2bcd8739ae039)(TooltipComponent, (0, $jz4iA.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $ase04.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $271f7ba63ef2f4f1$export$2e2bcd8739ae039)(ArrowComponent, (0, $jz4iA.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $ase04.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($8NFma.Fragment, {
        children: [
            /*#__PURE__*/ $8NFma.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $1IdZj.jsx)(PopperComponent, (0, $jz4iA.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $e3afd6b912cf1566$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $8b68638d54c8b630$var$cursorPosition.y,
                            left: $8b68638d54c8b630$var$cursorPosition.x,
                            right: $8b68638d54c8b630$var$cursorPosition.x,
                            bottom: $8b68638d54c8b630$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $1IdZj.jsx)(TransitionComponent, (0, $jz4iA.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $1IdZj.jsxs)(TooltipComponent, (0, $jz4iA.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $1IdZj.jsx)(ArrowComponent, (0, $jz4iA.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $8b68638d54c8b630$export$2e2bcd8739ae039 = $8b68638d54c8b630$var$Tooltip;


const $e2821c3898645c77$var$HtmlTooltip = (0, $32Puv.default)(({ className: className, ...props })=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $8b68638d54c8b630$export$2e2bcd8739ae039), {
        ...props,
        classes: {
            popper: className
        }
    }))(({ theme: theme })=>({
        [`& .${(0, $4fdb1e9100b4503a$export$2e2bcd8739ae039).tooltip}`]: {
            backgroundColor: "#f5f5f9",
            color: "rgba(0, 0, 0, 0.87)",
            fontSize: theme.typography.pxToRem(20),
            border: "1px solid #dadde9"
        }
    }));
function $e2821c3898645c77$export$2e2bcd8739ae039({ title: title, children: children }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)($e2821c3898645c77$var$HtmlTooltip, {
        title: title,
        slotProps: {
            popper: {
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [
                                0,
                                -14
                            ]
                        }
                    }
                ]
            }
        },
        children: children
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");


var $fzbVi = parcelRequire("fzbVi");

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");



var $2jLNc = parcelRequire("2jLNc");


var $8NFma = parcelRequire("8NFma");



var $1IdZj = parcelRequire("1IdZj");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $18b1e20a2e7d587d$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $18b1e20a2e7d587d$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $18b1e20a2e7d587d$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $18b1e20a2e7d587d$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $18b1e20a2e7d587d$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $18b1e20a2e7d587d$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($18b1e20a2e7d587d$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $18b1e20a2e7d587d$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$18b1e20a2e7d587d$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $18b1e20a2e7d587d$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $18b1e20a2e7d587d$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $18b1e20a2e7d587d$var$defaultGetTabbable, isEnabled: isEnabled = $18b1e20a2e7d587d$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $8NFma.useRef(false);
    const sentinelStart = $8NFma.useRef(null);
    const sentinelEnd = $8NFma.useRef(null);
    const nodeToRestore = $8NFma.useRef(null);
    const reactFocusEventTarget = $8NFma.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $8NFma.useRef(false);
    const rootRef = $8NFma.useRef(null);
    const handleRef = (0, $ab5db80457248826$export$2e2bcd8739ae039)((0, $b57b0985065b35bb$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $8NFma.useRef(null);
    $8NFma.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $8NFma.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $8NFma.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($8NFma.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $8NFma.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $18b1e20a2e7d587d$export$2e2bcd8739ae039 = $18b1e20a2e7d587d$var$FocusTrap;




var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");

var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");








var $1IdZj = parcelRequire("1IdZj");
'use client';
const $58f1e5df5b82b2d9$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $58f1e5df5b82b2d9$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $58f1e5df5b82b2d9$var$Fade = /*#__PURE__*/ $8NFma.forwardRef(function Fade(props, ref) {
    const theme = (0, $123a3c99b3d84a25$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $3a0de358fcee31a7$export$2e2bcd8739ae039) } = props, other = (0, $hQtye.default)(props, $58f1e5df5b82b2d9$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $8NFma.useRef(null);
    const handleRef = (0, $ebfa8c86b352582b$export$2e2bcd8739ae039)(nodeRef, (0, $b57b0985065b35bb$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $72f49021245a9e68$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $72f49021245a9e68$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $72f49021245a9e68$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)(TransitionComponent, (0, $jz4iA.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $8NFma.cloneElement(children, (0, $jz4iA.default)({
                style: (0, $jz4iA.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $58f1e5df5b82b2d9$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $58f1e5df5b82b2d9$export$2e2bcd8739ae039 = $58f1e5df5b82b2d9$var$Fade;



var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $3b3b996214a58e0a$export$9927a91fd93152bd(slot) {
    return (0, $guzMP.default)('MuiBackdrop', slot);
}
const $3b3b996214a58e0a$var$backdropClasses = (0, $bnCUV.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $3b3b996214a58e0a$export$2e2bcd8739ae039 = $3b3b996214a58e0a$var$backdropClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $c52377905c3fcb10$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $c52377905c3fcb10$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $3b3b996214a58e0a$export$9927a91fd93152bd), classes);
};
const $c52377905c3fcb10$var$BackdropRoot = (0, $32Puv.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $jz4iA.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $c52377905c3fcb10$var$Backdrop = /*#__PURE__*/ $8NFma.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $58f1e5df5b82b2d9$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $hQtye.default)(props, $c52377905c3fcb10$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $c52377905c3fcb10$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $1IdZj.jsx)(TransitionComponent, (0, $jz4iA.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)($c52377905c3fcb10$var$BackdropRoot, (0, $jz4iA.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $ase04.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $jz4iA.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $c52377905c3fcb10$export$2e2bcd8739ae039 = $c52377905c3fcb10$var$Backdrop;



var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $b311cb89efcaaf33$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $7258c265b8cfb555$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $062d70ae7e70697e$export$2e2bcd8739ae039(node) {
    const doc = (0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $e5b1ef83fa1138e1$var$isOverflowing(container) {
    const doc = (0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $062d70ae7e70697e$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $e5b1ef83fa1138e1$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $e5b1ef83fa1138e1$var$getPaddingRight(element) {
    return parseInt((0, $062d70ae7e70697e$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $e5b1ef83fa1138e1$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $e5b1ef83fa1138e1$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$e5b1ef83fa1138e1$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $e5b1ef83fa1138e1$export$e1bd0c6150f13d96(element, show);
    });
}
function $e5b1ef83fa1138e1$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $e5b1ef83fa1138e1$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($e5b1ef83fa1138e1$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $7258c265b8cfb555$export$2e2bcd8739ae039)((0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$e5b1ef83fa1138e1$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$e5b1ef83fa1138e1$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $062d70ae7e70697e$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $e5b1ef83fa1138e1$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $e5b1ef83fa1138e1$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $e5b1ef83fa1138e1$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $e5b1ef83fa1138e1$var$getHiddenSiblings(container);
        $e5b1ef83fa1138e1$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $e5b1ef83fa1138e1$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $e5b1ef83fa1138e1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $e5b1ef83fa1138e1$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $e5b1ef83fa1138e1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $e5b1ef83fa1138e1$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $e5b1ef83fa1138e1$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $e5b1ef83fa1138e1$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $15f5f31766bae46c$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $15f5f31766bae46c$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $15f5f31766bae46c$var$defaultManager = new (0, $e5b1ef83fa1138e1$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $15f5f31766bae46c$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $15f5f31766bae46c$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $8NFma.useRef({});
    const mountNodeRef = $8NFma.useRef(null);
    const modalRef = $8NFma.useRef(null);
    const handleRef = (0, $ab5db80457248826$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $8NFma.useState(!open);
    const hasTransition = $15f5f31766bae46c$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $1c8b1a0d94ed49c3$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $6f8092f41eb661ae$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $15f5f31766bae46c$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $8NFma.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $6f8092f41eb661ae$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $e5b1ef83fa1138e1$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $8NFma.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $8NFma.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $8NFma.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $5c18727d6ec444af$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $jz4iA.default)({}, propsEventHandlers, otherHandlers);
        return (0, $jz4iA.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $jz4iA.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $b311cb89efcaaf33$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $b311cb89efcaaf33$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $15f5f31766bae46c$export$2e2bcd8739ae039 = $15f5f31766bae46c$var$useModal;



var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $e80baa0bfdc05b9d$export$67960e22b12a638d(slot) {
    return (0, $guzMP.default)('MuiModal', slot);
}
const $e80baa0bfdc05b9d$var$modalClasses = (0, $bnCUV.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $e80baa0bfdc05b9d$export$2e2bcd8739ae039 = $e80baa0bfdc05b9d$var$modalClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $506a682a54b0bf04$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $506a682a54b0bf04$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $e80baa0bfdc05b9d$export$67960e22b12a638d), classes);
};
const $506a682a54b0bf04$var$ModalRoot = (0, $32Puv.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $506a682a54b0bf04$var$ModalBackdrop = (0, $32Puv.default)((0, $c52377905c3fcb10$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $506a682a54b0bf04$var$Modal = /*#__PURE__*/ $8NFma.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $aBf7M.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $506a682a54b0bf04$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $hQtye.default)(props, $506a682a54b0bf04$var$_excluded);
    const propsWithDefaults = (0, $jz4iA.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $15f5f31766bae46c$export$2e2bcd8739ae039)((0, $jz4iA.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $jz4iA.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $506a682a54b0bf04$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $506a682a54b0bf04$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $d19db5950c4a317f$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $ase04.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $d19db5950c4a317f$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $jz4iA.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $ase04.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $c165c485b51c6314$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)(RootSlot, (0, $jz4iA.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $1IdZj.jsx)(BackdropSlot, (0, $jz4iA.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $18b1e20a2e7d587d$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $8NFma.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $506a682a54b0bf04$export$2e2bcd8739ae039 = $506a682a54b0bf04$var$Modal;




var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");



var $2jLNc = parcelRequire("2jLNc");

var $jJYy4 = parcelRequire("jJYy4");

var $32Puv = parcelRequire("32Puv");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $302eaebe39ab9d0b$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $302eaebe39ab9d0b$export$2e2bcd8739ae039 = $302eaebe39ab9d0b$var$getOverlayAlpha;



var $aBf7M = parcelRequire("aBf7M");


var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $b112a60daad8dc59$export$29cdb466b9b6f20b(slot) {
    return (0, $guzMP.default)('MuiPaper', slot);
}
const $b112a60daad8dc59$var$paperClasses = (0, $bnCUV.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $b112a60daad8dc59$export$2e2bcd8739ae039 = $b112a60daad8dc59$var$paperClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $2e835c2a502e974e$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $2e835c2a502e974e$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $b112a60daad8dc59$export$29cdb466b9b6f20b), classes);
};
const $2e835c2a502e974e$var$PaperRoot = (0, $32Puv.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $jz4iA.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $jz4iA.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $jJYy4.alpha)('#fff', (0, $302eaebe39ab9d0b$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $jJYy4.alpha)('#fff', (0, $302eaebe39ab9d0b$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $2e835c2a502e974e$var$Paper = /*#__PURE__*/ $8NFma.forwardRef(function Paper(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $hQtye.default)(props, $2e835c2a502e974e$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $2e835c2a502e974e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($2e835c2a502e974e$var$PaperRoot, (0, $jz4iA.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $ase04.default)(classes.root, className),
        ref: ref
    }, other));
});
var $2e835c2a502e974e$export$2e2bcd8739ae039 = $2e835c2a502e974e$var$Paper;



var $aBf7M = parcelRequire("aBf7M");

var $32Puv = parcelRequire("32Puv");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $d4362b268ffadb4f$export$2177af0aa15c34c2(slot) {
    return (0, $guzMP.default)('MuiDialog', slot);
}
const $d4362b268ffadb4f$var$dialogClasses = (0, $bnCUV.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $d4362b268ffadb4f$export$2e2bcd8739ae039 = $d4362b268ffadb4f$var$dialogClasses;



var $8NFma = parcelRequire("8NFma");
const $312b0f8f5c2bd0bb$var$DialogContext = /*#__PURE__*/ $8NFma.createContext({});
var $312b0f8f5c2bd0bb$export$2e2bcd8739ae039 = $312b0f8f5c2bd0bb$var$DialogContext;





var $1IdZj = parcelRequire("1IdZj");
'use client';
const $d29652b1774880ed$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $d29652b1774880ed$var$DialogBackdrop = (0, $32Puv.default)((0, $c52377905c3fcb10$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $d29652b1774880ed$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $fzbVi.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $fzbVi.default)(scroll)}`,
            `paperWidth${(0, $fzbVi.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $d4362b268ffadb4f$export$2177af0aa15c34c2), classes);
};
const $d29652b1774880ed$var$DialogRoot = (0, $32Puv.default)((0, $506a682a54b0bf04$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $d29652b1774880ed$var$DialogContainer = (0, $32Puv.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $fzbVi.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $jz4iA.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $d29652b1774880ed$var$DialogPaper = (0, $32Puv.default)((0, $2e835c2a502e974e$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $fzbVi.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $fzbVi.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $d4362b268ffadb4f$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $d4362b268ffadb4f$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $d4362b268ffadb4f$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $d29652b1774880ed$var$Dialog = /*#__PURE__*/ $8NFma.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $123a3c99b3d84a25$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $2e835c2a502e974e$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $58f1e5df5b82b2d9$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $hQtye.default)(props, $d29652b1774880ed$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $d29652b1774880ed$var$useUtilityClasses(ownerState);
    const backdropClick = $8NFma.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $42cae6f168e9b9ae$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $8NFma.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($d29652b1774880ed$var$DialogRoot, (0, $jz4iA.default)({
        className: (0, $ase04.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $d29652b1774880ed$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $jz4iA.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)(TransitionComponent, (0, $jz4iA.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $1IdZj.jsx)($d29652b1774880ed$var$DialogContainer, {
                className: (0, $ase04.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)($d29652b1774880ed$var$DialogPaper, (0, $jz4iA.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $ase04.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $312b0f8f5c2bd0bb$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $d29652b1774880ed$export$2e2bcd8739ae039 = $d29652b1774880ed$var$Dialog;



var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");

var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $6a3284cce91fc864$export$61b0ee1f05fb344e(slot) {
    return (0, $guzMP.default)('MuiDialogContent', slot);
}
const $6a3284cce91fc864$var$dialogContentClasses = (0, $bnCUV.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $6a3284cce91fc864$export$2e2bcd8739ae039 = $6a3284cce91fc864$var$dialogContentClasses;



var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $f133c1c91c5d6b9a$export$f5d2ec7e4c47e088(slot) {
    return (0, $guzMP.default)('MuiDialogTitle', slot);
}
const $f133c1c91c5d6b9a$var$dialogTitleClasses = (0, $bnCUV.default)('MuiDialogTitle', [
    'root'
]);
var $f133c1c91c5d6b9a$export$2e2bcd8739ae039 = $f133c1c91c5d6b9a$var$dialogTitleClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $8e14d7c3972c0289$var$_excluded = [
    "className",
    "dividers"
];
const $8e14d7c3972c0289$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $6a3284cce91fc864$export$61b0ee1f05fb344e), classes);
};
const $8e14d7c3972c0289$var$DialogContentRoot = (0, $32Puv.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $f133c1c91c5d6b9a$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $8e14d7c3972c0289$var$DialogContent = /*#__PURE__*/ $8NFma.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $hQtye.default)(props, $8e14d7c3972c0289$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        dividers: dividers
    });
    const classes = $8e14d7c3972c0289$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($8e14d7c3972c0289$var$DialogContentRoot, (0, $jz4iA.default)({
        className: (0, $ase04.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $8e14d7c3972c0289$export$2e2bcd8739ae039 = $8e14d7c3972c0289$var$DialogContent;



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $3fjJg = parcelRequire("3fjJg");

var $2jLNc = parcelRequire("2jLNc");

var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");

var $fzbVi = parcelRequire("fzbVi");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $6a355308478148d9$export$24c1f8f60cbac79e(slot) {
    return (0, $guzMP.default)('MuiTypography', slot);
}
const $6a355308478148d9$var$typographyClasses = (0, $bnCUV.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $6a355308478148d9$export$2e2bcd8739ae039 = $6a355308478148d9$var$typographyClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $90a0bac4775b0256$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $90a0bac4775b0256$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $fzbVi.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $6a355308478148d9$export$24c1f8f60cbac79e), classes);
};
const $90a0bac4775b0256$export$140e2f5526d3cad8 = (0, $32Puv.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $fzbVi.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $90a0bac4775b0256$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $90a0bac4775b0256$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $90a0bac4775b0256$var$transformDeprecatedColors = (color)=>{
    return $90a0bac4775b0256$var$colorTransformations[color] || color;
};
const $90a0bac4775b0256$var$Typography = /*#__PURE__*/ $8NFma.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $90a0bac4775b0256$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $3fjJg.default)((0, $jz4iA.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $90a0bac4775b0256$var$defaultVariantMapping } = props, other = (0, $hQtye.default)(props, $90a0bac4775b0256$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $90a0bac4775b0256$var$defaultVariantMapping[variant]) || 'span';
    const classes = $90a0bac4775b0256$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($90a0bac4775b0256$export$140e2f5526d3cad8, (0, $jz4iA.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $ase04.default)(classes.root, className)
    }, other));
});
var $90a0bac4775b0256$export$2e2bcd8739ae039 = $90a0bac4775b0256$var$Typography;



var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $f6a26e9944fb97bc$var$_excluded = [
    "className",
    "id"
];
const $f6a26e9944fb97bc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $f133c1c91c5d6b9a$export$f5d2ec7e4c47e088), classes);
};
const $f6a26e9944fb97bc$var$DialogTitleRoot = (0, $32Puv.default)((0, $90a0bac4775b0256$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $f6a26e9944fb97bc$var$DialogTitle = /*#__PURE__*/ $8NFma.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $hQtye.default)(props, $f6a26e9944fb97bc$var$_excluded);
    const ownerState = props;
    const classes = $f6a26e9944fb97bc$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $8NFma.useContext((0, $312b0f8f5c2bd0bb$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $1IdZj.jsx)($f6a26e9944fb97bc$var$DialogTitleRoot, (0, $jz4iA.default)({
        component: "h2",
        className: (0, $ase04.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $f6a26e9944fb97bc$export$2e2bcd8739ae039 = $f6a26e9944fb97bc$var$DialogTitle;



var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");


var $2jLNc = parcelRequire("2jLNc");

var $jJYy4 = parcelRequire("jJYy4");

var $32Puv = parcelRequire("32Puv");

var $aBf7M = parcelRequire("aBf7M");


var $fzbVi = parcelRequire("fzbVi");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $74d5a9667dceae39$export$5e8702d71474f093(slot) {
    return (0, $guzMP.default)('MuiIconButton', slot);
}
const $74d5a9667dceae39$var$iconButtonClasses = (0, $bnCUV.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $74d5a9667dceae39$export$2e2bcd8739ae039 = $74d5a9667dceae39$var$iconButtonClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $2c24a543730d33c5$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $2c24a543730d33c5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $fzbVi.default)(color)}`,
            edge && `edge${(0, $fzbVi.default)(edge)}`,
            `size${(0, $fzbVi.default)(size)}`
        ]
    };
    return (0, $2jLNc.default)(slots, (0, $74d5a9667dceae39$export$5e8702d71474f093), classes);
};
const $2c24a543730d33c5$var$IconButtonRoot = (0, $32Puv.default)((0, $6d674dfb4ea8dd71$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $fzbVi.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $fzbVi.default)(ownerState.edge)}`],
            styles[`size${(0, $fzbVi.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jJYy4.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $jz4iA.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $jz4iA.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $jz4iA.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jJYy4.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $74d5a9667dceae39$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $2c24a543730d33c5$var$IconButton = /*#__PURE__*/ $8NFma.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $hQtye.default)(props, $2c24a543730d33c5$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $2c24a543730d33c5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($2c24a543730d33c5$var$IconButtonRoot, (0, $jz4iA.default)({
        className: (0, $ase04.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $2c24a543730d33c5$export$2e2bcd8739ae039 = $2c24a543730d33c5$var$IconButton;


var $1d81d1adfc7dcfa9$exports = {};
"use strict";
"use client";

var $4jcgx = parcelRequire("4jcgx");
Object.defineProperty($1d81d1adfc7dcfa9$exports, "__esModule", {
    value: true
});
$1d81d1adfc7dcfa9$exports.default = void 0;

var $1d81d1adfc7dcfa9$var$_createSvgIcon = $4jcgx((parcelRequire("64yct")));

var $1IdZj = parcelRequire("1IdZj");
var $1d81d1adfc7dcfa9$var$_default = $1d81d1adfc7dcfa9$exports.default = (0, $1d81d1adfc7dcfa9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $1IdZj.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



function $1c79c6e443eff86c$export$68a801b7b3c0bfaa() {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get("/sewppublic/fedramp/products");
}
function $1c79c6e443eff86c$export$9f45d621f32221e9(agencyListSeq) {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`/sewppublic/fedramp/agency-subagency-view/${agencyListSeq}`);
}
function $1c79c6e443eff86c$export$dba8ab375902654(productSeq) {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`/sewppublic/fedramp/product-view/${productSeq}`);
}
function $1c79c6e443eff86c$export$381faccc8bdc07bb(providerSeq, productSeq) {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`/sewppublic/fedramp/provider-view/${providerSeq}/${productSeq}`);
}
function $1c79c6e443eff86c$export$54188f1192d57560(productSeq, providerSeq) {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`/sewppublic/fedramp/contract-holder-view/${productSeq}/${providerSeq}`);
}



function $477a47307201604d$export$2e2bcd8739ae039({ productSeq: productSeq, productName: productName, closeModal: closeModal }) {
    const [agencySubAgencies, setAgencySubAgencies] = (0, $8NFma.useState)(/** @type {FedRampAgencySubAgencyModel[]} */ []);
    const [error, setError] = (0, $8NFma.useState)(null);
    (0, $8NFma.useEffect)(()=>{
        (0, $1c79c6e443eff86c$export$9f45d621f32221e9)(productSeq).then(({ data: data })=>{
            setAgencySubAgencies(data);
        }).catch((error)=>{
            setError(error);
        });
    }, [
        productSeq
    ]);
    let modalContent;
    if (error) modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
        children: (0, $53cc2e000314a49f$export$6bec1cb94a439bf6)
    });
    else if (!agencySubAgencies) modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
        children: "Loading Agency Authorization details"
    });
    else modalContent = /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            "List of Agencies/Subagencies for ",
            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                children: productName
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("ol", {
                children: agencySubAgencies.map((agencySubagency)=>/*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                        className: "fedramp-list-item-space-after",
                        children: [
                            agencySubagency.agencyName,
                            agencySubagency.subagencyNames.length > 1 && /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                                children: agencySubagency.subagencyNames.filter((subagencyName)=>subagencyName !== null).map((subagencyName)=>/*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: subagencyName
                                    }, subagencyName))
                            })
                        ]
                    }, agencySubagency.agencyName))
            })
        ]
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $d29652b1774880ed$export$2e2bcd8739ae039), {
        open: true,
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $f6a26e9944fb97bc$export$2e2bcd8739ae039), {
                sx: {
                    m: 0,
                    p: 2,
                    color: "white",
                    backgroundColor: "#2D5986",
                    padding: "8px 16px"
                },
                children: "Agencies Authorizations"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2c24a543730d33c5$export$2e2bcd8739ae039), {
                "aria-label": "close",
                onClick: closeModal,
                sx: {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    color: "white"
                },
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d81d1adfc7dcfa9$exports))), {})
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8e14d7c3972c0289$export$2e2bcd8739ae039), {
                children: modalContent
            })
        ]
    });
}
$477a47307201604d$export$2e2bcd8739ae039.propTypes = {
    productSeq: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired,
    productName: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    closeModal: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");






var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");


function $f1962841391cf633$export$2e2bcd8739ae039({ productDetails: productDetails, isLoggedIn: isLoggedIn }) {
    const tooltipTitle = /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            "For more information on this Provider or Product please use the ",
            /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                className: "fedramp-toolTipAnchor",
                href: "/sewp5public/rfitool",
                children: "SEWP Market Research Tool"
            })
        ]
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h5", {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                    children: productDetails.productName
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
                condensed: true,
                id: "fedramp-productViewTable",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                    className: "col-xs-4",
                                    children: "Provider"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                    className: "col-xs-4",
                                    children: "Service Model"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                    className: "col-xs-4",
                                    children: "Status"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                            children: [
                                productDetails.providerUrl === null || productDetails.providerUrl.indexOf(".") === -1 ? /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e2821c3898645c77$export$2e2bcd8739ae039), {
                                    title: tooltipTitle,
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                            children: productDetails.providerName
                                        })
                                    })
                                }) : /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                        href: productDetails.providerUrl.replace(/\s/g, ""),
                                        target: "_blank",
                                        children: productDetails.providerName
                                    })
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                    children: productDetails.serviceModel
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                    children: productDetails.status
                                })
                            ]
                        })
                    })
                ]
            }),
            productDetails.providerSeq > 0 && productDetails.compressedProviderName.toUpperCase() !== productDetails.compressedDefaultProviderName.toUpperCase() && /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                className: "fedramp-hasAcquired",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                        children: productDetails.providerName
                    }),
                    " is an affiliate/subsidiary of the SEWP ",
                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                        children: productDetails.providerDefaultName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "fedramp-modalPopUpheading",
                        children: "Agencies/Subagencies"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                    productDetails.agencyNames.length === 0 ? /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        className: "fedramp-nothingFound",
                        children: "No Agency/Subagency to display."
                    }) : /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
                        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("ol", {
                            children: [
                                productDetails.agencyNames.map((agency)=>/*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                        children: [
                                            "\xa0 ",
                                            agency.agencyName,
                                            agency.subagencyNames.filter((subAgencyName)=>subAgencyName !== null).length > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                                                children: agency.subagencyNames.filter((subAgencyName)=>subAgencyName !== null).map((subagencyName)=>/*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                                        children: [
                                                            "\xa0 ",
                                                            subagencyName
                                                        ]
                                                    }, subagencyName))
                                            })
                                        ]
                                    }, agency.agencyName)),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("br", {})
                            ]
                        })
                    })
                ]
            }),
            isLoggedIn && /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "fedramp-modalPopUpheading",
                        children: "Contract Holders"
                    }),
                    productDetails.chNames.length === 0 ? /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        className: "fedramp-nothingFound",
                        children: "No Contract Holders to display"
                    }) : /*#__PURE__*/ (0, $1IdZj.jsx)("ol", {
                        children: productDetails.chNames.map((chName)=>/*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    "\xa0",
                                    chName
                                ]
                            }, chName))
                    })
                ]
            })
        ]
    });
}
$f1962841391cf633$export$2e2bcd8739ae039.propTypes = {
    productDetails: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired,
    isLoggedIn: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired
};




function $3b6b14f2f940237b$export$2e2bcd8739ae039({ productSeq: productSeq, closeModal: closeModal, isLoggedIn: isLoggedIn }) {
    const [productDetails, setProductDetails] = (0, $8NFma.useState)(/** @type FedRampProductViewModel*/ null);
    const [error, setError] = (0, $8NFma.useState)(null);
    (0, $8NFma.useEffect)(()=>{
        setProductDetails(null);
        (0, $1c79c6e443eff86c$export$dba8ab375902654)(productSeq).then(({ data: data })=>{
            setProductDetails(data);
        }).catch((error)=>{
            setError(error);
        });
    }, [
        productSeq
    ]);
    let modalContent;
    if (error) modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
        children: (0, $53cc2e000314a49f$export$6bec1cb94a439bf6)
    });
    else if (productDetails) modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $f1962841391cf633$export$2e2bcd8739ae039), {
        productDetails: productDetails,
        isLoggedIn: isLoggedIn
    });
    else modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
        children: "Loading Product Details"
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $d29652b1774880ed$export$2e2bcd8739ae039), {
        open: true,
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $f6a26e9944fb97bc$export$2e2bcd8739ae039), {
                sx: {
                    m: 0,
                    p: 2,
                    color: "white",
                    backgroundColor: "#2D5986",
                    padding: "8px 16px"
                },
                children: "Product Details"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2c24a543730d33c5$export$2e2bcd8739ae039), {
                "aria-label": "close",
                onClick: closeModal,
                sx: {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    color: "white"
                },
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d81d1adfc7dcfa9$exports))), {})
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8e14d7c3972c0289$export$2e2bcd8739ae039), {
                children: modalContent
            })
        ]
    });
}
$3b6b14f2f940237b$export$2e2bcd8739ae039.propTypes = {
    productSeq: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired,
    closeModal: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    isLoggedIn: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired
};



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");






var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");
function $a10eb96732b5a33b$export$2e2bcd8739ae039({ providerDetails: providerDetails }) {
    function showAffiliateText() {
        return providerDetails.providerSeq > 0 && providerDetails.compressedProviderName !== providerDetails.compressedDefaultProviderName;
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                children: [
                    showAffiliateText() && /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                        className: "fedramp-hasAcquired",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: providerDetails.providerName
                            }),
                            " is an affiliate/subsidiary of the SEWP Provider ",
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: providerDetails.providerDefaultName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            className: "fedramp-providerAnchor",
                            href: providerDetails.providerUrl,
                            target: "_blank",
                            children: providerDetails.providerDefaultName
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "fedramp-modalPopUpheading",
                        children: "Description"
                    }),
                    providerDetails.providerDescription
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "fedramp-modalPopUpheading",
                        children: "Address"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "fedramp-addressDiv",
                        children: [
                            providerDetails.address0,
                            providerDetails.address1 && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                children: [
                                    ", ",
                                    providerDetails.address1
                                ]
                            }),
                            providerDetails.address2 && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                children: [
                                    ", ",
                                    providerDetails.address2
                                ]
                            }),
                            providerDetails.address3 && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                children: [
                                    ", ",
                                    providerDetails.address3
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                            providerDetails.city,
                            providerDetails.state && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                children: [
                                    ", ",
                                    providerDetails.state
                                ]
                            }),
                            providerDetails.zip && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                children: [
                                    " ",
                                    providerDetails.zip
                                ]
                            }),
                            providerDetails.country && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                                    providerDetails.country
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "fedramp-modalPopUpheading",
                        children: "Affiliates/Subsidiaries"
                    }),
                    providerDetails.providerAliases.length === 0 ? /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        className: "fedramp-nothingFound",
                        children: "No Affiliates/Subsidiaries to display"
                    }) : /*#__PURE__*/ (0, $1IdZj.jsx)("ol", {
                        children: providerDetails.providerAliases.map(({ aliasName: aliasName, compressedAliasName: compressedAliasName })=>{
                            if (providerDetails.compressedProviderName.toUpperCase() === compressedAliasName.toUpperCase() && providerDetails.compressedProviderName !== providerDetails.compressedDefaultProviderName) return /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                    style: {
                                        color: "#F1B21C"
                                    },
                                    children: [
                                        "\xa0",
                                        aliasName
                                    ]
                                })
                            }, aliasName + compressedAliasName);
                            else return /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    "\xa0",
                                    aliasName
                                ]
                            }, aliasName + compressedAliasName);
                        })
                    })
                ]
            })
        ]
    });
}
$a10eb96732b5a33b$export$2e2bcd8739ae039.propTypes = {
    providerDetails: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired
};




function $6abc19f9972ca46a$export$2e2bcd8739ae039({ providerSeq: providerSeq, productSeq: productSeq, closeModal: closeModal }) {
    const [providerDetails, setProviderDetails] = (0, $8NFma.useState)(/** @type FedRampProviderViewModel*/ null);
    const [error, setError] = (0, $8NFma.useState)(null);
    (0, $8NFma.useEffect)(()=>{
        setProviderDetails(null);
        (0, $1c79c6e443eff86c$export$381faccc8bdc07bb)(providerSeq, productSeq).then(({ data: data })=>{
            setProviderDetails(data);
        }).catch((error)=>{
            setError(error);
        });
    }, [
        providerSeq,
        productSeq
    ]);
    let modalContent;
    if (error) modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
        children: (0, $53cc2e000314a49f$export$6bec1cb94a439bf6)
    });
    else if (providerDetails) modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a10eb96732b5a33b$export$2e2bcd8739ae039), {
        providerDetails: providerDetails
    });
    else modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
        children: "Loading Provider Details"
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $d29652b1774880ed$export$2e2bcd8739ae039), {
        open: true,
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $f6a26e9944fb97bc$export$2e2bcd8739ae039), {
                sx: {
                    m: 0,
                    p: 2,
                    color: "white",
                    backgroundColor: "#2D5986",
                    padding: "8px 16px"
                },
                children: "Provider Details"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2c24a543730d33c5$export$2e2bcd8739ae039), {
                "aria-label": "close",
                onClick: closeModal,
                sx: {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    color: "white"
                },
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d81d1adfc7dcfa9$exports))), {})
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8e14d7c3972c0289$export$2e2bcd8739ae039), {
                children: modalContent
            })
        ]
    });
}
$6abc19f9972ca46a$export$2e2bcd8739ae039.propTypes = {
    providerSeq: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired,
    productSeq: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired,
    closeModal: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");






var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");


function $b2177831424c1b4e$export$2e2bcd8739ae039({ product: product, contractHoldersGroups: contractHoldersGroups, contractHolderData: contractHolderData }) {
    const [groupFilter, setGroupFilter] = (0, $8NFma.useState)("allGroups");
    function filterContractHolderData(group) {
        return contractHolderData.filter(({ group: chGroup })=>chGroup === group && (groupFilter === "allGroups" || groupFilter === chGroup));
    }
    /**
   * @param {React.ChangeEvent<HTMLInputElement>} event
   */ function handleFilterChange(event) {
        setGroupFilter(event.target.value);
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            "List of Contract Holders for ",
            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                children: product
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                className: "fedramp-chViewRadioContainer",
                children: [
                    "All Groups",
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        type: "radio",
                        value: "allGroups",
                        checked: groupFilter === "allGroups",
                        name: "chViewRadioBtn",
                        onChange: handleFilterChange
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                        className: "fedramp-radioMark"
                    })
                ]
            }),
            contractHoldersGroups.map(({ group: group })=>/*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                    className: "fedramp-chViewRadioContainer",
                    children: [
                        group,
                        /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                            type: "radio",
                            value: group,
                            name: "chViewRadioBtn",
                            checked: group === groupFilter,
                            onChange: handleFilterChange
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                            className: "fedramp-radioMark"
                        })
                    ]
                }, `${group}-radio`)),
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
                id: "fedramp-contractholderlist",
                condensed: true,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                        role: "rowgroup",
                        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                            role: "row",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                    className: "col-xs-5",
                                    role: "columnheader",
                                    children: "Company"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                    className: "col-xs-3",
                                    role: "columnheader",
                                    children: "Contract"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                    className: "col-xs-5",
                                    role: "columnheader",
                                    children: "Business Designation"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                        role: "rowgroup",
                        children: contractHoldersGroups.map(({ group: group, naicsCode: naicsCode })=>{
                            const filteredContractHolderData = filterContractHolderData(group);
                            if (filteredContractHolderData.length > 0) return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $8NFma.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                                        role: "row",
                                        className: "fedramp-groupheader",
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                                role: "columnheader",
                                                colSpan: "2",
                                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                                    children: group
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                                role: "columnheader",
                                                colSpan: "2",
                                                className: "text-right",
                                                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("strong", {
                                                    children: [
                                                        "NAICS Code: ",
                                                        naicsCode
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    filteredContractHolderData.sort((a, b)=>(0, $90eb12c1be8763cc$export$89a1f01f2a7cb2a1)(a, b, "companyName", "asc")).map(({ chInfoSeq: chInfoSeq, companyName: companyName, displayName: displayName, sewpContractNumber: sewpContractNumber, businessSizes: businessSizes })=>/*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                                            className: "fedramp-chViewRow",
                                            children: [
                                                /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                                    role: "rowheader",
                                                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("a", {
                                                        href: `/sewp5public/contractholders#/detail/${chInfoSeq}`,
                                                        target: "_blank",
                                                        children: [
                                                            companyName,
                                                            " (",
                                                            displayName,
                                                            ")"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                                    className: "text-center",
                                                    role: "gridcell",
                                                    children: sewpContractNumber
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                                    className: "text-center",
                                                    role: "gridcell",
                                                    children: businessSizes
                                                })
                                            ]
                                        }, `${chInfoSeq}-${group}`))
                                ]
                            }, group);
                        })
                    })
                ]
            })
        ]
    });
}
$b2177831424c1b4e$export$2e2bcd8739ae039.propTypes = {
    product: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    contractHoldersGroups: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object).isRequired,
    contractHolderData: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object).isRequired
};





function $f34d7c9819a43061$export$2e2bcd8739ae039({ productSeq: productSeq, providerSeq: providerSeq, product: product, closeModal: closeModal }) {
    const [contractHoldersGroups, setContractHoldersGroups] = (0, $8NFma.useState)(/** @type ContractHolderGroup[]*/ []);
    const [contractHolderData, setContractHolderData] = (0, $8NFma.useState)(/** @type FedRampContractHolder[]*/ []);
    const [error, setError] = (0, $8NFma.useState)(null);
    (0, $8NFma.useEffect)(()=>{
        (async ()=>{
            try {
                const [contractHoldersGroupsResponse, contractHolderDataResponse] = await Promise.all([
                    (0, $bcddd5910c38d878$export$ca61d323fa476ae8)(true),
                    (0, $1c79c6e443eff86c$export$54188f1192d57560)(productSeq, providerSeq)
                ]);
                setContractHoldersGroups(contractHoldersGroupsResponse);
                setContractHolderData(contractHolderDataResponse.data);
            } catch (error) {
                setError(error);
            }
        })();
    }, []);
    let modalContent;
    if (error) modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
        children: (0, $53cc2e000314a49f$export$6bec1cb94a439bf6)
    });
    else if (contractHoldersGroups.length > 0 && contractHolderData.length > 0) modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $b2177831424c1b4e$export$2e2bcd8739ae039), {
        product: product,
        contractHoldersGroups: contractHoldersGroups,
        contractHolderData: contractHolderData
    });
    else modalContent = /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
        children: "Loading Contract Holders"
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $d29652b1774880ed$export$2e2bcd8739ae039), {
        open: true,
        onClose: closeModal,
        maxWidth: "lg",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $f6a26e9944fb97bc$export$2e2bcd8739ae039), {
                sx: {
                    m: 0,
                    p: 2,
                    color: "white",
                    backgroundColor: "#2D5986",
                    padding: "8px 16px"
                },
                children: "Contract Holders"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2c24a543730d33c5$export$2e2bcd8739ae039), {
                "aria-label": "close",
                onClick: closeModal,
                sx: {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    color: "white"
                },
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d81d1adfc7dcfa9$exports))), {})
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8e14d7c3972c0289$export$2e2bcd8739ae039), {
                children: modalContent
            })
        ]
    });
}
$f34d7c9819a43061$export$2e2bcd8739ae039.propTypes = {
    productSeq: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired,
    providerSeq: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired,
    product: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    closeModal: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};



function $816b01da08dea86d$export$2e2bcd8739ae039({ fedRampProduct: fedRampProduct, isLoggedIn: isLoggedIn, setModal: setModal, visibleColumn: visibleColumn }) {
    const closeModal = ()=>{
        setModal(null);
    };
    function openAgencyAuthorizationModal(event) {
        setModal(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $477a47307201604d$export$2e2bcd8739ae039), {
            productSeq: fedRampProduct.productSeq,
            productName: fedRampProduct.product,
            closeModal: closeModal
        }));
    }
    function openProductDetailsModal(event) {
        setModal(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $3b6b14f2f940237b$export$2e2bcd8739ae039), {
            productSeq: fedRampProduct.productSeq,
            closeModal: closeModal,
            isLoggedIn: isLoggedIn
        }));
    }
    function openProviderDetailsModal(event) {
        setModal(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $6abc19f9972ca46a$export$2e2bcd8739ae039), {
            providerSeq: fedRampProduct.providerSeq,
            productSeq: fedRampProduct.productSeq,
            closeModal: closeModal
        }));
    }
    function openContractHoldersModal(event) {
        setModal(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $f34d7c9819a43061$export$2e2bcd8739ae039), {
            productSeq: fedRampProduct.productSeq,
            providerSeq: fedRampProduct.providerSeq,
            product: fedRampProduct.product,
            closeModal: closeModal
        }));
    }
    const tooltipTitle = /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            "For more information on this Provider or Product please use the ",
            /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                className: "toolTipAnchor",
                href: "/sewp5public/rfitool",
                children: "SEWP Market Research Tool"
            })
        ]
    });
    if (visibleColumn) return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "clickable blurred",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ed66b1318d0410ff$export$2e2bcd8739ae039), {
                    onClick: openProductDetailsModal,
                    children: fedRampProduct.product
                })
            }),
            fedRampProduct.missingProvider ? /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e2821c3898645c77$export$2e2bcd8739ae039), {
                title: tooltipTitle,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                    className: "missingProviderTd blurred",
                    children: fedRampProduct.missingProvider
                })
            }) : /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "clickable blurred",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ed66b1318d0410ff$export$2e2bcd8739ae039), {
                    onClick: openProviderDetailsModal,
                    children: fedRampProduct.provider
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: visibleColumn === 2 ? "visible-column" : "blurred",
                children: fedRampProduct.serviceModel
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: visibleColumn === 3 ? "visible-column" : "blurred",
                children: fedRampProduct.impactLevel
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: visibleColumn === 4 ? "visible-column" : "blurred",
                children: fedRampProduct.authorizationStatus
            }),
            fedRampProduct.agencyAuthCount > 0 ? /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "clickable blurred",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ed66b1318d0410ff$export$2e2bcd8739ae039), {
                    onClick: openAgencyAuthorizationModal,
                    children: "Details"
                })
            }) : /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "blurred",
                title: "No Agencies found to display",
                children: "None"
            }),
            isLoggedIn && (fedRampProduct.contractHoldersCount > 0 ? /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "clickable blurred",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ed66b1318d0410ff$export$2e2bcd8739ae039), {
                    onClick: openContractHoldersModal,
                    children: fedRampProduct.contractHoldersCount
                })
            }) : /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "blurred",
                title: "No Contract Holder found to display",
                children: fedRampProduct.contractHoldersCount
            }))
        ]
    });
    else return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "clickable",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ed66b1318d0410ff$export$2e2bcd8739ae039), {
                    onClick: openProductDetailsModal,
                    children: fedRampProduct.product
                })
            }),
            fedRampProduct.missingProvider ? /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e2821c3898645c77$export$2e2bcd8739ae039), {
                title: tooltipTitle,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                    className: "missingProviderTd",
                    children: fedRampProduct.missingProvider
                })
            }) : /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "clickable",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ed66b1318d0410ff$export$2e2bcd8739ae039), {
                    onClick: openProviderDetailsModal,
                    children: fedRampProduct.provider
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                children: fedRampProduct.serviceModel
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                children: fedRampProduct.impactLevel
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                children: fedRampProduct.authorizationStatus
            }),
            fedRampProduct.agencyAuthCount > 0 ? /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "clickable",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ed66b1318d0410ff$export$2e2bcd8739ae039), {
                    onClick: openAgencyAuthorizationModal,
                    children: "Details"
                })
            }) : /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                title: "No Agencies found to display",
                children: "None"
            }),
            isLoggedIn && (fedRampProduct.contractHoldersCount > 0 ? /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "clickable",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ed66b1318d0410ff$export$2e2bcd8739ae039), {
                    onClick: openContractHoldersModal,
                    children: fedRampProduct.contractHoldersCount
                })
            }) : /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                title: "No Contract Holder found to display",
                children: fedRampProduct.contractHoldersCount
            }))
        ]
    });
}
$816b01da08dea86d$export$2e2bcd8739ae039.propTypes = {
    fedRampProduct: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired,
    isLoggedIn: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired,
    setModal: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    visibleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number
};



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $9d5dfbcb0a5b63df$export$2e2bcd8739ae039({ hoverModalDisplay: hoverModalDisplay }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "fedramp-serviceModelBox",
        className: `fedramp-serviceModelBoxClass fedramp-hoverBox${hoverModalDisplay}`,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                children: "Service Model:"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            "The type of cloud service:",
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "IaaS:"
                            }),
                            " Infrastructure as a Service"
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "PaaS:"
                            }),
                            " Platform as a Service"
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "SaaS:"
                            }),
                            " Software as a Service"
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "a combination (i.e., PaaS & SaaS or IaaS & PaaS)"
                    })
                ]
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $ada6403b2535814e$export$2e2bcd8739ae039({ hoverModalDisplay: hoverModalDisplay }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "fedramp-impactLevelBox",
        className: `fedramp-impactLevelBoxClass fedramp-hoverBox${hoverModalDisplay}`,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                children: "Impact Level:"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            "The security level for the cloud service offering. Can be:",
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "Low"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "Low-Impact Software-as-a-Service (LI-SaaS)"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "Moderate"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "High"
                    })
                ]
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $9b69c217fe2fd838$export$2e2bcd8739ae039({ hoverModalDisplay: hoverModalDisplay }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "fedramp-statusBox",
        className: `fedramp-statusBoxClass fedramp-hoverBox${hoverModalDisplay}`,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                children: "Status:"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            "Authorization process status:",
            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "Ready:"
                            }),
                            "A Third Party Assessment Organization attests to a cloud service\u2019s readiness for the authorization process."
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "In Process:"
                            }),
                            " Working with the Joint Authorization Board or an Agency to attain a FedRAMP authorization."
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "Authorization:"
                            }),
                            " FedRAMP authorization process completed."
                        ]
                    })
                ]
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $ase04 = parcelRequire("ase04");

var $2jLNc = parcelRequire("2jLNc");


var $fzbVi = parcelRequire("fzbVi");

var $aBf7M = parcelRequire("aBf7M");

var $bnCUV = parcelRequire("bnCUV");

var $guzMP = parcelRequire("guzMP");
function $2412eb1e5c342a1c$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $guzMP.default)('MuiFab', slot);
}
const $2412eb1e5c342a1c$var$fabClasses = (0, $bnCUV.default)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $2412eb1e5c342a1c$export$2e2bcd8739ae039 = $2412eb1e5c342a1c$var$fabClasses;



var $32Puv = parcelRequire("32Puv");
var $fwZkm = parcelRequire("fwZkm");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $2b60c84459256518$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableFocusRipple",
    "focusVisibleClassName",
    "size",
    "variant"
];
const $2b60c84459256518$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $fzbVi.default)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $2jLNc.default)(slots, (0, $2412eb1e5c342a1c$export$e2cfa0ca4bce1fc2), classes);
    return (0, $jz4iA.default)({}, classes, composedClasses);
};
const $2b60c84459256518$var$FabRoot = (0, $32Puv.default)((0, $6d674dfb4ea8dd71$export$2e2bcd8739ae039), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $fwZkm.default)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $fzbVi.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $fzbVi.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $jz4iA.default)({}, theme.typography.button, {
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, $2412eb1e5c342a1c$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        }
    }, ownerState.size === 'small' && {
        width: 40,
        height: 40
    }, ownerState.size === 'medium' && {
        width: 48,
        height: 48
    }, ownerState.variant === 'extended' && {
        borderRadius: 24,
        padding: '0 16px',
        width: 'auto',
        minHeight: 'auto',
        minWidth: 48,
        height: 48
    }, ownerState.variant === 'extended' && ownerState.size === 'small' && {
        width: 'auto',
        padding: '0 8px',
        borderRadius: 17,
        minWidth: 34,
        height: 34
    }, ownerState.variant === 'extended' && ownerState.size === 'medium' && {
        width: 'auto',
        padding: '0 16px',
        borderRadius: 20,
        minWidth: 40,
        height: 40
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $jz4iA.default)({}, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (theme.vars || theme).palette[ownerState.color] != null && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }), ({ theme: theme })=>({
        [`&.${(0, $2412eb1e5c342a1c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    }));
const $2b60c84459256518$var$Fab = /*#__PURE__*/ $8NFma.forwardRef(function Fab(inProps, ref) {
    const props = (0, $aBf7M.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular' } = props, other = (0, $hQtye.default)(props, $2b60c84459256518$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    });
    const classes = $2b60c84459256518$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($2b60c84459256518$var$FabRoot, (0, $jz4iA.default)({
        className: (0, $ase04.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $ase04.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes,
        children: children
    }));
});
var $2b60c84459256518$export$2e2bcd8739ae039 = $2b60c84459256518$var$Fab;


var $ff1ac17d358a5d46$exports = {};
"use strict";
"use client";

var $4jcgx = parcelRequire("4jcgx");
Object.defineProperty($ff1ac17d358a5d46$exports, "__esModule", {
    value: true
});
$ff1ac17d358a5d46$exports.default = void 0;

var $ff1ac17d358a5d46$var$_createSvgIcon = $4jcgx((parcelRequire("64yct")));

var $1IdZj = parcelRequire("1IdZj");
var $ff1ac17d358a5d46$var$_default = $ff1ac17d358a5d46$exports.default = (0, $ff1ac17d358a5d46$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $1IdZj.jsx)("path", {
    d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
}), 'ArrowUpward');


function $3ae264d8021f71ef$export$2e2bcd8739ae039({ id: id, color: color, title: title = "Scroll to the top" }) {
    const [buttonDisplay, setButtonDisplay] = (0, $8NFma.useState)("none");
    (0, $8NFma.useEffect)(()=>{
        function onScroll(e) {
            if (window.scrollY > 0) setButtonDisplay("inline-flex");
            else setButtonDisplay("none");
        }
        window.addEventListener("scroll", onScroll);
        return ()=>{
            window.removeEventListener("scroll", onScroll);
        };
    }, []);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2b60c84459256518$export$2e2bcd8739ae039), {
        id: id,
        color: color,
        "aria-label": "Back to top",
        title: title,
        sx: {
            display: buttonDisplay
        },
        onClick: (event)=>{
            window.scrollTo(0, 0);
        },
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ff1ac17d358a5d46$exports))), {
            fontSize: "large"
        })
    });
}




function $451b754365c81789$export$89a51a73e540fea4() {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get("/sewppublic/user/login-status");
}



function $3402a8e9918e683c$export$8e3f903cccc5bbef(direction) {
    function convertImpactLevelToNumber(impactLevel) {
        switch(impactLevel){
            case "High":
                return 1;
            case "Moderate":
                return 2;
            case "LI-SaaS":
                return 3;
            case "Low":
                return 4;
            default:
                return 5;
        }
    }
    return (fedRampProduct1, fedRampProduct2)=>{
        const impactLevel1 = convertImpactLevelToNumber(fedRampProduct1.impactLevel);
        const impactLevel2 = convertImpactLevelToNumber(fedRampProduct2.impactLevel);
        if (impactLevel1 === impactLevel2) return 0;
        else if (impactLevel1 < impactLevel2) return direction === "asc" ? -1 : 1;
        else return direction === "asc" ? 1 : -1;
    };
}
function $3402a8e9918e683c$export$37eed6a7ca85c19a(direction) {
    function calculateReturn(provider1, provider2) {
        if (direction === "asc") {
            if (provider1.toLowerCase() < provider2.toLowerCase()) return -1;
            else if (provider1.toLowerCase() > provider2.toLowerCase()) return 1;
            else return 0;
        } else {
            if (provider1.toLowerCase() < provider2.toLowerCase()) return 1;
            else if (provider1.toLowerCase() > provider2.toLowerCase()) return -1;
            else return 0;
        }
    }
    return (fedRampProduct1, fedRampProduct2)=>{
        if (fedRampProduct1.missingProvider) {
            if (fedRampProduct2.missingProvider) return calculateReturn(fedRampProduct1.missingProvider, fedRampProduct2.missingProvider);
            else return calculateReturn(fedRampProduct1.missingProvider, fedRampProduct2.provider);
        } else if (fedRampProduct2.missingProvider) return calculateReturn(fedRampProduct1.provider, fedRampProduct2.missingProvider);
        else return calculateReturn(fedRampProduct1.provider, fedRampProduct2.provider);
    };
}





function $8810a6cea18d62f2$export$2e2bcd8739ae039() {
    const [fedRampProducts, setFedRampProducts] = (0, $8NFma.useState)(/** @type FedRampProduct[] */ []);
    const [isLoggedIn, setIsLoggedIn] = (0, $8NFma.useState)(false);
    const [searchFilter, setSearchFilter] = (0, $8NFma.useState)("Product");
    const [searchText, setSearchText] = (0, $8NFma.useState)("");
    const [modal, setModal] = (0, $8NFma.useState)(null);
    const [hoverModal, setHoverModal] = (0, $8NFma.useState)(null);
    const [hoverModalDisplay, setHoverModalDisplay] = (0, $8NFma.useState)("Absolute");
    const [visibleColumn, setVisibleColumn] = (0, $8NFma.useState)(null);
    const [loading, setLoading] = (0, $8NFma.useState)(false);
    const [error, setError] = (0, $8NFma.useState)(null);
    (0, $8NFma.useEffect)(()=>{
        document.title = "NASA SEWP FedRAMP Compliant Products";
    }, []);
    (0, $8NFma.useEffect)(()=>{
        function onScroll(e) {
            // outerHeight instead of innerHeight to work when zoomed in/out
            if (window.outerHeight / 2 > window.scrollY) setHoverModalDisplay("Absolute");
            else setHoverModalDisplay("Fixed");
        }
        window.addEventListener("scroll", onScroll);
        return ()=>{
            window.removeEventListener("scroll", onScroll);
        };
    }, []);
    (0, $8NFma.useEffect)(()=>{
        setLoading(true);
        (0, $1c79c6e443eff86c$export$68a801b7b3c0bfaa)().then(({ data: fedRampProductsData })=>{
            setFedRampProducts(fedRampProductsData);
            setLoading(false);
        }).catch((error)=>{
            setError(error);
        });
    }, []);
    (0, $8NFma.useEffect)(()=>{
        (0, $451b754365c81789$export$89a51a73e540fea4)().then(({ data: loggedInStatus })=>{
            setIsLoggedIn(loggedInStatus);
        }).catch((error)=>{
            setError(error);
        });
    }, []);
    function handleStatusMouseEnter(event) {
        setHoverModal(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $9b69c217fe2fd838$export$2e2bcd8739ae039), {
            hoverModalDisplay: hoverModalDisplay
        }));
        setVisibleColumn(4);
    }
    function handleStatusMouseLeave(event) {
        setHoverModal(null);
        setVisibleColumn(null);
    }
    const headerOptions = [
        {
            name: "Product",
            asc: (a, b)=>(0, $90eb12c1be8763cc$export$89a1f01f2a7cb2a1)(a, b, "product", "asc"),
            desc: (a, b)=>(0, $90eb12c1be8763cc$export$89a1f01f2a7cb2a1)(a, b, "product", "desc")
        },
        {
            name: "Provider",
            asc: (0, $3402a8e9918e683c$export$37eed6a7ca85c19a)("asc"),
            desc: (0, $3402a8e9918e683c$export$37eed6a7ca85c19a)("desc")
        },
        {
            name: "Service Model",
            asc: (a, b)=>(0, $90eb12c1be8763cc$export$89a1f01f2a7cb2a1)(a, b, "serviceModel", "asc"),
            desc: (a, b)=>(0, $90eb12c1be8763cc$export$89a1f01f2a7cb2a1)(a, b, "serviceModel", "desc"),
            onMouseEnter: (event)=>{
                setHoverModal(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $9d5dfbcb0a5b63df$export$2e2bcd8739ae039), {
                    hoverModalDisplay: hoverModalDisplay
                }));
                setVisibleColumn(2);
            },
            onMouseLeave: (event)=>{
                setHoverModal(null);
                setVisibleColumn(null);
            }
        },
        {
            name: "Impact Level",
            asc: (0, $3402a8e9918e683c$export$8e3f903cccc5bbef)("asc"),
            desc: (0, $3402a8e9918e683c$export$8e3f903cccc5bbef)("desc"),
            onMouseEnter: (event)=>{
                setHoverModal(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $ada6403b2535814e$export$2e2bcd8739ae039), {
                    hoverModalDisplay: hoverModalDisplay
                }));
                setVisibleColumn(3);
            },
            onMouseLeave: (event)=>{
                setHoverModal(null);
                setVisibleColumn(null);
            }
        },
        {
            name: "Status",
            asc: (a, b)=>(0, $90eb12c1be8763cc$export$89a1f01f2a7cb2a1)(a, b, "authorizationStatus", "asc"),
            desc: (a, b)=>(0, $90eb12c1be8763cc$export$89a1f01f2a7cb2a1)(a, b, "authorizationStatus", "desc"),
            onMouseEnter: handleStatusMouseEnter,
            onMouseLeave: handleStatusMouseLeave
        },
        {
            name: "Agency Authorization"
        }
    ];
    const loggedInHeaderOption = {
        name: "Contract Holders",
        asc: (a, b)=>(0, $90eb12c1be8763cc$export$93761ee88997c37f)(a, b, "contractHoldersCount", "asc"),
        desc: (a, b)=>(0, $90eb12c1be8763cc$export$93761ee88997c37f)(a, b, "contractHoldersCount", "desc")
    };
    function getFilteredProducts() {
        if (searchText !== "") {
            const reg = new RegExp((0, $3da708ea9eb0f551$export$f176fecabc1d6df7)(searchText));
            return fedRampProducts.filter((fedRampProduct)=>{
                if (searchFilter === "Product") return reg.test(fedRampProduct.product.toLowerCase());
                else if (searchFilter === "Provider") return reg.test(fedRampProduct.provider.toLowerCase()) || reg.test(fedRampProduct?.missingProvider?.toLowerCase());
                else return reg.test(fedRampProduct.product.toLowerCase()) || reg.test(fedRampProduct?.missingProvider?.toLowerCase()) || reg.test(fedRampProduct.provider.toLowerCase()) || reg.test(fedRampProduct.serviceModel.toLowerCase()) || reg.test(fedRampProduct.impactLevel.toLowerCase()) || reg.test(fedRampProduct.authorizationStatus.toLowerCase());
            });
        } else return fedRampProducts;
    }
    if (error) return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        id: "fedramp-wrapper",
        className: "container-fluid",
        children: (0, $53cc2e000314a49f$export$6bec1cb94a439bf6)
    });
    else return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "fedramp-wrapper",
        className: "container-fluid",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $b1d84336a1132a96$export$2e2bcd8739ae039), {
                isLoggedIn: isLoggedIn,
                searchFilter: searchFilter,
                setSearchFilter: setSearchFilter,
                searchText: searchText,
                setSearchText: setSearchText,
                hoverModal: hoverModal,
                blurred: !(visibleColumn === null)
            }),
            modal,
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $523f6a4431def88f$export$2e2bcd8739ae039), {
                tableClassName: "table_font table table-bordered table-condensed",
                data: getFilteredProducts(),
                dataMapper: (fedRampProduct)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $816b01da08dea86d$export$2e2bcd8739ae039), {
                        fedRampProduct: fedRampProduct,
                        isLoggedIn: isLoggedIn,
                        setModal: setModal,
                        visibleColumn: visibleColumn
                    }, fedRampProduct.productSeq),
                headerOptions: isLoggedIn ? [
                    ...headerOptions,
                    loggedInHeaderOption
                ] : headerOptions,
                initialSort: {
                    col: "Product",
                    dir: "asc"
                },
                isSelected: ()=>false,
                loading: loading,
                loadingMessage: "Loading FedRAMP products",
                stickyHeader: true
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3ae264d8021f71ef$export$2e2bcd8739ae039), {
                id: "fedramp-back-to-top",
                color: "primary"
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


function $fbb8967afad0beda$export$2e2bcd8739ae039({ ordersCount: ordersCount, user: user, displayCount: displayCount, changeDisplay: changeDisplay, currentPageCount: currentPageCount }) {
    const orderCountMessage = `(${ordersCount}) ${(0, $3da708ea9eb0f551$export$bbbd05c900f3568d)("order", ordersCount)} found` + (user.firstName === "" && user.lastName === "" ? "" : ` for ${user.firstName} ${user.lastName}`);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        className: "col-xs-4 no-border",
                        children: orderCountMessage
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("th", {
                        className: "col-xs-4 text-center no-border",
                        "data-ng-if": "orderCtl.totalRows>10",
                        children: [
                            "Displaying ",
                            currentPageCount,
                            " of ",
                            ordersCount,
                            " ",
                            (0, $3da708ea9eb0f551$export$bbbd05c900f3568d)("order", ordersCount)
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        className: `col-xs-${ordersCount === displayCount ? "6" : "4"} no-border float-right`,
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            className: "clickable-link",
                            onClick: changeDisplay,
                            href: "javascript:;",
                            children: ordersCount === displayCount ? "View 10 Orders per page" : "View All Orders"
                        })
                    })
                ]
            })
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

function $0594c779cf6bc1c4$export$2e2bcd8739ae039({ ordersCount: ordersCount }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "OrderStatusUserInstructions",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "STN (SEWP Tracking Number) is a unique number related to an order. You can have multiple order numbers associated with one SEWP Tracking Number."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "View the Order Details page by selecting an STN under the SEWP Tracking Number (STN) column."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "View the Contract Holder (CH) detail page by selecting a Contract Holder name under the Contract Holder (CH) column."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: 'E-mail the Contract Holder regarding your order by selecting "Contract Holder & SEWP" under Send E-Mail column.'
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: 'E-mail SEWP for help regarding your order by selecting "SEWP Only" under Send E-Mail column.'
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: "Sort any column by selecting the column heading (in ascending or descending order)."
                    }),
                    ordersCount > (0, $53cc2e000314a49f$export$17e3d0a570f32865) && /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: 'View more than 10 orders per page by selecting "View All Orders".'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                id: "video_OrderStatus",
                "data-videodiv-directive": "",
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("a", {
                    href: "/documents/OrderStatusTool.mp4",
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                            src: "/images/PLAY_50px.png",
                            alt: "PLAY"
                        }),
                        " Watch our 3-minute clip!"
                    ]
                })
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


function $55a9e705fcfeca8b$export$2e2bcd8739ae039({ id: id, className: className, summary: summary, caption: caption, condensed: condensed = true, data: data, mapper: mapper, loading: loading = false, loadingMessage: loadingMessage = (0, $53cc2e000314a49f$export$b8f07f75698d8349), emptyMessage: emptyMessage = "No results found", children: children }) {
    if (loading) return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        style: {
            textAlign: "center"
        },
        children: loadingMessage
    });
    else if (data && data.length === 0) return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
        id: id,
        className: className,
        summary: summary,
        caption: caption,
        condensed: condensed,
        children: [
            children,
            /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                        role: "row",
                        colSpan: "100",
                        className: "col-xs-12 text-center",
                        children: emptyMessage
                    })
                })
            })
        ]
    });
    else return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
        id: id,
        className: className,
        summary: summary,
        caption: caption,
        condensed: condensed,
        children: [
            children,
            /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                children: data.map((item)=>mapper(item))
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

/**
 * @typedef {import("../../../../jsdoc/PaginationPage.js").PaginationPage} PaginationPage
 */ /**
 * Generates list of PaginationPage objects corresponding to the given page information
 * @param {number} currentPage
 * @param {number} totalPages
 * @param {number} [spread=2] number of pages shown before and after current page
 * @returns {PaginationPage[]}
 */ const $e4ad8468e273976e$var$generatePageList = (currentPage, totalPages, spread = 2)=>{
    const pageList = [];
    pageList.push({
        display: "First",
        number: 0,
        status: currentPage === 0 ? (0, $53cc2e000314a49f$export$8ff3b730ee8bcf3d) : (0, $53cc2e000314a49f$export$e201258e0e3ffa55)
    });
    pageList.push({
        display: "Previous",
        number: currentPage - 1,
        status: currentPage === 0 ? (0, $53cc2e000314a49f$export$8ff3b730ee8bcf3d) : (0, $53cc2e000314a49f$export$e201258e0e3ffa55)
    });
    for(let i = spread; i > 0; i--)if (currentPage - i >= 0) pageList.push({
        display: (currentPage - i + 1).toString(),
        number: currentPage - i,
        status: (0, $53cc2e000314a49f$export$e201258e0e3ffa55)
    });
    pageList.push({
        display: (currentPage + 1).toString(),
        number: currentPage,
        status: (0, $53cc2e000314a49f$export$887255b691095f6f)
    });
    let i = currentPage + 1;
    while(i <= currentPage + spread && i < totalPages){
        pageList.push({
            display: (i + 1).toString(),
            number: i,
            status: (0, $53cc2e000314a49f$export$e201258e0e3ffa55)
        });
        i++;
    }
    pageList.push({
        display: "Next",
        number: currentPage + 1,
        status: currentPage === totalPages - 1 ? (0, $53cc2e000314a49f$export$8ff3b730ee8bcf3d) : (0, $53cc2e000314a49f$export$e201258e0e3ffa55)
    });
    pageList.push({
        display: "Last",
        number: totalPages - 1,
        status: currentPage === totalPages - 1 ? (0, $53cc2e000314a49f$export$8ff3b730ee8bcf3d) : (0, $53cc2e000314a49f$export$e201258e0e3ffa55)
    });
    return pageList;
};
function $e4ad8468e273976e$export$2e2bcd8739ae039({ id: id = "", className: className = "", currentPage: currentPage, setCurrentPage: setCurrentPage, totalPages: totalPages }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        id: id,
        className: className,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
            className: "pagination",
            children: $e4ad8468e273976e$var$generatePageList(currentPage, totalPages).map(({ display: display, number: number, status: status })=>{
                const onClick = ()=>{
                    if (status === (0, $53cc2e000314a49f$export$e201258e0e3ffa55)) {
                        setCurrentPage(number);
                        window.scrollTo(0, 0);
                    }
                };
                return /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                    className: status,
                    onClick: onClick,
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                        href: "javascript:;",
                        children: display
                    })
                }, display);
            })
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

/**
 * Replaces spaces and newlines with their Encoding
 * @param {string} unformatted
 * @returns {string}
 */ const $cf63eee1a5612b6a$var$replaceWhitespace = (unformatted)=>unformatted.replace(/ /g, "%20").replace(/\n/g, "%0d");
const $cf63eee1a5612b6a$export$d5477b0c960427e = ({ recipientList: recipientList, ccList: ccList, bccList: bccList, subject: subject, body: body })=>{
    let emailLink = `mailto:${recipientList}`;
    if (!ccList && !bccList && !subject && !body) return emailLink;
    else {
        emailLink += "?";
        let needsAnd = false;
        if (ccList) {
            emailLink += `cc=${ccList}`;
            needsAnd = true;
        }
        if (bccList) {
            emailLink += `${needsAnd ? "&" : ""}bcc=${bccList}`;
            needsAnd = true;
        }
        if (subject) {
            emailLink += `${needsAnd ? "&" : ""}subject=${$cf63eee1a5612b6a$var$replaceWhitespace(subject)}`;
            needsAnd = true;
        }
        if (body) emailLink += `${needsAnd ? "&" : ""}body=${$cf63eee1a5612b6a$var$replaceWhitespace(body)}`;
        return emailLink;
    }
};



function $c530db9bba392ed4$export$2e2bcd8739ae039({ item: item, user: user }) {
    const emailAll = (0, $cf63eee1a5612b6a$export$d5477b0c960427e)({
        recipientList: item.chEmailsConcatenated.trim(),
        ccList: (0, $53cc2e000314a49f$export$b93db1c84990f2fa),
        bccList: (0, $53cc2e000314a49f$export$b93db1c84990f2fa),
        subject: `Customer Question for Order Number: ${item.orderNumber}, STN: ${item.stnSeq}`,
        body: `Hi ${item.companyName} (${item.chDisplayName}),\n\n<ADD YOUR MESSAGE HERE>\n\nFrom:\n${user.firstName} ${user.lastName}`
    });
    const emailSEWP = (0, $cf63eee1a5612b6a$export$d5477b0c960427e)({
        recipientList: (0, $53cc2e000314a49f$export$b93db1c84990f2fa),
        subject: `Customer Question for Order Number: ${item.orderNumber}, STN: ${item.stnSeq}`,
        body: `Hi SEWP,\n\n<ADD YOUR MESSAGE HERE>\n\nFrom:\n${user.firstName} ${user.lastName}`
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        className: "order-entry-row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                role: "rowheader",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                    href: `#/detail/${item.stnSeq}`,
                    title: `Go to the detail page for ${item.stnSeq}`,
                    children: item.stnSeq
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: item.orderNumber
            }),
            item.rfqSeqFlag === 1 ? /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                    href: `../sewp5public/detail.html?rs=${item.rfqSeq}`,
                    children: item.rfqSeq
                })
            }) : /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                title: "You don't have access to this RFQ.",
                children: item.rfqSeq
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $a8cea113a6044695$export$a6c7ac8248d6e38a), {
                    to: `/sewp5public/contractholders#/detail/${item.chInfoSeq}`,
                    children: [
                        item.companyName,
                        " (",
                        item.chDisplayName,
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: item.awardDate
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: item.expDeliveryDate
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: item.totalAmountJSON
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: item.orderStatusDisplay
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-center",
                role: "gridcell",
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                    className: "list-unstyled",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                            className: "td-box-centered",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                href: emailAll,
                                children: "Contract Holder & SEWP"
                            })
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                            className: "td-box-centered",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                href: emailSEWP,
                                children: "SEWP Only"
                            })
                        })
                    ]
                })
            })
        ]
    });
}





function $c6a62f5a9973af68$export$2e2bcd8739ae039({ ordersList: ordersList, user: user, loadingOrdersList: loadingOrdersList }) {
    const [displayCount, setDisplayCount] = (0, $8NFma.useState)((0, $53cc2e000314a49f$export$17e3d0a570f32865));
    const [currentPage, setCurrentPage] = (0, $8NFma.useState)(0);
    const [sortOption, setSortOption] = (0, $8NFma.useState)((0, $53cc2e000314a49f$export$10bb27af362e4701));
    const totalPages = ordersList.length === 0 ? 1 : Math.ceil(ordersList.length / displayCount);
    const changeDisplay = ()=>{
        displayCount === (0, $53cc2e000314a49f$export$17e3d0a570f32865) ? setDisplayCount(ordersList.length) : setDisplayCount((0, $53cc2e000314a49f$export$17e3d0a570f32865));
        setCurrentPage(0);
    };
    /**
   * Maps OrdersListItem object to Component
   * @param {OrdersListItem} item
   * @returns {React.JSX.Element}
   */ const OrdersListItemDisplay = (item)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $c530db9bba392ed4$export$2e2bcd8739ae039), {
            item: item,
            user: user
        }, item.stnSeq);
    const sliceData = (data)=>data.slice(currentPage * displayCount, (currentPage + 1) * displayCount);
    const sortData = (data)=>data.sort((0, $90eb12c1be8763cc$export$697f390c5b62ec81)[sortOption]);
    const displayData = sliceData(sortData(ordersList));
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $fbb8967afad0beda$export$2e2bcd8739ae039), {
                user: user,
                ordersCount: ordersList.length,
                displayCount: displayCount,
                changeDisplay: changeDisplay,
                currentPageCount: displayData.length
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $0594c779cf6bc1c4$export$2e2bcd8739ae039), {
                ordersCount: ordersList.length
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $55a9e705fcfeca8b$export$2e2bcd8739ae039), {
                id: "orderlist",
                data: displayData,
                mapper: OrdersListItemDisplay,
                caption: "Sorted list of orders",
                loading: loadingOrdersList,
                loadingMessage: "Loading Orders...",
                emptyMessage: "No orders to display.",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                    role: "rowgroup",
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                        role: "row",
                        className: "order-entry-row",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "stnseq-head",
                                className: "text-center",
                                text: "SEWP Tracking Number (STN)",
                                onClick: (0, $90eb12c1be8763cc$export$ed6bdb0d0cb503ff)((0, $53cc2e000314a49f$export$10bb27af362e4701), setSortOption),
                                title: "STN",
                                sortOption: sortOption,
                                sortDesc: (0, $53cc2e000314a49f$export$10bb27af362e4701)
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "order-head",
                                className: "text-center",
                                text: "Order Number",
                                onClick: (0, $90eb12c1be8763cc$export$ed6bdb0d0cb503ff)((0, $53cc2e000314a49f$export$bb197327b04c878b), setSortOption),
                                title: "order number",
                                sortOption: sortOption,
                                sortDesc: (0, $53cc2e000314a49f$export$bb197327b04c878b)
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "rfq-head",
                                className: "text-center",
                                text: "RFQ",
                                onClick: (0, $90eb12c1be8763cc$export$ed6bdb0d0cb503ff)((0, $53cc2e000314a49f$export$5637c64aa29c45b0), setSortOption),
                                title: "RFQ",
                                sortOption: sortOption,
                                sortDesc: (0, $53cc2e000314a49f$export$5637c64aa29c45b0)
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "ch-head",
                                className: "text-center",
                                text: "Contract Holder (CH)",
                                onClick: (0, $90eb12c1be8763cc$export$ed6bdb0d0cb503ff)((0, $53cc2e000314a49f$export$1597d3d79f36bd09), setSortOption),
                                title: "CH",
                                sortOption: sortOption,
                                sortDesc: (0, $53cc2e000314a49f$export$1597d3d79f36bd09)
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "awarddate-head",
                                className: "text-center",
                                text: "Award Date",
                                onClick: (0, $90eb12c1be8763cc$export$ed6bdb0d0cb503ff)((0, $53cc2e000314a49f$export$d791af190ad3ce03), setSortOption),
                                title: "award date",
                                sortOption: sortOption,
                                sortDesc: (0, $53cc2e000314a49f$export$d791af190ad3ce03)
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "expecteddeliverydate-head",
                                className: "text-center",
                                text: "Expected Delivery Date",
                                onClick: (0, $90eb12c1be8763cc$export$ed6bdb0d0cb503ff)((0, $53cc2e000314a49f$export$258047127fa9a409), setSortOption),
                                title: "expected delivery date",
                                sortOption: sortOption,
                                sortDesc: (0, $53cc2e000314a49f$export$258047127fa9a409)
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "ordertotal-head",
                                className: "text-center",
                                text: "Order Total",
                                onClick: (0, $90eb12c1be8763cc$export$ed6bdb0d0cb503ff)((0, $53cc2e000314a49f$export$5252ff91cdd72fe4), setSortOption),
                                title: "order total",
                                sortOption: sortOption,
                                sortDesc: (0, $53cc2e000314a49f$export$5252ff91cdd72fe4)
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "orderstatus-head",
                                className: "text-center",
                                text: "Status",
                                onClick: (0, $90eb12c1be8763cc$export$ed6bdb0d0cb503ff)((0, $53cc2e000314a49f$export$bb33f37e01d8da72), setSortOption),
                                title: "status",
                                sortOption: sortOption,
                                sortDesc: (0, $53cc2e000314a49f$export$bb33f37e01d8da72)
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "emaillink-head",
                                className: "text-center",
                                title: "Not sortable",
                                text: "Send E-mail"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e4ad8468e273976e$export$2e2bcd8739ae039), {
                id: "pagination-box",
                currentPage: currentPage,
                setCurrentPage: setCurrentPage,
                totalPages: totalPages
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $cf36c7ed7e71e950$export$2e2bcd8739ae039({ stnSeq: stnSeq }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
        className: "page_title order-header",
        role: "banner",
        tabIndex: "-1",
        children: `Order Details for SEWP Tracking Number (STN): ${stnSeq}`
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");





function $f3a12ef36768f139$export$2e2bcd8739ae039({ chInfoSeq: chInfoSeq, rfqSeq: rfqSeq, stnSeq: stnSeq, awardDate: awardDate, chDisplayName: chDisplayName, chEmailsConcatenated: chEmailsConcatenated, companyName: companyName, contractNumber: contractNumber, deliveryStatus: deliveryStatus, expDeliveryDate: expDeliveryDate, firstName: firstName, lastName: lastName, modDate: modDate, modLevel: modLevel, orderNumbers: orderNumbers, orderStatus: orderStatus, orderTotal: orderTotal, rfqSeqFlag: rfqSeqFlag }) {
    const emailAll = (0, $cf63eee1a5612b6a$export$d5477b0c960427e)({
        recipientList: chEmailsConcatenated.trim(),
        ccList: (0, $53cc2e000314a49f$export$b93db1c84990f2fa),
        bccList: (0, $53cc2e000314a49f$export$b93db1c84990f2fa),
        subject: `Customer Question for Order Number: ${orderNumbers[0]}, STN: ${stnSeq}`,
        body: `Hi ${chDisplayName},\n\n<ADD YOUR MESSAGE HERE>\n\nFrom:\n${firstName} ${lastName}`
    });
    const emailSEWP = (0, $cf63eee1a5612b6a$export$d5477b0c960427e)({
        recipientList: (0, $53cc2e000314a49f$export$b93db1c84990f2fa),
        subject: `Customer Question for Order Number: ${orderNumbers[0]}, STN: ${stnSeq}`,
        body: `Hi SEWP,\n\n<ADD YOUR MESSAGE HERE>\n\nFrom:\n${firstName} ${lastName}`
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "panel-body",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
                        id: "generalInfo",
                        summary: `Order Details for STN: ${stnSeq}`,
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                                role: "rowgroup",
                                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                                    role: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                            id: "stnSeq-head",
                                            text: "STN"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                            id: "orderNumber-head",
                                            text: "Order Number(s)"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                            id: "rfqSeq-head",
                                            text: "RFQ"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                            id: "ch-head",
                                            text: "Contract Holder"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                            id: "contract-head",
                                            text: "Contract Number"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                            id: "ordertotal-head",
                                            text: "Order Amount"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                            id: "awardDate-head",
                                            text: "Award Date"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                            id: "modDate-head",
                                            text: "Mod Date"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                            id: "modLevel-head",
                                            text: "Mod Level"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                                role: "rowgroup",
                                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                                    role: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                            role: "rowheader",
                                            headers: "stn-head",
                                            children: stnSeq
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            role: "gridcell",
                                            headers: "row-head name-head",
                                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                                                className: "list-unstyled",
                                                children: orderNumbers.map((orderNumber, index)=>index === 0 ? /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                                            children: orderNumber
                                                        })
                                                    }, orderNumber) : /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                                        children: orderNumber
                                                    }, orderNumber))
                                            })
                                        }),
                                        rfqSeqFlag === 1 ? /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            className: "text-center",
                                            role: "gridcell",
                                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                                href: `../sewp5public/detail.html?rs=${rfqSeq}`,
                                                children: rfqSeq
                                            })
                                        }) : /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            className: "text-center",
                                            role: "gridcell",
                                            title: "You don't have access to this RFQ.",
                                            children: rfqSeq
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            role: "gridcell",
                                            headers: "row-head",
                                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $a8cea113a6044695$export$a6c7ac8248d6e38a), {
                                                to: `/sewp5public/contractholders#/detail/${chInfoSeq}`,
                                                children: [
                                                    companyName,
                                                    " (",
                                                    chDisplayName,
                                                    ")"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            role: "gridcell",
                                            headers: "row-head",
                                            children: contractNumber
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            role: "gridcell",
                                            headers: "row-head",
                                            children: orderTotal
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            role: "gridcell",
                                            headers: "row-head",
                                            children: awardDate
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            role: "gridcell",
                                            headers: "row-head",
                                            children: modDate
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            role: "gridcell",
                                            headers: "row-head",
                                            children: modLevel
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("h5", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "Order Status: "
                            }),
                            orderStatus
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("h5", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "Delivery Status: "
                            }),
                            deliveryStatus
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("h6", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                children: "Expected Delivery Date: "
                            }),
                            expDeliveryDate
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("th", {
                            className: "center",
                            children: [
                                "Questions about your order? ",
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("a", {
                                    href: emailAll,
                                    children: [
                                        "E-mail ",
                                        chDisplayName,
                                        " & SEWP "
                                    ]
                                }),
                                "OR ",
                                /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                    href: emailSEWP,
                                    children: "E-mail SEWP Only"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $0cfd664ceb09d51f$export$2e2bcd8739ae039({ contact: contact, primary: primary }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                role: "gridcell",
                headers: "row-head name-head",
                children: `${contact.firstName} ${contact.lastName}${primary ? " (Primary)" : ""}`
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                role: "gridcell",
                headers: "row-head email-head",
                children: contact.email
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                role: "gridcell",
                headers: "row-head phone-head",
                children: contact.phone
            })
        ]
    });
}


function $ebdbf90f3db27525$export$2e2bcd8739ae039({ stnSeq: stnSeq, existingContacts: existingContacts }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "panel-body",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
            id: "contactInfo",
            summary: `List of Contacts for STN: ${stnSeq}`,
            condensed: false,
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                    role: "rowgroup",
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                        role: "row",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "name-head",
                                text: "Name"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "email-head",
                                text: "E-mail Address"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                                id: "phone-head",
                                text: "Phone Number"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                    role: "rowgroup",
                    children: existingContacts.map((contact, index)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $0cfd664ceb09d51f$export$2e2bcd8739ae039), {
                            primary: index === 0,
                            contact: contact
                        }, contact.contactSeq))
                })
            ]
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $49788680172acc36$export$2e2bcd8739ae039({ existingAttachments: existingAttachments }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "panel-body",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
            className: "list-unstyled",
            children: existingAttachments.length === 0 ? /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                children: "No attachments found to display"
            }) : existingAttachments.map((attachment, index)=>/*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                        href: `attachment/${attachment}`,
                        children: attachment
                    })
                }, index))
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $f9a888f733e37507$export$2e2bcd8739ae039({ notesHistoryString: notesHistoryString }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "panel-body",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("pre", {
            children: notesHistoryString
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $922d6b3487a5b732$export$2e2bcd8739ae039({ id: id, className: className = "", text: text, onClick: onClick, disabled: disabled = false, title: title, small: small = false }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
        id: id,
        className: `${small ? "btn-small" : "btn"} ${className}`,
        disabled: disabled,
        onClick: onClick,
        title: title,
        children: text
    });
}



function $cae693ab0a5f39c2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "tabs",
        className: "btn-group panel",
        role: "group",
        "aria-label": "Select the button to go directly to that section of the page",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                id: "orderAppLinkButton",
                href: `#/${(0, $53cc2e000314a49f$export$fa0874104c3ed09a)}`,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $922d6b3487a5b732$export$2e2bcd8739ae039), {
                    small: true,
                    text: "Back to Orders List"
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $922d6b3487a5b732$export$2e2bcd8739ae039), {
                small: true,
                text: "Order General Info",
                onClick: ()=>document.getElementById("Order_geninfo").scrollIntoView()
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $922d6b3487a5b732$export$2e2bcd8739ae039), {
                small: true,
                text: "Contacts",
                onClick: ()=>document.getElementById("Order_contacts").scrollIntoView()
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $922d6b3487a5b732$export$2e2bcd8739ae039), {
                small: true,
                text: "Attachments",
                onClick: ()=>document.getElementById("Order_attachments").scrollIntoView()
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $922d6b3487a5b732$export$2e2bcd8739ae039), {
                small: true,
                text: "Notes History",
                onClick: ()=>document.getElementById("Order_notesHistory").scrollIntoView()
            })
        ]
    });
}



function $51c83b00d2ba29f5$export$a5be085772e686f9(sewperContactSeq) {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039)(`/sewppublic/orderapp/order/search/SCS/${sewperContactSeq}`);
}
function $51c83b00d2ba29f5$export$91043804b5457f8c(orderId) {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`/sewppublic/orderapp/order/orderdetails/${orderId}`);
}
function $51c83b00d2ba29f5$export$1f367265ec1dc779() {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get("/sewppublic/orderapp/order/user");
}


function $a291dc0c891e8959$export$2e2bcd8739ae039({ setFetchError: setFetchError, id: id, user: user }) {
    /** @type {[OrderDetails?, React.Dispatch<React.SetActionState<OrderDetails>>]} */ const [orderDetail, setOrderDetail] = (0, $8NFma.useState)();
    (0, $8NFma.useEffect)(()=>{
        (0, $51c83b00d2ba29f5$export$91043804b5457f8c)(id).then(({ data: orderDetailResponse })=>{
            setOrderDetail(orderDetailResponse);
        }).catch((error)=>{
            setFetchError(error);
        });
    }, [
        id
    ]);
    if (orderDetail) {
        // using an onClick instead of href b/c url already contains a '#'
        const scrollToTop = ()=>document.getElementById("TOP").scrollIntoView();
        const scrollToTopElement = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            className: "text-center link clickable",
            role: "link",
            children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                onClick: scrollToTop,
                children: "Back To Top"
            })
        });
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            id: "order-app-wrapper",
            className: "container-fluid",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    id: "TOP"
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cf36c7ed7e71e950$export$2e2bcd8739ae039), {
                    stnSeq: id
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cae693ab0a5f39c2$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $2715765958fac4b7$export$2e2bcd8739ae039), {
                    id: "Order_geninfo",
                    primary: true,
                    className: "table-responsive",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dd60dc182c32fb28$export$2e2bcd8739ae039), {
                            title: "Order General Info"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $f3a12ef36768f139$export$2e2bcd8739ae039), {
                            stnSeq: id,
                            orderStatus: orderDetail.orderStatus,
                            deliveryStatus: orderDetail.deliveryStatus,
                            expDeliveryDate: orderDetail.expDeliveryDate,
                            chDisplayName: orderDetail.chDisplayName,
                            chEmailsConcatenated: orderDetail.chEmailsConcatenated,
                            orderNumbers: orderDetail.orderNumbers,
                            firstName: user.firstName,
                            lastName: user.lastName,
                            rfqSeqFlag: orderDetail.rfqSeqFlag,
                            rfqSeq: orderDetail.rfqSeq,
                            companyName: orderDetail.companyName,
                            chInfoSeq: orderDetail.chInfoSeq,
                            contractNumber: orderDetail.contractNumber,
                            orderTotal: orderDetail.orderTotal,
                            awardDate: orderDetail.awardDate,
                            modDate: orderDetail.modDate,
                            modLevel: orderDetail.modLevel
                        })
                    ]
                }),
                scrollToTopElement,
                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $2715765958fac4b7$export$2e2bcd8739ae039), {
                    id: "Order_contacts",
                    primary: true,
                    className: "table-responsive",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dd60dc182c32fb28$export$2e2bcd8739ae039), {
                            title: "Contacts"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ebdbf90f3db27525$export$2e2bcd8739ae039), {
                            stnSeq: id,
                            existingContacts: orderDetail.existingContacts
                        })
                    ]
                }),
                scrollToTopElement,
                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $2715765958fac4b7$export$2e2bcd8739ae039), {
                    id: "Order_attachments",
                    primary: true,
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dd60dc182c32fb28$export$2e2bcd8739ae039), {
                            title: "Attachments"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $49788680172acc36$export$2e2bcd8739ae039), {
                            existingAttachments: orderDetail.existingAttachments
                        })
                    ]
                }),
                scrollToTopElement,
                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $2715765958fac4b7$export$2e2bcd8739ae039), {
                    id: "Order_notesHistory",
                    primary: true,
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dd60dc182c32fb28$export$2e2bcd8739ae039), {
                            title: "Notes History"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $f9a888f733e37507$export$2e2bcd8739ae039), {
                            notesHistoryString: orderDetail.notesHistoryString
                        })
                    ]
                }),
                scrollToTopElement
            ]
        });
    } else return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        children: "Loading Order Status..."
    });
}



const $f052fbb85346a1ed$export$ab4ae02812b15a92 = (path)=>{
    const pathArray = path.split("/");
    if (pathArray.length === 3 && pathArray[1] === (0, $53cc2e000314a49f$export$c62e1e68e9b129bf) && Number.isInteger(Number(pathArray[2]))) return {
        type: (0, $53cc2e000314a49f$export$c62e1e68e9b129bf),
        id: Number(pathArray[2])
    };
    else if (pathArray.length === 1 && pathArray[0] === "" || pathArray.length === 2 && pathArray[1] === (0, $53cc2e000314a49f$export$fa0874104c3ed09a)) return {
        type: (0, $53cc2e000314a49f$export$fa0874104c3ed09a)
    };
    else return {
        type: null
    };
};





function $59bf67ae5e339d17$export$2e2bcd8739ae039() {
    const [path, setPath] = (0, $8NFma.useState)(window.location.hash);
    const [fetchError, setFetchError] = (0, $8NFma.useState)(false);
    /** @type {[OrdersListItem[], React.Dispatch<React.SetActionState<OrdersListItem[]>>]} */ const [ordersList, setOrdersList] = (0, $8NFma.useState)([]);
    const [user, setUser] = (0, $8NFma.useState)({
        firstName: "",
        lastName: "",
        sewperContactSeq: ""
    });
    const [loadingOrdersList, setLoadingOrdersList] = (0, $8NFma.useState)(false);
    //listen for hash changes to update path state
    (0, $8NFma.useEffect)(()=>{
        window.onhashchange = ()=>{
            setPath(window.location.hash);
        };
    }, []);
    //update document title
    (0, $8NFma.useEffect)(()=>{
        const { type: type, id: id } = (0, $f052fbb85346a1ed$export$ab4ae02812b15a92)(path);
        switch(type){
            case 0, $53cc2e000314a49f$export$fa0874104c3ed09a:
                document.title = "NASA SEWP Orders List";
                break;
            case 0, $53cc2e000314a49f$export$c62e1e68e9b129bf:
                document.title = `NASA SEWP ORDER - ${id}`;
                break;
        }
    }, [
        path
    ]);
    (0, $8NFma.useEffect)(()=>{
        setLoadingOrdersList(true);
        (0, $51c83b00d2ba29f5$export$1f367265ec1dc779)().then(({ data: user })=>{
            setUser({
                firstName: user.sewperContactFirst,
                lastName: user.sewperContactLast,
                sewperContactSeq: user.sewperContactSeq
            });
            (0, $51c83b00d2ba29f5$export$a5be085772e686f9)(user.sewperContactSeq).then(({ data: ordersListResponse })=>{
                setOrdersList(ordersListResponse);
                setLoadingOrdersList(false);
            });
        }).catch((error)=>{
            setFetchError(error);
        });
    }, []);
    const display = (0, $f052fbb85346a1ed$export$ab4ae02812b15a92)(path);
    let content;
    if (fetchError) content = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        children: (0, $53cc2e000314a49f$export$6bec1cb94a439bf6)
    });
    else if (display.type === (0, $53cc2e000314a49f$export$fa0874104c3ed09a)) content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $c6a62f5a9973af68$export$2e2bcd8739ae039), {
        loadingOrdersList: loadingOrdersList,
        ordersList: ordersList,
        user: user
    });
    else if (display.type === (0, $53cc2e000314a49f$export$c62e1e68e9b129bf)) content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a291dc0c891e8959$export$2e2bcd8739ae039), {
        setFetchError: setFetchError,
        id: display.id,
        user: user
    });
    else content = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        children: "Page not found."
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "order-app-wrapper",
        className: "container-fluid",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                className: "page_title",
                role: "banner",
                tabIndex: "-1",
                children: "NASA SEWP Order Status"
            }),
            content
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");
function $7ad156834b5011ad$export$2e2bcd8739ae039() {
    const videoRef = (0, $8NFma.useRef)(null);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                className: "page_title",
                children: " Contract Holder Program Performance"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                className: "p_content",
                children: [
                    "The chart below is a current Program Performance rating by the SEWP Program Office based on the criteria described within the headings in each column. This does not constitute the official Past Performance ratings based on",
                    /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                        href: "https://acquisition.gov/far/part-42#FAR_Subpart_42_15",
                        target: "_blank",
                        children: " FAR Part 42.15"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                className: "p_content",
                children: "Reminder: If a best value decision for a delivery order award is being made, which may include the SEWP Program Performance criteria, the Request for Quote shall contain the evaluation criteria."
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                id: "programPerformanceVideo",
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("a", {
                    className: "ProgramPerformance",
                    target: "_blank",
                    href: "/documents/ProgramPerformance.mp4",
                    ref: videoRef,
                    onClick: (event)=>{
                        event.preventDefault();
                        videoPlayerHandler(videoRef.current);
                    },
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                            src: "/images/PLAY_50px.png",
                            alt: "PLAY"
                        }),
                        "Program Performance - Delivery Ratings"
                    ]
                })
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

function $799ca28831b28fe7$export$2e2bcd8739ae039({ id: id, className: className, onClick: onClick, title: title, children: children }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
        id: id,
        className: className,
        title: title,
        onClick: onClick,
        role: "columnheader",
        onKeyDown: (event)=>{
            if (event.key === (0, $53cc2e000314a49f$export$ddffaa7057c7de39)) onClick(event);
        },
        tabIndex: onClick ? 0 : -1,
        children: children
    });
}
$799ca28831b28fe7$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node
};



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $10c193ef5276d989$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("tr", {
        className: "extra-info",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
            colSpan: 6,
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("h6", {
                        className: "bold",
                        children: "Reports"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                        children: [
                            "The Reports rating is based on the contract holder ensuring that all required reports are submitted to the SEWP Program Office in a timely manner and accurate.",
                            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("em", {
                                children: "*Reports are as defined in section A.1.1. of the SEWP contracts "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        className: "performance-desc-range",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "excellent",
                                children: "Excellent - 100%"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "very-good",
                                children: "Very Good - 90-99%"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "good",
                                children: "Good - 80-89%"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "fair",
                                children: "Fair - 70-79%"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "poor",
                                children: "Poor - < 70%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Excellent"
                                    }),
                                    " = All items 100% on time and accurate"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Very Good"
                                    }),
                                    " = Average timeliness and accuracy between 90-99%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Good"
                                    }),
                                    " = Average timeliness and accuracy between 80-89%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Fair"
                                    }),
                                    " = Average timeliness and accuracy between 70-79%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Poor"
                                    }),
                                    " = Average timeliness and accuracy < 70%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Neutral"
                                    }),
                                    " = Contract Holder has not received any orders or performed any work on the SEWP contracts to date"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

function $3f4e0dc826a72806$export$2e2bcd8739ae039({ handleClick: handleClick, actionType: actionType }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        role: "button",
        className: "more-info-link",
        tabIndex: 0,
        title: "Click for more info",
        onClick: (event)=>{
            handleClick(actionType, event);
        },
        onKeyDown: (event)=>{
            if (event.key === (0, $53cc2e000314a49f$export$ddffaa7057c7de39)) handleClick(actionType, event);
        },
        children: "Click for more info"
    });
}
$3f4e0dc826a72806$export$2e2bcd8739ae039.propTypes = {
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    actionType: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired
};



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $eb2d2e1eebca3558$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("tr", {
        className: "extra-info",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
            colSpan: 6,
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("h6", {
                        className: "bold",
                        children: "Customer Satisfaction"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        children: "The Customer Satisfaction rating is based on the quality of products and services, responsiveness, and interaction with customers and problem resolution."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        className: "performance-desc-range",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "excellent",
                                children: "Excellent - 0-1"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "very-good",
                                children: "Very Good - 2-3"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "good",
                                children: "Good - 4-5"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "fair",
                                children: "Fair - 6-7"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "poor",
                                children: "Poor - > 7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Excellent"
                                    }),
                                    " = 0-1 reports of quality issues or concerns and all resolved to customer satisfaction with little or no delay"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Very Good"
                                    }),
                                    " = 2-3 reports of minor issues; all are resolved to customer satisfaction with little or no delay"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Good"
                                    }),
                                    " = 4-5 reports of issues not all fully resolved and/or a continuing pattern of delayed response to a customer"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Fair"
                                    }),
                                    " = 6-7 reports of issues that are not fully resolved and/or a continuing pattern of delayed response to a customer"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Poor"
                                    }),
                                    " = 7+ reports of issues that are not fully resolved and/or a continuing pattern of delayed response to a customer"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Neutral"
                                    }),
                                    " = Contract Holder has not received any orders or performed any work on the SEWP contracts to date"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $397fc727885190b9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("tr", {
        className: "extra-info",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
            colSpan: 6,
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("h6", {
                        className: "bold",
                        children: "Information Distribution"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                        children: [
                            "The Information Distribution rating is based the accuracy of the information provided by Contract Holder to Customers through sales agents, associated companies, website, handouts and etc. ",
                            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                            "The Contract Holder is responsible for communicating correct information on all business aspects that apply to the SEWP Program."
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        className: "performance-desc-range",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "excellent",
                                children: "Excellent - 0-1"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "very-good",
                                children: "Very Good - 2-3"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "good",
                                children: "Good - 4-5"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "fair",
                                children: "Fair - 6"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "poor",
                                children: "Poor - > 7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Excellent"
                                    }),
                                    " = 0-1 instance of incorrect or partial information provided to customer"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Very Good"
                                    }),
                                    " = 2-3 instances of incorrect or partial information and Contract Holder quickly resolved situation"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Good"
                                    }),
                                    " = 4-5 instances of incorrect or partial information and contract holder quickly resolved situation or instances of incorrect or partial information were not resolved and/or were repeated"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Fair"
                                    }),
                                    " = 6 instances of incorrect or partial information and contract holder quickly resolved situation or instances of incorrect or partial information were not resolved and/or were repeated"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Poor"
                                    }),
                                    " = 7+ requests to fix incorrect or partial information continuously ignored"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Neutral"
                                    }),
                                    " = Contract Holder has not received any orders or performed any work on the SEWP contracts to date"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $37838351ef4a37a1$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("tr", {
        className: "extra-info",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
            colSpan: 6,
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("h6", {
                        className: "bold",
                        children: "Contract Adherence"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        children: "The Contract Adherence rating refers to the Contract holder\u2019s ability to adhere to all contractual require including but not limited following the correct quoting procedures and SEWP order fulfillment guidelines."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        className: "performance-desc-range",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "excellent",
                                children: "Excellent - 0-2 / 100%-91% verified"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "very-good",
                                children: "Very Good - 3 / 90%-81% verified"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "good",
                                children: "Good - 4 / 80%-71% verified"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "fair",
                                children: "Fair - 5 / 70%-61% verified"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                className: "poor",
                                children: "Poor - >= 6 / <= 60%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Excellent"
                                    }),
                                    " = <= 2 issues occurred, and/or 100% - 91% verified orders"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Very Good"
                                    }),
                                    " = 3 issues occurred and contract holder quickly resolved situation, or issues occurred and several not resolved and/or were repeated, and /or 90% - 81% verified orders"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Good"
                                    }),
                                    " = 4 issues occurred and contract holder quickly resolved situation, or issues occurred and several not resolved and/or were repeated, and /or 80% - 71% verified orders"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Fair"
                                    }),
                                    " = 5 issues occurred and contract holder quickly resolved situation, or issues occurred and several not resolved and/or were repeated, and /or 70% - 61% verified orders"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Poor"
                                    }),
                                    " = >= 6 issues occurred and/or request to fix issues continuously ignored, and or  <= 60% verified orders"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "Neutral"
                                    }),
                                    " = Contract Holder has not received any orders or performed any work on the SEWP contracts to date"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $d8281485bd8e508a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("tr", {
        className: "extra-info",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
            colSpan: 6,
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("h6", {
                        className: "bold",
                        children: "Delivery Rating"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        children: "The Delivery rating refers to the contract holder's ability to meet the expected delivery date as agreed upon by both the contract holder and ordering agency during the quoting period of a SEWP request. The rating will be calculated based on the percentage of late deliveries and missed deliveries as well as factor in the average delay in delivery during the past six months for each contract holder."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        children: "The average delay will be considered and contract holders may receive up to 3 additional strikes:"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                children: "30 - 45 Days: 1 strike"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                children: "45 - 60 Days: 2 strikes"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                children: " \xa0 > 60 Days 3: Strikes"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("em", {
                            children: "Note: Unlike other Program Performance ratings, Delivery will be rated on a monthly basis"
                        })
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                        id: "delivery-info-list",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                    children: "Percentage: \xa0 Rating"
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "0-10%:"
                                    }),
                                    " \xa0 \xa0 ",
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "excellent",
                                        children: "No Downgrade or Strike (Excellent) "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "11-15%:"
                                    }),
                                    " \xa0 1 Strike"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "16-25%:"
                                    }),
                                    " \xa0 ",
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "very-good",
                                        children: "1 Downgrade (Very Good) "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "26-35%:"
                                    }),
                                    " \xa0 1 Downgrade + 1 Strike"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "36-45%:"
                                    }),
                                    " \xa0 ",
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "good",
                                        children: "2 Downgrade (Good) "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "46-55%:"
                                    }),
                                    " \xa0 2 Downgrade + 1 Strike"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "56-65%:"
                                    }),
                                    " \xa0 ",
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "fair",
                                        children: "3 Downgrade (Fair) "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "66-75%:"
                                    }),
                                    " \xa0 3 Downgrade + 1 Strike"
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "> 75%:"
                                    }),
                                    " \xa0 \xa0 \xa0",
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "poor",
                                        children: "4 Downgrade (Poor) "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("strong", {
                                        children: "< 5 Orders:"
                                    }),
                                    " \xa0Insufficient Data (Neutral Rating)"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}


function $ff0f056a92c54879$var$extraInfoReducer(state, action) {
    if (action.type === state) return null;
    else return action.type;
}
function $ff0f056a92c54879$export$2e2bcd8739ae039({ sortDir: sortDir, sortCol: sortCol, contractHolderPerformancesDispatch: contractHolderPerformancesDispatch }) {
    const [extraInfo, extraInfoDispatch] = (0, $8NFma.useReducer)($ff0f056a92c54879$var$extraInfoReducer, null);
    /**
   * Gets more info content if expanded, null if not expanded
   * @returns {React.JSX.Element|null}
   */ function getExtraInfoContent() {
        switch(extraInfo){
            case "reports":
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $10c193ef5276d989$export$2e2bcd8739ae039), {});
            case "customer satisfaction":
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eb2d2e1eebca3558$export$2e2bcd8739ae039), {});
            case "information distribution":
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $397fc727885190b9$export$2e2bcd8739ae039), {});
            case "contract adherence":
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $37838351ef4a37a1$export$2e2bcd8739ae039), {});
            case "delivery":
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $d8281485bd8e508a$export$2e2bcd8739ae039), {});
            default:
                return null;
        }
    }
    /**
   * OnClick handler for more info link
   * @param {string} type
   * @param {Event} event
   */ function handleOnClick(type, event) {
        event.stopPropagation();
        extraInfoDispatch({
            type: type
        });
    }
    const extraInfoContent = getExtraInfoContent();
    const icon = sortDir === "asc" ? "glyphicon glyphicon-arrow-up" : "glyphicon glyphicon-arrow-down";
    const ariaLabel = sortDir === "asc" ? "sorted in A to Z order" : "sorted in Z to A order";
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("thead", {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $799ca28831b28fe7$export$2e2bcd8739ae039), {
                        onClick: ()=>contractHolderPerformancesDispatch({
                                type: "sort",
                                sortCol: 0
                            }),
                        title: "Sort by Contract Holders",
                        className: "ch-name-header clickable",
                        children: [
                            "Contract Holders",
                            sortCol === 0 && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                "aria-label": ariaLabel,
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                                    className: icon
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $799ca28831b28fe7$export$2e2bcd8739ae039), {
                        onClick: ()=>contractHolderPerformancesDispatch({
                                type: "sort",
                                sortCol: 1
                            }),
                        title: "Sort by reports rating",
                        className: "clickable",
                        children: [
                            "Reports",
                            sortCol === 1 && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                "aria-label": ariaLabel,
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                                    className: icon
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3f4e0dc826a72806$export$2e2bcd8739ae039), {
                                handleClick: handleOnClick,
                                actionType: "reports"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $799ca28831b28fe7$export$2e2bcd8739ae039), {
                        onClick: ()=>contractHolderPerformancesDispatch({
                                type: "sort",
                                sortCol: 2
                            }),
                        title: "Sort by customer satisfaction rating",
                        className: "clickable",
                        children: [
                            "Customer Satisfaction",
                            sortCol === 2 && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                "aria-label": ariaLabel,
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                                    className: icon
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3f4e0dc826a72806$export$2e2bcd8739ae039), {
                                handleClick: handleOnClick,
                                actionType: "customer satisfaction"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $799ca28831b28fe7$export$2e2bcd8739ae039), {
                        onClick: ()=>contractHolderPerformancesDispatch({
                                type: "sort",
                                sortCol: 3
                            }),
                        title: "Sort by information distribution rating",
                        className: "clickable",
                        children: [
                            "Information Distribution",
                            sortCol === 3 && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                "aria-label": ariaLabel,
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                                    className: icon
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3f4e0dc826a72806$export$2e2bcd8739ae039), {
                                handleClick: handleOnClick,
                                actionType: "information distribution"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $799ca28831b28fe7$export$2e2bcd8739ae039), {
                        onClick: ()=>contractHolderPerformancesDispatch({
                                type: "sort",
                                sortCol: 4
                            }),
                        title: "Sort by contract adherence rating",
                        className: "clickable",
                        children: [
                            "Contract Adherence",
                            sortCol === 4 && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                "aria-label": ariaLabel,
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                                    className: icon
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3f4e0dc826a72806$export$2e2bcd8739ae039), {
                                handleClick: handleOnClick,
                                actionType: "contract adherence"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $799ca28831b28fe7$export$2e2bcd8739ae039), {
                        onClick: ()=>contractHolderPerformancesDispatch({
                                type: "sort",
                                sortCol: 5
                            }),
                        title: "Sort by delivery rating",
                        className: "clickable",
                        children: [
                            "Delivery",
                            sortCol === 5 && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                "aria-label": ariaLabel,
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                                    className: icon
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3f4e0dc826a72806$export$2e2bcd8739ae039), {
                                handleClick: handleOnClick,
                                actionType: "delivery"
                            })
                        ]
                    })
                ]
            }),
            extraInfoContent
        ]
    });
}
$ff0f056a92c54879$export$2e2bcd8739ae039.propTypes = {
    sortDir: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    sortCol: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number,
    contractHolderPerformancesDispatch: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func
};



var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

function $0d7f8f4641ec07fb$export$3775ca7ed97877ac(rating) {
    switch(rating){
        case 0, $53cc2e000314a49f$export$8bcc95d84aa607cf:
            return "excellent";
        case 0, $53cc2e000314a49f$export$26de73030d1d38:
            return "very-good";
        case 0, $53cc2e000314a49f$export$df3e15a50e220b07:
            return "good";
        case 0, $53cc2e000314a49f$export$88ae318293b73480:
            return "fair";
        case 0, $53cc2e000314a49f$export$5bec3bdf283420e5:
            return "poor";
        case 0, $53cc2e000314a49f$export$ac52cdfd4853e221:
            return "neutral";
    }
}
function $0d7f8f4641ec07fb$export$31e9844d44695797(rating) {
    switch(rating){
        case 0, $53cc2e000314a49f$export$8bcc95d84aa607cf:
            return 5;
        case 0, $53cc2e000314a49f$export$26de73030d1d38:
            return 4;
        case 0, $53cc2e000314a49f$export$df3e15a50e220b07:
            return 3;
        case 0, $53cc2e000314a49f$export$88ae318293b73480:
            return 2;
        case 0, $53cc2e000314a49f$export$5bec3bdf283420e5:
            return 1;
        case 0, $53cc2e000314a49f$export$ac52cdfd4853e221:
            return 0;
    }
}
function $0d7f8f4641ec07fb$export$33671114ca45bc09(key, dir) {
    return (rating1, rating2)=>{
        rating1 = $0d7f8f4641ec07fb$export$31e9844d44695797(rating1[key]);
        rating2 = $0d7f8f4641ec07fb$export$31e9844d44695797(rating2[key]);
        if (dir === "asc") {
            if (rating1 === 0) return 1;
            else if (rating2 === 0) return -1;
            else if (rating1 > rating2) return -1;
            else if (rating1 < rating2) return 1;
            else return 0;
        } else if (dir === "desc") {
            if (rating1 === 0) return 1;
            else if (rating2 === 0) return -1;
            else if (rating1 > rating2) return 1;
            else if (rating1 < rating2) return -1;
            else return 0;
        }
    };
}


function $634757c4d8408bce$export$2e2bcd8739ae039({ chPerformance: chPerformance }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        className: "ch-pp-row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                title: chPerformance.displayName,
                className: "ch-name",
                children: chPerformance.contractHolder
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: (0, $0d7f8f4641ec07fb$export$3775ca7ed97877ac)(chPerformance.reports),
                children: chPerformance.reports
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: (0, $0d7f8f4641ec07fb$export$3775ca7ed97877ac)(chPerformance.customerSatisfaction),
                children: chPerformance.customerSatisfaction
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: (0, $0d7f8f4641ec07fb$export$3775ca7ed97877ac)(chPerformance.informationDistribution),
                children: chPerformance.informationDistribution
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: (0, $0d7f8f4641ec07fb$export$3775ca7ed97877ac)(chPerformance.constractAdherence),
                children: chPerformance.constractAdherence
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: (0, $0d7f8f4641ec07fb$export$3775ca7ed97877ac)(chPerformance.delivery),
                children: chPerformance.delivery
            })
        ]
    });
}
$634757c4d8408bce$export$2e2bcd8739ae039.propTypes = {
    chPerformance: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired
};






function $21f3d17a99a60902$export$122ce715b95288ef() {
    return (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get("/sewppublic/chperformance/list");
}




/**
 * Reducer function for Program Performance Table
 * @param {Object} state
 * @param {Object} action
 * @returns {{sortCol: number, data: ContractHolderPerformanceRating[], sortDir: "asc" | "desc"}}
 */ function $b0256e0ff97c7eaf$var$sortReducer(state, action) {
    switch(action.type){
        case "init":
            return {
                data: action.data.sort((a, b)=>(0, $90eb12c1be8763cc$export$89a1f01f2a7cb2a1)(a, b, "contractHolder", "asc")),
                sortDir: "asc",
                sortCol: 0
            };
        case "sort":
            {
                const sortDir = action.sortCol === state.sortCol ? state.sortDir === "asc" ? "desc" : "asc" : "asc";
                if (action.sortCol === 0) return {
                    sortDir: sortDir,
                    sortCol: action.sortCol,
                    data: state.data.sort((a, b)=>(0, $90eb12c1be8763cc$export$89a1f01f2a7cb2a1)(a, b, "contractHolder", sortDir))
                };
                else if (action.sortCol === 1) return {
                    sortDir: sortDir,
                    sortCol: action.sortCol,
                    data: state.data.sort((0, $0d7f8f4641ec07fb$export$33671114ca45bc09)("reports", sortDir))
                };
                else if (action.sortCol === 2) return {
                    sortDir: sortDir,
                    sortCol: action.sortCol,
                    data: state.data.sort((0, $0d7f8f4641ec07fb$export$33671114ca45bc09)("customerSatisfaction", sortDir))
                };
                else if (action.sortCol === 3) return {
                    sortDir: sortDir,
                    sortCol: action.sortCol,
                    data: state.data.sort((0, $0d7f8f4641ec07fb$export$33671114ca45bc09)("informationDistribution", sortDir))
                };
                else if (action.sortCol === 4) return {
                    sortDir: sortDir,
                    sortCol: action.sortCol,
                    data: state.data.sort((0, $0d7f8f4641ec07fb$export$33671114ca45bc09)("constractAdherence", sortDir))
                };
                else if (action.sortCol === 5) return {
                    sortDir: sortDir,
                    sortCol: action.sortCol,
                    data: state.data.sort((0, $0d7f8f4641ec07fb$export$33671114ca45bc09)("delivery", sortDir))
                };
            }
    }
}
function $b0256e0ff97c7eaf$export$2e2bcd8739ae039() {
    const [contractHolderPerformances, contractHolderPerformancesDispatch] = (0, $8NFma.useReducer)($b0256e0ff97c7eaf$var$sortReducer, {
        /** @type {ContractHolderPerformanceRating[]} */ data: [],
        sortDir: "asc",
        sortCol: 0
    });
    const [error, setError] = (0, $8NFma.useState)(null);
    (0, $8NFma.useEffect)(()=>{
        document.title = "NASA SEWP V Contract Holder Program Performance";
    }, []);
    (0, $8NFma.useEffect)(()=>{
        (0, $21f3d17a99a60902$export$122ce715b95288ef)().then(({ data: data })=>{
            contractHolderPerformancesDispatch({
                type: "init",
                data: data
            });
        }).catch((error)=>{
            setError((0, $53cc2e000314a49f$export$6bec1cb94a439bf6));
        });
    }, []);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "program-performance-wrapper",
        className: "container-fluid",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7ad156834b5011ad$export$2e2bcd8739ae039), {}),
            error ? /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                children: error
            }) : /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
                id: "performance-table",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ff0f056a92c54879$export$2e2bcd8739ae039), {
                        sortDir: contractHolderPerformances.sortDir,
                        sortCol: contractHolderPerformances.sortCol,
                        contractHolderPerformancesDispatch: contractHolderPerformancesDispatch
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                        children: contractHolderPerformances.data.map((chPerformance)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $634757c4d8408bce$export$2e2bcd8739ae039), {
                                chPerformance: chPerformance
                            }, chPerformance.contractHolder))
                    })
                ]
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $deb843e897ae2e55$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "approved-contractors-header",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                className: "page_title",
                children: "SEWP Approved Support Service Contractors"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "content p_content",
                title: "help text",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        children: "The following Federal Contractors are approved to purchase from the SEWP contracts in support of their Federal Contract Number(s) through the Contract Period Of Performance Dates as listed below."
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            href: "/ordering.shtml#WHO",
                            children: "How To Become a NASA SEWP Approved Support Service Contractor?"
                        })
                    })
                ]
            })
        ]
    });
}



const $b3be86026417a151$export$398e5a802c8edf84 = ()=>(0, $218703de6b4a0d50$export$3988ae62b71be9a3)("/sewppublic/approvedcontractors/list").then(({ data: data })=>data);



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");
function $3d93d3b3ae5837bf$export$2e2bcd8739ae039({ approvedContractor: approvedContractor }) {
    const companyAddress = approvedContractor.address + " " + approvedContractor.city + ", " + approvedContractor.state + " " + approvedContractor.zip;
    const contractDate = new Date(approvedContractor.contractPopDate).toDateString();
    const contractDisplayDate = contractDate.substring(4, 10) + ", " + contractDate.substring(11);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
        role: "row",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "sitenames",
                title: companyAddress,
                role: "gridcell",
                children: approvedContractor.name
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-left",
                role: "gridcell",
                children: approvedContractor.federalContractNumber
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "text-left",
                role: "gridcell",
                children: contractDisplayDate
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                className: "shortagencynames",
                title: approvedContractor.agencyName,
                role: "gridcell",
                children: approvedContractor.shortAgencyName
            })
        ]
    });
}






function $3a2b5312e07ddd35$export$2e2bcd8739ae039({ approvedContractorsListData: approvedContractorsListData }) {
    //init state
    const [sortOption, setSortOption] = (0, $8NFma.useState)((0, $53cc2e000314a49f$export$8ce0397586013bef));
    //define onClick handlers
    const setSiteNameSort = ()=>{
        setSortOption((prevState)=>prevState === (0, $53cc2e000314a49f$export$8ce0397586013bef) ? (0, $53cc2e000314a49f$export$d5fcf051c75fdb4b) : (0, $53cc2e000314a49f$export$8ce0397586013bef));
    };
    const setContractSort = ()=>{
        setSortOption((prevState)=>prevState === (0, $53cc2e000314a49f$export$b9e81d98424fb77d) ? (0, $53cc2e000314a49f$export$adcfeb78a0beb383) : (0, $53cc2e000314a49f$export$b9e81d98424fb77d));
    };
    const setContractDateSort = ()=>{
        setSortOption((prevState)=>prevState === (0, $53cc2e000314a49f$export$feb7a771147f9ff4) ? (0, $53cc2e000314a49f$export$eb335583752f8a) : (0, $53cc2e000314a49f$export$feb7a771147f9ff4));
    };
    const setShortAgencyNameSort = ()=>{
        setSortOption((prevState)=>prevState === (0, $53cc2e000314a49f$export$5a7a5b700e65824d) ? (0, $53cc2e000314a49f$export$5d9a7f268c32987e) : (0, $53cc2e000314a49f$export$5a7a5b700e65824d));
    };
    const tableContent = /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
        role: "rowgroup",
        children: approvedContractorsListData.sort((0, $90eb12c1be8763cc$export$3d77ba5b4995b76e)[sortOption]).map((item)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $3d93d3b3ae5837bf$export$2e2bcd8739ae039), {
                approvedContractor: item
            }, item.id))
    }, "approvedContractors");
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $e889a8eb4a1c50f8$export$2e2bcd8739ae039), {
        id: "approvedContractorsTable",
        summary: "List of Approved Contractors",
        caption: "List of approved contractors sorted by site name",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("thead", {
                role: "rowgroup",
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                    role: "row",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                            id: "siteName-head",
                            className: "col-xs-6",
                            text: "Site Name (rollover to see address)",
                            onClick: setSiteNameSort,
                            title: "site name",
                            sortOption: sortOption,
                            sortDesc: (0, $53cc2e000314a49f$export$d5fcf051c75fdb4b)
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                            id: "contractNumber-head",
                            className: "col-xs-2 text-left",
                            text: "Federal Contract Number",
                            onClick: setContractSort,
                            title: "federal contract number",
                            sortOption: sortOption,
                            sortDesc: (0, $53cc2e000314a49f$export$adcfeb78a0beb383)
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                            id: "contractDate-head",
                            className: "col-xs-2 text-left",
                            text: "Contract Period of Performance Date",
                            onClick: setContractDateSort,
                            title: "contract date",
                            sortOption: sortOption,
                            sortDesc: (0, $53cc2e000314a49f$export$eb335583752f8a)
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ddbf4334159f7ead$export$2e2bcd8739ae039), {
                            id: "shortAgencyName-head",
                            className: "col-xs-3 text-left",
                            text: "Short Agency Name",
                            onClick: setShortAgencyNameSort,
                            title: "short agency name",
                            sortOption: sortOption,
                            sortDesc: (0, $53cc2e000314a49f$export$5d9a7f268c32987e)
                        })
                    ]
                })
            }),
            tableContent
        ]
    });
}




function $bed95d953ab71ffe$export$2e2bcd8739ae039() {
    /** @type {[ApprovedContractor[], React.Dispatch<React.SetActionState<ApprovedContractor[]>>]} */ const [approvedContractorListData, setApprovedContractorList] = (0, $8NFma.useState)([]);
    const [error, setError] = (0, $8NFma.useState)(null);
    (0, $8NFma.useEffect)(()=>{
        document.title = "SEWP Approved Support Service Contractors";
        (0, $b3be86026417a151$export$398e5a802c8edf84)().then((approvedContractorListData)=>{
            setApprovedContractorList(approvedContractorListData);
        }).catch((error)=>{
            setError(error);
        });
    }, []);
    if (error) return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        id: "approved-contractors-wrapper",
        className: "container-fluid",
        children: (0, $53cc2e000314a49f$export$6bec1cb94a439bf6)
    });
    else if (!approvedContractorListData.length) return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        id: "approved-contractors-wrapper",
        className: "container-fluid",
        children: "Loading Approved Contractors Data..."
    });
    else return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        id: "approved-contractors-wrapper",
        className: "container-fluid approved-contractors",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $deb843e897ae2e55$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3a2b5312e07ddd35$export$2e2bcd8739ae039), {
                approvedContractorsListData: approvedContractorListData
            })
        ]
    });
}


const $138f8f6eb781124e$var$router = (0, $a8cea113a6044695$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3e7b3d722a3264c2$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "sewppublic/contractholders",
                element: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7341fa3ebc5e1557$export$2e2bcd8739ae039), {})
            },
            {
                path: "sewppublic/fedramp",
                element: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8810a6cea18d62f2$export$2e2bcd8739ae039), {})
            },
            {
                path: "sewppublic/orderapp",
                element: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $59bf67ae5e339d17$export$2e2bcd8739ae039), {})
            },
            {
                path: "sewppublic/chperformance",
                element: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $b0256e0ff97c7eaf$export$2e2bcd8739ae039), {})
            },
            {
                path: "sewppublic/approvedcontractors",
                element: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bed95d953ab71ffe$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
(0, (/*@__PURE__*/$parcel$interopDefault($503937b663c395c4$exports))).createRoot(document.getElementById("root")).render(/*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).StrictMode, {
    children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a8cea113a6044695$export$323e4fc2fa4753fb), {
        router: $138f8f6eb781124e$var$router
    })
}));

})();
//# sourceMappingURL=sewp5public.js.map
